export let constants_diablo2_97 = {
    "classes": [
        {
            "id": 0,
            "n": "Amazon",
            "c": "ama",
            "as": "to Amazon Skill Levels",
            "ts": [
                "+%d to Bow and Crossbow Skills",
                "+%d to Passive and Magic Skills",
                "+%d to Javelin and Spear Skills"
            ],
            "co": "(Amazon Only)",
            "s": {
                "lpl": 8,
                "mpl": 6,
                "spl": 4,
                "lpv": 12,
                "spv": 4,
                "mpe": 6
            },
            "a": {
                "str": 20,
                "dex": 25,
                "int": 15,
                "vit": 20,
                "stam": 84,
                "hpadd": "30"
            }
        },
        {
            "id": 1,
            "n": "Sorceress",
            "c": "sor",
            "as": "to Sorceress Skill Levels",
            "ts": [
                "+%d to Fire Skills",
                "+%d to Lightning Skills",
                "+%d to Cold Skills"
            ],
            "co": "(Sorceress Only)",
            "s": {
                "lpl": 4,
                "mpl": 8,
                "spl": 4,
                "lpv": 8,
                "spv": 4,
                "mpe": 8
            },
            "a": {
                "str": 10,
                "dex": 25,
                "int": 35,
                "vit": 10,
                "stam": 74,
                "hpadd": "30"
            }
        },
        {
            "id": 2,
            "n": "Necromancer",
            "c": "nec",
            "as": "to Necromancer Skill Levels",
            "ts": [
                "+%d to Curses",
                "+%d to Poison and Bone Skills",
                "+%d to Summoning Skills"
            ],
            "co": "(Necromancer Only)",
            "s": {
                "lpl": 6,
                "mpl": 8,
                "spl": 4,
                "lpv": 8,
                "spv": 4,
                "mpe": 8
            },
            "a": {
                "str": 15,
                "dex": 25,
                "int": 25,
                "vit": 15,
                "stam": 79,
                "hpadd": "30"
            }
        },
        {
            "id": 3,
            "n": "Paladin",
            "c": "pal",
            "as": "to Paladin Skill Levels",
            "ts": [
                "+%d to Combat Skills",
                "+%d to Offensive Auras",
                "+%d to Defensive Auras"
            ],
            "co": "(Paladin Only)",
            "s": {
                "lpl": 8,
                "mpl": 6,
                "spl": 4,
                "lpv": 12,
                "spv": 4,
                "mpe": 6
            },
            "a": {
                "str": 25,
                "dex": 20,
                "int": 15,
                "vit": 25,
                "stam": 89,
                "hpadd": "30"
            }
        },
        {
            "id": 4,
            "n": "Barbarian",
            "c": "bar",
            "as": "to Barbarian Skill Levels",
            "ts": [
                "+%d to Combat Skills",
                "+%d to Masteries",
                "+%d to Warcries"
            ],
            "co": "(Barbarian Only)",
            "s": {
                "lpl": 8,
                "mpl": 4,
                "spl": 4,
                "lpv": 16,
                "spv": 4,
                "mpe": 4
            },
            "a": {
                "str": 30,
                "dex": 20,
                "int": 10,
                "vit": 25,
                "stam": 92,
                "hpadd": "30"
            }
        },
        {
            "id": 5,
            "n": "Druid",
            "c": "dru",
            "as": "to Druid Skills",
            "ts": [
                "+%d to Summoning Skills",
                "+%d to Shape Shifting Skills",
                "+%d to Elemental Skills"
            ],
            "co": "(Druid Only)",
            "s": {
                "lpl": 6,
                "mpl": 8,
                "spl": 4,
                "lpv": 8,
                "spv": 4,
                "mpe": 8
            },
            "a": {
                "str": 15,
                "dex": 20,
                "int": 20,
                "vit": 25,
                "stam": 84,
                "hpadd": "30"
            }
        },
        {
            "id": 6,
            "n": "Assassin",
            "c": "ass",
            "as": "to Assassin Skills",
            "ts": [
                "+%d to Traps",
                "+%d to Shadow Disciplines",
                "+%d to Martial Arts"
            ],
            "co": "(Assassin Only)",
            "s": {
                "lpl": 8,
                "mpl": 6,
                "spl": 5,
                "lpv": 12,
                "spv": 5,
                "mpe": 7
            },
            "a": {
                "str": 20,
                "dex": 20,
                "int": 25,
                "vit": 20,
                "stam": 95,
                "hpadd": "30"
            }
        }
    ],
    "skills": [
        {
            "id": 0,
            "s": "Attack",
            "n": "Attack"
        },
        {
            "id": 1,
            "s": "Kick",
            "n": "Kick"
        },
        {
            "id": 2,
            "s": "Throw",
            "n": "Throw"
        },
        {
            "id": 3,
            "s": "Unsummon",
            "n": "Unsummon"
        },
        {
            "id": 4,
            "s": "Left Hand Throw",
            "n": "Left Hand Throw"
        },
        {
            "id": 5,
            "s": "Left Hand Swing",
            "n": "Left Hand Swing"
        },
        {
            "id": 6,
            "s": "Magic Arrow",
            "n": "Magic Arrow",
            "c": "ama"
        },
        {
            "id": 7,
            "s": "Fire Arrow",
            "n": "Fire Arrow",
            "c": "ama"
        },
        {
            "id": 8,
            "s": "Inner Sight",
            "n": "Inner Sight",
            "c": "ama"
        },
        {
            "id": 9,
            "s": "Critical Strike",
            "n": "Critical Strike",
            "c": "ama"
        },
        {
            "id": 10,
            "s": "Jab",
            "n": "Jab",
            "c": "ama"
        },
        {
            "id": 11,
            "s": "Cold Arrow",
            "n": "Cold Arrow",
            "c": "ama"
        },
        {
            "id": 12,
            "s": "Multiple Shot",
            "n": "Multiple Shot",
            "c": "ama"
        },
        {
            "id": 13,
            "s": "Dodge",
            "n": "Dodge",
            "c": "ama"
        },
        {
            "id": 14,
            "s": "Power Strike",
            "n": "Power Strike",
            "c": "ama"
        },
        {
            "id": 15,
            "s": "Poison Javelin",
            "n": "Poison Javelin",
            "c": "ama"
        },
        {
            "id": 16,
            "s": "Exploding Arrow",
            "n": "Exploding Arrow",
            "c": "ama"
        },
        {
            "id": 17,
            "s": "Slow Missiles",
            "n": "Slow Missiles",
            "c": "ama"
        },
        {
            "id": 18,
            "s": "Avoid",
            "n": "Avoid",
            "c": "ama"
        },
        {
            "id": 19,
            "s": "Impale",
            "n": "Impale",
            "c": "ama"
        },
        {
            "id": 20,
            "s": "Lightning Bolt",
            "n": "Lightning Bolt",
            "c": "ama"
        },
        {
            "id": 21,
            "s": "Ice Arrow",
            "n": "Ice Arrow",
            "c": "ama"
        },
        {
            "id": 22,
            "s": "Guided Arrow",
            "n": "Guided Arrow",
            "c": "ama"
        },
        {
            "id": 23,
            "s": "Penetrate",
            "n": "Penetrate",
            "c": "ama"
        },
        {
            "id": 24,
            "s": "Charged Strike",
            "n": "Charged Strike",
            "c": "ama"
        },
        {
            "id": 25,
            "s": "Plague Javelin",
            "n": "Plague Javelin",
            "c": "ama"
        },
        {
            "id": 26,
            "s": "Strafe",
            "n": "Strafe",
            "c": "ama"
        },
        {
            "id": 27,
            "s": "Immolation Arrow",
            "n": "Immolation Arrow",
            "c": "ama"
        },
        {
            "id": 28,
            "s": "Dopplezon",
            "n": "Decoy",
            "c": "ama"
        },
        {
            "id": 29,
            "s": "Evade",
            "n": "Evade",
            "c": "ama"
        },
        {
            "id": 30,
            "s": "Fend",
            "n": "Fend",
            "c": "ama"
        },
        {
            "id": 31,
            "s": "Freezing Arrow",
            "n": "Freezing Arrow",
            "c": "ama"
        },
        {
            "id": 32,
            "s": "Valkyrie",
            "n": "Valkyrie",
            "c": "ama"
        },
        {
            "id": 33,
            "s": "Pierce",
            "n": "Pierce",
            "c": "ama"
        },
        {
            "id": 34,
            "s": "Lightning Strike",
            "n": "Lightning Strike",
            "c": "ama"
        },
        {
            "id": 35,
            "s": "Lightning Fury",
            "n": "Lightning Fury",
            "c": "ama"
        },
        {
            "id": 36,
            "s": "Fire Bolt",
            "n": "Fire Bolt",
            "c": "sor"
        },
        {
            "id": 37,
            "s": "Warmth",
            "n": "Warmth",
            "c": "sor"
        },
        {
            "id": 38,
            "s": "Charged Bolt",
            "n": "Charged Bolt",
            "c": "sor"
        },
        {
            "id": 39,
            "s": "Ice Bolt",
            "n": "Ice Bolt",
            "c": "sor"
        },
        {
            "id": 40,
            "s": "Frozen Armor",
            "n": "Frozen Armor",
            "c": "sor"
        },
        {
            "id": 41,
            "s": "Inferno",
            "n": "Inferno",
            "c": "sor"
        },
        {
            "id": 42,
            "s": "Static Field",
            "n": "Static Field",
            "c": "sor"
        },
        {
            "id": 43,
            "s": "Telekinesis",
            "n": "Telekinesis",
            "c": "sor"
        },
        {
            "id": 44,
            "s": "Frost Nova",
            "n": "Frost Nova",
            "c": "sor"
        },
        {
            "id": 45,
            "s": "Ice Blast",
            "n": "Ice Blast",
            "c": "sor"
        },
        {
            "id": 46,
            "s": "Blaze",
            "n": "Blaze",
            "c": "sor"
        },
        {
            "id": 47,
            "s": "Fire Ball",
            "n": "Fire Ball",
            "c": "sor"
        },
        {
            "id": 48,
            "s": "Nova",
            "n": "Nova",
            "c": "sor"
        },
        {
            "id": 49,
            "s": "Lightning",
            "n": "Lightning",
            "c": "sor"
        },
        {
            "id": 50,
            "s": "Shiver Armor",
            "n": "Shiver Armor",
            "c": "sor"
        },
        {
            "id": 51,
            "s": "Fire Wall",
            "n": "Fire Wall",
            "c": "sor"
        },
        {
            "id": 52,
            "s": "Enchant",
            "n": "Enchant",
            "c": "sor"
        },
        {
            "id": 53,
            "s": "Chain Lightning",
            "n": "Chain Lightning",
            "c": "sor"
        },
        {
            "id": 54,
            "s": "Teleport",
            "n": "Teleport",
            "c": "sor"
        },
        {
            "id": 55,
            "s": "Glacial Spike",
            "n": "Glacial Spike",
            "c": "sor"
        },
        {
            "id": 56,
            "s": "Meteor",
            "n": "Meteor",
            "c": "sor"
        },
        {
            "id": 57,
            "s": "Thunder Storm",
            "n": "Thunder Storm",
            "c": "sor"
        },
        {
            "id": 58,
            "s": "Energy Shield",
            "n": "Energy Shield",
            "c": "sor"
        },
        {
            "id": 59,
            "s": "Blizzard",
            "n": "Blizzard",
            "c": "sor"
        },
        {
            "id": 60,
            "s": "Chilling Armor",
            "n": "Chilling Armor",
            "c": "sor"
        },
        {
            "id": 61,
            "s": "Fire Mastery",
            "n": "Fire Mastery",
            "c": "sor"
        },
        {
            "id": 62,
            "s": "Hydra",
            "n": "Hydra",
            "c": "sor"
        },
        {
            "id": 63,
            "s": "Lightning Mastery",
            "n": "Lightning Mastery",
            "c": "sor"
        },
        {
            "id": 64,
            "s": "Frozen Orb",
            "n": "Frozen Orb",
            "c": "sor"
        },
        {
            "id": 65,
            "s": "Cold Mastery",
            "n": "Cold Mastery",
            "c": "sor"
        },
        {
            "id": 66,
            "s": "Amplify Damage",
            "n": "Amplify Damage",
            "c": "nec"
        },
        {
            "id": 67,
            "s": "Teeth",
            "n": "Teeth",
            "c": "nec"
        },
        {
            "id": 68,
            "s": "Bone Armor",
            "n": "Bone Armor",
            "c": "nec"
        },
        {
            "id": 69,
            "s": "Skeleton Mastery",
            "n": "Skeleton Mastery",
            "c": "nec"
        },
        {
            "id": 70,
            "s": "Raise Skeleton",
            "n": "Raise Skeleton",
            "c": "nec"
        },
        {
            "id": 71,
            "s": "Dim Vision",
            "n": "Dim Vision",
            "c": "nec"
        },
        {
            "id": 72,
            "s": "Weaken",
            "n": "Weaken",
            "c": "nec"
        },
        {
            "id": 73,
            "s": "Poison Dagger",
            "n": "Poison Dagger",
            "c": "nec"
        },
        {
            "id": 74,
            "s": "Corpse Explosion",
            "n": "Corpse Explosion",
            "c": "nec"
        },
        {
            "id": 75,
            "s": "Clay Golem",
            "n": "Clay Golem",
            "c": "nec"
        },
        {
            "id": 76,
            "s": "Iron Maiden",
            "n": "Iron Maiden",
            "c": "nec"
        },
        {
            "id": 77,
            "s": "Terror",
            "n": "Terror",
            "c": "nec"
        },
        {
            "id": 78,
            "s": "Bone Wall",
            "n": "Bone Wall",
            "c": "nec"
        },
        {
            "id": 79,
            "s": "Golem Mastery",
            "n": "Golem Mastery",
            "c": "nec"
        },
        {
            "id": 80,
            "s": "Raise Skeletal Mage",
            "n": "Raise Skeletal Mage",
            "c": "nec"
        },
        {
            "id": 81,
            "s": "Confuse",
            "n": "Confuse",
            "c": "nec"
        },
        {
            "id": 82,
            "s": "Life Tap",
            "n": "Life Tap",
            "c": "nec"
        },
        {
            "id": 83,
            "s": "Poison Explosion",
            "n": "Poison Explosion",
            "c": "nec"
        },
        {
            "id": 84,
            "s": "Bone Spear",
            "n": "Bone Spear",
            "c": "nec"
        },
        {
            "id": 85,
            "s": "BloodGolem",
            "n": "Blood Golem",
            "c": "nec"
        },
        {
            "id": 86,
            "s": "Attract",
            "n": "Attract",
            "c": "nec"
        },
        {
            "id": 87,
            "s": "Decrepify",
            "n": "Decrepify",
            "c": "nec"
        },
        {
            "id": 88,
            "s": "Bone Prison",
            "n": "Bone Prison",
            "c": "nec"
        },
        {
            "id": 89,
            "s": "Summon Resist",
            "n": "Summon Resist",
            "c": "nec"
        },
        {
            "id": 90,
            "s": "IronGolem",
            "n": "Iron Golem",
            "c": "nec"
        },
        {
            "id": 91,
            "s": "Lower Resist",
            "n": "Lower Resist",
            "c": "nec"
        },
        {
            "id": 92,
            "s": "Poison Nova",
            "n": "Poison Nova",
            "c": "nec"
        },
        {
            "id": 93,
            "s": "Bone Spirit",
            "n": "Bone Spirit",
            "c": "nec"
        },
        {
            "id": 94,
            "s": "FireGolem",
            "n": "Fire Golem",
            "c": "nec"
        },
        {
            "id": 95,
            "s": "Revive",
            "n": "Revive",
            "c": "nec"
        },
        {
            "id": 96,
            "s": "Sacrifice",
            "n": "Sacrifice",
            "c": "pal"
        },
        {
            "id": 97,
            "s": "Smite",
            "n": "Smite",
            "c": "pal"
        },
        {
            "id": 98,
            "s": "Might",
            "n": "Might",
            "c": "pal"
        },
        {
            "id": 99,
            "s": "Prayer",
            "n": "Prayer",
            "c": "pal"
        },
        {
            "id": 100,
            "s": "Resist Fire",
            "n": "Resist Fire",
            "c": "pal"
        },
        {
            "id": 101,
            "s": "Holy Bolt",
            "n": "Holy Bolt",
            "c": "pal"
        },
        {
            "id": 102,
            "s": "Holy Fire",
            "n": "Holy Fire",
            "c": "pal"
        },
        {
            "id": 103,
            "s": "Thorns",
            "n": "Thorns",
            "c": "pal"
        },
        {
            "id": 104,
            "s": "Defiance",
            "n": "Defiance",
            "c": "pal"
        },
        {
            "id": 105,
            "s": "Resist Cold",
            "n": "Resist Cold",
            "c": "pal"
        },
        {
            "id": 106,
            "s": "Zeal",
            "n": "Zeal",
            "c": "pal"
        },
        {
            "id": 107,
            "s": "Charge",
            "n": "Charge",
            "c": "pal"
        },
        {
            "id": 108,
            "s": "Blessed Aim",
            "n": "Blessed Aim",
            "c": "pal"
        },
        {
            "id": 109,
            "s": "Cleansing",
            "n": "Cleansing",
            "c": "pal"
        },
        {
            "id": 110,
            "s": "Resist Lightning",
            "n": "Resist Lightning",
            "c": "pal"
        },
        {
            "id": 111,
            "s": "Vengeance",
            "n": "Vengeance",
            "c": "pal"
        },
        {
            "id": 112,
            "s": "Blessed Hammer",
            "n": "Blessed Hammer",
            "c": "pal"
        },
        {
            "id": 113,
            "s": "Concentration",
            "n": "Concentration",
            "c": "pal"
        },
        {
            "id": 114,
            "s": "Holy Freeze",
            "n": "Holy Freeze",
            "c": "pal"
        },
        {
            "id": 115,
            "s": "Vigor",
            "n": "Vigor",
            "c": "pal"
        },
        {
            "id": 116,
            "s": "Conversion",
            "n": "Conversion",
            "c": "pal"
        },
        {
            "id": 117,
            "s": "Holy Shield",
            "n": "Holy Shield",
            "c": "pal"
        },
        {
            "id": 118,
            "s": "Holy Shock",
            "n": "Holy Shock",
            "c": "pal"
        },
        {
            "id": 119,
            "s": "Sanctuary",
            "n": "Sanctuary",
            "c": "pal"
        },
        {
            "id": 120,
            "s": "Meditation",
            "n": "Meditation",
            "c": "pal"
        },
        {
            "id": 121,
            "s": "Fist of the Heavens",
            "n": "Fist of the Heavens",
            "c": "pal"
        },
        {
            "id": 122,
            "s": "Fanaticism",
            "n": "Fanaticism",
            "c": "pal"
        },
        {
            "id": 123,
            "s": "Conviction",
            "n": "Conviction",
            "c": "pal"
        },
        {
            "id": 124,
            "s": "Redemption",
            "n": "Redemption",
            "c": "pal"
        },
        {
            "id": 125,
            "s": "Salvation",
            "n": "Salvation",
            "c": "pal"
        },
        {
            "id": 126,
            "s": "Bash",
            "n": "Bash",
            "c": "bar"
        },
        {
            "id": 127,
            "s": "Blade Mastery",
            "n": "Sword Mastery",
            "c": "bar"
        },
        {
            "id": 128,
            "s": "Axe Mastery",
            "n": "Axe Mastery",
            "c": "bar"
        },
        {
            "id": 129,
            "s": "Mace Mastery",
            "n": "Mace Mastery",
            "c": "bar"
        },
        {
            "id": 130,
            "s": "Howl",
            "n": "Howl",
            "c": "bar"
        },
        {
            "id": 131,
            "s": "Find Potion",
            "n": "Find Potion",
            "c": "bar"
        },
        {
            "id": 132,
            "s": "Leap",
            "n": "Leap",
            "c": "bar"
        },
        {
            "id": 133,
            "s": "Double Swing",
            "n": "Double Swing",
            "c": "bar"
        },
        {
            "id": 134,
            "s": "Pole Arm Mastery",
            "n": "Pole Arm Mastery",
            "c": "bar"
        },
        {
            "id": 135,
            "s": "Throwing Mastery",
            "n": "Throwing Mastery",
            "c": "bar"
        },
        {
            "id": 136,
            "s": "Spear Mastery",
            "n": "Spear Mastery",
            "c": "bar"
        },
        {
            "id": 137,
            "s": "Taunt",
            "n": "Taunt",
            "c": "bar"
        },
        {
            "id": 138,
            "s": "Shout",
            "n": "Shout",
            "c": "bar"
        },
        {
            "id": 139,
            "s": "Stun",
            "n": "Stun",
            "c": "bar"
        },
        {
            "id": 140,
            "s": "Double Throw",
            "n": "Double Throw",
            "c": "bar"
        },
        {
            "id": 141,
            "s": "Increased Stamina",
            "n": "Increased Stamina",
            "c": "bar"
        },
        {
            "id": 142,
            "s": "Find Item",
            "n": "Find Item",
            "c": "bar"
        },
        {
            "id": 143,
            "s": "Leap Attack",
            "n": "Leap Attack",
            "c": "bar"
        },
        {
            "id": 144,
            "s": "Concentrate",
            "n": "Concentrate",
            "c": "bar"
        },
        {
            "id": 145,
            "s": "Iron Skin",
            "n": "Iron Skin",
            "c": "bar"
        },
        {
            "id": 146,
            "s": "Battle Cry",
            "n": "Battle Cry",
            "c": "bar"
        },
        {
            "id": 147,
            "s": "Frenzy",
            "n": "Frenzy",
            "c": "bar"
        },
        {
            "id": 148,
            "s": "Increased Speed",
            "n": "Increased Speed",
            "c": "bar"
        },
        {
            "id": 149,
            "s": "Battle Orders",
            "n": "Battle Orders",
            "c": "bar"
        },
        {
            "id": 150,
            "s": "Grim Ward",
            "n": "Grim Ward",
            "c": "bar"
        },
        {
            "id": 151,
            "s": "Whirlwind",
            "n": "Whirlwind",
            "c": "bar"
        },
        {
            "id": 152,
            "s": "Berserk",
            "n": "Berserk",
            "c": "bar"
        },
        {
            "id": 153,
            "s": "Natural Resistance",
            "n": "Natural Resistance",
            "c": "bar"
        },
        {
            "id": 154,
            "s": "War Cry",
            "n": "War Cry",
            "c": "bar"
        },
        {
            "id": 155,
            "s": "Battle Command",
            "n": "Battle Command",
            "c": "bar"
        },
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 197,
            "s": "DiabWall",
            "n": "Firestorm"
        },
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 217,
            "s": "Scroll of Identify",
            "n": "Scroll of Identify"
        },
        {
            "id": 218,
            "s": "Book of Identify",
            "n": "Tome of Identify"
        },
        {
            "id": 219,
            "s": "Scroll of Townportal",
            "n": "Scroll of Townportal"
        },
        {
            "id": 220,
            "s": "Book of Townportal",
            "n": "Tome of Townportal"
        },
        {
            "id": 221,
            "s": "Raven",
            "n": "Raven",
            "c": "dru"
        },
        {
            "id": 222,
            "s": "Plague Poppy",
            "n": "Poison Creeper",
            "c": "dru"
        },
        {
            "id": 223,
            "s": "Wearwolf",
            "n": "Werewolf",
            "c": "dru"
        },
        {
            "id": 224,
            "s": "Shape Shifting",
            "n": "Lycanthropy",
            "c": "dru"
        },
        {
            "id": 225,
            "s": "Firestorm",
            "n": "Firestorm",
            "c": "dru"
        },
        {
            "id": 226,
            "s": "Oak Sage",
            "n": "Oak Sage",
            "c": "dru"
        },
        {
            "id": 227,
            "s": "Summon Spirit Wolf",
            "n": "Summon Spirit Wolf",
            "c": "dru"
        },
        {
            "id": 228,
            "s": "Wearbear",
            "n": "Werebear",
            "c": "dru"
        },
        {
            "id": 229,
            "s": "Molten Boulder",
            "n": "Molten Boulder",
            "c": "dru"
        },
        {
            "id": 230,
            "s": "Arctic Blast",
            "n": "Arctic Blast",
            "c": "dru"
        },
        {
            "id": 231,
            "s": "Cycle of Life",
            "n": "Carrion Vine",
            "c": "dru"
        },
        {
            "id": 232,
            "s": "Feral Rage",
            "n": "Feral Rage",
            "c": "dru"
        },
        {
            "id": 233,
            "s": "Maul",
            "n": "Maul",
            "c": "dru"
        },
        {
            "id": 234,
            "s": "Eruption",
            "n": "Fissure",
            "c": "dru"
        },
        {
            "id": 235,
            "s": "Cyclone Armor",
            "n": "Cyclone Armor",
            "c": "dru"
        },
        {
            "id": 236,
            "s": "Heart of Wolverine",
            "n": "Heart of Wolverine",
            "c": "dru"
        },
        {
            "id": 237,
            "s": "Summon Fenris",
            "n": "Summon Dire Wolf",
            "c": "dru"
        },
        {
            "id": 238,
            "s": "Rabies",
            "n": "Rabies",
            "c": "dru"
        },
        {
            "id": 239,
            "s": "Fire Claws",
            "n": "Fire Claws",
            "c": "dru"
        },
        {
            "id": 240,
            "s": "Twister",
            "n": "Twister",
            "c": "dru"
        },
        {
            "id": 241,
            "s": "Vines",
            "n": "Solar Creeper",
            "c": "dru"
        },
        {
            "id": 242,
            "s": "Hunger",
            "n": "Hunger",
            "c": "dru"
        },
        {
            "id": 243,
            "s": "Shock Wave",
            "n": "Shock Wave",
            "c": "dru"
        },
        {
            "id": 244,
            "s": "Volcano",
            "n": "Volcano",
            "c": "dru"
        },
        {
            "id": 245,
            "s": "Tornado",
            "n": "Tornado",
            "c": "dru"
        },
        {
            "id": 246,
            "s": "Spirit of Barbs",
            "n": "Spirit of Barbs",
            "c": "dru"
        },
        {
            "id": 247,
            "s": "Summon Grizzly",
            "n": "Summon Grizzly",
            "c": "dru"
        },
        {
            "id": 248,
            "s": "Fury",
            "n": "Fury",
            "c": "dru"
        },
        {
            "id": 249,
            "s": "Armageddon",
            "n": "Armageddon",
            "c": "dru"
        },
        {
            "id": 250,
            "s": "Hurricane",
            "n": "Hurricane",
            "c": "dru"
        },
        {
            "id": 251,
            "s": "Fire Trauma",
            "n": "Fire Blast",
            "c": "ass"
        },
        {
            "id": 252,
            "s": "Claw Mastery",
            "n": "Claw Mastery",
            "c": "ass"
        },
        {
            "id": 253,
            "s": "Psychic Hammer",
            "n": "Psychic Hammer",
            "c": "ass"
        },
        {
            "id": 254,
            "s": "Tiger Strike",
            "n": "Tiger Strike",
            "c": "ass"
        },
        {
            "id": 255,
            "s": "Dragon Talon",
            "n": "Dragon Talon",
            "c": "ass"
        },
        {
            "id": 256,
            "s": "Shock Field",
            "n": "Shock Web",
            "c": "ass"
        },
        {
            "id": 257,
            "s": "Blade Sentinel",
            "n": "Blade Sentinel",
            "c": "ass"
        },
        {
            "id": 258,
            "s": "Quickness",
            "n": "Burst of Speed",
            "c": "ass"
        },
        {
            "id": 259,
            "s": "Fists of Fire",
            "n": "Fists of Fire",
            "c": "ass"
        },
        {
            "id": 260,
            "s": "Dragon Claw",
            "n": "Dragon Claw",
            "c": "ass"
        },
        {
            "id": 261,
            "s": "Charged Bolt Sentry",
            "n": "Charged Bolt Sentry",
            "c": "ass"
        },
        {
            "id": 262,
            "s": "Wake of Fire Sentry",
            "n": "Wake of Fire",
            "c": "ass"
        },
        {
            "id": 263,
            "s": "Weapon Block",
            "n": "Weapon Block",
            "c": "ass"
        },
        {
            "id": 264,
            "s": "Cloak of Shadows",
            "n": "Cloak of Shadows",
            "c": "ass"
        },
        {
            "id": 265,
            "s": "Cobra Strike",
            "n": "Cobra Strike",
            "c": "ass"
        },
        {
            "id": 266,
            "s": "Blade Fury",
            "n": "Blade Fury",
            "c": "ass"
        },
        {
            "id": 267,
            "s": "Fade",
            "n": "Fade",
            "c": "ass"
        },
        {
            "id": 268,
            "s": "Shadow Warrior",
            "n": "Shadow Warrior",
            "c": "ass"
        },
        {
            "id": 269,
            "s": "Claws of Thunder",
            "n": "Claws of Thunder",
            "c": "ass"
        },
        {
            "id": 270,
            "s": "Dragon Tail",
            "n": "Dragon Tail",
            "c": "ass"
        },
        {
            "id": 271,
            "s": "Lightning Sentry",
            "n": "Lightning Sentry",
            "c": "ass"
        },
        {
            "id": 272,
            "s": "Inferno Sentry",
            "n": "Wake of Inferno",
            "c": "ass"
        },
        {
            "id": 273,
            "s": "Mind Blast",
            "n": "Mind Blast",
            "c": "ass"
        },
        {
            "id": 274,
            "s": "Blades of Ice",
            "n": "Blades of Ice",
            "c": "ass"
        },
        {
            "id": 275,
            "s": "Dragon Flight",
            "n": "Dragon Flight",
            "c": "ass"
        },
        {
            "id": 276,
            "s": "Death Sentry",
            "n": "Death Sentry",
            "c": "ass"
        },
        {
            "id": 277,
            "s": "Blade Shield",
            "n": "Blade Shield",
            "c": "ass"
        },
        {
            "id": 278,
            "s": "Venom",
            "n": "Venom",
            "c": "ass"
        },
        {
            "id": 279,
            "s": "Shadow Master",
            "n": "Shadow Master",
            "c": "ass"
        },
        {
            "id": 280,
            "s": "Royal Strike",
            "n": "Phoenix Strike",
            "c": "ass"
        },
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 350,
            "s": "Delerium Change",
            "n": "Delirium"
        },
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 357,
            "s": "Interact"
        },
        {
            "id": 358,
            "s": "Loot"
        },
        {
            "id": 359,
            "s": "TownPortal",
            "n": "Scroll of Townportal"
        },
        {
            "id": 360,
            "s": "EmoteWheel"
        },
        {
            "id": 361,
            "s": "SwapWeapons"
        },
        {
            "id": 362,
            "s": "Map"
        },
        {
            "id": 363,
            "s": "ShowItems"
        },
        {
            "id": 364,
            "s": "RunToggle"
        }
    ],
    "rare_names": [
        null,
        {
            "id": 1,
            "n": "Bite"
        },
        {
            "id": 2,
            "n": "Scratch"
        },
        {
            "id": 3,
            "n": "Scalpel"
        },
        {
            "id": 4,
            "n": "Fang"
        },
        {
            "id": 5,
            "n": "Gutter"
        },
        {
            "id": 6,
            "n": "Thirst"
        },
        {
            "id": 7,
            "n": "Razor"
        },
        {
            "id": 8,
            "n": "Scythe"
        },
        {
            "id": 9,
            "n": "Edge"
        },
        {
            "id": 10,
            "n": "Saw"
        },
        {
            "id": 11,
            "n": "Splitter"
        },
        {
            "id": 12,
            "n": "Cleaver"
        },
        {
            "id": 13,
            "n": "Sever"
        },
        {
            "id": 14,
            "n": "Sunder"
        },
        {
            "id": 15,
            "n": "Rend"
        },
        {
            "id": 16,
            "n": "Mangler"
        },
        {
            "id": 17,
            "n": "Slayer"
        },
        {
            "id": 18,
            "n": "Reaver"
        },
        {
            "id": 19,
            "n": "Spawn"
        },
        {
            "id": 20,
            "n": "Gnash"
        },
        {
            "id": 21,
            "n": "Star"
        },
        {
            "id": 22,
            "n": "Blow"
        },
        {
            "id": 23,
            "n": "Smasher"
        },
        {
            "id": 24,
            "n": "Bane"
        },
        {
            "id": 25,
            "n": "Crusher"
        },
        {
            "id": 26,
            "n": "Breaker"
        },
        {
            "id": 27,
            "n": "Grinder"
        },
        {
            "id": 28,
            "n": "Crack"
        },
        {
            "id": 29,
            "n": "Mallet"
        },
        {
            "id": 30,
            "n": "Knell"
        },
        {
            "id": 31,
            "n": "Lance"
        },
        {
            "id": 32,
            "n": "Spike"
        },
        {
            "id": 33,
            "n": "Impaler"
        },
        {
            "id": 34,
            "n": "Skewer"
        },
        {
            "id": 35,
            "n": "Prod"
        },
        {
            "id": 36,
            "n": "Scourge"
        },
        {
            "id": 37,
            "n": "Wand"
        },
        {
            "id": 38,
            "n": "Wrack"
        },
        {
            "id": 39,
            "n": "Barb"
        },
        {
            "id": 40,
            "n": "Needle"
        },
        {
            "id": 41,
            "n": "Dart"
        },
        {
            "id": 42,
            "n": "Bolt"
        },
        {
            "id": 43,
            "n": "Quarrel"
        },
        {
            "id": 44,
            "n": "Fletch"
        },
        {
            "id": 45,
            "n": "Flight"
        },
        {
            "id": 46,
            "n": "Nock"
        },
        {
            "id": 47,
            "n": "Horn"
        },
        {
            "id": 48,
            "n": "Stinger"
        },
        {
            "id": 49,
            "n": "Quill"
        },
        {
            "id": 50,
            "n": "Goad"
        },
        {
            "id": 51,
            "n": "Branch"
        },
        {
            "id": 52,
            "n": "Spire"
        },
        {
            "id": 53,
            "n": "Song"
        },
        {
            "id": 54,
            "n": "Call"
        },
        {
            "id": 55,
            "n": "Cry"
        },
        {
            "id": 56,
            "n": "Spell"
        },
        {
            "id": 57,
            "n": "Chant"
        },
        {
            "id": 58,
            "n": "Weaver"
        },
        {
            "id": 59,
            "n": "Gnarl"
        },
        {
            "id": 60,
            "n": "Visage"
        },
        {
            "id": 61,
            "n": "Crest"
        },
        {
            "id": 62,
            "n": "Circlet"
        },
        {
            "id": 63,
            "n": "Veil"
        },
        {
            "id": 64,
            "n": "Hood"
        },
        {
            "id": 65,
            "n": "Mask"
        },
        {
            "id": 66,
            "n": "Brow"
        },
        {
            "id": 67,
            "n": "Casque"
        },
        {
            "id": 68,
            "n": "Visor"
        },
        {
            "id": 69,
            "n": "Cowl"
        },
        {
            "id": 70,
            "n": "Hide"
        },
        {
            "id": 71,
            "n": "Pelt"
        },
        {
            "id": 72,
            "n": "Carapace"
        },
        {
            "id": 73,
            "n": "Coat"
        },
        {
            "id": 74,
            "n": "Wrap"
        },
        {
            "id": 75,
            "n": "Suit"
        },
        {
            "id": 76,
            "n": "Cloak"
        },
        {
            "id": 77,
            "n": "Shroud"
        },
        {
            "id": 78,
            "n": "Jack"
        },
        {
            "id": 79,
            "n": "Mantle"
        },
        {
            "id": 80,
            "n": "Guard"
        },
        {
            "id": 81,
            "n": "Badge"
        },
        {
            "id": 82,
            "n": "Rock"
        },
        {
            "id": 83,
            "n": "Aegis"
        },
        {
            "id": 84,
            "n": "Ward"
        },
        {
            "id": 85,
            "n": "Tower"
        },
        {
            "id": 86,
            "n": "Shield"
        },
        {
            "id": 87,
            "n": "Wing"
        },
        {
            "id": 88,
            "n": "Mark"
        },
        {
            "id": 89,
            "n": "Emblem"
        },
        {
            "id": 90,
            "n": "Hand"
        },
        {
            "id": 91,
            "n": "Fist"
        },
        {
            "id": 92,
            "n": "Claw"
        },
        {
            "id": 93,
            "n": "Clutches"
        },
        {
            "id": 94,
            "n": "Grip"
        },
        {
            "id": 95,
            "n": "Grasp"
        },
        {
            "id": 96,
            "n": "Hold"
        },
        {
            "id": 97,
            "n": "Touch"
        },
        {
            "id": 98,
            "n": "Finger"
        },
        {
            "id": 99,
            "n": "Knuckle"
        },
        {
            "id": 100,
            "n": "Shank"
        },
        {
            "id": 101,
            "n": "Spur"
        },
        {
            "id": 102,
            "n": "Tread"
        },
        {
            "id": 103,
            "n": "Stalker"
        },
        {
            "id": 104,
            "n": "Greaves"
        },
        {
            "id": 105,
            "n": "Blazer"
        },
        {
            "id": 106,
            "n": "Nails"
        },
        {
            "id": 107,
            "n": "Trample"
        },
        {
            "id": 108,
            "n": "Brogues"
        },
        {
            "id": 109,
            "n": "Track"
        },
        {
            "id": 110,
            "n": "Slippers"
        },
        {
            "id": 111,
            "n": "Clasp"
        },
        {
            "id": 112,
            "n": "Buckle"
        },
        {
            "id": 113,
            "n": "Harness"
        },
        {
            "id": 114,
            "n": "Lock"
        },
        {
            "id": 115,
            "n": "Fringe"
        },
        {
            "id": 116,
            "n": "Winding"
        },
        {
            "id": 117,
            "n": "Chain"
        },
        {
            "id": 118,
            "n": "Strap"
        },
        {
            "id": 119,
            "n": "Lash"
        },
        {
            "id": 120,
            "n": "Cord"
        },
        {
            "id": 121,
            "n": "Knot"
        },
        {
            "id": 122,
            "n": "Circle"
        },
        {
            "id": 123,
            "n": "Loop"
        },
        {
            "id": 124,
            "n": "Eye"
        },
        {
            "id": 125,
            "n": "Turn"
        },
        {
            "id": 126,
            "n": "Spiral"
        },
        {
            "id": 127,
            "n": "Coil"
        },
        {
            "id": 128,
            "n": "Gyre"
        },
        {
            "id": 129,
            "n": "Band"
        },
        {
            "id": 130,
            "n": "Whorl"
        },
        {
            "id": 131,
            "n": "Talisman"
        },
        {
            "id": 132,
            "n": "Heart"
        },
        {
            "id": 133,
            "n": "Noose"
        },
        {
            "id": 134,
            "n": "Necklace"
        },
        {
            "id": 135,
            "n": "Collar"
        },
        {
            "id": 136,
            "n": "Beads"
        },
        {
            "id": 137,
            "n": "Torc"
        },
        {
            "id": 138,
            "n": "Gorget"
        },
        {
            "id": 139,
            "n": "Scarab"
        },
        {
            "id": 140,
            "n": "Wood"
        },
        {
            "id": 141,
            "n": "Brand"
        },
        {
            "id": 142,
            "n": "Bludgeon"
        },
        {
            "id": 143,
            "n": "Cudgel"
        },
        {
            "id": 144,
            "n": "Loom"
        },
        {
            "id": 145,
            "n": "Harp"
        },
        {
            "id": 146,
            "n": "Master"
        },
        {
            "id": 147,
            "n": "Bar"
        },
        {
            "id": 148,
            "n": "Hew"
        },
        {
            "id": 149,
            "n": "Crook"
        },
        {
            "id": 150,
            "n": "Mar"
        },
        {
            "id": 151,
            "n": "Shell"
        },
        {
            "id": 152,
            "n": "Stake"
        },
        {
            "id": 153,
            "n": "Picket"
        },
        {
            "id": 154,
            "n": "Pale"
        },
        {
            "id": 155,
            "n": "Flange"
        },
        {
            "id": 156,
            "n": "Beast"
        },
        {
            "id": 157,
            "n": "Eagle"
        },
        {
            "id": 158,
            "n": "Raven"
        },
        {
            "id": 159,
            "n": "Viper"
        },
        {
            "id": 160,
            "n": "Ghoul"
        },
        {
            "id": 161,
            "n": "Skull"
        },
        {
            "id": 162,
            "n": "Blood"
        },
        {
            "id": 163,
            "n": "Dread"
        },
        {
            "id": 164,
            "n": "Doom"
        },
        {
            "id": 165,
            "n": "Grim"
        },
        {
            "id": 166,
            "n": "Bone"
        },
        {
            "id": 167,
            "n": "Death"
        },
        {
            "id": 168,
            "n": "Shadow"
        },
        {
            "id": 169,
            "n": "Storm"
        },
        {
            "id": 170,
            "n": "Rune"
        },
        {
            "id": 171,
            "n": "Plague"
        },
        {
            "id": 172,
            "n": "Stone"
        },
        {
            "id": 173,
            "n": "Wraith"
        },
        {
            "id": 174,
            "n": "Spirit"
        },
        {
            "id": 175,
            "n": "Storm"
        },
        {
            "id": 176,
            "n": "Demon"
        },
        {
            "id": 177,
            "n": "Cruel"
        },
        {
            "id": 178,
            "n": "Empyrian"
        },
        {
            "id": 179,
            "n": "Bramble"
        },
        {
            "id": 180,
            "n": "Pain"
        },
        {
            "id": 181,
            "n": "Loath"
        },
        {
            "id": 182,
            "n": "Glyph"
        },
        {
            "id": 183,
            "n": "Imp"
        },
        {
            "id": 184,
            "n": "Fiend"
        },
        {
            "id": 185,
            "n": "Hailstone"
        },
        {
            "id": 186,
            "n": "Gale"
        },
        {
            "id": 187,
            "n": "Dire"
        },
        {
            "id": 188,
            "n": "Soul"
        },
        {
            "id": 189,
            "n": "Brimstone"
        },
        {
            "id": 190,
            "n": "Corpse"
        },
        {
            "id": 191,
            "n": "Carrion"
        },
        {
            "id": 192,
            "n": "Armageddon"
        },
        {
            "id": 193,
            "n": "Havoc"
        },
        {
            "id": 194,
            "n": "Bitter"
        },
        {
            "id": 195,
            "n": "Entropy"
        },
        {
            "id": 196,
            "n": "Chaos"
        },
        {
            "id": 197,
            "n": "Order"
        },
        {
            "id": 198,
            "n": "Rule"
        },
        {
            "id": 199,
            "n": "Warp"
        },
        {
            "id": 200,
            "n": "Rift"
        },
        {
            "id": 201,
            "n": "Corruption"
        }
    ],
    "magic_prefixes": [
        null,
        {
            "id": 1
        },
        {
            "id": 2,
            "n": "Sturdy"
        },
        {
            "id": 3,
            "n": "Strong"
        },
        {
            "id": 4,
            "n": "Glorious"
        },
        {
            "id": 5,
            "n": "Blessed"
        },
        {
            "id": 6,
            "n": "Saintly",
            "tc": "dgld"
        },
        {
            "id": 7,
            "n": "Holy",
            "tc": "dgld"
        },
        {
            "id": 8,
            "n": "Devious",
            "tc": "dblu"
        },
        {
            "id": 9,
            "n": "Fortified",
            "tc": "dblu"
        },
        {
            "id": 10
        },
        {
            "id": 11
        },
        {
            "id": 12
        },
        {
            "id": 13,
            "n": "Jagged"
        },
        {
            "id": 14,
            "n": "Deadly"
        },
        {
            "id": 15,
            "n": "Vicious"
        },
        {
            "id": 16,
            "n": "Brutal"
        },
        {
            "id": 17,
            "n": "Massive",
            "tc": "dgld"
        },
        {
            "id": 18,
            "n": "Savage",
            "tc": "dgld"
        },
        {
            "id": 19,
            "n": "Merciless",
            "tc": "dgld"
        },
        {
            "id": 20,
            "n": "Vulpine",
            "tc": "cblu"
        },
        {
            "id": 21
        },
        {
            "id": 22
        },
        {
            "id": 23
        },
        {
            "id": 24
        },
        {
            "id": 25,
            "n": "Tireless"
        },
        {
            "id": 26,
            "n": "Rugged"
        },
        {
            "id": 27,
            "n": "Bronze"
        },
        {
            "id": 28,
            "n": "Iron"
        },
        {
            "id": 29,
            "n": "Steel"
        },
        {
            "id": 30,
            "n": "Silver"
        },
        {
            "id": 31
        },
        {
            "id": 32,
            "n": "Gold",
            "tc": "lgld"
        },
        {
            "id": 33,
            "n": "Platinum",
            "tc": "lgld"
        },
        {
            "id": 34,
            "n": "Meteoric",
            "tc": "lgld"
        },
        {
            "id": 35,
            "n": "Sharp"
        },
        {
            "id": 36,
            "n": "Fine"
        },
        {
            "id": 37,
            "n": "Warrior's"
        },
        {
            "id": 38,
            "n": "Soldier's"
        },
        {
            "id": 39,
            "n": "Knight's",
            "tc": "dgld"
        },
        {
            "id": 40,
            "n": "Lord's",
            "tc": "dgld"
        },
        {
            "id": 41,
            "n": "King's",
            "tc": "dgld"
        },
        {
            "id": 42,
            "n": "Howling",
            "tc": "oran"
        },
        {
            "id": 43,
            "n": "Fortuitous"
        },
        {
            "id": 44
        },
        {
            "id": 45
        },
        {
            "id": 46
        },
        {
            "id": 47
        },
        {
            "id": 48
        },
        {
            "id": 49,
            "n": "Glimmering"
        },
        {
            "id": 50,
            "n": "Glowing",
            "tc": "lyel"
        },
        {
            "id": 51
        },
        {
            "id": 52
        },
        {
            "id": 53,
            "n": "Lizard's"
        },
        {
            "id": 54
        },
        {
            "id": 55,
            "n": "Snake's"
        },
        {
            "id": 56,
            "n": "Serpent's"
        },
        {
            "id": 57,
            "n": "Serpent's"
        },
        {
            "id": 58,
            "n": "Drake's",
            "tc": "cblu"
        },
        {
            "id": 59,
            "n": "Dragon's",
            "tc": "cblu"
        },
        {
            "id": 60,
            "n": "Dragon's",
            "tc": "cblu"
        },
        {
            "id": 61,
            "n": "Wyrm's",
            "tc": "cblu"
        },
        {
            "id": 62
        },
        {
            "id": 63
        },
        {
            "id": 64,
            "n": "Prismatic",
            "tc": "lpur"
        },
        {
            "id": 65,
            "n": "Prismatic",
            "tc": "lpur"
        },
        {
            "id": 66,
            "n": "Azure"
        },
        {
            "id": 67,
            "n": "Lapis"
        },
        {
            "id": 68,
            "n": "Lapis"
        },
        {
            "id": 69,
            "n": "Cobalt"
        },
        {
            "id": 70,
            "n": "Cobalt"
        },
        {
            "id": 71
        },
        {
            "id": 72,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 73
        },
        {
            "id": 74
        },
        {
            "id": 75,
            "n": "Crimson"
        },
        {
            "id": 76,
            "n": "Burgundy"
        },
        {
            "id": 77,
            "n": "Burgundy"
        },
        {
            "id": 78,
            "n": "Garnet"
        },
        {
            "id": 79,
            "n": "Garnet"
        },
        {
            "id": 80
        },
        {
            "id": 81,
            "n": "Ruby",
            "tc": "lred"
        },
        {
            "id": 82
        },
        {
            "id": 83
        },
        {
            "id": 84,
            "n": "Ocher"
        },
        {
            "id": 85,
            "n": "Tangerine"
        },
        {
            "id": 86,
            "n": "Tangerine"
        },
        {
            "id": 87,
            "n": "Coral"
        },
        {
            "id": 88,
            "n": "Coral"
        },
        {
            "id": 89
        },
        {
            "id": 90,
            "n": "Amber",
            "tc": "lyel"
        },
        {
            "id": 91
        },
        {
            "id": 92
        },
        {
            "id": 93,
            "n": "Beryl"
        },
        {
            "id": 94,
            "n": "Jade"
        },
        {
            "id": 95,
            "n": "Jade"
        },
        {
            "id": 96,
            "n": "Viridian"
        },
        {
            "id": 97,
            "n": "Viridian"
        },
        {
            "id": 98
        },
        {
            "id": 99,
            "n": "Emerald",
            "tc": "lgrn"
        },
        {
            "id": 100
        },
        {
            "id": 101,
            "n": "Fletcher's"
        },
        {
            "id": 102,
            "n": "Archer's",
            "tc": "cgrn"
        },
        {
            "id": 103,
            "n": "Archer's",
            "tc": "cgrn"
        },
        {
            "id": 104,
            "n": "Monk's"
        },
        {
            "id": 105,
            "n": "Priest's",
            "tc": "cgrn"
        },
        {
            "id": 106,
            "n": "Priest's",
            "tc": "cgrn"
        },
        {
            "id": 107,
            "n": "Summoner's"
        },
        {
            "id": 108,
            "n": "Necromancer's",
            "tc": "cgrn"
        },
        {
            "id": 109,
            "n": "Necromancer's",
            "tc": "cgrn"
        },
        {
            "id": 110,
            "n": "Angel's"
        },
        {
            "id": 111,
            "n": "Arch-Angel's",
            "tc": "cgrn"
        },
        {
            "id": 112,
            "n": "Arch-Angel's",
            "tc": "cgrn"
        },
        {
            "id": 113,
            "n": "Slayer's"
        },
        {
            "id": 114,
            "n": "Berserker's",
            "tc": "cgrn"
        },
        {
            "id": 115,
            "n": "Berserker's",
            "tc": "cgrn"
        },
        {
            "id": 116
        },
        {
            "id": 117
        },
        {
            "id": 118,
            "n": "Triumphant"
        },
        {
            "id": 119,
            "n": "Stout"
        },
        {
            "id": 120,
            "n": "Stout"
        },
        {
            "id": 121,
            "n": "Stout"
        },
        {
            "id": 122,
            "n": "Burly"
        },
        {
            "id": 123,
            "n": "Burly"
        },
        {
            "id": 124,
            "n": "Burly"
        },
        {
            "id": 125,
            "n": "Stalwart"
        },
        {
            "id": 126,
            "n": "Stalwart"
        },
        {
            "id": 127,
            "n": "Stalwart"
        },
        {
            "id": 128,
            "n": "Stout"
        },
        {
            "id": 129,
            "n": "Stout"
        },
        {
            "id": 130,
            "n": "Stout"
        },
        {
            "id": 131,
            "n": "Burly"
        },
        {
            "id": 132,
            "n": "Burly"
        },
        {
            "id": 133,
            "n": "Stalwart"
        },
        {
            "id": 134,
            "n": "Stalwart"
        },
        {
            "id": 135,
            "n": "Stout"
        },
        {
            "id": 136,
            "n": "Stout"
        },
        {
            "id": 137,
            "n": "Burly"
        },
        {
            "id": 138,
            "n": "Stalwart"
        },
        {
            "id": 139,
            "n": "Blanched",
            "tc": "whit"
        },
        {
            "id": 140,
            "n": "Eburine",
            "tc": "whit"
        },
        {
            "id": 141,
            "n": "Bone",
            "tc": "whit"
        },
        {
            "id": 142,
            "n": "Ivory",
            "tc": "whit"
        },
        {
            "id": 143,
            "n": "Sturdy"
        },
        {
            "id": 144,
            "n": "Sturdy"
        },
        {
            "id": 145,
            "n": "Strong"
        },
        {
            "id": 146,
            "n": "Glorious"
        },
        {
            "id": 147,
            "n": "Blessed"
        },
        {
            "id": 148,
            "n": "Saintly",
            "tc": "dgld"
        },
        {
            "id": 149,
            "n": "Holy",
            "tc": "dgld"
        },
        {
            "id": 150,
            "n": "Godly",
            "tc": "dgld"
        },
        {
            "id": 151,
            "n": "Devious"
        },
        {
            "id": 152,
            "n": "Void"
        },
        {
            "id": 153,
            "n": "Null",
            "tc": "dblu"
        },
        {
            "id": 154,
            "n": "Antimagic",
            "tc": "dblu"
        },
        {
            "id": 155,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 156,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 157,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 158,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 159,
            "n": "Bloody",
            "tc": "dred"
        },
        {
            "id": 160,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 161,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 162,
            "n": "Bloody",
            "tc": "dred"
        },
        {
            "id": 163,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 164,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 165,
            "n": "Bloody",
            "tc": "dred"
        },
        {
            "id": 166,
            "n": "Scarlet",
            "tc": "dred"
        },
        {
            "id": 167,
            "n": "Crimson",
            "tc": "dred"
        },
        {
            "id": 168,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 169,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 170,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 171,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 172,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 173,
            "n": "Serrated",
            "tc": "blac"
        },
        {
            "id": 174,
            "n": "Serrated",
            "tc": "blac"
        },
        {
            "id": 175,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 176,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 177,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 178,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 179,
            "n": "Serrated",
            "tc": "blac"
        },
        {
            "id": 180,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 181,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 182,
            "n": "Serrated",
            "tc": "blac"
        },
        {
            "id": 183,
            "n": "Carbuncle",
            "tc": "dred"
        },
        {
            "id": 184,
            "n": "Carmine",
            "tc": "dred"
        },
        {
            "id": 185,
            "n": "Vermilion",
            "tc": "dred"
        },
        {
            "id": 186,
            "n": "Jagged"
        },
        {
            "id": 187,
            "n": "Deadly"
        },
        {
            "id": 188,
            "n": "Vicious"
        },
        {
            "id": 189,
            "n": "Brutal"
        },
        {
            "id": 190,
            "n": "Massive",
            "tc": "dgld"
        },
        {
            "id": 191,
            "n": "Savage",
            "tc": "dgld"
        },
        {
            "id": 192,
            "n": "Merciless",
            "tc": "dgld"
        },
        {
            "id": 193,
            "n": "Ferocious",
            "tc": "blac"
        },
        {
            "id": 194,
            "n": "Cruel",
            "tc": "blac"
        },
        {
            "id": 195,
            "n": "Cinnabar",
            "tc": "dred"
        },
        {
            "id": 196,
            "n": "Rusty",
            "tc": "dred"
        },
        {
            "id": 197,
            "n": "Realgar",
            "tc": "dred"
        },
        {
            "id": 198,
            "n": "Ruby",
            "tc": "dred"
        },
        {
            "id": 199,
            "n": "Vulpine",
            "tc": "cblu"
        },
        {
            "id": 200,
            "n": "Dun"
        },
        {
            "id": 201,
            "n": "Tireless"
        },
        {
            "id": 202,
            "n": "Tireless"
        },
        {
            "id": 203,
            "n": "Brown"
        },
        {
            "id": 204,
            "n": "Rugged"
        },
        {
            "id": 205,
            "n": "Rugged"
        },
        {
            "id": 206,
            "n": "Rugged"
        },
        {
            "id": 207,
            "n": "Rugged"
        },
        {
            "id": 208,
            "n": "Rugged"
        },
        {
            "id": 209,
            "n": "Rugged"
        },
        {
            "id": 210,
            "n": "Rugged"
        },
        {
            "id": 211,
            "n": "Rugged"
        },
        {
            "id": 212,
            "n": "Rugged"
        },
        {
            "id": 213,
            "n": "Rugged"
        },
        {
            "id": 214,
            "n": "Rugged"
        },
        {
            "id": 215,
            "n": "Vigorous"
        },
        {
            "id": 216,
            "n": "Chestnut"
        },
        {
            "id": 217,
            "n": "Maroon"
        },
        {
            "id": 218,
            "n": "Bronze"
        },
        {
            "id": 219,
            "n": "Bronze"
        },
        {
            "id": 220,
            "n": "Bronze"
        },
        {
            "id": 221,
            "n": "Iron"
        },
        {
            "id": 222,
            "n": "Iron"
        },
        {
            "id": 223,
            "n": "Iron"
        },
        {
            "id": 224,
            "n": "Steel"
        },
        {
            "id": 225,
            "n": "Steel"
        },
        {
            "id": 226,
            "n": "Steel"
        },
        {
            "id": 227,
            "n": "Bronze"
        },
        {
            "id": 228,
            "n": "Bronze"
        },
        {
            "id": 229,
            "n": "Bronze"
        },
        {
            "id": 230,
            "n": "Iron"
        },
        {
            "id": 231,
            "n": "Iron"
        },
        {
            "id": 232,
            "n": "Steel"
        },
        {
            "id": 233,
            "n": "Steel"
        },
        {
            "id": 234,
            "n": "Bronze"
        },
        {
            "id": 235,
            "n": "Bronze"
        },
        {
            "id": 236,
            "n": "Iron"
        },
        {
            "id": 237,
            "n": "Steel"
        },
        {
            "id": 238,
            "n": "Bronze"
        },
        {
            "id": 239,
            "n": "Iron"
        },
        {
            "id": 240,
            "n": "Steel"
        },
        {
            "id": 241,
            "n": "Silver"
        },
        {
            "id": 242,
            "n": "Gold",
            "tc": "lgld"
        },
        {
            "id": 243,
            "n": "Platinum",
            "tc": "lgld"
        },
        {
            "id": 244,
            "n": "Meteoric",
            "tc": "lgld"
        },
        {
            "id": 245,
            "n": "Strange",
            "tc": "lgld"
        },
        {
            "id": 246,
            "n": "Weird",
            "tc": "lgld"
        },
        {
            "id": 247,
            "n": "Nickel"
        },
        {
            "id": 248,
            "n": "Tin"
        },
        {
            "id": 249,
            "n": "Silver"
        },
        {
            "id": 250,
            "n": "Argent"
        },
        {
            "id": 251,
            "n": "Fine"
        },
        {
            "id": 252,
            "n": "Fine"
        },
        {
            "id": 253,
            "n": "Sharp"
        },
        {
            "id": 254,
            "n": "Fine"
        },
        {
            "id": 255,
            "n": "Sharp"
        },
        {
            "id": 256,
            "n": "Fine"
        },
        {
            "id": 257,
            "n": "Sharp"
        },
        {
            "id": 258,
            "n": "Fine"
        },
        {
            "id": 259,
            "n": "Warrior's"
        },
        {
            "id": 260,
            "n": "Soldier's"
        },
        {
            "id": 261,
            "n": "Knight's",
            "tc": "dgld"
        },
        {
            "id": 262,
            "n": "Lord's",
            "tc": "dgld"
        },
        {
            "id": 263,
            "n": "King's",
            "tc": "dgld"
        },
        {
            "id": 264,
            "n": "Master's",
            "tc": "dgld"
        },
        {
            "id": 265,
            "n": "Grandmaster's",
            "tc": "dgld"
        },
        {
            "id": 266,
            "n": "Glimmering"
        },
        {
            "id": 267,
            "n": "Glowing",
            "tc": "lyel"
        },
        {
            "id": 268,
            "n": "Bright"
        },
        {
            "id": 269,
            "n": "Screaming",
            "tc": "oran"
        },
        {
            "id": 270,
            "n": "Howling",
            "tc": "oran"
        },
        {
            "id": 271,
            "n": "Wailing",
            "tc": "oran"
        },
        {
            "id": 272,
            "n": "Screaming",
            "tc": "oran"
        },
        {
            "id": 273,
            "n": "Howling",
            "tc": "oran"
        },
        {
            "id": 274,
            "n": "Wailing",
            "tc": "oran"
        },
        {
            "id": 275,
            "n": "Lucky"
        },
        {
            "id": 276,
            "n": "Lucky"
        },
        {
            "id": 277,
            "n": "Lucky"
        },
        {
            "id": 278,
            "n": "Lucky"
        },
        {
            "id": 279,
            "n": "Lucky"
        },
        {
            "id": 280,
            "n": "Lucky"
        },
        {
            "id": 281,
            "n": "Felicitous"
        },
        {
            "id": 282,
            "n": "Fortuitous"
        },
        {
            "id": 283,
            "n": "Emerald"
        },
        {
            "id": 284,
            "n": "Lizard's"
        },
        {
            "id": 285,
            "n": "Lizard's"
        },
        {
            "id": 286,
            "n": "Lizard's"
        },
        {
            "id": 287,
            "n": "Snake's"
        },
        {
            "id": 288,
            "n": "Snake's"
        },
        {
            "id": 289,
            "n": "Snake's"
        },
        {
            "id": 290,
            "n": "Serpent's"
        },
        {
            "id": 291,
            "n": "Serpent's"
        },
        {
            "id": 292,
            "n": "Serpent's"
        },
        {
            "id": 293,
            "n": "Lizard's"
        },
        {
            "id": 294,
            "n": "Lizard's"
        },
        {
            "id": 295,
            "n": "Lizard's"
        },
        {
            "id": 296,
            "n": "Snake's"
        },
        {
            "id": 297,
            "n": "Snake's"
        },
        {
            "id": 298,
            "n": "Serpent's"
        },
        {
            "id": 299,
            "n": "Serpent's"
        },
        {
            "id": 300,
            "n": "Lizard's"
        },
        {
            "id": 301,
            "n": "Lizard's"
        },
        {
            "id": 302,
            "n": "Snake's"
        },
        {
            "id": 303,
            "n": "Serpent's"
        },
        {
            "id": 304,
            "n": "Lizard's"
        },
        {
            "id": 305,
            "n": "Snake's"
        },
        {
            "id": 306,
            "n": "Serpent's"
        },
        {
            "id": 307,
            "n": "Serpent's"
        },
        {
            "id": 308,
            "n": "Drake's",
            "tc": "cblu"
        },
        {
            "id": 309,
            "n": "Dragon's",
            "tc": "cblu"
        },
        {
            "id": 310,
            "n": "Dragon's",
            "tc": "cblu"
        },
        {
            "id": 311,
            "n": "Wyrm's",
            "tc": "cblu"
        },
        {
            "id": 312,
            "n": "Great Wyrm's",
            "tc": "cblu"
        },
        {
            "id": 313,
            "n": "Bahamut's",
            "tc": "cblu"
        },
        {
            "id": 314,
            "n": "Zircon",
            "tc": "cblu"
        },
        {
            "id": 315,
            "n": "Jacinth",
            "tc": "cblu"
        },
        {
            "id": 316,
            "n": "Turquoise",
            "tc": "cblu"
        },
        {
            "id": 317,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 318,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 319,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 320,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 321,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 322,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 323,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 324,
            "n": "Rainbow",
            "tc": "lpur"
        },
        {
            "id": 325,
            "n": "Scintillating",
            "tc": "lpur"
        },
        {
            "id": 326,
            "n": "Prismatic",
            "tc": "lpur"
        },
        {
            "id": 327,
            "n": "Chromatic",
            "tc": "lpur"
        },
        {
            "id": 328,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 329,
            "n": "Rainbow",
            "tc": "lpur"
        },
        {
            "id": 330,
            "n": "Scintillating",
            "tc": "lpur"
        },
        {
            "id": 331,
            "n": "Prismatic",
            "tc": "lpur"
        },
        {
            "id": 332,
            "n": "Chromatic",
            "tc": "lpur"
        },
        {
            "id": 333,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 334,
            "n": "Rainbow",
            "tc": "lpur"
        },
        {
            "id": 335,
            "n": "Scintillating",
            "tc": "lpur"
        },
        {
            "id": 336,
            "n": "Shimmering",
            "tc": "lpur"
        },
        {
            "id": 337,
            "n": "Scintillating",
            "tc": "lpur"
        },
        {
            "id": 338,
            "n": "Azure"
        },
        {
            "id": 339,
            "n": "Lapis"
        },
        {
            "id": 340,
            "n": "Cobalt",
            "tc": "lblu"
        },
        {
            "id": 341,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 342,
            "n": "Azure"
        },
        {
            "id": 343,
            "n": "Lapis"
        },
        {
            "id": 344,
            "n": "Cobalt",
            "tc": "lblu"
        },
        {
            "id": 345,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 346,
            "n": "Azure"
        },
        {
            "id": 347,
            "n": "Lapis"
        },
        {
            "id": 348,
            "n": "Cobalt",
            "tc": "lblu"
        },
        {
            "id": 349,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 350,
            "n": "Azure"
        },
        {
            "id": 351,
            "n": "Lapis"
        },
        {
            "id": 352,
            "n": "Lapis"
        },
        {
            "id": 353,
            "n": "Cobalt"
        },
        {
            "id": 354,
            "n": "Cobalt"
        },
        {
            "id": 355,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 356,
            "n": "Lapis Lazuli",
            "tc": "lblu"
        },
        {
            "id": 357,
            "n": "Sapphire",
            "tc": "lblu"
        },
        {
            "id": 358,
            "n": "Crimson"
        },
        {
            "id": 359,
            "n": "Russet"
        },
        {
            "id": 360,
            "n": "Garnet",
            "tc": "lred"
        },
        {
            "id": 361,
            "n": "Ruby",
            "tc": "lred"
        },
        {
            "id": 362,
            "n": "Crimson"
        },
        {
            "id": 363,
            "n": "Russet"
        },
        {
            "id": 364,
            "n": "Garnet",
            "tc": "lred"
        },
        {
            "id": 365,
            "n": "Ruby",
            "tc": "lred"
        },
        {
            "id": 366,
            "n": "Crimson"
        },
        {
            "id": 367,
            "n": "Russet",
            "tc": "lred"
        },
        {
            "id": 368,
            "n": "Garnet",
            "tc": "lred"
        },
        {
            "id": 369,
            "n": "Ruby"
        },
        {
            "id": 370,
            "n": "Russet"
        },
        {
            "id": 371,
            "n": "Russet"
        },
        {
            "id": 372,
            "n": "Garnet"
        },
        {
            "id": 373,
            "n": "Garnet"
        },
        {
            "id": 374,
            "n": "Ruby",
            "tc": "lred"
        },
        {
            "id": 375,
            "n": "Garnet",
            "tc": "lred"
        },
        {
            "id": 376,
            "n": "Ruby",
            "tc": "lred"
        },
        {
            "id": 377,
            "n": "Tangerine"
        },
        {
            "id": 378,
            "n": "Ocher"
        },
        {
            "id": 379,
            "n": "Coral",
            "tc": "lyel"
        },
        {
            "id": 380,
            "n": "Amber",
            "tc": "lyel"
        },
        {
            "id": 381,
            "n": "Tangerine"
        },
        {
            "id": 382,
            "n": "Ocher"
        },
        {
            "id": 383,
            "n": "Coral",
            "tc": "lyel"
        },
        {
            "id": 384,
            "n": "Amber",
            "tc": "lyel"
        },
        {
            "id": 385,
            "n": "Tangerine"
        },
        {
            "id": 386,
            "n": "Ocher"
        },
        {
            "id": 387,
            "n": "Coral",
            "tc": "lyel"
        },
        {
            "id": 388,
            "n": "Amber",
            "tc": "lyel"
        },
        {
            "id": 389,
            "n": "Tangerine"
        },
        {
            "id": 390,
            "n": "Ocher"
        },
        {
            "id": 391,
            "n": "Ocher"
        },
        {
            "id": 392,
            "n": "Coral"
        },
        {
            "id": 393,
            "n": "Coral"
        },
        {
            "id": 394,
            "n": "Amber",
            "tc": "lyel"
        },
        {
            "id": 395,
            "n": "Camphor",
            "tc": "lyel"
        },
        {
            "id": 396,
            "n": "Ambergris",
            "tc": "lyel"
        },
        {
            "id": 397,
            "n": "Beryl"
        },
        {
            "id": 398,
            "n": "Viridian"
        },
        {
            "id": 399,
            "n": "Jade",
            "tc": "cgrn"
        },
        {
            "id": 400,
            "n": "Emerald",
            "tc": "cgrn"
        },
        {
            "id": 401,
            "n": "Beryl"
        },
        {
            "id": 402,
            "n": "Viridian"
        },
        {
            "id": 403,
            "n": "Jade",
            "tc": "cgrn"
        },
        {
            "id": 404,
            "n": "Emerald",
            "tc": "cgrn"
        },
        {
            "id": 405,
            "n": "Beryl"
        },
        {
            "id": 406,
            "n": "Viridian"
        },
        {
            "id": 407,
            "n": "Jade",
            "tc": "cgrn"
        },
        {
            "id": 408,
            "n": "Emerald",
            "tc": "cgrn"
        },
        {
            "id": 409,
            "n": "Beryl"
        },
        {
            "id": 410,
            "n": "Viridian"
        },
        {
            "id": 411,
            "n": "Viridian"
        },
        {
            "id": 412,
            "n": "Jade"
        },
        {
            "id": 413,
            "n": "Jade"
        },
        {
            "id": 414,
            "n": "Emerald",
            "tc": "cgrn"
        },
        {
            "id": 415,
            "n": "Beryl",
            "tc": "cgrn"
        },
        {
            "id": 416,
            "n": "Jade",
            "tc": "cgrn"
        },
        {
            "id": 417,
            "n": "Triumphant"
        },
        {
            "id": 418,
            "n": "Victorious"
        },
        {
            "id": 419,
            "n": "Aureolic"
        },
        {
            "id": 420,
            "n": "Mechanic's"
        },
        {
            "id": 421,
            "n": "Artisan's"
        },
        {
            "id": 422,
            "n": "Jeweler's"
        },
        {
            "id": 423,
            "n": "Lunar"
        },
        {
            "id": 424,
            "n": "Arcadian"
        },
        {
            "id": 425,
            "n": "Unearthly"
        },
        {
            "id": 426,
            "n": "Astral"
        },
        {
            "id": 427,
            "n": "Elysian",
            "tc": "dgld"
        },
        {
            "id": 428,
            "n": "Celestial",
            "tc": "dgld"
        },
        {
            "id": 429,
            "n": "Diamond"
        },
        {
            "id": 430,
            "n": "Fletcher's"
        },
        {
            "id": 431,
            "n": "Acrobatic"
        },
        {
            "id": 432,
            "n": "Harpoonist's"
        },
        {
            "id": 433,
            "n": "Fletcher's"
        },
        {
            "id": 434,
            "n": "Bowyer's",
            "tc": "lgld"
        },
        {
            "id": 435,
            "n": "Archer's",
            "tc": "lgld"
        },
        {
            "id": 436,
            "n": "Acrobatic"
        },
        {
            "id": 437,
            "n": "Gymnastic",
            "tc": "lgld"
        },
        {
            "id": 438,
            "n": "Athletic",
            "tc": "lgld"
        },
        {
            "id": 439,
            "n": "Harpoonist's"
        },
        {
            "id": 440,
            "n": "Spearmaiden's",
            "tc": "lgld"
        },
        {
            "id": 441,
            "n": "Lancer's",
            "tc": "lgld"
        },
        {
            "id": 442,
            "n": "Burning"
        },
        {
            "id": 443,
            "n": "Sparking"
        },
        {
            "id": 444,
            "n": "Chilling"
        },
        {
            "id": 445,
            "n": "Burning"
        },
        {
            "id": 446,
            "n": "Blazing",
            "tc": "lgld"
        },
        {
            "id": 447,
            "n": "Volcanic",
            "tc": "lgld"
        },
        {
            "id": 448,
            "n": "Sparking"
        },
        {
            "id": 449,
            "n": "Charged",
            "tc": "lgld"
        },
        {
            "id": 450,
            "n": "Powered",
            "tc": "lgld"
        },
        {
            "id": 451,
            "n": "Chilling"
        },
        {
            "id": 452,
            "n": "Freezing",
            "tc": "lgld"
        },
        {
            "id": 453,
            "n": "Glacial",
            "tc": "lgld"
        },
        {
            "id": 454,
            "n": "Hexing"
        },
        {
            "id": 455,
            "n": "Fungal"
        },
        {
            "id": 456,
            "n": "Graverobber's"
        },
        {
            "id": 457,
            "n": "Hexing"
        },
        {
            "id": 458,
            "n": "Blighting",
            "tc": "lgld"
        },
        {
            "id": 459,
            "n": "Cursing",
            "tc": "lgld"
        },
        {
            "id": 460,
            "n": "Fungal"
        },
        {
            "id": 461,
            "n": "Noxious",
            "tc": "lgld"
        },
        {
            "id": 462,
            "n": "Venomous",
            "tc": "lgld"
        },
        {
            "id": 463,
            "n": "Graverobber's"
        },
        {
            "id": 464,
            "n": "Mojo",
            "tc": "lgld"
        },
        {
            "id": 465,
            "n": "Golemlord's",
            "tc": "lgld"
        },
        {
            "id": 466,
            "n": "Lion Branded"
        },
        {
            "id": 467,
            "n": "Captain's"
        },
        {
            "id": 468,
            "n": "Preserver's"
        },
        {
            "id": 469,
            "n": "Lion Branded"
        },
        {
            "id": 470,
            "n": "Hawk Branded",
            "tc": "lgld"
        },
        {
            "id": 471,
            "n": "Rose Branded",
            "tc": "lgld"
        },
        {
            "id": 472,
            "n": "Captain's"
        },
        {
            "id": 473,
            "n": "Commander's",
            "tc": "lgld"
        },
        {
            "id": 474,
            "n": "Marshal's",
            "tc": "lgld"
        },
        {
            "id": 475,
            "n": "Preserver's"
        },
        {
            "id": 476,
            "n": "Warden's",
            "tc": "lgld"
        },
        {
            "id": 477,
            "n": "Guardian's",
            "tc": "lgld"
        },
        {
            "id": 478,
            "n": "Expert's"
        },
        {
            "id": 479,
            "n": "Fanatic"
        },
        {
            "id": 480,
            "n": "Sounding"
        },
        {
            "id": 481,
            "n": "Expert's"
        },
        {
            "id": 482,
            "n": "Veteran's",
            "tc": "lgld"
        },
        {
            "id": 483,
            "n": "Master's",
            "tc": "lgld"
        },
        {
            "id": 484,
            "n": "Fanatic"
        },
        {
            "id": 485,
            "n": "Raging",
            "tc": "lgld"
        },
        {
            "id": 486,
            "n": "Furious",
            "tc": "lgld"
        },
        {
            "id": 487,
            "n": "Sounding"
        },
        {
            "id": 488,
            "n": "Resonant",
            "tc": "lgld"
        },
        {
            "id": 489,
            "n": "Echoing",
            "tc": "lgld"
        },
        {
            "id": 490,
            "n": "Trainer's"
        },
        {
            "id": 491,
            "n": "Spiritual"
        },
        {
            "id": 492,
            "n": "Natural"
        },
        {
            "id": 493,
            "n": "Trainer's"
        },
        {
            "id": 494,
            "n": "Caretaker's",
            "tc": "lgld"
        },
        {
            "id": 495,
            "n": "Keeper's",
            "tc": "lgld"
        },
        {
            "id": 496,
            "n": "Spiritual"
        },
        {
            "id": 497,
            "n": "Feral",
            "tc": "lgld"
        },
        {
            "id": 498,
            "n": "Communal",
            "tc": "lgld"
        },
        {
            "id": 499,
            "n": "Natural"
        },
        {
            "id": 500,
            "n": "Terrene",
            "tc": "lgld"
        },
        {
            "id": 501,
            "n": "Gaean",
            "tc": "lgld"
        },
        {
            "id": 502,
            "n": "Entrapping"
        },
        {
            "id": 503,
            "n": "Mentalist's"
        },
        {
            "id": 504,
            "n": "Shogukusha's"
        },
        {
            "id": 505,
            "n": "Entrapping"
        },
        {
            "id": 506,
            "n": "Trickster's",
            "tc": "lgld"
        },
        {
            "id": 507,
            "n": "Cunning",
            "tc": "lgld"
        },
        {
            "id": 508,
            "n": "Mentalist's"
        },
        {
            "id": 509,
            "n": "Psychic",
            "tc": "lgld"
        },
        {
            "id": 510,
            "n": "Shadow",
            "tc": "lgld"
        },
        {
            "id": 511,
            "n": "Shogukusha's"
        },
        {
            "id": 512,
            "n": "Sensei's",
            "tc": "lgld"
        },
        {
            "id": 513,
            "n": "Kenshi's",
            "tc": "lgld"
        },
        {
            "id": 514,
            "n": "Enlightened",
            "tc": "whit"
        },
        {
            "id": 515,
            "n": "Enlightened",
            "tc": "whit"
        },
        {
            "id": 516,
            "n": "Honorable",
            "tc": "whit"
        },
        {
            "id": 517,
            "n": "Honorable",
            "tc": "whit"
        },
        {
            "id": 518,
            "n": "Righteous",
            "tc": "whit"
        },
        {
            "id": 519,
            "n": "Righteous",
            "tc": "whit"
        },
        {
            "id": 520,
            "n": "Faithful",
            "tc": "whit"
        },
        {
            "id": 521,
            "n": "Faithful",
            "tc": "whit"
        },
        {
            "id": 522,
            "n": "Knave's",
            "tc": "whit"
        },
        {
            "id": 523,
            "n": "Jack's",
            "tc": "whit"
        },
        {
            "id": 524,
            "n": "Jester's",
            "tc": "whit"
        },
        {
            "id": 525,
            "n": "Joker's",
            "tc": "whit"
        },
        {
            "id": 526,
            "n": "Fool's",
            "tc": "whit"
        },
        {
            "id": 527,
            "n": "Alarming",
            "tc": "whit"
        },
        {
            "id": 528,
            "n": "Calling",
            "tc": "whit"
        },
        {
            "id": 529,
            "n": "Yelling",
            "tc": "whit"
        },
        {
            "id": 530,
            "n": "Howling",
            "tc": "whit"
        },
        {
            "id": 531,
            "n": "Grinding",
            "tc": "whit"
        },
        {
            "id": 532,
            "n": "Paradox",
            "tc": "whit"
        },
        {
            "id": 533,
            "n": "Paradox",
            "tc": "whit"
        },
        {
            "id": 534,
            "n": "Robineye",
            "tc": "whit"
        },
        {
            "id": 535,
            "n": "Sparroweye",
            "tc": "whit"
        },
        {
            "id": 536,
            "n": "Falconeye",
            "tc": "whit"
        },
        {
            "id": 537,
            "n": "Hawkeye",
            "tc": "whit"
        },
        {
            "id": 538,
            "n": "Eagleeye",
            "tc": "whit"
        },
        {
            "id": 539,
            "n": "Visionary",
            "tc": "whit"
        },
        {
            "id": 540,
            "n": "Mnemonic",
            "tc": "cblu"
        },
        {
            "id": 541,
            "n": "Snowy",
            "tc": "lblu"
        },
        {
            "id": 542,
            "n": "Shivering",
            "tc": "lblu"
        },
        {
            "id": 543,
            "n": "Boreal",
            "tc": "lblu"
        },
        {
            "id": 544,
            "n": "Hibernal",
            "tc": "lblu"
        },
        {
            "id": 545,
            "n": "Fiery",
            "tc": "dred"
        },
        {
            "id": 546,
            "n": "Smoldering",
            "tc": "dred"
        },
        {
            "id": 547,
            "n": "Smoking",
            "tc": "dred"
        },
        {
            "id": 548,
            "n": "Flaming",
            "tc": "dred"
        },
        {
            "id": 549,
            "n": "Condensing",
            "tc": "dred"
        },
        {
            "id": 550,
            "n": "Static",
            "tc": "lyel"
        },
        {
            "id": 551,
            "n": "Glowing",
            "tc": "lyel"
        },
        {
            "id": 552,
            "n": "Buzzing",
            "tc": "lyel"
        },
        {
            "id": 553,
            "n": "Arcing",
            "tc": "lyel"
        },
        {
            "id": 554,
            "n": "Shocking",
            "tc": "lyel"
        },
        {
            "id": 555,
            "n": "Septic",
            "tc": "dgrn"
        },
        {
            "id": 556,
            "n": "Foul",
            "tc": "dgrn"
        },
        {
            "id": 557,
            "n": "Corrosive",
            "tc": "dgrn"
        },
        {
            "id": 558,
            "n": "Toxic",
            "tc": "dgrn"
        },
        {
            "id": 559,
            "n": "Pestilent",
            "tc": "dgrn"
        },
        {
            "id": 560,
            "n": "Maiden's"
        },
        {
            "id": 561,
            "n": "Valkyrie's",
            "tc": "cgrn"
        },
        {
            "id": 562,
            "n": "Maiden's"
        },
        {
            "id": 563,
            "n": "Valkyrie's",
            "tc": "cgrn"
        },
        {
            "id": 564,
            "n": "Monk's"
        },
        {
            "id": 565,
            "n": "Priest's",
            "tc": "cgrn"
        },
        {
            "id": 566,
            "n": "Monk's"
        },
        {
            "id": 567,
            "n": "Priest's",
            "tc": "cgrn"
        },
        {
            "id": 568,
            "n": "Monk's"
        },
        {
            "id": 569,
            "n": "Priest's",
            "tc": "cgrn"
        },
        {
            "id": 570,
            "n": "Summoner's"
        },
        {
            "id": 571,
            "n": "Necromancer's",
            "tc": "cgrn"
        },
        {
            "id": 572,
            "n": "Summoner's"
        },
        {
            "id": 573,
            "n": "Necromancer's",
            "tc": "cgrn"
        },
        {
            "id": 574,
            "n": "Angel's"
        },
        {
            "id": 575,
            "n": "Arch-Angel's",
            "tc": "cgrn"
        },
        {
            "id": 576,
            "n": "Angel's"
        },
        {
            "id": 577,
            "n": "Arch-Angel's",
            "tc": "cgrn"
        },
        {
            "id": 578,
            "n": "Slayer's"
        },
        {
            "id": 579,
            "n": "Berserker's",
            "tc": "cgrn"
        },
        {
            "id": 580,
            "n": "Slayer's"
        },
        {
            "id": 581,
            "n": "Berserker's",
            "tc": "cgrn"
        },
        {
            "id": 582,
            "n": "Slayer's"
        },
        {
            "id": 583,
            "n": "Berserker's",
            "tc": "cgrn"
        },
        {
            "id": 584,
            "n": "Shaman's"
        },
        {
            "id": 585,
            "n": "Hierophant's",
            "tc": "cgrn"
        },
        {
            "id": 586,
            "n": "Shaman's"
        },
        {
            "id": 587,
            "n": "Hierophant's",
            "tc": "cgrn"
        },
        {
            "id": 588,
            "n": "Magekiller's"
        },
        {
            "id": 589,
            "n": "Witch-hunter's",
            "tc": "cgrn"
        },
        {
            "id": 590,
            "n": "Magekiller's"
        },
        {
            "id": 591,
            "n": "Witch-hunter's",
            "tc": "cgrn"
        },
        {
            "id": 592,
            "n": "Compact"
        },
        {
            "id": 593,
            "n": "Thin"
        },
        {
            "id": 594,
            "n": "Dense"
        },
        {
            "id": 595,
            "n": "Consecrated"
        },
        {
            "id": 596,
            "n": "Pure",
            "tc": "lgld"
        },
        {
            "id": 597,
            "n": "Sacred",
            "tc": "lgld"
        },
        {
            "id": 598,
            "n": "Hallowed",
            "tc": "lgld"
        },
        {
            "id": 599,
            "n": "Divine",
            "tc": "lgld"
        },
        {
            "id": 600,
            "n": "Pearl"
        },
        {
            "id": 601,
            "n": "Crimson"
        },
        {
            "id": 602,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 603,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 604,
            "n": "Bloody",
            "tc": "dred"
        },
        {
            "id": 605,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 606,
            "n": "Sanguinary",
            "tc": "dred"
        },
        {
            "id": 607,
            "n": "Red",
            "tc": "dred"
        },
        {
            "id": 608,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 609,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 610,
            "n": "Serrated",
            "tc": "blac"
        },
        {
            "id": 611,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 612,
            "n": "Forked",
            "tc": "blac"
        },
        {
            "id": 613,
            "n": "Jagged",
            "tc": "blac"
        },
        {
            "id": 614,
            "n": "Snowy"
        },
        {
            "id": 615,
            "n": "Shivering"
        },
        {
            "id": 616,
            "n": "Boreal",
            "tc": "lblu"
        },
        {
            "id": 617,
            "n": "Hibernal",
            "tc": "lblu"
        },
        {
            "id": 618,
            "n": "Snowy"
        },
        {
            "id": 619,
            "n": "Shivering"
        },
        {
            "id": 620,
            "n": "Boreal",
            "tc": "lblu"
        },
        {
            "id": 621,
            "n": "Hibernal",
            "tc": "lblu"
        },
        {
            "id": 622,
            "n": "Snowy"
        },
        {
            "id": 623,
            "n": "Shivering"
        },
        {
            "id": 624,
            "n": "Boreal",
            "tc": "lblu"
        },
        {
            "id": 625,
            "n": "Hibernal",
            "tc": "lblu"
        },
        {
            "id": 626,
            "n": "Fiery"
        },
        {
            "id": 627,
            "n": "Smoldering"
        },
        {
            "id": 628,
            "n": "Smoking",
            "tc": "lred"
        },
        {
            "id": 629,
            "n": "Flaming",
            "tc": "lred"
        },
        {
            "id": 630,
            "n": "Fiery"
        },
        {
            "id": 631,
            "n": "Smoldering"
        },
        {
            "id": 632,
            "n": "Smoking",
            "tc": "lred"
        },
        {
            "id": 633,
            "n": "Flaming",
            "tc": "lred"
        },
        {
            "id": 634,
            "n": "Fiery"
        },
        {
            "id": 635,
            "n": "Smoldering"
        },
        {
            "id": 636,
            "n": "Smoking",
            "tc": "lred"
        },
        {
            "id": 637,
            "n": "Flaming",
            "tc": "lred"
        },
        {
            "id": 638,
            "n": "Static"
        },
        {
            "id": 639,
            "n": "Glowing"
        },
        {
            "id": 640,
            "n": "Arcing",
            "tc": "whit"
        },
        {
            "id": 641,
            "n": "Shocking",
            "tc": "whit"
        },
        {
            "id": 642,
            "n": "Static"
        },
        {
            "id": 643,
            "n": "Glowing"
        },
        {
            "id": 644,
            "n": "Arcing",
            "tc": "whit"
        },
        {
            "id": 645,
            "n": "Shocking",
            "tc": "whit"
        },
        {
            "id": 646,
            "n": "Static"
        },
        {
            "id": 647,
            "n": "Glowing"
        },
        {
            "id": 648,
            "n": "Arcing",
            "tc": "whit"
        },
        {
            "id": 649,
            "n": "Shocking",
            "tc": "whit"
        },
        {
            "id": 650,
            "n": "Septic"
        },
        {
            "id": 651,
            "n": "Foul"
        },
        {
            "id": 652,
            "n": "Toxic",
            "tc": "dgrn"
        },
        {
            "id": 653,
            "n": "Pestilent",
            "tc": "dgrn"
        },
        {
            "id": 654,
            "n": "Septic"
        },
        {
            "id": 655,
            "n": "Foul"
        },
        {
            "id": 656,
            "n": "Toxic",
            "tc": "dgrn"
        },
        {
            "id": 657,
            "n": "Pestilent",
            "tc": "dgrn"
        },
        {
            "id": 658,
            "n": "Septic"
        },
        {
            "id": 659,
            "n": "Foul"
        },
        {
            "id": 660,
            "n": "Toxic",
            "tc": "dgrn"
        },
        {
            "id": 661,
            "n": "Pestilent",
            "tc": "dgrn"
        },
        {
            "id": 662,
            "n": "Tireless"
        },
        {
            "id": 663,
            "n": "Lizard's"
        },
        {
            "id": 664,
            "n": "Azure"
        },
        {
            "id": 665,
            "n": "Crimson"
        },
        {
            "id": 666,
            "n": "Tangerine"
        },
        {
            "id": 667,
            "n": "Beryl"
        },
        {
            "id": 668,
            "n": "Godly",
            "tc": "dgld"
        },
        {
            "id": 669,
            "n": "Cruel",
            "tc": "blac"
        },
        {
            "id": 670
        }
    ],
    "magic_suffixes": [
        null,
        {
            "id": 1,
            "n": "of Health"
        },
        {
            "id": 2,
            "n": "of Protection"
        },
        {
            "id": 3,
            "n": "of Absorption"
        },
        {
            "id": 4,
            "n": "of Life",
            "tc": "dblu"
        },
        {
            "id": 5
        },
        {
            "id": 6,
            "n": "of Warding"
        },
        {
            "id": 7,
            "n": "of the Sentinel"
        },
        {
            "id": 8,
            "n": "of Guarding"
        },
        {
            "id": 9,
            "n": "of Negation"
        },
        {
            "id": 10
        },
        {
            "id": 11,
            "n": "of Piercing"
        },
        {
            "id": 12,
            "n": "of Bashing"
        },
        {
            "id": 13,
            "n": "of Puncturing"
        },
        {
            "id": 14,
            "n": "of Thorns"
        },
        {
            "id": 15,
            "n": "of Spikes",
            "tc": "oran"
        },
        {
            "id": 16,
            "n": "of Readiness"
        },
        {
            "id": 17,
            "n": "of Alacrity"
        },
        {
            "id": 18,
            "n": "of Swiftness"
        },
        {
            "id": 19,
            "n": "of Quickness",
            "tc": "dyel"
        },
        {
            "id": 20,
            "n": "of Blocking"
        },
        {
            "id": 21,
            "n": "of Deflecting"
        },
        {
            "id": 22,
            "n": "of the Apprentice"
        },
        {
            "id": 23,
            "n": "of the Magus"
        },
        {
            "id": 24,
            "n": "of Frost"
        },
        {
            "id": 25,
            "n": "of the Glacier"
        },
        {
            "id": 26,
            "n": "of Frost"
        },
        {
            "id": 27,
            "n": "of Thawing"
        },
        {
            "id": 28,
            "n": "of Flame"
        },
        {
            "id": 29,
            "n": "of Fire"
        },
        {
            "id": 30,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 31,
            "n": "of Flame"
        },
        {
            "id": 32,
            "n": "of Shock"
        },
        {
            "id": 33,
            "n": "of Lightning"
        },
        {
            "id": 34,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 35,
            "n": "of Shock"
        },
        {
            "id": 36,
            "n": "of Craftmanship"
        },
        {
            "id": 37,
            "n": "of Quality"
        },
        {
            "id": 38,
            "n": "of Maiming"
        },
        {
            "id": 39,
            "n": "of Slaying"
        },
        {
            "id": 40,
            "n": "of Gore"
        },
        {
            "id": 41,
            "n": "of Carnage",
            "tc": "blac"
        },
        {
            "id": 42,
            "n": "of Slaughter",
            "tc": "blac"
        },
        {
            "id": 43,
            "n": "of Maiming"
        },
        {
            "id": 44,
            "n": "of Worth"
        },
        {
            "id": 45,
            "n": "of Measure"
        },
        {
            "id": 46,
            "n": "of Excellence"
        },
        {
            "id": 47,
            "n": "of Performance",
            "tc": "blac"
        },
        {
            "id": 48,
            "n": "of Measure"
        },
        {
            "id": 49,
            "n": "of Blight"
        },
        {
            "id": 50,
            "n": "of Venom"
        },
        {
            "id": 51,
            "n": "of Pestilence",
            "tc": "dgrn"
        },
        {
            "id": 52,
            "n": "of Blight"
        },
        {
            "id": 53,
            "n": "of Dexterity"
        },
        {
            "id": 54,
            "n": "of Dexterity"
        },
        {
            "id": 55,
            "n": "of Skill"
        },
        {
            "id": 56,
            "n": "of Skill"
        },
        {
            "id": 57,
            "n": "of Accuracy"
        },
        {
            "id": 58,
            "n": "of Precision"
        },
        {
            "id": 59,
            "n": "of Precision"
        },
        {
            "id": 60,
            "n": "of Perfection",
            "tc": "dgld"
        },
        {
            "id": 61,
            "n": "of Balance"
        },
        {
            "id": 62,
            "n": "of Stability",
            "tc": "dyel"
        },
        {
            "id": 63
        },
        {
            "id": 64,
            "n": "of Regeneration"
        },
        {
            "id": 65,
            "n": "of Regeneration"
        },
        {
            "id": 66,
            "n": "of Regeneration"
        },
        {
            "id": 67,
            "n": "of Regrowth",
            "tc": "cred"
        },
        {
            "id": 68,
            "n": "of Regrowth",
            "tc": "cred"
        },
        {
            "id": 69,
            "n": "of Vileness"
        },
        {
            "id": 70
        },
        {
            "id": 71,
            "n": "of Greed"
        },
        {
            "id": 72,
            "n": "of Wealth",
            "tc": "lgld"
        },
        {
            "id": 73,
            "n": "of Chance"
        },
        {
            "id": 74,
            "n": "of Fortune",
            "tc": "lgld"
        },
        {
            "id": 75,
            "n": "of Energy"
        },
        {
            "id": 76,
            "n": "of Energy"
        },
        {
            "id": 77,
            "n": "of the Mind"
        },
        {
            "id": 78,
            "n": "of Brilliance"
        },
        {
            "id": 79,
            "n": "of Sorcery",
            "tc": "dgld"
        },
        {
            "id": 80,
            "n": "of Wizardry",
            "tc": "dgld"
        },
        {
            "id": 81,
            "n": "of the Bear"
        },
        {
            "id": 82,
            "n": "of Light"
        },
        {
            "id": 83,
            "n": "of Radiance"
        },
        {
            "id": 84,
            "n": "of the Sun"
        },
        {
            "id": 85,
            "n": "of Life"
        },
        {
            "id": 86,
            "n": "of the Jackal"
        },
        {
            "id": 87,
            "n": "of the Fox"
        },
        {
            "id": 88,
            "n": "of the Wolf"
        },
        {
            "id": 89,
            "n": "of the Wolf"
        },
        {
            "id": 90,
            "n": "of the Tiger"
        },
        {
            "id": 91,
            "n": "of the Mammoth",
            "tc": "cred"
        },
        {
            "id": 92,
            "n": "of the Mammoth",
            "tc": "cred"
        },
        {
            "id": 93,
            "n": "of the Colossus",
            "tc": "cred"
        },
        {
            "id": 94,
            "n": "of the Leech"
        },
        {
            "id": 95,
            "n": "of the Locust",
            "tc": "cred"
        },
        {
            "id": 96,
            "n": "of the Bat"
        },
        {
            "id": 97,
            "n": "of the Vampire",
            "tc": "cblu"
        },
        {
            "id": 98,
            "n": "of Defiance",
            "tc": "dred"
        },
        {
            "id": 99,
            "n": "of Amelioration"
        },
        {
            "id": 100,
            "n": "of Remedy"
        },
        {
            "id": 101
        },
        {
            "id": 102,
            "n": "of Simplicity"
        },
        {
            "id": 103,
            "n": "of Ease"
        },
        {
            "id": 104
        },
        {
            "id": 105,
            "n": "of Strength"
        },
        {
            "id": 106,
            "n": "of Might"
        },
        {
            "id": 107,
            "n": "of the Ox"
        },
        {
            "id": 108,
            "n": "of the Ox"
        },
        {
            "id": 109,
            "n": "of the Giant",
            "tc": "dgld"
        },
        {
            "id": 110,
            "n": "of the Giant",
            "tc": "dgld"
        },
        {
            "id": 111,
            "n": "of the Titan",
            "tc": "dgld"
        },
        {
            "id": 112,
            "n": "of Pacing"
        },
        {
            "id": 113,
            "n": "of Haste"
        },
        {
            "id": 114,
            "n": "of Speed"
        },
        {
            "id": 115,
            "n": "of Health"
        },
        {
            "id": 116,
            "n": "of Protection"
        },
        {
            "id": 117,
            "n": "of Absorption"
        },
        {
            "id": 118,
            "n": "of Life",
            "tc": "dblu"
        },
        {
            "id": 119,
            "n": "of Life Everlasting"
        },
        {
            "id": 120,
            "n": "of Protection"
        },
        {
            "id": 121,
            "n": "of Absorption"
        },
        {
            "id": 122,
            "n": "of Life"
        },
        {
            "id": 123,
            "n": "of Amicae"
        },
        {
            "id": 124,
            "n": "of Warding"
        },
        {
            "id": 125,
            "n": "of the Sentinel"
        },
        {
            "id": 126,
            "n": "of Guarding"
        },
        {
            "id": 127,
            "n": "of Negation"
        },
        {
            "id": 128,
            "n": "of the Sentinel"
        },
        {
            "id": 129,
            "n": "of Guarding"
        },
        {
            "id": 130,
            "n": "of Negation"
        },
        {
            "id": 131,
            "n": "of Coolness"
        },
        {
            "id": 132,
            "n": "of Inflammability"
        },
        {
            "id": 133,
            "n": "of Amianthus"
        },
        {
            "id": 134,
            "n": "of Quenching"
        },
        {
            "id": 135,
            "n": "of Coolness"
        },
        {
            "id": 136,
            "n": "of Inflammability"
        },
        {
            "id": 137,
            "n": "of Amianthus"
        },
        {
            "id": 138,
            "n": "of Quenching"
        },
        {
            "id": 139,
            "n": "of Faith"
        },
        {
            "id": 140,
            "n": "of Resistance"
        },
        {
            "id": 141,
            "n": "of Insulation"
        },
        {
            "id": 142,
            "n": "of Grounding"
        },
        {
            "id": 143,
            "n": "of the Dynamo"
        },
        {
            "id": 144,
            "n": "of Resistance"
        },
        {
            "id": 145,
            "n": "of Insulation"
        },
        {
            "id": 146,
            "n": "of Grounding"
        },
        {
            "id": 147,
            "n": "of the Dynamo"
        },
        {
            "id": 148,
            "n": "of Stoicism"
        },
        {
            "id": 149,
            "n": "of Warming"
        },
        {
            "id": 150,
            "n": "of Thawing"
        },
        {
            "id": 151,
            "n": "of the Dunes"
        },
        {
            "id": 152,
            "n": "of the Scirocco"
        },
        {
            "id": 153,
            "n": "of Warming"
        },
        {
            "id": 154,
            "n": "of Thawing"
        },
        {
            "id": 155,
            "n": "of the Dunes"
        },
        {
            "id": 156,
            "n": "of the Scirocco"
        },
        {
            "id": 157,
            "n": "of Desire"
        },
        {
            "id": 158,
            "n": "of Piercing"
        },
        {
            "id": 159,
            "n": "of Bashing"
        },
        {
            "id": 160,
            "n": "of Puncturing"
        },
        {
            "id": 161,
            "n": "of Thorns"
        },
        {
            "id": 162,
            "n": "of Spikes",
            "tc": "oran"
        },
        {
            "id": 163,
            "n": "of Razors",
            "tc": "oran"
        },
        {
            "id": 164,
            "n": "of Swords",
            "tc": "oran"
        },
        {
            "id": 165,
            "n": "of Malice"
        },
        {
            "id": 166,
            "n": "of Readiness"
        },
        {
            "id": 167,
            "n": "of Alacrity"
        },
        {
            "id": 168,
            "n": "of Swiftness"
        },
        {
            "id": 169,
            "n": "of Quickness",
            "tc": "dyel"
        },
        {
            "id": 170,
            "n": "of Alacrity",
            "tc": "dyel"
        },
        {
            "id": 171,
            "n": "of Fervor"
        },
        {
            "id": 172,
            "n": "of Blocking"
        },
        {
            "id": 173,
            "n": "of Deflecting"
        },
        {
            "id": 174,
            "n": "of the Apprentice"
        },
        {
            "id": 175,
            "n": "of the Magus"
        },
        {
            "id": 176,
            "n": "of Frost"
        },
        {
            "id": 177,
            "n": "of the Icicle"
        },
        {
            "id": 178,
            "n": "of the Glacier",
            "tc": "dblu"
        },
        {
            "id": 179,
            "n": "of Winter",
            "tc": "dblu"
        },
        {
            "id": 180,
            "n": "of Frost"
        },
        {
            "id": 181,
            "n": "of Frigidity",
            "tc": "dblu"
        },
        {
            "id": 182,
            "n": "of Thawing"
        },
        {
            "id": 183,
            "n": "of Flame"
        },
        {
            "id": 184,
            "n": "of Fire"
        },
        {
            "id": 185,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 186,
            "n": "of Incineration",
            "tc": "dred"
        },
        {
            "id": 187,
            "n": "of Flame"
        },
        {
            "id": 188,
            "n": "of Passion",
            "tc": "dred"
        },
        {
            "id": 189,
            "n": "of Shock"
        },
        {
            "id": 190,
            "n": "of Lightning"
        },
        {
            "id": 191,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 192,
            "n": "of Storms",
            "tc": "dyel"
        },
        {
            "id": 193,
            "n": "of Shock"
        },
        {
            "id": 194,
            "n": "of Ennui",
            "tc": "dyel"
        },
        {
            "id": 195,
            "n": "of Craftmanship"
        },
        {
            "id": 196,
            "n": "of Quality"
        },
        {
            "id": 197,
            "n": "of Maiming"
        },
        {
            "id": 198,
            "n": "of Slaying"
        },
        {
            "id": 199,
            "n": "of Gore"
        },
        {
            "id": 200,
            "n": "of Carnage",
            "tc": "blac"
        },
        {
            "id": 201,
            "n": "of Slaughter",
            "tc": "blac"
        },
        {
            "id": 202,
            "n": "of Butchery",
            "tc": "blac"
        },
        {
            "id": 203,
            "n": "of Evisceration",
            "tc": "blac"
        },
        {
            "id": 204,
            "n": "of Maiming"
        },
        {
            "id": 205,
            "n": "of Craftmanship"
        },
        {
            "id": 206,
            "n": "of Craftmanship"
        },
        {
            "id": 207,
            "n": "of Craftmanship"
        },
        {
            "id": 208,
            "n": "of Quality"
        },
        {
            "id": 209,
            "n": "of Quality"
        },
        {
            "id": 210,
            "n": "of Maiming"
        },
        {
            "id": 211,
            "n": "of Maiming"
        },
        {
            "id": 212,
            "n": "of Craftmanship"
        },
        {
            "id": 213,
            "n": "of Craftmanship"
        },
        {
            "id": 214,
            "n": "of Quality"
        },
        {
            "id": 215,
            "n": "of Quality"
        },
        {
            "id": 216,
            "n": "of Maiming"
        },
        {
            "id": 217,
            "n": "of Craftmanship"
        },
        {
            "id": 218,
            "n": "of Quality"
        },
        {
            "id": 219,
            "n": "of Maiming"
        },
        {
            "id": 220,
            "n": "of Ire"
        },
        {
            "id": 221,
            "n": "of Wrath",
            "tc": "blac"
        },
        {
            "id": 222,
            "n": "of Carnage",
            "tc": "blac"
        },
        {
            "id": 223,
            "n": "of Worth"
        },
        {
            "id": 224,
            "n": "of Measure"
        },
        {
            "id": 225,
            "n": "of Excellence"
        },
        {
            "id": 226,
            "n": "of Performance",
            "tc": "blac"
        },
        {
            "id": 227,
            "n": "of Transcendence",
            "tc": "blac"
        },
        {
            "id": 228,
            "n": "of Worth"
        },
        {
            "id": 229,
            "n": "of Measure"
        },
        {
            "id": 230,
            "n": "of Excellence"
        },
        {
            "id": 231,
            "n": "of Performance"
        },
        {
            "id": 232,
            "n": "of Joyfulness",
            "tc": "whit"
        },
        {
            "id": 233,
            "n": "of Bliss",
            "tc": "whit"
        },
        {
            "id": 234,
            "n": "of Blight"
        },
        {
            "id": 235,
            "n": "of Venom"
        },
        {
            "id": 236,
            "n": "of Pestilence",
            "tc": "dgrn"
        },
        {
            "id": 237,
            "n": "of Anthrax",
            "tc": "dgrn"
        },
        {
            "id": 238,
            "n": "of Blight"
        },
        {
            "id": 239,
            "n": "of Envy",
            "tc": "dgrn"
        },
        {
            "id": 240,
            "n": "of Dexterity"
        },
        {
            "id": 241,
            "n": "of Skill"
        },
        {
            "id": 242,
            "n": "of Accuracy"
        },
        {
            "id": 243,
            "n": "of Precision"
        },
        {
            "id": 244,
            "n": "of Perfection",
            "tc": "dgld"
        },
        {
            "id": 245,
            "n": "of Nirvana",
            "tc": "dgld"
        },
        {
            "id": 246,
            "n": "of Dexterity"
        },
        {
            "id": 247,
            "n": "of Skill"
        },
        {
            "id": 248,
            "n": "of Accuracy"
        },
        {
            "id": 249,
            "n": "of Precision"
        },
        {
            "id": 250,
            "n": "of Perfection",
            "tc": "dgld"
        },
        {
            "id": 251,
            "n": "of Dexterity"
        },
        {
            "id": 252,
            "n": "of Skill"
        },
        {
            "id": 253,
            "n": "of Accuracy"
        },
        {
            "id": 254,
            "n": "of Precision",
            "tc": "dgld"
        },
        {
            "id": 255,
            "n": "of Dexterity"
        },
        {
            "id": 256,
            "n": "of Dexterity"
        },
        {
            "id": 257,
            "n": "of Dexterity"
        },
        {
            "id": 258,
            "n": "of Dexterity"
        },
        {
            "id": 259,
            "n": "of Dexterity"
        },
        {
            "id": 260,
            "n": "of Dexterity"
        },
        {
            "id": 261,
            "n": "of Daring"
        },
        {
            "id": 262,
            "n": "of Balance"
        },
        {
            "id": 263,
            "n": "of Equilibrium"
        },
        {
            "id": 264,
            "n": "of Stability",
            "tc": "dyel"
        },
        {
            "id": 265,
            "n": "of Balance"
        },
        {
            "id": 266,
            "n": "of Balance"
        },
        {
            "id": 267,
            "n": "of Balance",
            "tc": "dyel"
        },
        {
            "id": 268,
            "n": "of Truth"
        },
        {
            "id": 269,
            "n": "of Regeneration"
        },
        {
            "id": 270,
            "n": "of Regeneration"
        },
        {
            "id": 271,
            "n": "of Regeneration"
        },
        {
            "id": 272,
            "n": "of Regrowth",
            "tc": "cred"
        },
        {
            "id": 273,
            "n": "of Regrowth",
            "tc": "cred"
        },
        {
            "id": 274,
            "n": "of Revivification",
            "tc": "cred"
        },
        {
            "id": 275,
            "n": "of Honor"
        },
        {
            "id": 276,
            "n": "of Vileness"
        },
        {
            "id": 277,
            "n": "of Greed"
        },
        {
            "id": 278,
            "n": "of Wealth",
            "tc": "lgld"
        },
        {
            "id": 279,
            "n": "of Greed"
        },
        {
            "id": 280,
            "n": "of Greed"
        },
        {
            "id": 281,
            "n": "of Greed"
        },
        {
            "id": 282,
            "n": "of Greed"
        },
        {
            "id": 283,
            "n": "of Greed"
        },
        {
            "id": 284,
            "n": "of Greed"
        },
        {
            "id": 285,
            "n": "of Avarice"
        },
        {
            "id": 286,
            "n": "of Chance"
        },
        {
            "id": 287,
            "n": "of Fortune",
            "tc": "lgld"
        },
        {
            "id": 288,
            "n": "of Fortune",
            "tc": "lgld"
        },
        {
            "id": 289,
            "n": "of Luck",
            "tc": "lgld"
        },
        {
            "id": 290,
            "n": "of Fortune"
        },
        {
            "id": 291,
            "n": "of Good Luck"
        },
        {
            "id": 292,
            "n": "of Prosperity"
        },
        {
            "id": 293,
            "n": "of Energy"
        },
        {
            "id": 294,
            "n": "of the Mind"
        },
        {
            "id": 295,
            "n": "of Brilliance"
        },
        {
            "id": 296,
            "n": "of Sorcery"
        },
        {
            "id": 297,
            "n": "of Wizardry",
            "tc": "dgld"
        },
        {
            "id": 298,
            "n": "of Enlightenment",
            "tc": "dgld"
        },
        {
            "id": 299,
            "n": "of Energy"
        },
        {
            "id": 300,
            "n": "of the Mind"
        },
        {
            "id": 301,
            "n": "of Brilliance"
        },
        {
            "id": 302,
            "n": "of Sorcery"
        },
        {
            "id": 303,
            "n": "of Wizardry",
            "tc": "dgld"
        },
        {
            "id": 304,
            "n": "of Energy"
        },
        {
            "id": 305,
            "n": "of the Mind"
        },
        {
            "id": 306,
            "n": "of Brilliance"
        },
        {
            "id": 307,
            "n": "of Sorcery",
            "tc": "dgld"
        },
        {
            "id": 308,
            "n": "of Knowledge"
        },
        {
            "id": 309,
            "n": "of the Bear"
        },
        {
            "id": 310,
            "n": "of Light"
        },
        {
            "id": 311,
            "n": "of Radiance"
        },
        {
            "id": 312,
            "n": "of the Sun"
        },
        {
            "id": 313,
            "n": "of the Jackal"
        },
        {
            "id": 314,
            "n": "of the Fox"
        },
        {
            "id": 315,
            "n": "of the Wolf"
        },
        {
            "id": 316,
            "n": "of the Tiger"
        },
        {
            "id": 317,
            "n": "of the Mammoth",
            "tc": "cred"
        },
        {
            "id": 318,
            "n": "of the Colossus",
            "tc": "cred"
        },
        {
            "id": 319,
            "n": "of the Squid",
            "tc": "cred"
        },
        {
            "id": 320,
            "n": "of the Whale",
            "tc": "cred"
        },
        {
            "id": 321,
            "n": "of the Jackal"
        },
        {
            "id": 322,
            "n": "of the Fox"
        },
        {
            "id": 323,
            "n": "of the Wolf"
        },
        {
            "id": 324,
            "n": "of the Tiger"
        },
        {
            "id": 325,
            "n": "of the Mammoth",
            "tc": "cred"
        },
        {
            "id": 326,
            "n": "of the Colossus",
            "tc": "cred"
        },
        {
            "id": 327,
            "n": "of the Jackal"
        },
        {
            "id": 328,
            "n": "of the Fox"
        },
        {
            "id": 329,
            "n": "of the Wolf"
        },
        {
            "id": 330,
            "n": "of the Tiger"
        },
        {
            "id": 331,
            "n": "of the Mammoth",
            "tc": "cred"
        },
        {
            "id": 332,
            "n": "of Life"
        },
        {
            "id": 333,
            "n": "of Life"
        },
        {
            "id": 334,
            "n": "of Life"
        },
        {
            "id": 335,
            "n": "of Sustenance"
        },
        {
            "id": 336,
            "n": "of Sustenance"
        },
        {
            "id": 337,
            "n": "of Sustenance"
        },
        {
            "id": 338,
            "n": "of Vita"
        },
        {
            "id": 339,
            "n": "of Vita"
        },
        {
            "id": 340,
            "n": "of Vita"
        },
        {
            "id": 341,
            "n": "of Life"
        },
        {
            "id": 342,
            "n": "of Life"
        },
        {
            "id": 343,
            "n": "of Sustenance"
        },
        {
            "id": 344,
            "n": "of Sustenance"
        },
        {
            "id": 345,
            "n": "of Vita"
        },
        {
            "id": 346,
            "n": "of Vita"
        },
        {
            "id": 347,
            "n": "of Life"
        },
        {
            "id": 348,
            "n": "of Sustenance"
        },
        {
            "id": 349,
            "n": "of Vita"
        },
        {
            "id": 350,
            "n": "of Spirit"
        },
        {
            "id": 351,
            "n": "of Hope"
        },
        {
            "id": 352,
            "n": "of the Leech"
        },
        {
            "id": 353,
            "n": "of the Locust",
            "tc": "cred"
        },
        {
            "id": 354,
            "n": "of the Lamprey",
            "tc": "cred"
        },
        {
            "id": 355,
            "n": "of the Leech"
        },
        {
            "id": 356,
            "n": "of the Locust"
        },
        {
            "id": 357,
            "n": "of the Lamprey",
            "tc": "cred"
        },
        {
            "id": 358,
            "n": "of the Leech",
            "tc": "cred"
        },
        {
            "id": 359,
            "n": "of the Bat"
        },
        {
            "id": 360,
            "n": "of the Wraith",
            "tc": "cred"
        },
        {
            "id": 361,
            "n": "of the Vampire",
            "tc": "cred"
        },
        {
            "id": 362,
            "n": "of the Bat"
        },
        {
            "id": 363,
            "n": "of the Wraith"
        },
        {
            "id": 364,
            "n": "of the Vampire",
            "tc": "cred"
        },
        {
            "id": 365,
            "n": "of the Bat",
            "tc": "cred"
        },
        {
            "id": 366,
            "n": "of Defiance",
            "tc": "dred"
        },
        {
            "id": 367,
            "n": "of Amelioration"
        },
        {
            "id": 368,
            "n": "of Remedy"
        },
        {
            "id": 369,
            "n": "of Simplicity"
        },
        {
            "id": 370,
            "n": "of Ease"
        },
        {
            "id": 371,
            "n": "of Freedom"
        },
        {
            "id": 372,
            "n": "of Strength"
        },
        {
            "id": 373,
            "n": "of Might"
        },
        {
            "id": 374,
            "n": "of the Ox"
        },
        {
            "id": 375,
            "n": "of the Giant"
        },
        {
            "id": 376,
            "n": "of the Titan",
            "tc": "dgld"
        },
        {
            "id": 377,
            "n": "of Atlas",
            "tc": "dgld"
        },
        {
            "id": 378,
            "n": "of Strength"
        },
        {
            "id": 379,
            "n": "of Might"
        },
        {
            "id": 380,
            "n": "of the Ox"
        },
        {
            "id": 381,
            "n": "of the Giant"
        },
        {
            "id": 382,
            "n": "of the Titan",
            "tc": "dgld"
        },
        {
            "id": 383,
            "n": "of Strength"
        },
        {
            "id": 384,
            "n": "of Might"
        },
        {
            "id": 385,
            "n": "of the Ox"
        },
        {
            "id": 386,
            "n": "of the Giant",
            "tc": "dgld"
        },
        {
            "id": 387,
            "n": "of Strength"
        },
        {
            "id": 388,
            "n": "of Strength"
        },
        {
            "id": 389,
            "n": "of Strength"
        },
        {
            "id": 390,
            "n": "of Strength"
        },
        {
            "id": 391,
            "n": "of Strength"
        },
        {
            "id": 392,
            "n": "of Strength"
        },
        {
            "id": 393,
            "n": "of Virility"
        },
        {
            "id": 394,
            "n": "of Pacing"
        },
        {
            "id": 395,
            "n": "of Haste"
        },
        {
            "id": 396,
            "n": "of Speed"
        },
        {
            "id": 397,
            "n": "of Transportation"
        },
        {
            "id": 398,
            "n": "of Acceleration"
        },
        {
            "id": 399,
            "n": "of Inertia"
        },
        {
            "id": 400,
            "n": "of Inertia"
        },
        {
            "id": 401,
            "n": "of Inertia"
        },
        {
            "id": 402,
            "n": "of Self-Repair"
        },
        {
            "id": 403,
            "n": "of Restoration"
        },
        {
            "id": 404,
            "n": "of Ages"
        },
        {
            "id": 405,
            "n": "of Replenishing"
        },
        {
            "id": 406,
            "n": "of Propogation"
        },
        {
            "id": 407,
            "n": "of the Centaur",
            "tc": "cred"
        },
        {
            "id": 408,
            "n": "of Memory",
            "tc": "cred"
        },
        {
            "id": 409,
            "n": "of the Elephant",
            "tc": "cred"
        },
        {
            "id": 410,
            "n": "of Power",
            "tc": "dgld"
        },
        {
            "id": 411,
            "n": "of Grace",
            "tc": "dgld"
        },
        {
            "id": 412,
            "n": "of Grace and Power",
            "tc": "dgld"
        },
        {
            "id": 413,
            "n": "of the Yeti",
            "tc": "lblu"
        },
        {
            "id": 414,
            "n": "of the Phoenix",
            "tc": "cred"
        },
        {
            "id": 415,
            "n": "of the Efreeti",
            "tc": "cblu"
        },
        {
            "id": 416,
            "n": "of the Cobra",
            "tc": "dyel"
        },
        {
            "id": 417,
            "n": "of the Elements",
            "tc": "dgld"
        },
        {
            "id": 418,
            "n": "of Firebolts"
        },
        {
            "id": 419,
            "n": "of Firebolts"
        },
        {
            "id": 420,
            "n": "of Firebolts"
        },
        {
            "id": 421,
            "n": "of Charged Bolt"
        },
        {
            "id": 422,
            "n": "of Charged Bolt"
        },
        {
            "id": 423,
            "n": "of Charged Bolt"
        },
        {
            "id": 424,
            "n": "of Icebolt",
            "tc": "lblu"
        },
        {
            "id": 425,
            "n": "of Frozen Armor"
        },
        {
            "id": 426,
            "n": "of Static Field"
        },
        {
            "id": 427,
            "n": "of Telekinesis"
        },
        {
            "id": 428,
            "n": "of Frost Shield",
            "tc": "lblu"
        },
        {
            "id": 429,
            "n": "of Ice Blast"
        },
        {
            "id": 430,
            "n": "of Blaze"
        },
        {
            "id": 431,
            "n": "of Fire Ball"
        },
        {
            "id": 432,
            "n": "of Nova",
            "tc": "cblu"
        },
        {
            "id": 433,
            "n": "of Nova",
            "tc": "cblu"
        },
        {
            "id": 434,
            "n": "of Nova Shield",
            "tc": "cblu"
        },
        {
            "id": 435,
            "n": "of Nova Shield",
            "tc": "cblu"
        },
        {
            "id": 436,
            "n": "of Nova Shield",
            "tc": "cblu"
        },
        {
            "id": 437,
            "n": "of Lightning",
            "tc": "cblu"
        },
        {
            "id": 438,
            "n": "of Lightning",
            "tc": "cblu"
        },
        {
            "id": 439,
            "n": "of Shiver Armor"
        },
        {
            "id": 440,
            "n": "of Fire Wall"
        },
        {
            "id": 441,
            "n": "of Enchant"
        },
        {
            "id": 442,
            "n": "of Chain Lightning"
        },
        {
            "id": 443,
            "n": "of Chain Lightning"
        },
        {
            "id": 444,
            "n": "of Chain Lightning"
        },
        {
            "id": 445,
            "n": "of Teleport Shield",
            "tc": "whit"
        },
        {
            "id": 446,
            "n": "of Teleport Shield",
            "tc": "whit"
        },
        {
            "id": 447,
            "n": "of Teleport Shield",
            "tc": "whit"
        },
        {
            "id": 448,
            "n": "of Glacial Spike"
        },
        {
            "id": 449,
            "n": "of Meteor"
        },
        {
            "id": 450,
            "n": "of Thunder Storm"
        },
        {
            "id": 451,
            "n": "of Energy Shield"
        },
        {
            "id": 452,
            "n": "of Blizzard"
        },
        {
            "id": 453,
            "n": "of Chilling Armor"
        },
        {
            "id": 454,
            "n": "of Hydra Shield",
            "tc": "cred"
        },
        {
            "id": 455,
            "n": "of Frozen Orb"
        },
        {
            "id": 456,
            "n": "of Dawn"
        },
        {
            "id": 457,
            "n": "of Sunlight"
        },
        {
            "id": 458,
            "n": "of Magic Arrow"
        },
        {
            "id": 459,
            "n": "of Magic Arrow"
        },
        {
            "id": 460,
            "n": "of Fire Arrow"
        },
        {
            "id": 461,
            "n": "of Fire Arrow"
        },
        {
            "id": 462,
            "n": "of Inner Sight"
        },
        {
            "id": 463,
            "n": "of Inner Sight"
        },
        {
            "id": 464,
            "n": "of Jab"
        },
        {
            "id": 465,
            "n": "of Jab"
        },
        {
            "id": 466,
            "n": "of Cold Arrow"
        },
        {
            "id": 467,
            "n": "of Cold Arrow"
        },
        {
            "id": 468,
            "n": "of Multiple Shot"
        },
        {
            "id": 469,
            "n": "of Multiple Shot"
        },
        {
            "id": 470,
            "n": "of Power Strike"
        },
        {
            "id": 471,
            "n": "of Power Strike"
        },
        {
            "id": 472,
            "n": "of Poison Jab"
        },
        {
            "id": 473,
            "n": "of Poison Jab"
        },
        {
            "id": 474,
            "n": "of Exploding Arrow"
        },
        {
            "id": 475,
            "n": "of Exploding Arrow"
        },
        {
            "id": 476,
            "n": "of Slow Missile"
        },
        {
            "id": 477,
            "n": "of Slow Missile"
        },
        {
            "id": 478,
            "n": "of Impaling Strike"
        },
        {
            "id": 479,
            "n": "of Impaling Strike"
        },
        {
            "id": 480,
            "n": "of Lightning Javelin"
        },
        {
            "id": 481,
            "n": "of Lightning Javelin"
        },
        {
            "id": 482,
            "n": "of Ice Arrow"
        },
        {
            "id": 483,
            "n": "of Ice Arrow"
        },
        {
            "id": 484,
            "n": "of Guided Arrow"
        },
        {
            "id": 485,
            "n": "of Guided Arrow"
        },
        {
            "id": 486,
            "n": "of Charged Strike"
        },
        {
            "id": 487,
            "n": "of Charged Strike"
        },
        {
            "id": 488,
            "n": "of Plague Jab"
        },
        {
            "id": 489,
            "n": "of Plague Jab"
        },
        {
            "id": 490,
            "n": "of Immolating Arrow"
        },
        {
            "id": 491,
            "n": "of Immolating Arrow"
        },
        {
            "id": 492,
            "n": "of Fending"
        },
        {
            "id": 493,
            "n": "of Fending"
        },
        {
            "id": 494,
            "n": "of Freezing Arrow"
        },
        {
            "id": 495,
            "n": "of Freezing Arrow"
        },
        {
            "id": 496,
            "n": "of Lightning Strike"
        },
        {
            "id": 497,
            "n": "of Lightning Strike"
        },
        {
            "id": 498,
            "n": "of Lightning Fury"
        },
        {
            "id": 499,
            "n": "of Lightning Fury"
        },
        {
            "id": 500,
            "n": "of Fire Bolt"
        },
        {
            "id": 501,
            "n": "of Fire Bolt"
        },
        {
            "id": 502,
            "n": "of Charged Bolt"
        },
        {
            "id": 503,
            "n": "of Charged Bolt"
        },
        {
            "id": 504,
            "n": "of Ice Bolt"
        },
        {
            "id": 505,
            "n": "of Ice Bolt"
        },
        {
            "id": 506,
            "n": "of Frozen Armor"
        },
        {
            "id": 507,
            "n": "of Frozen Armor"
        },
        {
            "id": 508,
            "n": "of Static Field"
        },
        {
            "id": 509,
            "n": "of Static Field"
        },
        {
            "id": 510,
            "n": "of Telekinesis"
        },
        {
            "id": 511,
            "n": "of Telekinesis"
        },
        {
            "id": 512,
            "n": "of Frost Nova"
        },
        {
            "id": 513,
            "n": "of Frost Nova"
        },
        {
            "id": 514,
            "n": "of Ice Blast"
        },
        {
            "id": 515,
            "n": "of Ice Blast"
        },
        {
            "id": 516,
            "n": "of Blazing"
        },
        {
            "id": 517,
            "n": "of Blazing"
        },
        {
            "id": 518,
            "n": "of Fire Ball"
        },
        {
            "id": 519,
            "n": "of Fire Ball"
        },
        {
            "id": 520,
            "n": "of Nova"
        },
        {
            "id": 521,
            "n": "of Nova"
        },
        {
            "id": 522,
            "n": "of Lightning"
        },
        {
            "id": 523,
            "n": "of Lightning"
        },
        {
            "id": 524,
            "n": "of Shiver Armor"
        },
        {
            "id": 525,
            "n": "of Shiver Armor"
        },
        {
            "id": 526,
            "n": "of Fire Wall"
        },
        {
            "id": 527,
            "n": "of Fire Wall"
        },
        {
            "id": 528,
            "n": "of Enchantment"
        },
        {
            "id": 529,
            "n": "of Enchantment"
        },
        {
            "id": 530,
            "n": "of Chain Lightning"
        },
        {
            "id": 531,
            "n": "of Chain Lightning"
        },
        {
            "id": 532,
            "n": "of Teleportation"
        },
        {
            "id": 533,
            "n": "of Teleportation"
        },
        {
            "id": 534,
            "n": "of Glacial Spike"
        },
        {
            "id": 535,
            "n": "of Glacial Spike"
        },
        {
            "id": 536,
            "n": "of Meteor"
        },
        {
            "id": 537,
            "n": "of Meteor"
        },
        {
            "id": 538,
            "n": "of Thunder Storm"
        },
        {
            "id": 539,
            "n": "of Thunder Storm"
        },
        {
            "id": 540,
            "n": "of Energy Shield"
        },
        {
            "id": 541,
            "n": "of Energy Shield"
        },
        {
            "id": 542,
            "n": "of Blizzard"
        },
        {
            "id": 543,
            "n": "of Blizzard"
        },
        {
            "id": 544,
            "n": "of Chilling Armor"
        },
        {
            "id": 545,
            "n": "of Chilling Armor"
        },
        {
            "id": 546,
            "n": "of Hydra"
        },
        {
            "id": 547,
            "n": "of Hydra"
        },
        {
            "id": 548,
            "n": "of Frozen Orb"
        },
        {
            "id": 549,
            "n": "of Frozen Orb"
        },
        {
            "id": 550,
            "n": "of Amplify Damage"
        },
        {
            "id": 551,
            "n": "of Amplify Damage"
        },
        {
            "id": 552,
            "n": "of Teeth"
        },
        {
            "id": 553,
            "n": "of Teeth"
        },
        {
            "id": 554,
            "n": "of Bone Armor"
        },
        {
            "id": 555,
            "n": "of Bone Armor"
        },
        {
            "id": 556,
            "n": "of Raise Skeleton"
        },
        {
            "id": 557,
            "n": "of Raise Skeleton"
        },
        {
            "id": 558,
            "n": "of Dim Vision"
        },
        {
            "id": 559,
            "n": "of Dim Vision"
        },
        {
            "id": 560,
            "n": "of Weaken"
        },
        {
            "id": 561,
            "n": "of Weaken"
        },
        {
            "id": 562,
            "n": "of Poison Dagger"
        },
        {
            "id": 563,
            "n": "of Poison Dagger"
        },
        {
            "id": 564,
            "n": "of Corpse Explosion"
        },
        {
            "id": 565,
            "n": "of Corpse Explosion"
        },
        {
            "id": 566,
            "n": "of Clay Golem"
        },
        {
            "id": 567,
            "n": "of Clay Golem"
        },
        {
            "id": 568,
            "n": "of Iron Maiden"
        },
        {
            "id": 569,
            "n": "of Iron Maiden"
        },
        {
            "id": 570,
            "n": "of Terror"
        },
        {
            "id": 571,
            "n": "of Terror"
        },
        {
            "id": 572,
            "n": "of Bone Wall"
        },
        {
            "id": 573,
            "n": "of Bone Wall"
        },
        {
            "id": 574,
            "n": "of Skeletal Mages"
        },
        {
            "id": 575,
            "n": "of Skeletal Mages"
        },
        {
            "id": 576,
            "n": "of Confusion"
        },
        {
            "id": 577,
            "n": "of Confusion"
        },
        {
            "id": 578,
            "n": "of Life Tap"
        },
        {
            "id": 579,
            "n": "of Life Tap"
        },
        {
            "id": 580,
            "n": "of Poison Explosion"
        },
        {
            "id": 581,
            "n": "of Poison Explosion"
        },
        {
            "id": 582,
            "n": "of Bone Spear"
        },
        {
            "id": 583,
            "n": "of Bone Spear"
        },
        {
            "id": 584,
            "n": "of Blood Golem"
        },
        {
            "id": 585,
            "n": "of Blood Golem"
        },
        {
            "id": 586,
            "n": "of Attract"
        },
        {
            "id": 587,
            "n": "of Attract"
        },
        {
            "id": 588,
            "n": "of Decrepify"
        },
        {
            "id": 589,
            "n": "of Decrepify"
        },
        {
            "id": 590,
            "n": "of Bone Prison"
        },
        {
            "id": 591,
            "n": "of Bone Prison"
        },
        {
            "id": 592,
            "n": "of Iron Golem"
        },
        {
            "id": 593,
            "n": "of Iron Golem"
        },
        {
            "id": 594,
            "n": "of Lower Resistance"
        },
        {
            "id": 595,
            "n": "of Lower Resistance"
        },
        {
            "id": 596,
            "n": "of Poison Nova"
        },
        {
            "id": 597,
            "n": "of Poison Nova"
        },
        {
            "id": 598,
            "n": "of Bone Spirit"
        },
        {
            "id": 599,
            "n": "of Bone Spirit"
        },
        {
            "id": 600,
            "n": "of Fire Golem"
        },
        {
            "id": 601,
            "n": "of Fire Golem"
        },
        {
            "id": 602,
            "n": "of Revivification"
        },
        {
            "id": 603,
            "n": "of Revivification"
        },
        {
            "id": 604,
            "n": "of Sacrifice"
        },
        {
            "id": 605,
            "n": "of Sacrifice"
        },
        {
            "id": 606,
            "n": "of Holy Bolt"
        },
        {
            "id": 607,
            "n": "of Holy Bolt"
        },
        {
            "id": 608,
            "n": "of Zeal"
        },
        {
            "id": 609,
            "n": "of Zeal"
        },
        {
            "id": 610,
            "n": "of Vengeance"
        },
        {
            "id": 611,
            "n": "of Vengeance"
        },
        {
            "id": 612,
            "n": "of Blessed Hammer"
        },
        {
            "id": 613,
            "n": "of Blessed Hammer"
        },
        {
            "id": 614,
            "n": "of Conversion"
        },
        {
            "id": 615,
            "n": "of Conversion"
        },
        {
            "id": 616,
            "n": "of Fist of the Heavens"
        },
        {
            "id": 617,
            "n": "of Fist of the Heavens"
        },
        {
            "id": 618,
            "n": "of Bashing"
        },
        {
            "id": 619,
            "n": "of Bashing"
        },
        {
            "id": 620,
            "n": "of Howl"
        },
        {
            "id": 621,
            "n": "of Howl"
        },
        {
            "id": 622,
            "n": "of Find Potion"
        },
        {
            "id": 623,
            "n": "of Find Potion"
        },
        {
            "id": 624,
            "n": "of Taunt"
        },
        {
            "id": 625,
            "n": "of Taunt"
        },
        {
            "id": 626,
            "n": "of Shout"
        },
        {
            "id": 627,
            "n": "of Shout"
        },
        {
            "id": 628,
            "n": "of Stun"
        },
        {
            "id": 629,
            "n": "of Stun"
        },
        {
            "id": 630,
            "n": "of Find Item"
        },
        {
            "id": 631,
            "n": "of Find Item"
        },
        {
            "id": 632,
            "n": "of Concentration"
        },
        {
            "id": 633,
            "n": "of Concentration"
        },
        {
            "id": 634,
            "n": "of Battle Cry"
        },
        {
            "id": 635,
            "n": "of Battle Cry"
        },
        {
            "id": 636,
            "n": "of Battle Orders"
        },
        {
            "id": 637,
            "n": "of Battle Orders"
        },
        {
            "id": 638,
            "n": "of Grim Ward"
        },
        {
            "id": 639,
            "n": "of Grim Ward"
        },
        {
            "id": 640,
            "n": "of War Cry"
        },
        {
            "id": 641,
            "n": "of War Cry"
        },
        {
            "id": 642,
            "n": "of Battle Command"
        },
        {
            "id": 643,
            "n": "of Battle Command"
        },
        {
            "id": 644,
            "n": "of Firestorms"
        },
        {
            "id": 645,
            "n": "of Firestorms"
        },
        {
            "id": 646,
            "n": "of Molten Boulder"
        },
        {
            "id": 647,
            "n": "of Molten Boulder"
        },
        {
            "id": 648,
            "n": "of Fissure"
        },
        {
            "id": 649,
            "n": "of Fissure"
        },
        {
            "id": 650,
            "n": "of Cyclone Armor"
        },
        {
            "id": 651,
            "n": "of Cyclone Armor"
        },
        {
            "id": 652,
            "n": "of Twister"
        },
        {
            "id": 653,
            "n": "of Twister"
        },
        {
            "id": 654,
            "n": "of Volcano"
        },
        {
            "id": 655,
            "n": "of Volcano"
        },
        {
            "id": 656,
            "n": "of Tornado"
        },
        {
            "id": 657,
            "n": "of Tornado"
        },
        {
            "id": 658,
            "n": "of Armageddon"
        },
        {
            "id": 659,
            "n": "of Armageddon"
        },
        {
            "id": 660,
            "n": "of Hurricane"
        },
        {
            "id": 661,
            "n": "of Hurricane"
        },
        {
            "id": 662,
            "n": "of Amplify Damage"
        },
        {
            "id": 663,
            "n": "of the Icicle",
            "tc": "dblu"
        },
        {
            "id": 664,
            "n": "of the Glacier",
            "tc": "dblu"
        },
        {
            "id": 665,
            "n": "of Fire",
            "tc": "dred"
        },
        {
            "id": 666,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 667,
            "n": "of Lightning",
            "tc": "dyel"
        },
        {
            "id": 668,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 669,
            "n": "of Daring"
        },
        {
            "id": 670,
            "n": "of Daring"
        },
        {
            "id": 671,
            "n": "of Knowledge"
        },
        {
            "id": 672,
            "n": "of Knowledge"
        },
        {
            "id": 673,
            "n": "of Virility"
        },
        {
            "id": 674,
            "n": "of Virility"
        },
        {
            "id": 675,
            "n": "of Readiness"
        },
        {
            "id": 676,
            "n": "of Craftmanship"
        },
        {
            "id": 677,
            "n": "of Quality"
        },
        {
            "id": 678,
            "n": "of Maiming"
        },
        {
            "id": 679,
            "n": "of Craftmanship"
        },
        {
            "id": 680,
            "n": "of Quality"
        },
        {
            "id": 681,
            "n": "of Craftmanship"
        },
        {
            "id": 682,
            "n": "of Blight"
        },
        {
            "id": 683,
            "n": "of Venom"
        },
        {
            "id": 684,
            "n": "of Pestilence",
            "tc": "dgrn"
        },
        {
            "id": 685,
            "n": "of Anthrax",
            "tc": "dgrn"
        },
        {
            "id": 686,
            "n": "of Blight"
        },
        {
            "id": 687,
            "n": "of Venom"
        },
        {
            "id": 688,
            "n": "of Pestilence",
            "tc": "dgrn"
        },
        {
            "id": 689,
            "n": "of Anthrax",
            "tc": "dgrn"
        },
        {
            "id": 690,
            "n": "of Blight"
        },
        {
            "id": 691,
            "n": "of Venom"
        },
        {
            "id": 692,
            "n": "of Pestilence",
            "tc": "dgrn"
        },
        {
            "id": 693,
            "n": "of Anthrax",
            "tc": "dgrn"
        },
        {
            "id": 694,
            "n": "of Frost"
        },
        {
            "id": 695,
            "n": "of the Icicle"
        },
        {
            "id": 696,
            "n": "of the Glacier",
            "tc": "dblu"
        },
        {
            "id": 697,
            "n": "of Winter",
            "tc": "dblu"
        },
        {
            "id": 698,
            "n": "of Frost"
        },
        {
            "id": 699,
            "n": "of the Icicle"
        },
        {
            "id": 700,
            "n": "of the Glacier",
            "tc": "dblu"
        },
        {
            "id": 701,
            "n": "of Winter",
            "tc": "dblu"
        },
        {
            "id": 702,
            "n": "of Frost"
        },
        {
            "id": 703,
            "n": "of the Icicle"
        },
        {
            "id": 704,
            "n": "of the Glacier",
            "tc": "dblu"
        },
        {
            "id": 705,
            "n": "of Winter",
            "tc": "dblu"
        },
        {
            "id": 706,
            "n": "of Flame"
        },
        {
            "id": 707,
            "n": "of Fire"
        },
        {
            "id": 708,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 709,
            "n": "of Incineration",
            "tc": "dred"
        },
        {
            "id": 710,
            "n": "of Flame"
        },
        {
            "id": 711,
            "n": "of Fire"
        },
        {
            "id": 712,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 713,
            "n": "of Incineration",
            "tc": "dred"
        },
        {
            "id": 714,
            "n": "of Flame"
        },
        {
            "id": 715,
            "n": "of Fire"
        },
        {
            "id": 716,
            "n": "of Burning",
            "tc": "dred"
        },
        {
            "id": 717,
            "n": "of Incineration",
            "tc": "dred"
        },
        {
            "id": 718,
            "n": "of Shock"
        },
        {
            "id": 719,
            "n": "of Lightning"
        },
        {
            "id": 720,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 721,
            "n": "of Storms",
            "tc": "dyel"
        },
        {
            "id": 722,
            "n": "of Shock"
        },
        {
            "id": 723,
            "n": "of Lightning"
        },
        {
            "id": 724,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 725,
            "n": "of Storms",
            "tc": "dyel"
        },
        {
            "id": 726,
            "n": "of Shock"
        },
        {
            "id": 727,
            "n": "of Lightning"
        },
        {
            "id": 728,
            "n": "of Thunder",
            "tc": "dyel"
        },
        {
            "id": 729,
            "n": "of Storms",
            "tc": "dyel"
        },
        {
            "id": 730,
            "n": "of Dexterity"
        },
        {
            "id": 731,
            "n": "of Dexterity"
        },
        {
            "id": 732,
            "n": "of Strength"
        },
        {
            "id": 733,
            "n": "of Strength"
        },
        {
            "id": 734,
            "n": "of Thorns"
        },
        {
            "id": 735,
            "n": "of Frost"
        },
        {
            "id": 736,
            "n": "of Flame"
        },
        {
            "id": 737,
            "n": "of Blight"
        },
        {
            "id": 738,
            "n": "of Shock"
        },
        {
            "id": 739,
            "n": "of Regeneration"
        },
        {
            "id": 740,
            "n": "of Energy"
        },
        {
            "id": 741,
            "n": "of Light"
        },
        {
            "id": 742,
            "n": "of the Leech"
        },
        {
            "id": 743,
            "n": "of the Locust"
        },
        {
            "id": 744,
            "n": "of the Lamprey",
            "tc": "cred"
        },
        {
            "id": 745,
            "n": "of the Bat"
        },
        {
            "id": 746,
            "n": "of the Wraith"
        },
        {
            "id": 747,
            "n": "of the Vampire",
            "tc": "cred"
        },
        {
            "id": 748
        }
    ],
    "properties": {
        "ac": [
            {
                "s": "armorclass",
                "type": "other",
                "f": 1
            }
        ],
        "ac-miss": [
            {
                "s": "armorclass_vs_missile",
                "type": "other",
                "f": 1
            }
        ],
        "ac-hth": [
            {
                "s": "armorclass_vs_hth",
                "type": "other",
                "f": 1
            }
        ],
        "red-dmg": [
            {
                "s": "normal_damage_reduction",
                "type": "other",
                "f": 1
            }
        ],
        "red-dmg%": [
            {
                "s": "damageresist",
                "type": "other",
                "f": 1
            }
        ],
        "ac%": [
            {
                "s": "item_armor_percent",
                "type": "other",
                "f": 2
            }
        ],
        "red-mag": [
            {
                "s": "magic_damage_reduction",
                "type": "other",
                "f": 1
            }
        ],
        "str": [
            {
                "s": "strength",
                "type": "other",
                "f": 1
            }
        ],
        "dex": [
            {
                "s": "dexterity",
                "type": "other",
                "f": 1
            }
        ],
        "vit": [
            {
                "s": "vitality",
                "type": "other",
                "f": 1
            }
        ],
        "enr": [
            {
                "s": "energy",
                "type": "other",
                "f": 1
            }
        ],
        "mana": [
            {
                "s": "maxmana",
                "type": "other",
                "f": 1
            }
        ],
        "mana%": [
            {
                "s": "item_maxmana_percent",
                "type": "other",
                "f": 1
            }
        ],
        "hp": [
            {
                "s": "maxhp",
                "type": "other",
                "f": 1
            }
        ],
        "hp%": [
            {
                "s": "item_maxhp_percent",
                "type": "other",
                "f": 1
            }
        ],
        "att": [
            {
                "s": "tohit",
                "type": "other",
                "f": 1
            }
        ],
        "block": [
            {
                "s": "toblock",
                "type": "other",
                "f": 1
            }
        ],
        "cold-min": [
            {
                "s": "coldmindam",
                "type": "other",
                "f": 1
            }
        ],
        "cold-max": [
            {
                "s": "coldmaxdam",
                "type": "other",
                "f": 1
            }
        ],
        "cold-len": [
            {
                "s": "coldlength",
                "type": "other",
                "f": 1
            }
        ],
        "fire-min": [
            {
                "s": "firemindam",
                "type": "other",
                "f": 1
            }
        ],
        "fire-max": [
            {
                "s": "firemaxdam",
                "type": "other",
                "f": 1
            }
        ],
        "ltng-min": [
            {
                "s": "lightmindam",
                "type": "other",
                "f": 1
            }
        ],
        "ltng-max": [
            {
                "s": "lightmaxdam",
                "type": "other",
                "f": 1
            }
        ],
        "pois-min": [
            {
                "s": "poisonmindam",
                "type": "other",
                "f": 1
            }
        ],
        "pois-max": [
            {
                "s": "poisonmaxdam",
                "type": "other",
                "f": 1
            }
        ],
        "pois-len": [
            {
                "s": "poisonlength",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-min": [
            {
                "s": "mindamage",
                "type": "other",
                "f": 5
            }
        ],
        "dmg-max": [
            {
                "s": "maxdamage",
                "type": "other",
                "f": 6
            }
        ],
        "dmg%": [
            {
                "s": "item_maxdamage_percent",
                "type": "all",
                "f": 7
            }
        ],
        "dmg-to-mana": [
            {
                "s": "item_damagetomana",
                "type": "other",
                "f": 1
            }
        ],
        "res-fire": [
            {
                "s": "fireresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-fire-max": [
            {
                "s": "maxfireresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-ltng": [
            {
                "s": "lightresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-ltng-max": [
            {
                "s": "maxlightresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-cold": [
            {
                "s": "coldresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-cold-max": [
            {
                "s": "maxcoldresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-mag": [
            {
                "s": "magicresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-mag-max": [
            {
                "s": "maxmagicresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-pois": [
            {
                "s": "poisonresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-pois-max": [
            {
                "s": "maxpoisonresist",
                "type": "other",
                "f": 1
            }
        ],
        "res-all": [
            {
                "s": "fireresist",
                "type": "other",
                "f": 1
            },
            {
                "s": "lightresist",
                "type": "all",
                "f": 3
            },
            {
                "s": "coldresist",
                "type": "all",
                "f": 3
            },
            {
                "s": "poisonresist",
                "type": "all",
                "f": 3
            }
        ],
        "res-all-max": [
            {
                "s": "maxfireresist",
                "type": "other",
                "f": 1
            },
            {
                "s": "maxlightresist",
                "type": "all",
                "f": 3
            },
            {
                "s": "maxcoldresist",
                "type": "all",
                "f": 3
            },
            {
                "s": "maxpoisonresist",
                "type": "all",
                "f": 3
            }
        ],
        "abs-fire%": [
            {
                "s": "item_absorbfire_percent",
                "type": "other",
                "f": 1
            }
        ],
        "abs-fire": [
            {
                "s": "item_absorbfire",
                "type": "other",
                "f": 1
            }
        ],
        "abs-ltng%": [
            {
                "s": "item_absorblight_percent",
                "type": "other",
                "f": 1
            }
        ],
        "abs-ltng": [
            {
                "s": "item_absorblight",
                "type": "other",
                "f": 1
            }
        ],
        "abs-mag%": [
            {
                "s": "item_absorbmagic_percent",
                "type": "other",
                "f": 1
            }
        ],
        "abs-mag": [
            {
                "s": "item_absorbmagic",
                "type": "other",
                "f": 1
            }
        ],
        "abs-cold%": [
            {
                "s": "item_absorbcold_percent",
                "type": "other",
                "f": 1
            }
        ],
        "abs-cold": [
            {
                "s": "item_absorbcold",
                "type": "other",
                "f": 1
            }
        ],
        "dur": [
            {
                "s": "maxdurability",
                "type": "other",
                "f": 1
            }
        ],
        "dur%": [
            {
                "s": "item_maxdurability_percent",
                "type": "other",
                "f": 13
            }
        ],
        "regen": [
            {
                "s": "hpregen",
                "type": "other",
                "f": 1
            }
        ],
        "thorns": [
            {
                "s": "item_attackertakesdamage",
                "type": "other",
                "f": 1
            }
        ],
        "swing1": [
            {
                "s": "item_fasterattackrate",
                "type": "other",
                "f": 8
            }
        ],
        "swing2": [
            {
                "s": "item_fasterattackrate",
                "type": "other",
                "f": 8
            }
        ],
        "swing3": [
            {
                "s": "item_fasterattackrate",
                "type": "other",
                "f": 8
            }
        ],
        "gold%": [
            {
                "s": "item_goldbonus",
                "type": "other",
                "f": 1
            }
        ],
        "mag%": [
            {
                "s": "item_magicbonus",
                "type": "other",
                "f": 1
            }
        ],
        "knock": [
            {
                "s": "item_knockback",
                "type": "other",
                "f": 1
            }
        ],
        "regen-stam": [
            {
                "s": "staminarecoverybonus",
                "type": "other",
                "f": 1
            }
        ],
        "regen-mana": [
            {
                "s": "manarecoverybonus",
                "type": "other",
                "f": 1
            }
        ],
        "stam": [
            {
                "s": "maxstamina",
                "type": "other",
                "f": 1
            }
        ],
        "time": [
            {
                "s": "item_timeduration",
                "type": "other",
                "f": 1
            }
        ],
        "manasteal": [
            {
                "s": "manadrainmindam",
                "type": "other",
                "f": 1
            }
        ],
        "lifesteal": [
            {
                "s": "lifedrainmindam",
                "type": "other",
                "f": 1
            }
        ],
        "ama": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 0
            }
        ],
        "pal": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 3
            }
        ],
        "nec": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 2
            }
        ],
        "sor": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 1
            }
        ],
        "bar": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 4
            }
        ],
        "herb": [
            {
                "s": "item_doubleherbduration",
                "type": "other",
                "f": 1
            }
        ],
        "light": [
            {
                "s": "item_lightradius",
                "type": "other",
                "f": 1
            }
        ],
        "color": [
            {
                "s": "item_lightcolor",
                "type": "other",
                "f": 1
            }
        ],
        "ease": [
            {
                "s": "item_req_percent",
                "type": "other",
                "f": 1
            }
        ],
        "move1": [
            {
                "s": "item_fastermovevelocity",
                "type": "other",
                "f": 8
            }
        ],
        "move2": [
            {
                "s": "item_fastermovevelocity",
                "type": "other",
                "f": 8
            }
        ],
        "move3": [
            {
                "s": "item_fastermovevelocity",
                "type": "other",
                "f": 8
            }
        ],
        "balance1": [
            {
                "s": "item_fastergethitrate",
                "type": "other",
                "f": 8
            }
        ],
        "balance2": [
            {
                "s": "item_fastergethitrate",
                "type": "other",
                "f": 8
            }
        ],
        "balance3": [
            {
                "s": "item_fastergethitrate",
                "type": "other",
                "f": 8
            }
        ],
        "block1": [
            {
                "s": "item_fasterblockrate",
                "type": "other",
                "f": 8
            }
        ],
        "block2": [
            {
                "s": "item_fasterblockrate",
                "type": "other",
                "f": 8
            }
        ],
        "block3": [
            {
                "s": "item_fasterblockrate",
                "type": "other",
                "f": 8
            }
        ],
        "cast1": [
            {
                "s": "item_fastercastrate",
                "type": "other",
                "f": 8
            }
        ],
        "cast2": [
            {
                "s": "item_fastercastrate",
                "type": "other",
                "f": 8
            }
        ],
        "cast3": [
            {
                "s": "item_fastercastrate",
                "type": "other",
                "f": 8
            }
        ],
        "res-pois-len": [
            {
                "s": "item_poisonlengthresist",
                "type": "other",
                "f": 1
            }
        ],
        "dmg": [
            {
                "s": "item_normaldamage",
                "type": "other",
                "f": 1
            }
        ],
        "howl": [
            {
                "s": "item_howl",
                "type": "other",
                "f": 1
            }
        ],
        "stupidity": [
            {
                "s": "item_stupidity",
                "type": "other",
                "f": 1
            }
        ],
        "ignore-ac": [
            {
                "s": "item_ignoretargetac",
                "type": "other",
                "f": 1
            }
        ],
        "reduce-ac": [
            {
                "s": "item_fractionaltargetac",
                "type": "other",
                "f": 1
            }
        ],
        "noheal": [
            {
                "s": "item_preventheal",
                "type": "other",
                "f": 1
            }
        ],
        "half-freeze": [
            {
                "s": "item_halffreezeduration",
                "type": "other",
                "f": 1
            }
        ],
        "att%": [
            {
                "s": "item_tohit_percent",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-ac": [
            {
                "s": "item_damagetargetac",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-demon": [
            {
                "s": "item_demondamage_percent",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-undead": [
            {
                "s": "item_undeaddamage_percent",
                "type": "other",
                "f": 1
            }
        ],
        "att-demon": [
            {
                "s": "item_demon_tohit",
                "type": "other",
                "f": 1
            }
        ],
        "att-undead": [
            {
                "s": "item_undead_tohit",
                "type": "other",
                "f": 1
            }
        ],
        "throw": [
            {
                "s": "item_throwable",
                "type": "other",
                "f": 1
            }
        ],
        "fireskill": [
            {
                "s": "item_elemskill",
                "type": "other",
                "f": 21,
                "val": 1
            }
        ],
        "allskills": [
            {
                "s": "item_allskills",
                "type": "other",
                "f": 1
            }
        ],
        "light-thorns": [
            {
                "s": "item_attackertakeslightdamage",
                "type": "other",
                "f": 1
            }
        ],
        "freeze": [
            {
                "s": "item_freeze",
                "type": "other",
                "f": 1
            }
        ],
        "openwounds": [
            {
                "s": "item_openwounds",
                "type": "other",
                "f": 1
            }
        ],
        "crush": [
            {
                "s": "item_crushingblow",
                "type": "other",
                "f": 1
            }
        ],
        "kick": [
            {
                "s": "item_kickdamage",
                "type": "other",
                "f": 1
            }
        ],
        "mana-kill": [
            {
                "s": "item_manaafterkill",
                "type": "other",
                "f": 1
            }
        ],
        "demon-heal": [
            {
                "s": "item_healafterdemonkill",
                "type": "other",
                "f": 1
            }
        ],
        "bloody": [
            {
                "s": "item_extrablood",
                "type": "other",
                "f": 1
            }
        ],
        "deadly": [
            {
                "s": "item_deadlystrike",
                "type": "other",
                "f": 1
            }
        ],
        "slow": [
            {
                "s": "item_slow",
                "type": "other",
                "f": 1
            }
        ],
        "nofreeze": [
            {
                "s": "item_cannotbefrozen",
                "type": "other",
                "f": 1
            }
        ],
        "stamdrain": [
            {
                "s": "item_staminadrainpct",
                "type": "other",
                "f": 1
            }
        ],
        "reanimate": [
            {
                "s": "item_reanimate",
                "type": "other",
                "f": 24
            }
        ],
        "pierce": [
            {
                "s": "item_pierce",
                "type": "other",
                "f": 1
            }
        ],
        "magicarrow": [
            {
                "s": "item_magicarrow",
                "type": "other",
                "f": 1
            }
        ],
        "explosivearrow": [
            {
                "s": "item_explosivearrow",
                "type": "other",
                "f": 1
            }
        ],
        "dru": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 5
            }
        ],
        "ass": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 21,
                "val": 6
            }
        ],
        "skill": [
            {
                "s": "item_singleskill",
                "type": "other",
                "f": 22
            }
        ],
        "skilltab": [
            {
                "s": "item_addskill_tab",
                "type": "other",
                "f": 10
            }
        ],
        "aura": [
            {
                "s": "item_aura",
                "type": "other",
                "f": 22
            }
        ],
        "att-skill": [
            {
                "s": "item_skillonattack",
                "type": "proc",
                "f": 11
            }
        ],
        "hit-skill": [
            {
                "s": "item_skillonhit",
                "type": "proc",
                "f": 11
            }
        ],
        "gethit-skill": [
            {
                "s": "item_skillongethit",
                "type": "proc",
                "f": 11
            }
        ],
        "gembonus": [],
        "regen-dur": [],
        "fire-fx": [],
        "ltng-fx": [],
        "sock": [
            {
                "s": "item_numsockets",
                "type": "other",
                "f": 14
            }
        ],
        "dmg-fire": [
            {
                "s": "firemindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "firemaxdam",
                "type": "max",
                "f": 16
            }
        ],
        "dmg-ltng": [
            {
                "s": "lightmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "lightmaxdam",
                "type": "max",
                "f": 16
            }
        ],
        "dmg-mag": [
            {
                "s": "magicmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "magicmaxdam",
                "type": "max",
                "f": 16
            }
        ],
        "dmg-cold": [
            {
                "s": "coldmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "coldmaxdam",
                "type": "max",
                "f": 16
            },
            {
                "s": "coldlength",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-pois": [
            {
                "s": "poisonmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "poisonmaxdam",
                "type": "max",
                "f": 16
            },
            {
                "s": "poisonlength",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-throw": [
            {
                "s": "item_throw_mindamage",
                "type": "min",
                "f": 15
            },
            {
                "s": "item_throw_maxdamage",
                "type": "max",
                "f": 16
            }
        ],
        "dmg-norm": [
            {
                "s": "mindamage",
                "type": "min",
                "f": 15
            },
            {
                "s": "maxdamage",
                "type": "max",
                "f": 16
            }
        ],
        "ac/lvl": [
            {
                "s": "item_armor_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "ac%/lvl": [
            {
                "s": "item_armorpercent_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "hp/lvl": [
            {
                "s": "item_hp_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "mana/lvl": [
            {
                "s": "item_mana_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg/lvl": [
            {
                "s": "item_maxdamage_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg%/lvl": [
            {
                "s": "item_maxdamage_percent_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "str/lvl": [
            {
                "s": "item_strength_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dex/lvl": [
            {
                "s": "item_dexterity_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "enr/lvl": [
            {
                "s": "item_energy_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "vit/lvl": [
            {
                "s": "item_vitality_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "att/lvl": [
            {
                "s": "item_tohit_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "att%/lvl": [
            {
                "s": "item_tohitpercent_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-cold/lvl": [
            {
                "s": "item_cold_damagemax_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-fire/lvl": [
            {
                "s": "item_fire_damagemax_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-ltng/lvl": [
            {
                "s": "item_ltng_damagemax_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-pois/lvl": [
            {
                "s": "item_pois_damagemax_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "res-cold/lvl": [
            {
                "s": "item_resist_cold_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "res-fire/lvl": [
            {
                "s": "item_resist_fire_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "res-ltng/lvl": [
            {
                "s": "item_resist_ltng_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "res-pois/lvl": [
            {
                "s": "item_resist_pois_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "abs-cold/lvl": [
            {
                "s": "item_absorb_cold_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "abs-fire/lvl": [
            {
                "s": "item_absorb_fire_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "abs-ltng/lvl": [
            {
                "s": "item_absorb_ltng_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "abs-pois/lvl": [
            {
                "s": "item_absorb_pois_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "thorns/lvl": [
            {
                "s": "item_thorns_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "gold%/lvl": [
            {
                "s": "item_find_gold_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "mag%/lvl": [
            {
                "s": "item_find_magic_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "regen-stam/lvl": [
            {
                "s": "item_regenstamina_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "stam/lvl": [
            {
                "s": "item_stamina_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-dem/lvl": [
            {
                "s": "item_damage_demon_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-und/lvl": [
            {
                "s": "item_damage_undead_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "att-dem/lvl": [
            {
                "s": "item_tohit_demon_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "att-und/lvl": [
            {
                "s": "item_tohit_undead_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "crush/lvl": [
            {
                "s": "item_crushingblow_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "wounds/lvl": [
            {
                "s": "item_openwounds_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "kick/lvl": [
            {
                "s": "item_kick_damage_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "deadly/lvl": [
            {
                "s": "item_deadlystrike_perlevel",
                "type": "param",
                "f": 17
            }
        ],
        "gems%/lvl": [],
        "rep-dur": [
            {
                "s": "item_replenish_durability",
                "type": "param",
                "f": 17
            }
        ],
        "rep-quant": [
            {
                "s": "item_replenish_quantity",
                "type": "param",
                "f": 17
            }
        ],
        "stack": [
            {
                "s": "item_extra_stack",
                "type": "other",
                "f": 1
            }
        ],
        "item%": [],
        "dmg-slash": [],
        "dmg-slash%": [],
        "dmg-crush": [],
        "dmg-crush%": [],
        "dmg-thrust": [],
        "dmg-thrust%": [],
        "abs-slash": [],
        "abs-crush": [],
        "abs-thrust": [],
        "abs-slash%": [],
        "abs-crush%": [],
        "abs-thrust%": [],
        "ac/time": [
            {
                "s": "item_armor_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "ac%/time": [
            {
                "s": "item_armorpercent_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "hp/time": [
            {
                "s": "item_hp_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "mana/time": [
            {
                "s": "item_mana_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg/time": [
            {
                "s": "item_maxdamage_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg%/time": [
            {
                "s": "item_maxdamage_percent_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "str/time": [
            {
                "s": "item_strength_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dex/time": [
            {
                "s": "item_dexterity_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "enr/time": [
            {
                "s": "item_energy_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "vit/time": [
            {
                "s": "item_vitality_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "att/time": [
            {
                "s": "item_tohit_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "att%/time": [
            {
                "s": "item_tohitpercent_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-cold/time": [
            {
                "s": "item_cold_damagemax_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-fire/time": [
            {
                "s": "item_fire_damagemax_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-ltng/time": [
            {
                "s": "item_ltng_damagemax_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-pois/time": [
            {
                "s": "item_pois_damagemax_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "res-cold/time": [
            {
                "s": "item_resist_cold_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "res-fire/time": [
            {
                "s": "item_resist_fire_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "res-ltng/time": [
            {
                "s": "item_resist_ltng_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "res-pois/time": [
            {
                "s": "item_resist_pois_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "abs-cold/time": [
            {
                "s": "item_absorb_cold_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "abs-fire/time": [
            {
                "s": "item_absorb_fire_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "abs-ltng/time": [
            {
                "s": "item_absorb_ltng_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "abs-pois/time": [
            {
                "s": "item_absorb_pois_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "gold%/time": [
            {
                "s": "item_find_gold_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "mag%/time": [
            {
                "s": "item_find_magic_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "regen-stam/time": [
            {
                "s": "item_regenstamina_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "stam/time": [
            {
                "s": "item_stamina_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-dem/time": [
            {
                "s": "item_damage_demon_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "dmg-und/time": [
            {
                "s": "item_damage_undead_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "att-dem/time": [
            {
                "s": "item_tohit_demon_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "att-und/time": [
            {
                "s": "item_tohit_undead_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "crush/time": [
            {
                "s": "item_crushingblow_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "wounds/time": [
            {
                "s": "item_openwounds_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "kick/time": [
            {
                "s": "item_kick_damage_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "deadly/time": [
            {
                "s": "item_deadlystrike_bytime",
                "type": "other",
                "f": 18
            }
        ],
        "gems%/time": [],
        "pierce-fire": [
            {
                "s": "passive_fire_pierce",
                "type": "other",
                "f": 1
            }
        ],
        "pierce-ltng": [
            {
                "s": "passive_ltng_pierce",
                "type": "other",
                "f": 1
            }
        ],
        "pierce-cold": [
            {
                "s": "passive_cold_pierce",
                "type": "other",
                "f": 1
            }
        ],
        "pierce-pois": [
            {
                "s": "passive_pois_pierce",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-mon": [],
        "dmg%-mon": [],
        "att-mon": [],
        "att%-mon": [],
        "ac-mon": [],
        "ac%-mon": [],
        "indestruct": [
            {
                "s": "item_indesctructible",
                "type": "other",
                "f": 20
            }
        ],
        "charged": [
            {
                "s": "item_charged_skill",
                "type": "charges",
                "f": 19
            }
        ],
        "extra-fire": [
            {
                "s": "passive_fire_mastery",
                "type": "other",
                "f": 1
            }
        ],
        "extra-ltng": [
            {
                "s": "passive_ltng_mastery",
                "type": "other",
                "f": 1
            }
        ],
        "extra-cold": [
            {
                "s": "passive_cold_mastery",
                "type": "other",
                "f": 1
            }
        ],
        "extra-pois": [
            {
                "s": "passive_pois_mastery",
                "type": "other",
                "f": 1
            }
        ],
        "dmg-elem": [
            {
                "s": "firemindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "firemaxdam",
                "type": "max",
                "f": 16
            },
            {
                "s": "lightmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "lightmaxdam",
                "type": "max",
                "f": 16
            },
            {
                "s": "coldmindam",
                "type": "min",
                "f": 15
            },
            {
                "s": "coldmaxdam",
                "type": "max",
                "f": 16
            },
            {
                "s": "coldlength",
                "type": "param",
                "f": 17
            }
        ],
        "dmg-elem-min": [
            {
                "s": "firemindam",
                "type": "other",
                "f": 1
            },
            {
                "s": "lightmindam",
                "type": "all",
                "f": 3
            },
            {
                "s": "coldmindam",
                "type": "all",
                "f": 3
            }
        ],
        "dmg-elem-max": [
            {
                "s": "firemaxdam",
                "type": "other",
                "f": 1
            },
            {
                "s": "lightmaxdam",
                "type": "all",
                "f": 3
            },
            {
                "s": "coldmaxdam",
                "type": "all",
                "f": 3
            },
            {
                "s": "coldlength",
                "type": "param",
                "f": 17
            }
        ],
        "all-stats": [
            {
                "s": "strength",
                "type": "other",
                "f": 1
            },
            {
                "s": "energy",
                "type": "all",
                "f": 3
            },
            {
                "s": "dexterity",
                "type": "all",
                "f": 3
            },
            {
                "s": "vitality",
                "type": "all",
                "f": 3
            }
        ],
        "addxp": [
            {
                "s": "item_addexperience",
                "type": "other",
                "f": 1
            }
        ],
        "heal-kill": [
            {
                "s": "item_healafterkill",
                "type": "other",
                "f": 1
            }
        ],
        "cheap": [
            {
                "s": "item_reducedprices",
                "type": "other",
                "f": 1
            }
        ],
        "rip": [
            {
                "s": "item_restinpeace",
                "type": "other",
                "f": 1
            }
        ],
        "att-mon%": [
            {
                "s": "attack_vs_montype",
                "type": "other",
                "f": 24
            }
        ],
        "dmg-mon%": [
            {
                "s": "damage_vs_montype",
                "type": "other",
                "f": 24
            }
        ],
        "kill-skill": [
            {
                "s": "item_skillonkill",
                "type": "proc",
                "f": 11
            }
        ],
        "death-skill": [
            {
                "s": "item_skillondeath",
                "type": "proc",
                "f": 11
            }
        ],
        "levelup-skill": [
            {
                "s": "item_skillonlevelup",
                "type": "proc",
                "f": 11
            }
        ],
        "skill-rand": [
            {
                "s": "item_singleskill",
                "type": "other",
                "f": 12
            }
        ],
        "fade": [
            {
                "s": "fade",
                "type": "param",
                "f": 17
            }
        ],
        "levelreq": [
            {
                "s": "item_levelreq",
                "type": "other",
                "f": 1
            }
        ],
        "ethereal": [
            {
                "type": "other",
                "f": 23
            }
        ],
        "oskill": [
            {
                "s": "item_nonclassskill",
                "type": "other",
                "f": 22
            }
        ],
        "state": [
            {
                "s": "state",
                "type": "other",
                "f": 24
            }
        ],
        "randclassskill": [
            {
                "s": "item_addclassskills",
                "type": "other",
                "f": 36,
                "val": 3
            }
        ],
        "noconsume": [
            {
                "s": "item_noconsume",
                "type": "other",
                "f": 1
            }
        ],
        "": []
    },
    "magical_properties": [
        {
            "id": 0,
            "s": "strength",
            "cB": 10,
            "cS": 0,
            "sB": 8,
            "sA": 32,
            "so": 67,
            "dF": 19,
            "dP": "to Strength",
            "dN": "to all Attributes",
            "dg": 1,
            "dgF": 19,
            "dgP": "to all Attributes"
        },
        {
            "id": 1,
            "s": "energy",
            "cB": 10,
            "cS": 0,
            "sB": 7,
            "sA": 32,
            "so": 61,
            "dF": 19,
            "dP": "to Energy",
            "dN": "to all Attributes",
            "dg": 1,
            "dgF": 19,
            "dgP": "to all Attributes",
            "o": 8,
            "os": [
                "maxmana"
            ]
        },
        {
            "id": 2,
            "s": "dexterity",
            "cB": 10,
            "cS": 0,
            "sB": 7,
            "sA": 32,
            "so": 65,
            "dF": 19,
            "dP": "to Dexterity",
            "dN": "to all Attributes",
            "dg": 1,
            "dgF": 19,
            "dgP": "to all Attributes"
        },
        {
            "id": 3,
            "s": "vitality",
            "cB": 10,
            "cS": 0,
            "sB": 7,
            "sA": 32,
            "so": 63,
            "dF": 19,
            "dP": "to Vitality",
            "dN": "to all Attributes",
            "dg": 1,
            "dgF": 19,
            "dgP": "to all Attributes",
            "o": 9,
            "os": [
                "maxhp",
                "maxstamina"
            ]
        },
        {
            "id": 4,
            "s": "statpts",
            "cB": 10,
            "cS": 0
        },
        {
            "id": 5,
            "s": "newskills",
            "cB": 8,
            "cS": 0
        },
        {
            "id": 6,
            "s": "hitpoints",
            "cB": 21,
            "cS": 0,
            "vS": 8
        },
        {
            "id": 7,
            "s": "maxhp",
            "cB": 21,
            "cS": 0,
            "vS": 8,
            "sB": 9,
            "sA": 32,
            "so": 59,
            "dF": 19,
            "dP": "to Life",
            "dN": "to Life"
        },
        {
            "id": 8,
            "s": "mana",
            "cB": 21,
            "cS": 0,
            "vS": 8
        },
        {
            "id": 9,
            "s": "maxmana",
            "cB": 21,
            "cS": 0,
            "vS": 8,
            "sB": 8,
            "sA": 32,
            "so": 55,
            "dF": 19,
            "dP": "to Mana",
            "dN": "to Mana"
        },
        {
            "id": 10,
            "s": "stamina",
            "cB": 21,
            "cS": 0,
            "vS": 8
        },
        {
            "id": 11,
            "s": "maxstamina",
            "cB": 21,
            "cS": 0,
            "vS": 8,
            "sB": 8,
            "sA": 32,
            "so": 51,
            "dF": 19,
            "dP": "Maximum Stamina",
            "dN": "Maximum Stamina"
        },
        {
            "id": 12,
            "s": "level",
            "cB": 7,
            "cS": 0
        },
        {
            "id": 13,
            "s": "experience",
            "cB": 32,
            "cS": 0
        },
        {
            "id": 14,
            "s": "gold",
            "cB": 25,
            "cS": 0
        },
        {
            "id": 15,
            "s": "goldbank",
            "cB": 25,
            "cS": 0
        },
        {
            "id": 16,
            "s": "item_armor_percent",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 74,
            "dF": 19,
            "dP": "Enhanced Defense",
            "dN": "Enhanced Defense",
            "o": 13,
            "os": [
                "armorclass"
            ]
        },
        {
            "id": 17,
            "s": "item_maxdamage_percent",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 129,
            "dF": 19,
            "dP": "Enhanced Maximum Damage",
            "dN": "Enhanced Maximum Damage",
            "o": 13,
            "os": [
                "maxdamage",
                "secondary_maxdamage",
                "item_throw_maxdamage"
            ],
            "np": 2,
            "dR": "Adds %d-%d damage",
            "dE": "Enhanced Damage}"
        },
        {
            "id": 18,
            "s": "item_mindamage_percent",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 130,
            "dF": 19,
            "dP": "Enhanced Minimum Damage",
            "dN": "Enhanced Minimum Damage",
            "o": 13,
            "os": [
                "mindamage",
                "secondary_mindamage",
                "item_throw_mindamage"
            ]
        },
        {
            "id": 19,
            "s": "tohit",
            "sS": 1,
            "sB": 10,
            "so": 115,
            "dF": 19,
            "dP": "to Attack Rating",
            "dN": "to Attack Rating"
        },
        {
            "id": 20,
            "s": "toblock",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 134,
            "dF": 19,
            "dP": "Increased Chance of Blocking",
            "dN": "Increased Chance of Blocking"
        },
        {
            "id": 21,
            "s": "mindamage",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 127,
            "dF": 19,
            "dP": "to Minimum Damage",
            "dN": "to Minimum Damage"
        },
        {
            "id": 22,
            "s": "maxdamage",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 126,
            "dF": 19,
            "dP": "to Maximum Damage",
            "dN": "to Maximum Damage"
        },
        {
            "id": 23,
            "s": "secondary_mindamage",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 124,
            "dF": 19,
            "dP": "to Minimum Damage",
            "dN": "to Minimum Damage"
        },
        {
            "id": 24,
            "s": "secondary_maxdamage",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 123,
            "dF": 19,
            "dP": "to Maximum Damage",
            "dN": "to Maximum Damage"
        },
        {
            "id": 25,
            "s": "damagepercent",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 26,
            "s": "manarecovery",
            "sB": 8,
            "sA": 0
        },
        {
            "id": 27,
            "s": "manarecoverybonus",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 52,
            "dF": 19,
            "dP": "Regenerate Mana",
            "dN": "Regenerate Mana"
        },
        {
            "id": 28,
            "s": "staminarecoverybonus",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 48,
            "dF": 19,
            "dP": "Heal Stamina Plus",
            "dN": "Heal Stamina Plus"
        },
        {
            "id": 29,
            "s": "lastexp"
        },
        {
            "id": 30,
            "s": "nextexp"
        },
        {
            "id": 31,
            "s": "armorclass",
            "sS": 1,
            "sB": 11,
            "sA": 10,
            "so": 71,
            "dF": 19,
            "dP": "Defense",
            "dN": "Defense"
        },
        {
            "id": 32,
            "s": "armorclass_vs_missile",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 69,
            "dF": 19,
            "dP": "Defense vs. Missile",
            "dN": "Defense vs. Missile"
        },
        {
            "id": 33,
            "s": "armorclass_vs_hth",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 70,
            "dF": 19,
            "dP": "Defense vs. Melee",
            "dN": "Defense vs. Melee"
        },
        {
            "id": 34,
            "s": "normal_damage_reduction",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 22,
            "dF": 19,
            "dP": "Damage Reduced by",
            "dN": "Damage Reduced by"
        },
        {
            "id": 35,
            "s": "magic_damage_reduction",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 21,
            "dF": 19,
            "dP": "Magic Damage Reduced by",
            "dN": "Magic Damage Reduced by"
        },
        {
            "id": 36,
            "s": "damageresist",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 22,
            "dF": 19
        },
        {
            "id": 37,
            "s": "magicresist",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 41,
            "dF": 19,
            "dP": "Magic Resist",
            "dN": "Magic Resist"
        },
        {
            "id": 38,
            "s": "maxmagicresist",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 46,
            "dF": 19,
            "dP": "to Maximum Magic Resist",
            "dN": "to Maximum Magic Resist"
        },
        {
            "id": 39,
            "s": "fireresist",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 36,
            "dF": 19,
            "dP": "Fire Resist",
            "dN": "All Resistances +%d",
            "dg": 2,
            "dgF": 19,
            "dgP": "All Resistances +%d"
        },
        {
            "id": 40,
            "s": "maxfireresist",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 42,
            "dF": 19,
            "dP": "to Maximum Fire Resist",
            "dN": "to Maximum Fire Resist"
        },
        {
            "id": 41,
            "s": "lightresist",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 38,
            "dF": 19,
            "dP": "Lightning Resist",
            "dN": "All Resistances +%d",
            "dg": 2,
            "dgF": 19,
            "dgP": "All Resistances +%d"
        },
        {
            "id": 42,
            "s": "maxlightresist",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 43,
            "dF": 19,
            "dP": "to Maximum Lightning Resist",
            "dN": "to Maximum Lightning Resist"
        },
        {
            "id": 43,
            "s": "coldresist",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 40,
            "dF": 19,
            "dP": "Cold Resist",
            "dN": "All Resistances +%d",
            "dg": 2,
            "dgF": 19,
            "dgP": "All Resistances +%d"
        },
        {
            "id": 44,
            "s": "maxcoldresist",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 44,
            "dF": 19,
            "dP": "to Maximum Cold Resist",
            "dN": "to Maximum Cold Resist"
        },
        {
            "id": 45,
            "s": "poisonresist",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 34,
            "dF": 19,
            "dP": "Poison Resist",
            "dN": "All Resistances +%d",
            "dg": 2,
            "dgF": 19,
            "dgP": "All Resistances +%d"
        },
        {
            "id": 46,
            "s": "maxpoisonresist",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 45,
            "dF": 19,
            "dP": "to Maximum Poison Resist",
            "dN": "to Maximum Poison Resist"
        },
        {
            "id": 47,
            "s": "damageaura",
            "sS": 1
        },
        {
            "id": 48,
            "s": "firemindam",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 102,
            "dF": 19,
            "dP": "to Minimum Fire Damage",
            "dN": "to Minimum Fire Damage",
            "np": 2,
            "dR": "Adds %d-%d fire damage",
            "dE": "+%d fire damage"
        },
        {
            "id": 49,
            "s": "firemaxdam",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 101,
            "dF": 19,
            "dP": "to Maximum Fire Damage",
            "dN": "to Maximum Fire Damage"
        },
        {
            "id": 50,
            "s": "lightmindam",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 99,
            "dF": 19,
            "dP": "to Minimum Lightning Damage",
            "dN": "to Minimum Lightning Damage",
            "np": 2,
            "dR": "Adds %d-%d lightning damage",
            "dE": "+%d lightning damage"
        },
        {
            "id": 51,
            "s": "lightmaxdam",
            "sS": 1,
            "sB": 10,
            "sA": 0,
            "so": 98,
            "dF": 19,
            "dP": "to Maximum Lightning Damage",
            "dN": "to Maximum Lightning Damage"
        },
        {
            "id": 52,
            "s": "magicmindam",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 104,
            "dF": 19,
            "dP": "+%d magic damage",
            "dN": "+%d magic damage",
            "np": 2,
            "dR": "Adds %d-%d magic damage",
            "dE": "+%d magic damage"
        },
        {
            "id": 53,
            "s": "magicmaxdam",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 103,
            "dF": 19,
            "dP": "+%d magic damage",
            "dN": "+%d magic damage"
        },
        {
            "id": 54,
            "s": "coldmindam",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 96,
            "dF": 19,
            "dP": "to Minimum Cold Damage",
            "dN": "to Minimum Cold Damage",
            "np": 3,
            "dR": "Adds %d-%d cold damage",
            "dE": "+%d cold damage"
        },
        {
            "id": 55,
            "s": "coldmaxdam",
            "sS": 1,
            "sB": 9,
            "sA": 0,
            "so": 95,
            "dF": 19,
            "dP": "to Maximum Cold Damage",
            "dN": "to Maximum Cold Damage"
        },
        {
            "id": 56,
            "s": "coldlength",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 57,
            "s": "poisonmindam",
            "sS": 1,
            "sB": 10,
            "sA": 0,
            "so": 92,
            "dF": 19,
            "dP": "to Minimum Poison Damage",
            "dN": "to Minimum Poison Damage",
            "np": 3,
            "dR": "Adds %d-%d poison damage over %d seconds",
            "dE": "+%d poison damage over %d seconds"
        },
        {
            "id": 58,
            "s": "poisonmaxdam",
            "sS": 1,
            "sB": 10,
            "sA": 0,
            "so": 91,
            "dF": 19,
            "dP": "to Maximum Poison Damage",
            "dN": "to Maximum Poison Damage"
        },
        {
            "id": 59,
            "s": "poisonlength",
            "sS": 1,
            "sB": 9,
            "sA": 0
        },
        {
            "id": 60,
            "s": "lifedrainmindam",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 88,
            "dF": 19,
            "dP": "Life stolen per hit",
            "dN": "Life stolen per hit"
        },
        {
            "id": 61,
            "s": "lifedrainmaxdam",
            "sS": 1
        },
        {
            "id": 62,
            "s": "manadrainmindam",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 89,
            "dF": 19,
            "dP": "Mana stolen per hit",
            "dN": "Mana stolen per hit"
        },
        {
            "id": 63,
            "s": "manadrainmaxdam",
            "sS": 1
        },
        {
            "id": 64,
            "s": "stamdrainmindam",
            "sS": 1
        },
        {
            "id": 65,
            "s": "stamdrainmaxdam",
            "sS": 1
        },
        {
            "id": 66,
            "s": "stunlength"
        },
        {
            "id": 67,
            "s": "velocitypercent",
            "sS": 1,
            "sB": 7,
            "sA": 30
        },
        {
            "id": 68,
            "s": "attackrate",
            "sS": 1,
            "sB": 7,
            "sA": 30
        },
        {
            "id": 69,
            "s": "other_animrate",
            "sS": 1
        },
        {
            "id": 70,
            "s": "quantity",
            "sS": 1
        },
        {
            "id": 71,
            "s": "value",
            "sS": 1,
            "sB": 8,
            "sA": 100
        },
        {
            "id": 72,
            "s": "durability",
            "sS": 1,
            "sB": 9,
            "sA": 0
        },
        {
            "id": 73,
            "s": "maxdurability",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 74,
            "s": "hpregen",
            "sB": 6,
            "sA": 30,
            "so": 56,
            "dF": 19,
            "dP": "Replenish Life",
            "dN": "Drain Life"
        },
        {
            "id": 75,
            "s": "item_maxdurability_percent",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 3,
            "dF": 19,
            "dP": "Increase Maximum Durability",
            "dN": "Increase Maximum Durability",
            "o": 13,
            "os": [
                "maxdurability"
            ]
        },
        {
            "id": 76,
            "s": "item_maxhp_percent",
            "sS": 1,
            "sB": 6,
            "sA": 10,
            "so": 58,
            "dF": 19,
            "dP": "Increase Maximum Life",
            "dN": "Increase Maximum Life",
            "o": 11,
            "os": [
                "maxhp"
            ]
        },
        {
            "id": 77,
            "s": "item_maxmana_percent",
            "sS": 1,
            "sB": 6,
            "sA": 10,
            "so": 54,
            "dF": 19,
            "dP": "Increase Maximum Mana",
            "dN": "Increase Maximum Mana",
            "o": 11,
            "os": [
                "maxmana"
            ]
        },
        {
            "id": 78,
            "s": "item_attackertakesdamage",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 13,
            "dF": 19,
            "dP": "Attacker Takes Damage of",
            "dN": "Attacker Takes Damage of"
        },
        {
            "id": 79,
            "s": "item_goldbonus",
            "sS": 1,
            "sB": 9,
            "sA": 100,
            "so": 10,
            "dF": 19,
            "dP": "Extra Gold from Monsters",
            "dN": "Extra Gold from Monsters"
        },
        {
            "id": 80,
            "s": "item_magicbonus",
            "sS": 1,
            "sB": 8,
            "sA": 100,
            "so": 8,
            "dF": 19,
            "dP": "Better Chance of Getting Magic Items",
            "dN": "Better Chance of Getting Magic Items"
        },
        {
            "id": 81,
            "s": "item_knockback",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 76,
            "dF": 19,
            "dP": "Knockback",
            "dN": "Knockback"
        },
        {
            "id": 82,
            "s": "item_timeduration",
            "sS": 1,
            "sB": 9,
            "sA": 20
        },
        {
            "id": 83,
            "s": "item_addclassskills",
            "sS": 1,
            "sB": 3,
            "sA": 0,
            "sP": 3,
            "so": 150,
            "dF": 13,
            "dP": "to Amazon Skill Levels",
            "dN": "to Amazon Skill Levels"
        },
        {
            "id": 84,
            "s": "unsentparam1"
        },
        {
            "id": 85,
            "s": "item_addexperience",
            "sS": 1,
            "sB": 9,
            "sA": 50,
            "so": 11,
            "dF": 19,
            "dP": "to Experience Gained",
            "dN": "to Experience Gained"
        },
        {
            "id": 86,
            "s": "item_healafterkill",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 16,
            "dF": 19,
            "dP": "Life after each Kill",
            "dN": "Life after each Kill"
        },
        {
            "id": 87,
            "s": "item_reducedprices",
            "sB": 7,
            "sA": 0,
            "so": 8,
            "dF": 19,
            "dP": "Reduces all Vendor Prices",
            "dN": "Reduces all Vendor Prices"
        },
        {
            "id": 88,
            "s": "item_doubleherbduration",
            "sS": 1,
            "sB": 1,
            "sA": 0
        },
        {
            "id": 89,
            "s": "item_lightradius",
            "sS": 1,
            "sB": 4,
            "sA": 4,
            "so": 6,
            "dF": 19,
            "dP": "to Light Radius",
            "dN": "to Light Radius"
        },
        {
            "id": 90,
            "s": "item_lightcolor",
            "sS": 1,
            "sB": 24,
            "sA": 0
        },
        {
            "id": 91,
            "s": "item_req_percent",
            "sS": 1,
            "sB": 8,
            "sA": 100,
            "so": 0,
            "dF": 19,
            "dP": "Requirements",
            "dN": "Requirements"
        },
        {
            "id": 92,
            "s": "item_levelreq",
            "sB": 7
        },
        {
            "id": 93,
            "s": "item_fasterattackrate",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 145,
            "dF": 19,
            "dP": "Increased Attack Speed",
            "dN": "Increased Attack Speed"
        },
        {
            "id": 94,
            "s": "item_levelreqpct",
            "sB": 7,
            "sA": 64,
            "o": 13,
            "os": [
                "item_levelreq"
            ]
        },
        {
            "id": 95,
            "s": "lastblockframe"
        },
        {
            "id": 96,
            "s": "item_fastermovevelocity",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 148,
            "dF": 19,
            "dP": "Faster Run/Walk",
            "dN": "Faster Run/Walk"
        },
        {
            "id": 97,
            "s": "item_nonclassskill",
            "e": 1,
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "sP": 9,
            "so": 81,
            "dF": 28
        },
        {
            "id": 98,
            "s": "state",
            "sB": 1,
            "sP": 8
        },
        {
            "id": 99,
            "s": "item_fastergethitrate",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 139,
            "dF": 19,
            "dP": "Faster Hit Recovery",
            "dN": "Faster Hit Recovery"
        },
        {
            "id": 100,
            "s": "monster_playercount"
        },
        {
            "id": 101,
            "s": "skill_poison_override_length"
        },
        {
            "id": 102,
            "s": "item_fasterblockrate",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 136,
            "dF": 19,
            "dP": "Faster Block Rate",
            "dN": "Faster Block Rate"
        },
        {
            "id": 103,
            "s": "skill_bypass_undead"
        },
        {
            "id": 104,
            "s": "skill_bypass_demons"
        },
        {
            "id": 105,
            "s": "item_fastercastrate",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 142,
            "dF": 19,
            "dP": "Faster Cast Rate",
            "dN": "Faster Cast Rate"
        },
        {
            "id": 106,
            "s": "skill_bypass_beasts"
        },
        {
            "id": 107,
            "s": "item_singleskill",
            "e": 1,
            "sS": 1,
            "sB": 3,
            "sA": 0,
            "sP": 9,
            "so": 81,
            "dF": 27
        },
        {
            "id": 108,
            "s": "item_restinpeace",
            "sB": 1,
            "sA": 0,
            "so": 81,
            "dF": 19,
            "dP": "Slain Monsters Rest in Peace",
            "dN": "Slain Monsters Rest in Peace"
        },
        {
            "id": 109,
            "s": "curse_resistance",
            "sB": 9,
            "sA": 0
        },
        {
            "id": 110,
            "s": "item_poisonlengthresist",
            "sS": 1,
            "sB": 8,
            "sA": 20,
            "so": 18,
            "dF": 19,
            "dP": "Poison Length Reduced by",
            "dN": "Poison Length Reduced by"
        },
        {
            "id": 111,
            "s": "item_normaldamage",
            "sS": 1,
            "sB": 9,
            "sA": 20,
            "so": 122,
            "dF": 19,
            "dP": "Damage",
            "dN": "Damage"
        },
        {
            "id": 112,
            "s": "item_howl",
            "sS": 1,
            "sB": 7,
            "sA": -1,
            "so": 79,
            "dF": 5,
            "dP": "Hit Causes Monster to Flee",
            "dN": "Hit Causes Monster to Flee"
        },
        {
            "id": 113,
            "s": "item_stupidity",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 80,
            "dF": 12,
            "dV": 2,
            "dP": "Hit Blinds Target",
            "dN": "Hit Blinds Target"
        },
        {
            "id": 114,
            "s": "item_damagetomana",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 11,
            "dF": 19,
            "dP": "Damage Taken Goes To Mana",
            "dN": "Damage Taken Goes To Mana"
        },
        {
            "id": 115,
            "s": "item_ignoretargetac",
            "sS": 1,
            "sB": 1,
            "sA": 0,
            "so": 119,
            "dF": 19,
            "dP": "Ignore Target's Defense",
            "dN": "Ignore Target's Defense"
        },
        {
            "id": 116,
            "s": "item_fractionaltargetac",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 118,
            "dF": 19,
            "dP": "Target Defense",
            "dN": "Target Defense"
        },
        {
            "id": 117,
            "s": "item_preventheal",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 81,
            "dF": 19,
            "dP": "Prevent Monster Heal",
            "dN": "Prevent Monster Heal"
        },
        {
            "id": 118,
            "s": "item_halffreezeduration",
            "sS": 1,
            "sB": 1,
            "sA": 0,
            "so": 19,
            "dF": 19,
            "dP": "Half Freeze Duration",
            "dN": "Half Freeze Duration"
        },
        {
            "id": 119,
            "s": "item_tohit_percent",
            "sS": 1,
            "sB": 9,
            "sA": 20,
            "so": 117,
            "dF": 19,
            "dP": "Bonus to Attack Rating",
            "dN": "Bonus to Attack Rating"
        },
        {
            "id": 120,
            "s": "item_damagetargetac",
            "sS": 1,
            "sB": 7,
            "sA": 128,
            "so": 75,
            "dF": 19,
            "dP": "to Monster Defense Per Hit",
            "dN": "to Monster Defense Per Hit"
        },
        {
            "id": 121,
            "s": "item_demondamage_percent",
            "sS": 1,
            "sB": 9,
            "sA": 20,
            "so": 112,
            "dF": 19,
            "dP": "Damage to Demons",
            "dN": "Damage to Demons"
        },
        {
            "id": 122,
            "s": "item_undeaddamage_percent",
            "sS": 1,
            "sB": 9,
            "sA": 20,
            "so": 108,
            "dF": 19,
            "dP": "Damage to Undead",
            "dN": "Damage to Undead"
        },
        {
            "id": 123,
            "s": "item_demon_tohit",
            "sS": 1,
            "sB": 10,
            "sA": 128,
            "so": 110,
            "dF": 19,
            "dP": "to Attack Rating against Demons",
            "dN": "to Attack Rating against Demons"
        },
        {
            "id": 124,
            "s": "item_undead_tohit",
            "sS": 1,
            "sB": 10,
            "sA": 128,
            "so": 106,
            "dF": 19,
            "dP": "to Attack Rating against Undead",
            "dN": "to Attack Rating against Undead"
        },
        {
            "id": 125,
            "s": "item_throwable",
            "sS": 1,
            "sB": 1,
            "sA": 0,
            "so": 5,
            "dF": 19,
            "dP": "Throwable",
            "dN": "Throwable"
        },
        {
            "id": 126,
            "s": "item_elemskill",
            "sS": 1,
            "sB": 3,
            "sA": 0,
            "sP": 3,
            "so": 157,
            "dF": 19,
            "dP": "to Fire Skills",
            "dN": "to Fire Skills"
        },
        {
            "id": 127,
            "s": "item_allskills",
            "sS": 1,
            "sB": 3,
            "sA": 0,
            "so": 158,
            "dF": 19,
            "dP": "to All Skills",
            "dN": "to All Skills"
        },
        {
            "id": 128,
            "s": "item_attackertakeslightdamage",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 14,
            "dF": 19,
            "dP": "Attacker Takes Lightning Damage of",
            "dN": "Attacker Takes Lightning Damage of"
        },
        {
            "id": 129,
            "s": "ironmaiden_level",
            "sS": 1
        },
        {
            "id": 130,
            "s": "lifetap_level",
            "sS": 1
        },
        {
            "id": 131,
            "s": "thorns_percent"
        },
        {
            "id": 132,
            "s": "bonearmor",
            "sS": 1
        },
        {
            "id": 133,
            "s": "bonearmormax",
            "sS": 1
        },
        {
            "id": 134,
            "s": "item_freeze",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 78,
            "dF": 12,
            "dV": 2,
            "dP": "Freezes target",
            "dN": "Freezes target"
        },
        {
            "id": 135,
            "s": "item_openwounds",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 83,
            "dF": 19,
            "dP": "Chance of Open Wounds",
            "dN": "Chance of Open Wounds"
        },
        {
            "id": 136,
            "s": "item_crushingblow",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 87,
            "dF": 19,
            "dP": "Chance of Crushing Blow",
            "dN": "Chance of Crushing Blow"
        },
        {
            "id": 137,
            "s": "item_kickdamage",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 121,
            "dF": 19,
            "dP": "Kick Damage",
            "dN": "Kick Damage"
        },
        {
            "id": 138,
            "s": "item_manaafterkill",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 16,
            "dF": 19,
            "dP": "to Mana after each Kill",
            "dN": "to Mana after each Kill"
        },
        {
            "id": 139,
            "s": "item_healafterdemonkill",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 15,
            "dF": 19,
            "dP": "Life after each Demon Kill",
            "dN": "Life after each Demon Kill"
        },
        {
            "id": 140,
            "s": "item_extrablood",
            "sS": 1,
            "sB": 7,
            "sA": 0
        },
        {
            "id": 141,
            "s": "item_deadlystrike",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 85,
            "dF": 19,
            "dP": "Deadly Strike",
            "dN": "Deadly Strike"
        },
        {
            "id": 142,
            "s": "item_absorbfire_percent",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 23,
            "dF": 19,
            "dP": "Fire Absorb",
            "dN": "Fire Absorb"
        },
        {
            "id": 143,
            "s": "item_absorbfire",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 27,
            "dF": 19,
            "dP": "Fire Absorb",
            "dN": "Fire Absorb"
        },
        {
            "id": 144,
            "s": "item_absorblight_percent",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 24,
            "dF": 19,
            "dP": "Lightning Absorb",
            "dN": "Lightning Absorb"
        },
        {
            "id": 145,
            "s": "item_absorblight",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 29,
            "dF": 19,
            "dP": "Lightning Absorb",
            "dN": "Lightning Absorb"
        },
        {
            "id": 146,
            "s": "item_absorbmagic_percent",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 26,
            "dF": 19,
            "dP": "Magic Absorb",
            "dN": "Magic Absorb"
        },
        {
            "id": 147,
            "s": "item_absorbmagic",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 33,
            "dF": 19,
            "dP": "Magic Absorb",
            "dN": "Magic Absorb"
        },
        {
            "id": 148,
            "s": "item_absorbcold_percent",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 25,
            "dF": 19,
            "dP": "Cold Absorb",
            "dN": "Cold Absorb"
        },
        {
            "id": 149,
            "s": "item_absorbcold",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 31,
            "dF": 19,
            "dP": "Cold Absorb",
            "dN": "Cold Absorb"
        },
        {
            "id": 150,
            "s": "item_slow",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 77,
            "dF": 19,
            "dP": "Slows Target by",
            "dN": "Slows Target by"
        },
        {
            "id": 151,
            "s": "item_aura",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "sP": 9,
            "so": 159,
            "dF": 16,
            "dV": 0,
            "dP": "Level %d %s Aura When Equipped",
            "dN": "Level %d %s Aura When Equipped"
        },
        {
            "id": 152,
            "s": "item_indesctructible",
            "sS": 1,
            "sB": 1,
            "so": 160,
            "dF": 19,
            "dP": "Indestructible",
            "dN": "Indestructible"
        },
        {
            "id": 153,
            "s": "item_cannotbefrozen",
            "sS": 1,
            "sB": 1,
            "so": 20,
            "dF": 19,
            "dP": "Cannot Be Frozen",
            "dN": "Cannot Be Frozen"
        },
        {
            "id": 154,
            "s": "item_staminadrainpct",
            "sS": 1,
            "sB": 7,
            "sA": 20,
            "so": 49,
            "dF": 19,
            "dP": "Slower Stamina Drain",
            "dN": "Slower Stamina Drain"
        },
        {
            "id": 155,
            "s": "item_reanimate",
            "sB": 7,
            "sA": 0,
            "sP": 10,
            "so": 17,
            "dF": 23,
            "dP": "Reanimate as:",
            "dN": "Reanimate as:"
        },
        {
            "id": 156,
            "s": "item_pierce",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 132,
            "dF": 19,
            "dP": "Piercing Attack",
            "dN": "Piercing Attack"
        },
        {
            "id": 157,
            "s": "item_magicarrow",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 131,
            "dF": 19,
            "dP": "Fires Magic Arrows",
            "dN": "Fires Magic Arrows"
        },
        {
            "id": 158,
            "s": "item_explosivearrow",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 133,
            "dF": 19,
            "dP": "Fires Explosive Arrows or Bolts",
            "dN": "Fires Explosive Arrows or Bolts"
        },
        {
            "id": 159,
            "s": "item_throw_mindamage",
            "sS": 1,
            "sB": 6,
            "sA": 0
        },
        {
            "id": 160,
            "s": "item_throw_maxdamage",
            "sS": 1,
            "sB": 7,
            "sA": 0
        },
        {
            "id": 161,
            "s": "skill_handofathena",
            "sS": 1
        },
        {
            "id": 162,
            "s": "skill_staminapercent",
            "sS": 1,
            "o": 1,
            "os": [
                "maxstamina"
            ]
        },
        {
            "id": 163,
            "s": "skill_passive_staminapercent",
            "sS": 1,
            "o": 1,
            "os": [
                "maxstamina"
            ]
        },
        {
            "id": 164,
            "s": "skill_concentration",
            "sS": 1
        },
        {
            "id": 165,
            "s": "skill_enchant",
            "sS": 1
        },
        {
            "id": 166,
            "s": "skill_pierce",
            "sS": 1
        },
        {
            "id": 167,
            "s": "skill_conviction",
            "sS": 1
        },
        {
            "id": 168,
            "s": "skill_chillingarmor",
            "sS": 1
        },
        {
            "id": 169,
            "s": "skill_frenzy",
            "sS": 1
        },
        {
            "id": 170,
            "s": "skill_decrepify",
            "sS": 1
        },
        {
            "id": 171,
            "s": "skill_armor_percent",
            "sS": 1
        },
        {
            "id": 172,
            "s": "alignment"
        },
        {
            "id": 173,
            "s": "target0"
        },
        {
            "id": 174,
            "s": "target1"
        },
        {
            "id": 175,
            "s": "goldlost"
        },
        {
            "id": 176,
            "s": "conversion_level"
        },
        {
            "id": 177,
            "s": "conversion_maxhp"
        },
        {
            "id": 178,
            "s": "unit_dooverlay"
        },
        {
            "id": 179,
            "s": "attack_vs_montype",
            "sB": 9,
            "sP": 10,
            "so": 108,
            "dF": 22,
            "dP": "to Attack Rating versus",
            "dN": "to Attack Rating versus"
        },
        {
            "id": 180,
            "s": "damage_vs_montype",
            "sB": 9,
            "sP": 10,
            "so": 106,
            "dF": 22,
            "dP": "to Damage versus",
            "dN": "to Damage versus"
        },
        {
            "id": 181,
            "s": "fade",
            "sB": 3
        },
        {
            "id": 182,
            "s": "armor_override_percent",
            "sS": 1
        },
        {
            "id": 183,
            "s": "unused183"
        },
        {
            "id": 184,
            "s": "unused184"
        },
        {
            "id": 185,
            "s": "bonus_mindamage",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 186,
            "s": "bonus_maxdamage",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 187,
            "s": "unused187"
        },
        {
            "id": 188,
            "s": "item_addskill_tab",
            "sS": 1,
            "sB": 3,
            "sA": 0,
            "sP": 16,
            "so": 151,
            "dF": 14,
            "dP": "+%d to Javelin and Spear Skills",
            "dN": "+%d to Javelin and Spear Skills"
        },
        {
            "id": 189,
            "s": "unused189"
        },
        {
            "id": 190,
            "s": "unused190"
        },
        {
            "id": 191,
            "s": "unused191"
        },
        {
            "id": 192,
            "s": "unused192"
        },
        {
            "id": 193,
            "s": "unused193"
        },
        {
            "id": 194,
            "s": "item_numsockets",
            "sS": 1,
            "sB": 4,
            "sA": 0
        },
        {
            "id": 195,
            "s": "item_skillonattack",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s on attack",
            "dN": "%d%% Chance to cast level %d %s on attack"
        },
        {
            "id": 196,
            "s": "item_skillonkill",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s when you Kill an Enemy",
            "dN": "%d%% Chance to cast level %d %s when you Kill an Enemy"
        },
        {
            "id": 197,
            "s": "item_skillondeath",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s when you Die",
            "dN": "%d%% Chance to cast level %d %s when you Die"
        },
        {
            "id": 198,
            "s": "item_skillonhit",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s on striking",
            "dN": "%d%% Chance to cast level %d %s on striking"
        },
        {
            "id": 199,
            "s": "item_skillonlevelup",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s when you Level-Up",
            "dN": "%d%% Chance to cast level %d %s when you Level-Up"
        },
        {
            "id": 200,
            "s": "unused200"
        },
        {
            "id": 201,
            "s": "item_skillongethit",
            "e": 2,
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "sP": 16,
            "so": 160,
            "dF": 15,
            "dP": "%d%% Chance to cast level %d %s when struck",
            "dN": "%d%% Chance to cast level %d %s when struck"
        },
        {
            "id": 202,
            "s": "unused202"
        },
        {
            "id": 203,
            "s": "unused203"
        },
        {
            "id": 204,
            "s": "item_charged_skill",
            "e": 3,
            "sS": 1,
            "sB": 16,
            "sA": 0,
            "sP": 16,
            "so": 1,
            "dF": 24,
            "dP": "(%d/%d Charges)",
            "dN": "(%d/%d Charges)"
        },
        {
            "id": 205,
            "s": "item_noconsume",
            "sS": 1,
            "sB": 7,
            "sA": 0,
            "so": 4,
            "dF": 19
        },
        {
            "id": 206,
            "s": "passive_mastery_noconsume",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 207,
            "s": "passive_mastery_replenish_oncrit",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 208,
            "s": "unused208",
            "e": 3,
            "sS": 1
        },
        {
            "id": 209,
            "s": "unused209",
            "e": 3,
            "sS": 1
        },
        {
            "id": 210,
            "s": "unused210",
            "e": 3,
            "sS": 1
        },
        {
            "id": 211,
            "s": "unused211",
            "e": 3,
            "sS": 1
        },
        {
            "id": 212,
            "s": "passive_mastery_gethit_rate",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 213,
            "s": "passive_mastery_attack_speed",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 214,
            "s": "item_armor_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 72,
            "dF": 19,
            "dP": "Defense",
            "dN": "Defense",
            "d2": "(Based on Character Level)",
            "o": 4,
            "op": 3,
            "ob": "level",
            "os": [
                "armorclass"
            ]
        },
        {
            "id": 215,
            "s": "item_armorpercent_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 73,
            "dF": 19,
            "dP": "Enhanced Defense",
            "dN": "Enhanced Defense",
            "d2": "(Based on Character Level)",
            "o": 5,
            "op": 3,
            "ob": "level",
            "os": [
                "armorclass"
            ]
        },
        {
            "id": 216,
            "s": "item_hp_perlevel",
            "vS": 8,
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 57,
            "dF": 19,
            "dP": "to Life",
            "dN": "to Life",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "maxhp"
            ]
        },
        {
            "id": 217,
            "s": "item_mana_perlevel",
            "vS": 8,
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 53,
            "dF": 19,
            "dP": "to Mana",
            "dN": "to Mana",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "maxmana"
            ]
        },
        {
            "id": 218,
            "s": "item_maxdamage_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 125,
            "dF": 19,
            "dP": "to Maximum Damage",
            "dN": "to Maximum Damage",
            "d2": "(Based on Character Level)",
            "o": 4,
            "op": 3,
            "ob": "level",
            "os": [
                "maxdamage",
                "secondary_maxdamage",
                "item_throw_maxdamage"
            ]
        },
        {
            "id": 219,
            "s": "item_maxdamage_percent_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 128,
            "dF": 19,
            "dP": "Enhanced Maximum Damage",
            "dN": "Enhanced Maximum Damage",
            "d2": "(Based on Character Level)",
            "o": 5,
            "op": 3,
            "ob": "level",
            "os": [
                "maxdamage",
                "secondary_maxdamage",
                "item_throw_maxdamage"
            ]
        },
        {
            "id": 220,
            "s": "item_strength_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 66,
            "dF": 19,
            "dP": "to Strength",
            "dN": "to Strength",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "strength"
            ]
        },
        {
            "id": 221,
            "s": "item_dexterity_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 64,
            "dF": 19,
            "dP": "to Dexterity",
            "dN": "to Dexterity",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "dexterity"
            ]
        },
        {
            "id": 222,
            "s": "item_energy_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 60,
            "dF": 19,
            "dP": "to Energy",
            "dN": "to Energy",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "energy"
            ]
        },
        {
            "id": 223,
            "s": "item_vitality_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 62,
            "dF": 19,
            "dP": "to Vitality",
            "dN": "to Vitality",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "vitality"
            ]
        },
        {
            "id": 224,
            "s": "item_tohit_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 114,
            "dF": 19,
            "dP": "to Attack Rating",
            "dN": "to Attack Rating",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 1,
            "ob": "level",
            "os": [
                "tohit"
            ]
        },
        {
            "id": 225,
            "s": "item_tohitpercent_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 116,
            "dF": 19,
            "dP": "Bonus to Attack Rating",
            "dN": "Bonus to Attack Rating",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 1,
            "ob": "level",
            "os": [
                "item_tohit_percent"
            ]
        },
        {
            "id": 226,
            "s": "item_cold_damagemax_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 94,
            "dF": 19,
            "dP": "to Maximum Cold Damage",
            "dN": "to Maximum Cold Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "coldmaxdam"
            ]
        },
        {
            "id": 227,
            "s": "item_fire_damagemax_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 100,
            "dF": 19,
            "dP": "to Maximum Fire Damage",
            "dN": "to Maximum Fire Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "firemaxdam"
            ]
        },
        {
            "id": 228,
            "s": "item_ltng_damagemax_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 97,
            "dF": 19,
            "dP": "to Maximum Lightning Damage",
            "dN": "to Maximum Lightning Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "lightmaxdam"
            ]
        },
        {
            "id": 229,
            "s": "item_pois_damagemax_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 90,
            "dF": 19,
            "dP": "to Maximum Poison Damage",
            "dN": "to Maximum Poison Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "poisonmaxdam"
            ]
        },
        {
            "id": 230,
            "s": "item_resist_cold_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 39,
            "dF": 19,
            "dP": "Cold Resist",
            "dN": "Cold Resist",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "coldresist"
            ]
        },
        {
            "id": 231,
            "s": "item_resist_fire_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 35,
            "dF": 19,
            "dP": "Fire Resist",
            "dN": "Fire Resist",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "fireresist"
            ]
        },
        {
            "id": 232,
            "s": "item_resist_ltng_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 37,
            "dF": 19,
            "dP": "Lightning Resist",
            "dN": "Lightning Resist",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "lightresist"
            ]
        },
        {
            "id": 233,
            "s": "item_resist_pois_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 33,
            "dF": 19,
            "dP": "Poison Resist",
            "dN": "Poison Resist",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "poisonresist"
            ]
        },
        {
            "id": 234,
            "s": "item_absorb_cold_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 32,
            "dF": 19,
            "dP": "Absorbs Cold Damage",
            "dN": "Absorbs Cold Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_absorbcold"
            ]
        },
        {
            "id": 235,
            "s": "item_absorb_fire_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 28,
            "dF": 19,
            "dP": "Absorbs Fire Damage",
            "dN": "Absorbs Fire Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_absorbfire"
            ]
        },
        {
            "id": 236,
            "s": "item_absorb_ltng_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 30,
            "dF": 19,
            "dP": "Absorbs Lightning Damage",
            "dN": "Absorbs Lightning Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_absorblight"
            ]
        },
        {
            "id": 237,
            "s": "item_absorb_pois_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_absorbmagic"
            ]
        },
        {
            "id": 238,
            "s": "item_thorns_perlevel",
            "sS": 1,
            "sB": 5,
            "sA": 0,
            "so": 12,
            "dF": 19,
            "dP": "Attacker Takes Damage of",
            "dN": "Attacker Takes Damage of",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_attackertakesdamage"
            ]
        },
        {
            "id": 239,
            "s": "item_find_gold_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 9,
            "dF": 19,
            "dP": "Extra Gold from Monsters",
            "dN": "Extra Gold from Monsters",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_goldbonus"
            ]
        },
        {
            "id": 240,
            "s": "item_find_magic_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 7,
            "dF": 19,
            "dP": "Better Chance of Getting Magic Items",
            "dN": "Better Chance of Getting Magic Items",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_magicbonus"
            ]
        },
        {
            "id": 241,
            "s": "item_regenstamina_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 47,
            "dF": 19,
            "dP": "Heal Stamina Plus",
            "dN": "Heal Stamina Plus",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "staminarecoverybonus"
            ]
        },
        {
            "id": 242,
            "s": "item_stamina_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 50,
            "dF": 19,
            "dP": "Maximum Stamina",
            "dN": "Maximum Stamina",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "maxstamina"
            ]
        },
        {
            "id": 243,
            "s": "item_damage_demon_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 111,
            "dF": 19,
            "dP": "Damage to Demons",
            "dN": "Damage to Demons",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_demondamage_percent"
            ]
        },
        {
            "id": 244,
            "s": "item_damage_undead_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 107,
            "dF": 19,
            "dP": "Damage to Undead",
            "dN": "Damage to Undead",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_undeaddamage_percent"
            ]
        },
        {
            "id": 245,
            "s": "item_tohit_demon_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 109,
            "dF": 19,
            "dP": "to Attack Rating against Demons",
            "dN": "to Attack Rating against Demons",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 1,
            "ob": "level",
            "os": [
                "item_demon_tohit"
            ]
        },
        {
            "id": 246,
            "s": "item_tohit_undead_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 105,
            "dF": 19,
            "dP": "to Attack Rating against Undead",
            "dN": "to Attack Rating against Undead",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 1,
            "ob": "level",
            "os": [
                "item_undead_tohit"
            ]
        },
        {
            "id": 247,
            "s": "item_crushingblow_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 86,
            "dF": 19,
            "dP": "Chance of Crushing Blow",
            "dN": "Chance of Crushing Blow",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_crushingblow"
            ]
        },
        {
            "id": 248,
            "s": "item_openwounds_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 82,
            "dF": 19,
            "dP": "Chance of Open Wounds",
            "dN": "Chance of Open Wounds",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_openwounds"
            ]
        },
        {
            "id": 249,
            "s": "item_kick_damage_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 120,
            "dF": 19,
            "dP": "Kick Damage",
            "dN": "Kick Damage",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_kickdamage"
            ]
        },
        {
            "id": 250,
            "s": "item_deadlystrike_perlevel",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 84,
            "dF": 19,
            "dP": "Deadly Strike",
            "dN": "Deadly Strike",
            "d2": "(Based on Character Level)",
            "o": 2,
            "op": 3,
            "ob": "level",
            "os": [
                "item_deadlystrike"
            ]
        },
        {
            "id": 251,
            "s": "item_find_gems_perlevel",
            "sS": 1
        },
        {
            "id": 252,
            "s": "item_replenish_durability",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 1,
            "dF": 11,
            "dP": "Repairs %d durability per second",
            "dN": "Repairs %d durability per second"
        },
        {
            "id": 253,
            "s": "item_replenish_quantity",
            "sS": 1,
            "sB": 6,
            "sA": 0,
            "so": 2,
            "dF": 19,
            "dP": "Replenishes quantity",
            "dN": "Replenishes quantity"
        },
        {
            "id": 254,
            "s": "item_extra_stack",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 4,
            "dF": 19,
            "dP": "Increased Stack Size",
            "dN": "Increased Stack Size"
        },
        {
            "id": 255,
            "s": "item_find_item",
            "sS": 1
        },
        {
            "id": 256,
            "s": "item_slash_damage",
            "sS": 1
        },
        {
            "id": 257,
            "s": "item_slash_damage_percent",
            "sS": 1
        },
        {
            "id": 258,
            "s": "item_crush_damage",
            "sS": 1
        },
        {
            "id": 259,
            "s": "item_crush_damage_percent",
            "sS": 1
        },
        {
            "id": 260,
            "s": "item_thrust_damage",
            "sS": 1
        },
        {
            "id": 261,
            "s": "item_thrust_damage_percent",
            "sS": 1
        },
        {
            "id": 262,
            "s": "item_absorb_slash",
            "sS": 1
        },
        {
            "id": 263,
            "s": "item_absorb_crush",
            "sS": 1
        },
        {
            "id": 264,
            "s": "item_absorb_thrust",
            "sS": 1
        },
        {
            "id": 265,
            "s": "item_absorb_slash_percent",
            "sS": 1
        },
        {
            "id": 266,
            "s": "item_absorb_crush_percent",
            "sS": 1
        },
        {
            "id": 267,
            "s": "item_absorb_thrust_percent",
            "sS": 1
        },
        {
            "id": 268,
            "s": "item_armor_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "Defense",
            "dN": "Defense",
            "o": 6,
            "os": [
                "armorclass"
            ]
        },
        {
            "id": 269,
            "s": "item_armorpercent_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Enhanced Defense",
            "dN": "Enhanced Defense",
            "o": 7,
            "os": [
                "armorclass"
            ]
        },
        {
            "id": 270,
            "s": "item_hp_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Life",
            "dN": "to Life",
            "o": 6,
            "os": [
                "maxhp"
            ]
        },
        {
            "id": 271,
            "s": "item_mana_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Mana",
            "dN": "to Mana",
            "o": 6,
            "os": [
                "maxmana"
            ]
        },
        {
            "id": 272,
            "s": "item_maxdamage_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Maximum Damage",
            "dN": "to Maximum Damage",
            "o": 6,
            "os": [
                "maxdamage",
                "secondary_maxdamage",
                "item_throw_maxdamage"
            ]
        },
        {
            "id": 273,
            "s": "item_maxdamage_percent_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Enhanced Maximum Damage",
            "dN": "Enhanced Maximum Damage",
            "o": 7,
            "os": [
                "maxdamage",
                "secondary_mindamage",
                "item_throw_mindamage"
            ]
        },
        {
            "id": 274,
            "s": "item_strength_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Strength",
            "dN": "to Strength",
            "o": 6,
            "os": [
                "strength"
            ]
        },
        {
            "id": 275,
            "s": "item_dexterity_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Dexterity",
            "dN": "to Dexterity",
            "o": 6,
            "os": [
                "dexterity"
            ]
        },
        {
            "id": 276,
            "s": "item_energy_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Energy",
            "dN": "to Energy",
            "o": 6,
            "os": [
                "energy"
            ]
        },
        {
            "id": 277,
            "s": "item_vitality_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Vitality",
            "dN": "to Vitality",
            "o": 6,
            "os": [
                "vitality"
            ]
        },
        {
            "id": 278,
            "s": "item_tohit_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Attack Rating",
            "dN": "to Attack Rating",
            "o": 6,
            "os": [
                "tohit"
            ]
        },
        {
            "id": 279,
            "s": "item_tohitpercent_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Bonus to Attack Rating",
            "dN": "Bonus to Attack Rating",
            "o": 6,
            "os": [
                "item_tohit_percent"
            ]
        },
        {
            "id": 280,
            "s": "item_cold_damagemax_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Maximum Cold Damage",
            "dN": "to Maximum Cold Damage",
            "o": 6,
            "os": [
                "coldmaxdam"
            ]
        },
        {
            "id": 281,
            "s": "item_fire_damagemax_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Maximum Fire Damage",
            "dN": "to Maximum Fire Damage",
            "o": 6,
            "os": [
                "firemaxdam"
            ]
        },
        {
            "id": 282,
            "s": "item_ltng_damagemax_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Maximum Lightning Damage",
            "dN": "to Maximum Lightning Damage",
            "o": 6,
            "os": [
                "lightmaxdam"
            ]
        },
        {
            "id": 283,
            "s": "item_pois_damagemax_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Maximum Poison Damage",
            "dN": "to Maximum Poison Damage",
            "o": 6,
            "os": [
                "poisonmaxdam"
            ]
        },
        {
            "id": 284,
            "s": "item_resist_cold_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Cold Resist",
            "dN": "Cold Resist",
            "o": 6,
            "os": [
                "coldresist"
            ]
        },
        {
            "id": 285,
            "s": "item_resist_fire_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Fire Resist",
            "dN": "Fire Resist",
            "o": 6,
            "os": [
                "fireresist"
            ]
        },
        {
            "id": 286,
            "s": "item_resist_ltng_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Lightning Resist",
            "dN": "Lightning Resist",
            "o": 6,
            "os": [
                "lightresist"
            ]
        },
        {
            "id": 287,
            "s": "item_resist_pois_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Poison Resist",
            "dN": "Poison Resist",
            "o": 6,
            "os": [
                "poisonresist"
            ]
        },
        {
            "id": 288,
            "s": "item_absorb_cold_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Absorbs Cold Damage",
            "dN": "Absorbs Cold Damage",
            "o": 6,
            "os": [
                "item_absorbcold"
            ]
        },
        {
            "id": 289,
            "s": "item_absorb_fire_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Absorbs Fire Damage",
            "dN": "Absorbs Fire Damage",
            "o": 6,
            "os": [
                "item_absorbfire"
            ]
        },
        {
            "id": 290,
            "s": "item_absorb_ltng_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Absorbs Lightning Damage",
            "dN": "Absorbs Lightning Damage",
            "o": 6,
            "os": [
                "item_absorblight"
            ]
        },
        {
            "id": 291,
            "s": "item_absorb_pois_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "o": 6,
            "os": [
                "item_absorbmagic"
            ]
        },
        {
            "id": 292,
            "s": "item_find_gold_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Extra Gold from Monsters",
            "dN": "Extra Gold from Monsters",
            "o": 6,
            "os": [
                "item_goldbonus"
            ]
        },
        {
            "id": 293,
            "s": "item_find_magic_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Better Chance of Getting Magic Items",
            "dN": "Better Chance of Getting Magic Items",
            "o": 6,
            "os": [
                "item_magicbonus"
            ]
        },
        {
            "id": 294,
            "s": "item_regenstamina_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Heal Stamina Plus",
            "dN": "Heal Stamina Plus",
            "o": 6,
            "os": [
                "staminarecoverybonus"
            ]
        },
        {
            "id": 295,
            "s": "item_stamina_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "Maximum Stamina",
            "dN": "Maximum Stamina",
            "o": 6,
            "os": [
                "maxstamina"
            ]
        },
        {
            "id": 296,
            "s": "item_damage_demon_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Damage to Demons",
            "dN": "Damage to Demons",
            "o": 6,
            "os": [
                "item_demondamage_percent"
            ]
        },
        {
            "id": 297,
            "s": "item_damage_undead_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Damage to Undead",
            "dN": "Damage to Undead",
            "o": 6,
            "os": [
                "item_undeaddamage_percent"
            ]
        },
        {
            "id": 298,
            "s": "item_tohit_demon_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Attack Rating against Demons",
            "dN": "to Attack Rating against Demons",
            "o": 6,
            "os": [
                "item_demon_tohit"
            ]
        },
        {
            "id": 299,
            "s": "item_tohit_undead_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "to Attack Rating against Undead",
            "dN": "to Attack Rating against Undead",
            "o": 6,
            "os": [
                "item_undead_tohit"
            ]
        },
        {
            "id": 300,
            "s": "item_crushingblow_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Chance of Crushing Blow",
            "dN": "Chance of Crushing Blow",
            "o": 6,
            "os": [
                "item_crushingblow"
            ]
        },
        {
            "id": 301,
            "s": "item_openwounds_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Chance of Open Wounds",
            "dN": "Chance of Open Wounds",
            "o": 6,
            "os": [
                "item_openwounds"
            ]
        },
        {
            "id": 302,
            "s": "item_kick_damage_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 17,
            "dP": "Kick Damage",
            "dN": "Kick Damage",
            "o": 6,
            "os": [
                "item_kickdamage"
            ]
        },
        {
            "id": 303,
            "s": "item_deadlystrike_bytime",
            "e": 4,
            "sS": 1,
            "sB": 22,
            "sA": 0,
            "so": 180,
            "dF": 18,
            "dP": "Deadly Strike",
            "dN": "Deadly Strike",
            "o": 6,
            "os": [
                "item_deadlystrike"
            ]
        },
        {
            "id": 304,
            "s": "item_find_gems_bytime",
            "e": 4,
            "sS": 1
        },
        {
            "id": 305,
            "s": "item_pierce_cold",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Cold Resistance",
            "dN": "to Enemy Cold Resistance"
        },
        {
            "id": 306,
            "s": "item_pierce_fire",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Fire Resistance",
            "dN": "to Enemy Fire Resistance"
        },
        {
            "id": 307,
            "s": "item_pierce_ltng",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Lightning Resistance",
            "dN": "to Enemy Lightning Resistance"
        },
        {
            "id": 308,
            "s": "item_pierce_pois",
            "sS": 1,
            "sB": 8,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Poison Resistance",
            "dN": "to Enemy Poison Resistance"
        },
        {
            "id": 309,
            "s": "item_damage_vs_monster",
            "sS": 1
        },
        {
            "id": 310,
            "s": "item_damage_percent_vs_monster",
            "sS": 1
        },
        {
            "id": 311,
            "s": "item_tohit_vs_monster",
            "sS": 1
        },
        {
            "id": 312,
            "s": "item_tohit_percent_vs_monster",
            "sS": 1
        },
        {
            "id": 313,
            "s": "item_ac_vs_monster",
            "sS": 1
        },
        {
            "id": 314,
            "s": "item_ac_percent_vs_monster",
            "sS": 1
        },
        {
            "id": 315,
            "s": "firelength",
            "sS": 1
        },
        {
            "id": 316,
            "s": "burningmin",
            "sS": 1
        },
        {
            "id": 317,
            "s": "burningmax",
            "sS": 1
        },
        {
            "id": 318,
            "s": "progressive_damage",
            "sS": 1
        },
        {
            "id": 319,
            "s": "progressive_steal",
            "sS": 1
        },
        {
            "id": 320,
            "s": "progressive_other",
            "sS": 1
        },
        {
            "id": 321,
            "s": "progressive_fire",
            "sS": 1
        },
        {
            "id": 322,
            "s": "progressive_cold",
            "sS": 1
        },
        {
            "id": 323,
            "s": "progressive_lightning",
            "sS": 1
        },
        {
            "id": 324,
            "s": "item_extra_charges",
            "sS": 1,
            "sB": 6,
            "sA": 0
        },
        {
            "id": 325,
            "s": "progressive_tohit",
            "sS": 1
        },
        {
            "id": 326,
            "s": "poison_count",
            "sS": 1
        },
        {
            "id": 327,
            "s": "damage_framerate",
            "sS": 1
        },
        {
            "id": 328,
            "s": "pierce_idx",
            "sS": 1
        },
        {
            "id": 329,
            "s": "passive_fire_mastery",
            "sS": 1,
            "sB": 9,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Fire Skill Damage",
            "dN": "to Fire Skill Damage"
        },
        {
            "id": 330,
            "s": "passive_ltng_mastery",
            "sS": 1,
            "sB": 9,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Lightning Skill Damage",
            "dN": "to Lightning Skill Damage"
        },
        {
            "id": 331,
            "s": "passive_cold_mastery",
            "sS": 1,
            "sB": 9,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Cold Skill Damage",
            "dN": "to Cold Skill Damage"
        },
        {
            "id": 332,
            "s": "passive_pois_mastery",
            "sS": 1,
            "sB": 9,
            "sA": 50,
            "so": 88,
            "dF": 19,
            "dP": "to Poison Skill Damage",
            "dN": "to Poison Skill Damage"
        },
        {
            "id": 333,
            "s": "passive_fire_pierce",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Fire Resistance",
            "dN": "to Enemy Fire Resistance"
        },
        {
            "id": 334,
            "s": "passive_ltng_pierce",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Lightning Resistance",
            "dN": "to Enemy Lightning Resistance"
        },
        {
            "id": 335,
            "s": "passive_cold_pierce",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Cold Resistance",
            "dN": "to Enemy Cold Resistance"
        },
        {
            "id": 336,
            "s": "passive_pois_pierce",
            "sS": 1,
            "sB": 8,
            "sA": 0,
            "so": 88,
            "dF": 19,
            "dP": "to Enemy Poison Resistance",
            "dN": "to Enemy Poison Resistance"
        },
        {
            "id": 337,
            "s": "passive_critical_strike",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 338,
            "s": "passive_dodge",
            "sS": 1,
            "sB": 7,
            "sA": 0
        },
        {
            "id": 339,
            "s": "passive_avoid",
            "sS": 1,
            "sB": 7,
            "sA": 0
        },
        {
            "id": 340,
            "s": "passive_evade",
            "sS": 1,
            "sB": 7,
            "sA": 0
        },
        {
            "id": 341,
            "s": "passive_warmth",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 342,
            "s": "passive_mastery_melee_th",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 343,
            "s": "passive_mastery_melee_dmg",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 344,
            "s": "passive_mastery_melee_crit",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 345,
            "s": "passive_mastery_throw_th",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 346,
            "s": "passive_mastery_throw_dmg",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 347,
            "s": "passive_mastery_throw_crit",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 348,
            "s": "passive_weaponblock",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 349,
            "s": "passive_summon_resist",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 350,
            "s": "modifierlist_skill"
        },
        {
            "id": 351,
            "s": "modifierlist_level"
        },
        {
            "id": 352,
            "s": "last_sent_hp_pct",
            "sS": 1
        },
        {
            "id": 353,
            "s": "source_unit_type"
        },
        {
            "id": 354,
            "s": "source_unit_id"
        },
        {
            "id": 355,
            "s": "shortparam1"
        },
        {
            "id": 356,
            "s": "questitemdifficulty",
            "sB": 2,
            "sA": 0
        },
        {
            "id": 357,
            "s": "passive_mag_mastery",
            "sS": 1,
            "sB": 9,
            "sA": 50
        },
        {
            "id": 358,
            "s": "passive_mag_pierce",
            "sS": 1,
            "sB": 8,
            "sA": 0
        },
        {
            "id": 359,
            "s": "skill_cooldown"
        },
        {
            "id": 360,
            "s": "skill_missile_damage_scale"
        }
    ],
    "runewords": [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 27,
            "n": "Ancients' Pledge",
            "types": [
                "shld"
            ],
            "r": [
                "r08",
                "r09",
                "r07"
            ],
            "m": [
                {
                    "prop": "res-cold",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 13,
                    "max": 13
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        null,
        null,
        {
            "id": 30,
            "n": "Beast",
            "types": [
                "axe",
                "scep",
                "hamm"
            ],
            "r": [
                "r30",
                "r03",
                "r22",
                "r23",
                "r17"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "aura",
                    "p": 122,
                    "min": 9,
                    "max": 9
                },
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 270
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 40
                },
                {
                    "prop": "charged",
                    "p": 247,
                    "min": 5,
                    "max": 13
                },
                {
                    "prop": "oskill",
                    "p": 228,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "oskill",
                    "p": 224,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        null,
        {
            "id": 32,
            "n": "Black",
            "types": [
                "club",
                "hamm",
                "mace"
            ],
            "r": [
                "r10",
                "r16",
                "r04"
            ],
            "m": [
                {
                    "prop": "crush",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "swing2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "charged",
                    "p": 74,
                    "min": 12,
                    "max": 4
                }
            ]
        },
        null,
        {
            "id": 34,
            "n": "Bone",
            "types": [
                "tors"
            ],
            "r": [
                "r12",
                "r22",
                "r22"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 84,
                    "min": 15,
                    "max": 10
                },
                {
                    "prop": "gethit-skill",
                    "p": 68,
                    "min": 15,
                    "max": 10
                },
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana",
                    "min": 100,
                    "max": 150
                }
            ]
        },
        {
            "id": 35,
            "n": "Bramble",
            "types": [
                "tors"
            ],
            "r": [
                "r08",
                "r27",
                "r29",
                "r05"
            ],
            "m": [
                {
                    "prop": "balance2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "aura",
                    "p": 103,
                    "min": 15,
                    "max": 21
                },
                {
                    "prop": "heal-kill",
                    "min": 13,
                    "max": 13
                },
                {
                    "prop": "extra-pois",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "res-pois",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "charged",
                    "p": 246,
                    "min": 33,
                    "max": 13
                }
            ]
        },
        {
            "id": 36,
            "n": "Brand",
            "types": [
                "miss"
            ],
            "r": [
                "r31",
                "r28",
                "r23",
                "r25"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 260,
                    "max": 340
                },
                {
                    "prop": "dmg-demon",
                    "min": 280,
                    "max": 330
                },
                {
                    "prop": "hit-skill",
                    "p": 84,
                    "min": 100,
                    "max": 18
                },
                {
                    "prop": "gethit-skill",
                    "p": 66,
                    "min": 35,
                    "max": 14
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "explosivearrow",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 37,
            "n": "Breath of the Dying",
            "types": [
                "weap"
            ],
            "r": [
                "r26",
                "r15",
                "r01",
                "r02",
                "r33",
                "r05"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "dmg-undead",
                    "min": 125,
                    "max": 125
                },
                {
                    "prop": "lifesteal",
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "kill-skill",
                    "p": 92,
                    "min": 50,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 350,
                    "max": 400
                },
                {
                    "prop": "all-stats",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        null,
        {
            "id": 39,
            "n": "Call to Arms",
            "types": [
                "weap"
            ],
            "r": [
                "r11",
                "r08",
                "r23",
                "r24",
                "r27"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 240
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "oskill",
                    "p": 155,
                    "min": 2,
                    "max": 6
                },
                {
                    "prop": "oskill",
                    "p": 149,
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "oskill",
                    "p": 146,
                    "min": 1,
                    "max": 4
                },
                {
                    "prop": "regen",
                    "min": 12,
                    "max": 12
                }
            ]
        },
        {
            "id": 40,
            "n": "Chains of Honor",
            "types": [
                "tors"
            ],
            "r": [
                "r14",
                "r22",
                "r30",
                "r24"
            ],
            "m": [
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac%",
                    "min": 70,
                    "max": 70
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        null,
        {
            "id": 42,
            "n": "Chaos",
            "types": [
                "h2h"
            ],
            "r": [
                "r19",
                "r27",
                "r22"
            ],
            "m": [
                {
                    "prop": "demon-heal",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 290
                },
                {
                    "prop": "dmg-mag",
                    "min": 216,
                    "max": 471
                },
                {
                    "prop": "oskill",
                    "p": 151,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing2",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "hit-skill",
                    "p": 64,
                    "min": 9,
                    "max": 11
                },
                {
                    "prop": "hit-skill",
                    "p": 38,
                    "min": 11,
                    "max": 9
                }
            ]
        },
        {
            "id": 43,
            "n": "Crescent Moon",
            "types": [
                "axe",
                "swor",
                "pole"
            ],
            "r": [
                "r13",
                "r22",
                "r03"
            ],
            "m": [
                {
                    "prop": "pierce-ltng",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "abs-mag",
                    "min": 9,
                    "max": 11
                },
                {
                    "prop": "charged",
                    "p": 227,
                    "min": 30,
                    "max": 18
                },
                {
                    "prop": "hit-skill",
                    "p": 42,
                    "min": 7,
                    "max": 13
                },
                {
                    "prop": "hit-skill",
                    "p": 53,
                    "min": 10,
                    "max": 17
                }
            ]
        },
        null,
        null,
        {
            "id": 46,
            "n": "Death",
            "types": [
                "swor",
                "axe"
            ],
            "r": [
                "r15",
                "r01",
                "r26",
                "r09",
                "r25"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 300,
                    "max": 385
                },
                {
                    "prop": "deadly/lvl",
                    "p": 4
                },
                {
                    "prop": "charged",
                    "p": 85,
                    "min": 15,
                    "max": 22
                },
                {
                    "prop": "att-skill",
                    "p": 55,
                    "min": 25,
                    "max": 18
                },
                {
                    "prop": "death-skill",
                    "p": 53,
                    "min": 100,
                    "max": 44
                },
                {
                    "prop": "crush",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        {
            "id": 48,
            "n": "Delirium",
            "types": [
                "helm"
            ],
            "r": [
                "r20",
                "r24",
                "r16"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 81,
                    "min": 11,
                    "max": 18
                },
                {
                    "prop": "charged",
                    "p": 86,
                    "min": 60,
                    "max": 17
                },
                {
                    "prop": "gethit-skill",
                    "p": 77,
                    "min": 14,
                    "max": 13
                },
                {
                    "prop": "ac",
                    "min": 261,
                    "max": 261
                },
                {
                    "prop": "gethit-skill",
                    "p": 273,
                    "min": 6,
                    "max": 14
                },
                {
                    "prop": "gethit-skill",
                    "p": 350,
                    "min": 1,
                    "max": 50
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        null,
        null,
        {
            "id": 51,
            "n": "Destruction",
            "types": [
                "pole",
                "swor"
            ],
            "r": [
                "r26",
                "r28",
                "r30",
                "r31",
                "r18"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 350,
                    "max": 350
                },
                {
                    "prop": "dmg-mag",
                    "min": 100,
                    "max": 180
                },
                {
                    "prop": "hit-skill",
                    "p": 229,
                    "min": 5,
                    "max": 23
                },
                {
                    "prop": "death-skill",
                    "p": 56,
                    "min": 100,
                    "max": 45
                },
                {
                    "prop": "att-skill",
                    "p": 48,
                    "min": 15,
                    "max": 22
                },
                {
                    "prop": "hit-skill",
                    "p": 244,
                    "min": 23,
                    "max": 12
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 52,
            "n": "Doom",
            "types": [
                "axe",
                "pole",
                "hamm"
            ],
            "r": [
                "r15",
                "r27",
                "r22",
                "r28",
                "r32"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 280,
                    "max": 320
                },
                {
                    "prop": "aura",
                    "p": 114,
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "swing2",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "pierce-cold",
                    "min": 40,
                    "max": 60
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hit-skill",
                    "p": 244,
                    "min": 5,
                    "max": 18
                }
            ]
        },
        {
            "id": 53,
            "n": "Dragon",
            "types": [
                "tors",
                "shld"
            ],
            "r": [
                "r29",
                "r28",
                "r12"
            ],
            "m": [
                {
                    "prop": "ac",
                    "min": 360,
                    "max": 360
                },
                {
                    "prop": "ac-miss",
                    "min": 230,
                    "max": 230
                },
                {
                    "prop": "str/lvl",
                    "p": 3
                },
                {
                    "prop": "hit-skill",
                    "p": 62,
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 278,
                    "min": 20,
                    "max": 18
                },
                {
                    "prop": "aura",
                    "p": 102,
                    "min": 14,
                    "max": 14
                },
                {
                    "prop": "all-stats",
                    "min": 3,
                    "max": 5
                }
            ]
        },
        null,
        {
            "id": 55,
            "n": "Dream",
            "types": [
                "helm",
                "shld"
            ],
            "r": [
                "r16",
                "r31",
                "r21"
            ],
            "m": [
                {
                    "prop": "ac",
                    "min": 150,
                    "max": 220
                },
                {
                    "prop": "gethit-skill",
                    "p": 81,
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "mana/lvl",
                    "p": 5
                },
                {
                    "prop": "res-all",
                    "min": 5,
                    "max": 20
                },
                {
                    "prop": "balance3",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "aura",
                    "p": 118,
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mag%",
                    "min": 12,
                    "max": 25
                }
            ]
        },
        {
            "id": 56,
            "n": "Duress",
            "types": [
                "tors"
            ],
            "r": [
                "r13",
                "r22",
                "r10"
            ],
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 37,
                    "max": 133
                },
                {
                    "prop": "dmg%",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "crush",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "stamdrain",
                    "min": -20,
                    "max": -20
                }
            ]
        },
        {
            "id": 57,
            "n": "Edge",
            "types": [
                "miss"
            ],
            "r": [
                "r03",
                "r07",
                "r11"
            ],
            "m": [
                {
                    "prop": "dmg-demon",
                    "min": 320,
                    "max": 380
                },
                {
                    "prop": "dmg-undead",
                    "min": 280,
                    "max": 280
                },
                {
                    "prop": "swing2",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "aura",
                    "p": 103,
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "all-stats",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "cheap",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        null,
        {
            "id": 59,
            "n": "Enigma",
            "types": [
                "tors"
            ],
            "r": [
                "r31",
                "r06",
                "r30"
            ],
            "m": [
                {
                    "prop": "ac",
                    "min": 750,
                    "max": 775
                },
                {
                    "prop": "heal-kill",
                    "min": 14,
                    "max": 14
                },
                {
                    "prop": "move2",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "str/lvl",
                    "p": 6
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mag%/lvl",
                    "p": 8
                },
                {
                    "prop": "oskill",
                    "p": 54,
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 60,
            "n": "Enlightenment",
            "types": [
                "tors"
            ],
            "r": [
                "r21",
                "r08",
                "r12"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 47,
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 46,
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "sor",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "oskill",
                    "p": 37,
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        {
            "id": 62,
            "n": "Eternity",
            "types": [
                "mele"
            ],
            "r": [
                "r11",
                "r30",
                "r24",
                "r12",
                "r29"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 260,
                    "max": 310
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "slow",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "charged",
                    "p": 95,
                    "min": 88,
                    "max": 8
                },
                {
                    "prop": "regen",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "regen-mana",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 63,
            "n": "Exile",
            "types": [
                "pala"
            ],
            "r": [
                "r26",
                "r27",
                "r24",
                "r14"
            ],
            "m": [
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac%",
                    "min": 220,
                    "max": 260
                },
                {
                    "prop": "aura",
                    "p": 104,
                    "min": 13,
                    "max": 16
                },
                {
                    "prop": "skilltab",
                    "p": 10,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hit-skill",
                    "p": 82,
                    "min": 15,
                    "max": 5
                },
                {
                    "prop": "rep-dur",
                    "p": 25
                }
            ]
        },
        {
            "id": 64,
            "n": "Faith",
            "types": [
                "miss"
            ],
            "r": [
                "r27",
                "r31",
                "r20",
                "r02"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 280,
                    "max": 280
                },
                {
                    "prop": "att%",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "dmg-fire",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "aura",
                    "p": 122,
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "reanimate",
                    "p": 1,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 65,
            "n": "Famine",
            "types": [
                "axe",
                "hamm"
            ],
            "r": [
                "r19",
                "r27",
                "r09",
                "r31"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 270,
                    "max": 320
                },
                {
                    "prop": "lifesteal",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-mag",
                    "min": 180,
                    "max": 200
                },
                {
                    "prop": "dmg-elem",
                    "min": 50,
                    "max": 200
                },
                {
                    "prop": "ethereal",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 66,
            "n": "Flame",
            "types": [
                "helm"
            ],
            "r": [
                "r04",
                "r21",
                "r26"
            ],
            "m": [
                {
                    "prop": "fireskill",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "aura",
                    "p": 100,
                    "min": 4,
                    "max": 8
                },
                {
                    "prop": "pierce-fire",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "mana",
                    "min": 50,
                    "max": 75
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-pois-len",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 67,
            "n": "Fortitude",
            "types": [
                "weap",
                "tors"
            ],
            "r": [
                "r01",
                "r12",
                "r14",
                "r28"
            ],
            "m": [
                {
                    "prop": "ac%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg%",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "cast3",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "gethit-skill",
                    "p": 60,
                    "min": 20,
                    "max": 15
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "hp/lvl",
                    "min": 8,
                    "max": 12
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 30
                }
            ]
        },
        null,
        null,
        {
            "id": 70,
            "n": "Fury",
            "types": [
                "mele"
            ],
            "r": [
                "r31",
                "r25",
                "r05"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 209,
                    "max": 209
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "openwounds",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "deadly",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "skill",
                    "p": 147,
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 71,
            "n": "Gloom",
            "types": [
                "tors"
            ],
            "r": [
                "r19",
                "r22",
                "r21"
            ],
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 230
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "gethit-skill",
                    "p": 71,
                    "min": 15,
                    "max": 3
                },
                {
                    "prop": "balance2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "light",
                    "min": -3,
                    "max": -3
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        {
            "id": 73,
            "n": "Grief",
            "types": [
                "swor",
                "axe"
            ],
            "r": [
                "r05",
                "r03",
                "r28",
                "r23",
                "r08"
            ],
            "m": [
                {
                    "prop": "dmg-dem/lvl",
                    "p": 15
                },
                {
                    "prop": "dmg",
                    "min": 340,
                    "max": 400
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "hit-skill",
                    "p": 278,
                    "min": 35,
                    "max": 15
                },
                {
                    "prop": "pierce-pois",
                    "min": 20,
                    "max": 25
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "heal-kill",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 74,
            "n": "Hand of Justice",
            "types": [
                "weap"
            ],
            "r": [
                "r29",
                "r32",
                "r11",
                "r28"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "dmg%",
                    "min": 280,
                    "max": 330
                },
                {
                    "prop": "aura",
                    "p": 102,
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "levelup-skill",
                    "p": 46,
                    "min": 100,
                    "max": 36
                },
                {
                    "prop": "death-skill",
                    "p": 56,
                    "min": 100,
                    "max": 48
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "pierce-fire",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 75,
            "n": "Harmony",
            "types": [
                "miss"
            ],
            "r": [
                "r03",
                "r06",
                "r12",
                "r18"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 275
                },
                {
                    "prop": "dmg-elem",
                    "min": 55,
                    "max": 160
                },
                {
                    "prop": "charged",
                    "p": 95,
                    "min": 25,
                    "max": 20
                },
                {
                    "prop": "aura",
                    "p": 115,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "oskill",
                    "p": 32,
                    "min": 2,
                    "max": 6
                },
                {
                    "prop": "regen-mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        null,
        {
            "id": 77,
            "n": "Heart of the Oak",
            "types": [
                "staf",
                "mace"
            ],
            "r": [
                "r18",
                "r26",
                "r21",
                "r10"
            ],
            "m": [
                {
                    "prop": "cast2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "charged",
                    "p": 226,
                    "min": 25,
                    "max": 4
                },
                {
                    "prop": "mana%",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "allskills",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "regen",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "charged",
                    "p": 221,
                    "min": 60,
                    "max": 14
                }
            ]
        },
        null,
        null,
        {
            "id": 80,
            "n": "Holy Thunder",
            "types": [
                "scep"
            ],
            "r": [
                "r05",
                "r08",
                "r09",
                "r07"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "dmg-ltng",
                    "min": 20,
                    "max": 60
                },
                {
                    "prop": "dmg-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-ltng",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "res-ltng-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 118,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "charged",
                    "p": 53,
                    "min": 60,
                    "max": 7
                }
            ]
        },
        {
            "id": 81,
            "n": "Honor",
            "types": [
                "mele"
            ],
            "r": [
                "r11",
                "r01",
                "r06",
                "r03",
                "r12"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 160
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "deadly",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        null,
        null,
        null,
        {
            "id": 85,
            "n": "Ice",
            "types": [
                "miss"
            ],
            "r": [
                "r11",
                "r13",
                "r31",
                "r28"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 210
                },
                {
                    "prop": "aura",
                    "p": 114,
                    "min": 18,
                    "max": 18
                },
                {
                    "prop": "extra-cold",
                    "min": 25,
                    "max": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 44,
                    "min": 25,
                    "max": 22
                },
                {
                    "prop": "levelup-skill",
                    "p": 59,
                    "min": 100,
                    "max": 40
                },
                {
                    "prop": "pierce-cold",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "gold%/lvl",
                    "p": 25
                }
            ]
        },
        {
            "id": 86,
            "n": "Infinity",
            "types": [
                "pole",
                "spea"
            ],
            "r": [
                "r30",
                "r23",
                "r30",
                "r24"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 255,
                    "max": 325
                },
                {
                    "prop": "move3",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "vit/lvl",
                    "p": 4
                },
                {
                    "prop": "aura",
                    "p": 123,
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "kill-skill",
                    "p": 53,
                    "min": 50,
                    "max": 20
                },
                {
                    "prop": "pierce-ltng",
                    "min": 45,
                    "max": 55
                },
                {
                    "prop": "charged",
                    "p": 235,
                    "min": 30,
                    "max": 21
                }
            ]
        },
        null,
        {
            "id": 88,
            "n": "Insight",
            "types": [
                "pole",
                "staf",
                "miss"
            ],
            "r": [
                "r08",
                "r03",
                "r07",
                "r12"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 260
                },
                {
                    "prop": "att%",
                    "min": 180,
                    "max": 250
                },
                {
                    "prop": "mag%",
                    "min": 23,
                    "max": 23
                },
                {
                    "prop": "oskill",
                    "p": 9,
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "cast2",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "aura",
                    "p": 120,
                    "min": 12,
                    "max": 17
                },
                {
                    "prop": "all-stats",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        null,
        null,
        {
            "id": 91,
            "n": "King's Grace",
            "types": [
                "swor",
                "scep"
            ],
            "r": [
                "r11",
                "r08",
                "r10"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "dmg-demon",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att-demon",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "att-undead",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 92,
            "n": "Kingslayer",
            "types": [
                "swor",
                "axe"
            ],
            "r": [
                "r23",
                "r22",
                "r25",
                "r19"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 230,
                    "max": 270
                },
                {
                    "prop": "reduce-ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "oskill",
                    "p": 111,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "gold%",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        null,
        null,
        {
            "id": 95,
            "n": "Last Wish",
            "types": [
                "swor",
                "hamm",
                "axe"
            ],
            "r": [
                "r31",
                "r23",
                "r31",
                "r29",
                "r31",
                "r30"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 330,
                    "max": 375
                },
                {
                    "prop": "att-skill",
                    "p": 38,
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hit-skill",
                    "p": 82,
                    "min": 10,
                    "max": 18
                },
                {
                    "prop": "gethit-skill",
                    "p": 267,
                    "min": 6,
                    "max": 11
                },
                {
                    "prop": "crush",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "mag%/lvl",
                    "p": 4
                },
                {
                    "prop": "aura",
                    "p": 98,
                    "min": 17,
                    "max": 17
                }
            ]
        },
        null,
        {
            "id": 97,
            "n": "Lawbringer",
            "types": [
                "swor",
                "hamm",
                "scep"
            ],
            "r": [
                "r11",
                "r20",
                "r18"
            ],
            "m": [
                {
                    "prop": "dmg-cold",
                    "min": 130,
                    "max": 180
                },
                {
                    "prop": "dmg-fire",
                    "min": 150,
                    "max": 210
                },
                {
                    "prop": "aura",
                    "p": 119,
                    "min": 16,
                    "max": 18
                },
                {
                    "prop": "hit-skill",
                    "p": 87,
                    "min": 20,
                    "max": 15
                },
                {
                    "prop": "ac-miss",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "rip",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 98,
            "n": "Leaf",
            "types": [
                "staf"
            ],
            "r": [
                "r03",
                "r08"
            ],
            "m": [
                {
                    "prop": "fireskill",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac/lvl",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "res-cold",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "skill",
                    "p": 41,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 36,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 37,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        null,
        {
            "id": 100,
            "n": "Lionheart",
            "types": [
                "tors"
            ],
            "r": [
                "r15",
                "r17",
                "r19"
            ],
            "m": [
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 101,
            "n": "Lore",
            "types": [
                "helm"
            ],
            "r": [
                "r09",
                "r12"
            ],
            "m": [
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana-kill",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        null,
        null,
        null,
        null,
        {
            "id": 106,
            "n": "Malice",
            "types": [
                "mele"
            ],
            "r": [
                "r06",
                "r01",
                "r05"
            ],
            "m": [
                {
                    "prop": "openwounds",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-ac",
                    "min": -100,
                    "max": -100
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "light",
                    "min": -1,
                    "max": -1
                },
                {
                    "prop": "regen",
                    "min": -5,
                    "max": -5
                }
            ]
        },
        {
            "id": 107,
            "n": "Melody",
            "types": [
                "miss"
            ],
            "r": [
                "r13",
                "r18",
                "r04"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "skilltab",
                    "p": 0,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 9,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 13,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 17,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg-undead",
                    "min": 300,
                    "max": 300
                }
            ]
        },
        {
            "id": 108,
            "n": "Memory",
            "types": [
                "staf"
            ],
            "r": [
                "r17",
                "r16",
                "r12",
                "r05"
            ],
            "m": [
                {
                    "prop": "mana%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-mag",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "cast2",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "sor",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 58,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 42,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 109,
            "n": "Mist",
            "types": [
                "miss"
            ],
            "r": [
                "r32",
                "r13",
                "r25",
                "r10",
                "r06"
            ],
            "m": [
                {
                    "prop": "allskills",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg%",
                    "min": 325,
                    "max": 375
                },
                {
                    "prop": "aura",
                    "p": 113,
                    "min": 8,
                    "max": 12
                },
                {
                    "prop": "pierce",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "vit",
                    "min": 24,
                    "max": 24
                },
                {
                    "prop": "res-all",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        null,
        null,
        {
            "id": 112,
            "n": "Myth",
            "types": [
                "tors"
            ],
            "r": [
                "r15",
                "r11",
                "r04"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 137,
                    "min": 10,
                    "max": 1
                },
                {
                    "prop": "gethit-skill",
                    "p": 130,
                    "min": 3,
                    "max": 1
                },
                {
                    "prop": "bar",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 113,
            "n": "Nadir",
            "types": [
                "helm"
            ],
            "r": [
                "r04",
                "r03"
            ],
            "m": [
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": -3,
                    "max": -3
                },
                {
                    "prop": "charged",
                    "p": 264,
                    "min": 9,
                    "max": 13
                },
                {
                    "prop": "gold%",
                    "min": -33,
                    "max": -33
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        null,
        null,
        {
            "id": 116,
            "n": "Oath",
            "types": [
                "swor",
                "axe",
                "mace"
            ],
            "r": [
                "r13",
                "r21",
                "r23",
                "r17"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 210,
                    "max": 340
                },
                {
                    "prop": "swing1",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 93,
                    "min": 30,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 90,
                    "min": 14,
                    "max": 17
                },
                {
                    "prop": "charged",
                    "p": 236,
                    "min": 20,
                    "max": 16
                },
                {
                    "prop": "abs-mag",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 117,
            "n": "Obedience",
            "types": [
                "pole",
                "spea"
            ],
            "r": [
                "r15",
                "r18",
                "r10",
                "r05",
                "r19"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 370,
                    "max": 370
                },
                {
                    "prop": "crush",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "kill-skill",
                    "p": 52,
                    "min": 30,
                    "max": 21
                },
                {
                    "prop": "pierce-fire",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "balance3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        null,
        {
            "id": 119,
            "n": "Obsession",
            "types": [
                "staf"
            ],
            "r": [
                "r33",
                "r24",
                "r20",
                "r17",
                "r16",
                "r04"
            ],
            "m": [
                {
                    "prop": "allskills",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "gethit-skill",
                    "p": 72,
                    "min": 24,
                    "max": 10
                },
                {
                    "prop": "cast3",
                    "min": 65,
                    "max": 65
                },
                {
                    "prop": "balance3",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "res-all",
                    "min": 60,
                    "max": 70
                },
                {
                    "prop": "hp%",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "regen-mana",
                    "min": 15,
                    "max": 30
                }
            ]
        },
        {
            "id": 120,
            "n": "Passion",
            "types": [
                "weap"
            ],
            "r": [
                "r14",
                "r09",
                "r02",
                "r20"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 210
                },
                {
                    "prop": "oskill",
                    "p": 106,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 80
                },
                {
                    "prop": "oskill",
                    "p": 152,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "charged",
                    "p": 236,
                    "min": 12,
                    "max": 3
                },
                {
                    "prop": "stupidity",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        null,
        {
            "id": 122,
            "n": "Patter",
            "types": [
                "h2h"
            ],
            "r": [
                "r07",
                "r09",
                "r10"
            ],
            "m": [
                {
                    "prop": "att%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 40,
                    "max": 80
                },
                {
                    "prop": "dmg-fire",
                    "min": 12,
                    "max": 32
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "dex",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 123,
            "n": "Peace",
            "types": [
                "tors"
            ],
            "r": [
                "r13",
                "r10",
                "r11"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 32,
                    "min": 2,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 17,
                    "min": 4,
                    "max": 5
                },
                {
                    "prop": "ama",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "oskill",
                    "p": 9,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 124,
            "n": "Voice of Reason",
            "types": [
                "swor",
                "mace"
            ],
            "r": [
                "r20",
                "r18",
                "r01",
                "r02"
            ],
            "m": [
                {
                    "prop": "dmg-demon",
                    "min": 220,
                    "max": 350
                },
                {
                    "prop": "dmg-undead",
                    "min": 280,
                    "max": 300
                },
                {
                    "prop": "dmg-cold",
                    "min": 100,
                    "max": 220
                },
                {
                    "prop": "pierce-cold",
                    "min": 24,
                    "max": 24
                },
                {
                    "prop": "hit-skill",
                    "p": 45,
                    "min": 18,
                    "max": 20
                },
                {
                    "prop": "hit-skill",
                    "p": 64,
                    "min": 15,
                    "max": 13
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        null,
        null,
        {
            "id": 128,
            "n": "Phoenix",
            "types": [
                "weap",
                "shld"
            ],
            "r": [
                "r26",
                "r26",
                "r28",
                "r31"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 350,
                    "max": 400
                },
                {
                    "prop": "ac-miss",
                    "min": 350,
                    "max": 400
                },
                {
                    "prop": "hit-skill",
                    "p": 225,
                    "min": 40,
                    "max": 22
                },
                {
                    "prop": "levelup-skill",
                    "p": 46,
                    "min": 100,
                    "max": 40
                },
                {
                    "prop": "pierce-fire",
                    "min": 28,
                    "max": 28
                },
                {
                    "prop": "aura",
                    "p": 124,
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "abs-fire",
                    "min": 15,
                    "max": 21
                }
            ]
        },
        null,
        null,
        {
            "id": 131,
            "n": "Plague",
            "types": [
                "swor",
                "knif",
                "h2h"
            ],
            "r": [
                "r32",
                "r13",
                "r22"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 220,
                    "max": 320
                },
                {
                    "prop": "gethit-skill",
                    "p": 91,
                    "min": 20,
                    "max": 12
                },
                {
                    "prop": "hit-skill",
                    "p": 92,
                    "min": 25,
                    "max": 15
                },
                {
                    "prop": "pierce-pois",
                    "min": 23,
                    "max": 23
                },
                {
                    "prop": "deadly/lvl",
                    "p": 3
                },
                {
                    "prop": "aura",
                    "p": 109,
                    "min": 13,
                    "max": 17
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        null,
        null,
        {
            "id": 134,
            "n": "Pride",
            "types": [
                "pole",
                "spea"
            ],
            "r": [
                "r32",
                "r29",
                "r16",
                "r28"
            ],
            "m": [
                {
                    "prop": "dmg-dem/lvl",
                    "p": 8
                },
                {
                    "prop": "dmg-ltng",
                    "min": 50,
                    "max": 280
                },
                {
                    "prop": "att%",
                    "min": 260,
                    "max": 300
                },
                {
                    "prop": "aura",
                    "p": 113,
                    "min": 16,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 51,
                    "min": 25,
                    "max": 17
                },
                {
                    "prop": "regen",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "gold%/lvl",
                    "p": 15
                }
            ]
        },
        {
            "id": 135,
            "n": "Principle",
            "types": [
                "tors"
            ],
            "r": [
                "r08",
                "r25",
                "r02"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 101,
                    "min": 100,
                    "max": 5
                },
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hp",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        null,
        {
            "id": 137,
            "n": "Prudence",
            "types": [
                "tors"
            ],
            "r": [
                "r23",
                "r03"
            ],
            "m": [
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 170
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "balance2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "rep-dur",
                    "p": 25
                },
                {
                    "prop": "light",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        null,
        null,
        {
            "id": 141,
            "n": "Radiance",
            "types": [
                "helm"
            ],
            "r": [
                "r04",
                "r12",
                "r06"
            ],
            "m": [
                {
                    "prop": "light",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "mana",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "ac%",
                    "min": 75,
                    "max": 75
                }
            ]
        },
        {
            "id": 142,
            "n": "Rain",
            "types": [
                "tors"
            ],
            "r": [
                "r09",
                "r23",
                "r06"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 240,
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 235,
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "dru",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana",
                    "min": 100,
                    "max": 150
                }
            ]
        },
        null,
        null,
        {
            "id": 145,
            "n": "Rhyme",
            "types": [
                "shld"
            ],
            "r": [
                "r13",
                "r05"
            ],
            "m": [
                {
                    "prop": "block2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "gold%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 146,
            "n": "Rift",
            "types": [
                "pole",
                "scep"
            ],
            "r": [
                "r15",
                "r18",
                "r20",
                "r25"
            ],
            "m": [
                {
                    "prop": "dmg-mag",
                    "min": 160,
                    "max": 250
                },
                {
                    "prop": "dmg-fire",
                    "min": 60,
                    "max": 180
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 38,
                    "max": 38
                },
                {
                    "prop": "hit-skill",
                    "p": 245,
                    "min": 20,
                    "max": 16
                },
                {
                    "prop": "att-skill",
                    "p": 64,
                    "min": 16,
                    "max": 21
                },
                {
                    "prop": "charged",
                    "p": 76,
                    "min": 40,
                    "max": 15
                },
                {
                    "prop": "all-stats",
                    "min": 5,
                    "max": 10
                }
            ]
        },
        {
            "id": 147,
            "n": "Sanctuary",
            "types": [
                "shld"
            ],
            "r": [
                "r18",
                "r18",
                "r23"
            ],
            "m": [
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "block2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 130,
                    "max": 160
                },
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 70
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 17,
                    "min": 60,
                    "max": 12
                }
            ]
        },
        null,
        null,
        null,
        {
            "id": 151,
            "n": "Silence",
            "types": [
                "weap"
            ],
            "r": [
                "r14",
                "r02",
                "r15",
                "r24",
                "r03",
                "r26"
            ],
            "m": [
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "stupidity",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        null,
        {
            "id": 153,
            "n": "Smoke",
            "types": [
                "tors"
            ],
            "r": [
                "r04",
                "r17"
            ],
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "ac%",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": -1,
                    "max": -1
                },
                {
                    "prop": "charged",
                    "p": 72,
                    "min": 18,
                    "max": 6
                }
            ]
        },
        null,
        {
            "id": 155,
            "n": "Spirit",
            "types": [
                "swor",
                "shld"
            ],
            "r": [
                "r07",
                "r10",
                "r09",
                "r11"
            ],
            "m": [
                {
                    "prop": "balance3",
                    "min": 55,
                    "max": 55
                },
                {
                    "prop": "mana",
                    "min": 89,
                    "max": 112
                },
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "vit",
                    "min": 22,
                    "max": 22
                },
                {
                    "prop": "cast3",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "abs-mag",
                    "min": 3,
                    "max": 8
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 156,
            "n": "Splendor",
            "types": [
                "shld"
            ],
            "r": [
                "r05",
                "r17"
            ],
            "m": [
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "gold%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 100
                },
                {
                    "prop": "block2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        {
            "id": 158,
            "n": "Stealth",
            "types": [
                "tors"
            ],
            "r": [
                "r07",
                "r05"
            ],
            "m": [
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dex",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "stam",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "move2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "cast2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "balance2",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 159,
            "n": "Steel",
            "types": [
                "swor",
                "axe",
                "mace"
            ],
            "r": [
                "r03",
                "r01"
            ],
            "m": [
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-min",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg-max",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        null,
        null,
        {
            "id": 162,
            "n": "Stone",
            "types": [
                "tors"
            ],
            "r": [
                "r13",
                "r22",
                "r21",
                "r17"
            ],
            "m": [
                {
                    "prop": "ac%",
                    "min": 220,
                    "max": 260
                },
                {
                    "prop": "charged",
                    "p": 75,
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "ac-miss",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "charged",
                    "p": 229,
                    "min": 80,
                    "max": 16
                },
                {
                    "prop": "str",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "vit",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "balance2",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        null,
        {
            "id": 164,
            "n": "Strength",
            "types": [
                "mele"
            ],
            "r": [
                "r11",
                "r03"
            ],
            "m": [
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
            "id": 173,
            "n": "Treachery",
            "types": [
                "tors"
            ],
            "r": [
                "r13",
                "r10",
                "r20"
            ],
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 278,
                    "min": 25,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 267,
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "ass",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "swing2",
                    "min": 45,
                    "max": 45
                }
            ]
        },
        null,
        null,
        {
            "id": 176,
            "n": "Unbending Will",
            "types": [
                "swor"
            ],
            "r": [
                "r19",
                "r16",
                "r06",
                "r02",
                "r01",
                "r15"
            ],
            "m": [
                {
                    "prop": "skilltab",
                    "p": 12,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "hit-skill",
                    "p": 137,
                    "min": 18,
                    "max": 18
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 300,
                    "max": 350
                },
                {
                    "prop": "red-dmg",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 10
                }
            ]
        },
        null,
        null,
        {
            "id": 179,
            "n": "Venom",
            "types": [
                "weap"
            ],
            "r": [
                "r07",
                "r14",
                "r23"
            ],
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 175,
                    "min": 312,
                    "max": 312
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "charged",
                    "p": 83,
                    "min": 27,
                    "max": 15
                },
                {
                    "prop": "charged",
                    "p": 92,
                    "min": 11,
                    "max": 13
                },
                {
                    "prop": "manasteal",
                    "min": 7,
                    "max": 7
                }
            ]
        },
        null,
        null,
        null,
        null,
        null,
        {
            "id": 185,
            "n": "Wealth",
            "types": [
                "tors"
            ],
            "r": [
                "r20",
                "r18",
                "r03"
            ],
            "m": [
                {
                    "prop": "gold%",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "mag%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        null,
        {
            "id": 187,
            "n": "White",
            "types": [
                "wand"
            ],
            "r": [
                "r14",
                "r16"
            ],
            "m": [
                {
                    "prop": "skilltab",
                    "p": 7,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "red-mag",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana",
                    "min": 13,
                    "max": 13
                },
                {
                    "prop": "skill",
                    "p": 68,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 84,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 69,
                    "min": 4,
                    "max": 4
                }
            ]
        },
        {
            "id": 188,
            "n": "Wind",
            "types": [
                "mele"
            ],
            "r": [
                "r29",
                "r01"
            ],
            "m": [
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 160
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "hit-skill",
                    "p": 245,
                    "min": 10,
                    "max": 9
                },
                {
                    "prop": "charged",
                    "p": 240,
                    "min": 127,
                    "max": 13
                },
                {
                    "prop": "balance2",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        null,
        {
            "id": 190,
            "n": "Wisdom",
            "types": [
                "helm"
            ],
            "r": [
                "r21",
                "r06",
                "r02"
            ],
            "m": [
                {
                    "prop": "pierce",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 8
                },
                {
                    "prop": "att%",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        null,
        null,
        {
            "id": 193,
            "n": "Wrath",
            "types": [
                "miss"
            ],
            "r": [
                "r21",
                "r17",
                "r30",
                "r23"
            ],
            "m": [
                {
                    "prop": "dmg-demon",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "dmg-undead",
                    "min": 250,
                    "max": 300
                },
                {
                    "prop": "dmg-ltng",
                    "min": 41,
                    "max": 240
                },
                {
                    "prop": "dmg-mag",
                    "min": 85,
                    "max": 120
                },
                {
                    "prop": "hit-skill",
                    "p": 82,
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "hit-skill",
                    "p": 87,
                    "min": 30,
                    "max": 1
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        null,
        {
            "id": 195,
            "n": "Zephyr",
            "types": [
                "miss"
            ],
            "r": [
                "r09",
                "r05"
            ],
            "m": [
                {
                    "prop": "move2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "att",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "gethit-skill",
                    "p": 240,
                    "min": 7,
                    "max": 1
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                }
            ]
        }
    ],
    "set_items": [
        {
            "id": 0,
            "n": "Civerb's Ward",
            "c": "lrg",
            "tc": "lyel",
            "lvl": "13",
            "m": [
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "block",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": [
                {
                    "prop": "mana",
                    "min": 21,
                    "max": 22
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 26
                }
            ]
        },
        {
            "id": 1,
            "n": "Civerb's Icon",
            "c": "amu",
            "tc": "lyel",
            "lvl": "13",
            "m": [
                {
                    "prop": "regen-mana",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "regen",
                    "min": 4,
                    "max": 4
                }
            ],
            "ms": [
                {
                    "prop": "res-cold",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 2,
            "n": "Civerb's Cudgel",
            "c": "gsc",
            "tc": "lyel",
            "lvl": "13",
            "m": [
                {
                    "prop": "att",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "dmg-max",
                    "min": 17,
                    "max": 23
                }
            ],
            "ms": [
                {
                    "prop": "dmg/lvl",
                    "p": 8
                }
            ]
        },
        {
            "id": 3,
            "n": "Hsarus' Iron Heel",
            "c": "mbt",
            "tc": "dred",
            "lvl": "4",
            "m": [
                {
                    "prop": "res-fire",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 4,
            "n": "Hsarus' Iron Fist",
            "c": "buc",
            "tc": "dred",
            "lvl": "4",
            "m": [
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 5,
            "n": "Hsarus' Iron Stay",
            "c": "mbl",
            "tc": "dred",
            "lvl": "4",
            "m": [
                {
                    "prop": "res-cold",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 6,
            "n": "Cleglaw's Tooth",
            "c": "lsd",
            "tc": "lred",
            "lvl": "6",
            "m": [
                {
                    "prop": "att%",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "dmg/lvl",
                    "p": 10
                }
            ]
        },
        {
            "id": 7,
            "n": "Cleglaw's Claw",
            "c": "sml",
            "tc": "lred",
            "lvl": "6",
            "m": [
                {
                    "prop": "ac",
                    "min": 17,
                    "max": 17
                },
                {
                    "prop": "res-pois-len",
                    "min": 75,
                    "max": 75
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 8,
            "n": "Cleglaw's Pincers",
            "c": "mgl",
            "tc": "lred",
            "lvl": "6",
            "m": [
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "slow",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 9,
            "n": "Iratha's Collar",
            "c": "amu",
            "tc": "lgry",
            "lvl": "21",
            "m": [
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-pois-len",
                    "min": 75,
                    "max": 75
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 10,
            "n": "Iratha's Cuff",
            "c": "tgl",
            "tc": "lgry",
            "lvl": "21",
            "m": [
                {
                    "prop": "res-cold",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 11,
            "n": "Iratha's Coil",
            "c": "crn",
            "tc": "lgry",
            "lvl": "21",
            "m": [
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-ltng",
                    "min": 30,
                    "max": 30
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 12,
            "n": "Iratha's Cord",
            "c": "tbl",
            "tc": "lgry",
            "lvl": "21",
            "m": [
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-min",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 13,
            "n": "Isenhart's Lightbrand",
            "c": "bsd",
            "tc": "lgld",
            "lvl": "11",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 10
                }
            ]
        },
        {
            "id": 14,
            "n": "Isenhart's Parry",
            "c": "gts",
            "tc": "lgld",
            "lvl": "11",
            "m": [
                {
                    "prop": "ac",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "light-thorns",
                    "min": 4,
                    "max": 4
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 8,
                    "max": 8
                }
            ]
        },
        {
            "id": 15,
            "n": "Isenhart's Case",
            "c": "brs",
            "tc": "lgld",
            "lvl": "11",
            "m": [
                {
                    "prop": "ac",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 16,
            "n": "Isenhart's Horns",
            "c": "fhl",
            "tc": "lgld",
            "lvl": "11",
            "m": [
                {
                    "prop": "dex",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 8,
                    "max": 8
                }
            ]
        },
        {
            "id": 17,
            "n": "Vidala's Barb",
            "c": "lbb",
            "tc": "blac",
            "lvl": "19",
            "m": [
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 18,
            "n": "Vidala's Fetlock",
            "c": "tbt",
            "tc": "blac",
            "lvl": "19",
            "m": [
                {
                    "prop": "stam",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "move3",
                    "min": 30,
                    "max": 30
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 8,
                    "max": 8
                }
            ]
        },
        {
            "id": 19,
            "n": "Vidala's Ambush",
            "c": "lea",
            "tc": "blac",
            "lvl": "19",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dex",
                    "min": 11,
                    "max": 11
                }
            ],
            "ms": [
                {
                    "prop": "res-fire",
                    "min": 24,
                    "max": 24
                },
                {
                    "prop": "ac/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 20,
            "n": "Vidala's Snare",
            "c": "amu",
            "tc": "blac",
            "lvl": "19",
            "m": [
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-cold",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 21,
            "n": "Milabrega's Orb",
            "c": "kit",
            "tc": "dblu",
            "lvl": "23",
            "m": [
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 22,
            "n": "Milabrega's Rod",
            "c": "wsp",
            "tc": "dblu",
            "lvl": "23",
            "m": [
                {
                    "prop": "pal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": []
        },
        {
            "id": 23,
            "n": "Milabrega's Diadem",
            "c": "crn",
            "tc": "dblu",
            "lvl": "23",
            "m": [
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": [
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 24,
            "n": "Milabrega's Robe",
            "c": "aar",
            "tc": "dblu",
            "lvl": "23",
            "m": [
                {
                    "prop": "thorns",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 25,
            "n": "Cathan's Rule",
            "c": "bst",
            "tc": "dgrn",
            "lvl": "15",
            "m": [
                {
                    "prop": "fireskill",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "fire-max",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": [
                {
                    "prop": "mana",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 26,
            "n": "Cathan's Mesh",
            "c": "chn",
            "tc": "dgrn",
            "lvl": "15",
            "m": [
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                }
            ],
            "ms": [
                {
                    "prop": "thorns",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 27,
            "n": "Cathan's Visage",
            "c": "msk",
            "tc": "dgrn",
            "lvl": "15",
            "m": [
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-cold",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 28,
            "n": "Cathan's Sigil",
            "c": "amu",
            "tc": "dgrn",
            "lvl": "15",
            "m": [
                {
                    "prop": "balance1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light-thorns",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 29,
            "n": "Cathan's Seal",
            "c": "rin",
            "tc": "dgrn",
            "lvl": "15",
            "m": [
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 30,
            "n": "Tancred's Crowbill",
            "c": "mpi",
            "tc": "dgld",
            "lvl": "27",
            "m": [
                {
                    "prop": "att",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 80
                }
            ],
            "ms": [
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 31,
            "n": "Tancred's Spine",
            "c": "ful",
            "tc": "dgld",
            "lvl": "27",
            "m": [
                {
                    "prop": "hp",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 32,
            "n": "Tancred's Hobnails",
            "c": "lbt",
            "tc": "dgld",
            "lvl": "27",
            "m": [
                {
                    "prop": "regen-stam",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": [
                {
                    "prop": "move3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 33,
            "n": "Tancred's Weird",
            "c": "amu",
            "tc": "dgld",
            "lvl": "27",
            "m": [
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "red-mag",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "mag%",
                    "min": 78,
                    "max": 78
                },
                {
                    "prop": "att",
                    "min": 60,
                    "max": 60
                }
            ]
        },
        {
            "id": 34,
            "n": "Tancred's Skull",
            "c": "bhm",
            "tc": "dgld",
            "lvl": "27",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "att",
                    "min": 40,
                    "max": 40
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 35,
            "n": "Sigon's Gage",
            "c": "hgl",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "att",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 36,
            "n": "Sigon's Visor",
            "c": "ghm",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 37,
            "n": "Sigon's Shelter",
            "c": "gth",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "ac%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-ltng",
                    "min": 30,
                    "max": 30
                }
            ],
            "ms": [
                {
                    "prop": "thorns",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 38,
            "n": "Sigon's Sabot",
            "c": "hbt",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                }
            ],
            "ms": [
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 39,
            "n": "Sigon's Wrap",
            "c": "hbl",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 40,
            "n": "Sigon's Guard",
            "c": "tow",
            "tc": "whit",
            "lvl": "9",
            "m": [
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": []
        },
        {
            "id": 41,
            "n": "Infernal Cranium",
            "c": "cap",
            "tc": "lyel",
            "lvl": "7",
            "m": [
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 42,
            "n": "Infernal Torch",
            "c": "gwn",
            "tc": "lyel",
            "lvl": "7",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "nec",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 43,
            "n": "Infernal Sign",
            "c": "tbl",
            "tc": "lyel",
            "lvl": "7",
            "m": [
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 44,
            "n": "Berserker's Headgear",
            "c": "hlm",
            "tc": "dred",
            "lvl": "5",
            "m": [
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-fire",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 16
                }
            ]
        },
        {
            "id": 45,
            "n": "Berserker's Hauberk",
            "c": "spl",
            "tc": "dred",
            "lvl": "5",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "bar",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 24
                }
            ]
        },
        {
            "id": 46,
            "n": "Berserker's Hatchet",
            "c": "2ax",
            "tc": "dred",
            "lvl": "5",
            "m": [
                {
                    "prop": "att%",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 47,
            "n": "Death's Hand",
            "c": "lgl",
            "tc": "lred",
            "lvl": "8",
            "m": [
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-pois-len",
                    "min": 75,
                    "max": 75
                }
            ],
            "ms": [
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 48,
            "n": "Death's Guard",
            "c": "lbl",
            "tc": "lred",
            "lvl": "8",
            "m": [
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 49,
            "n": "Death's Touch",
            "c": "wsd",
            "tc": "lred",
            "lvl": "8",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "lifesteal",
                    "min": 4,
                    "max": 4
                }
            ],
            "ms": [
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 25,
                    "max": 75
                }
            ]
        },
        {
            "id": 50,
            "n": "Angelic Sickle",
            "c": "sbr",
            "tc": "lgry",
            "lvl": "17",
            "m": [
                {
                    "prop": "att",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "dmg-undead",
                    "min": 250,
                    "max": 250
                }
            ],
            "ms": [
                {
                    "prop": "dmg%",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 51,
            "n": "Angelic Mantle",
            "c": "rng",
            "tc": "lgry",
            "lvl": "17",
            "m": [
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac%",
                    "min": 40,
                    "max": 40
                }
            ],
            "ms": [
                {
                    "prop": "ac",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 52,
            "n": "Angelic Halo",
            "c": "rin",
            "tc": "lgry",
            "lvl": "17",
            "m": [
                {
                    "prop": "regen",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 24
                },
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 53,
            "n": "Angelic Wings",
            "c": "amu",
            "tc": "lgry",
            "lvl": "17",
            "m": [
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "hp",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 54,
            "n": "Arctic Horn",
            "c": "swb",
            "tc": "lgld",
            "lvl": "3",
            "m": [
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "att/lvl",
                    "p": 16
                },
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 55,
            "n": "Arctic Furs",
            "c": "qui",
            "tc": "lgld",
            "lvl": "3",
            "m": [
                {
                    "prop": "ac%",
                    "min": 275,
                    "max": 325
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 24
                },
                {
                    "prop": "res-cold",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 56,
            "n": "Arctic Binding",
            "c": "vbl",
            "tc": "lgld",
            "lvl": "3",
            "m": [
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                }
            ],
            "ms": [
                {
                    "prop": "mag%",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-cold",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 57,
            "n": "Arctic Mitts",
            "c": "tgl",
            "tc": "lgld",
            "lvl": "3",
            "m": [
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing1",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": [
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 58,
            "n": "Arcanna's Sign",
            "c": "amu",
            "tc": "blac",
            "lvl": "20",
            "m": [
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen-mana",
                    "min": 20,
                    "max": 20
                }
            ],
            "ms": [
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 59,
            "n": "Arcanna's Deathwand",
            "c": "wst",
            "tc": "blac",
            "lvl": "20",
            "m": [
                {
                    "prop": "sor",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "deadly",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "mana",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "regen-mana",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 60,
            "n": "Arcanna's Head",
            "c": "skp",
            "tc": "blac",
            "lvl": "20",
            "m": [
                {
                    "prop": "regen",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "thorns",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "ac/lvl",
                    "p": 24
                },
                {
                    "prop": "res-ltng",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 61,
            "n": "Arcanna's Flesh",
            "c": "ltp",
            "tc": "blac",
            "lvl": "20",
            "m": [
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                }
            ],
            "ms": [
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 62,
            "n": "Natalya's Totem",
            "c": "xh9",
            "tc": "dgry",
            "lvl": "22",
            "m": [
                {
                    "prop": "ac",
                    "min": 135,
                    "max": 175
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                }
            ],
            "ms": []
        },
        {
            "id": 63,
            "n": "Natalya's Mark",
            "c": "7qr",
            "tc": "dgry",
            "lvl": "22",
            "m": [
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-fire",
                    "min": 12,
                    "max": 17
                },
                {
                    "prop": "dmg-undead",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 200
                }
            ],
            "ms": []
        },
        {
            "id": 64,
            "n": "Natalya's Shadow",
            "c": "ucl",
            "tc": "dgry",
            "lvl": "22",
            "m": [
                {
                    "prop": "ac",
                    "min": 150,
                    "max": 225
                },
                {
                    "prop": "hp/lvl",
                    "p": 8
                },
                {
                    "prop": "skilltab",
                    "p": 19,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-pois-len",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 3
                }
            ],
            "ms": []
        },
        {
            "id": 65,
            "n": "Natalya's Soul",
            "c": "xmb",
            "tc": "dgry",
            "lvl": "22",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 125
                },
                {
                    "prop": "move3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "regen-stam/lvl",
                    "p": 2
                },
                {
                    "prop": "dur",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-cold",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "res-ltng",
                    "min": 15,
                    "max": 25
                }
            ],
            "ms": []
        },
        {
            "id": 66,
            "n": "Aldur's Stony Gaze",
            "c": "dr8",
            "tc": "oran",
            "lvl": "29",
            "m": [
                {
                    "prop": "ac",
                    "min": 90,
                    "max": 90
                },
                {
                    "prop": "regen-mana",
                    "min": 17,
                    "max": 17
                },
                {
                    "prop": "light",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "balance3",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 67,
            "n": "Aldur's Deception",
            "c": "uul",
            "tc": "oran",
            "lvl": "29",
            "m": [
                {
                    "prop": "ac",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "skilltab",
                    "p": 16,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-ltng",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                },
                {
                    "prop": "skilltab",
                    "p": 17,
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": [
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 68,
            "n": "Aldur's Rhythm",
            "c": "9mt",
            "tc": "oran",
            "lvl": "29",
            "m": [
                {
                    "prop": "dmg-norm",
                    "min": 40,
                    "max": 62
                },
                {
                    "prop": "dmg-ltng",
                    "min": 50,
                    "max": 75
                },
                {
                    "prop": "lifesteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 69,
            "n": "Aldur's Advance",
            "c": "xtb",
            "tc": "oran",
            "lvl": "29",
            "m": [
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "regen-stam",
                    "min": 32,
                    "max": 32
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "move3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "stam",
                    "min": 180,
                    "max": 180
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 70,
            "n": "Immortal King's Will",
            "c": "ba5",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac",
                    "min": 125,
                    "max": 125
                },
                {
                    "prop": "gold%",
                    "min": 37,
                    "max": 37
                },
                {
                    "prop": "skilltab",
                    "p": 14,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 40
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": []
        },
        {
            "id": 71,
            "c": "uar",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac",
                    "min": 400,
                    "max": 400
                },
                {
                    "prop": "gethit-skill",
                    "p": 52,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "skilltab",
                    "p": 12,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "balance2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-ltng",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 72,
            "n": "Immortal King's Detail",
            "c": "zhb",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac",
                    "min": 36,
                    "max": 36
                },
                {
                    "prop": "res-fire",
                    "min": 28,
                    "max": 28
                },
                {
                    "prop": "res-ltng",
                    "min": 31,
                    "max": 31
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "ac",
                    "min": 105,
                    "max": 105
                },
                {
                    "prop": "balance2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "red-dmg%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "skilltab",
                    "p": 13,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 73,
            "n": "Immortal King's Forge",
            "c": "xhg",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac",
                    "min": 65,
                    "max": 65
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 38,
                    "min": 12,
                    "max": 4
                }
            ],
            "ms": [
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "lifesteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "freeze",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 74,
            "n": "Immortal King's Pillar",
            "c": "xhb",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "move3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "att",
                    "min": 110,
                    "max": 110
                },
                {
                    "prop": "hp",
                    "min": 44,
                    "max": 44
                }
            ],
            "ms": [
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "skilltab",
                    "p": 12,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac",
                    "min": 160,
                    "max": 160
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 75,
            "n": "Immortal King's Stone Crusher",
            "c": "7m7",
            "tc": "lgry",
            "lvl": "37",
            "m": [
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg-undead",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "crush",
                    "min": 35,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "dmg-fire",
                    "min": 211,
                    "max": 397
                },
                {
                    "prop": "dmg-ltng",
                    "min": 7,
                    "max": 477
                },
                {
                    "prop": "dmg-cold",
                    "p": 150,
                    "min": 127,
                    "max": 364
                },
                {
                    "prop": "dmg-pois",
                    "p": 150,
                    "min": 349,
                    "max": 349
                },
                {
                    "prop": "dmg-mag",
                    "min": 250,
                    "max": 361
                }
            ]
        },
        {
            "id": 76,
            "n": "Tal Rasha's Fine-Spun Cloth",
            "c": "zmb",
            "tc": "dpur",
            "lvl": "26",
            "m": [
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                },
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 37,
                    "max": 37
                },
                {
                    "prop": "mag%",
                    "min": 10,
                    "max": 15
                }
            ],
            "ms": [
                {
                    "prop": "ac",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 77,
            "n": "Tal Rasha's Adjudication",
            "c": "amu",
            "tc": "dpur",
            "lvl": "26",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "sor",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-ltng",
                    "min": 3,
                    "max": 32
                },
                {
                    "prop": "mana",
                    "min": 42,
                    "max": 42
                }
            ],
            "ms": [
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 78,
            "n": "Tal Rasha's Lidless Eye",
            "c": "oba",
            "tc": "dpur",
            "lvl": "26",
            "m": [
                {
                    "prop": "hp",
                    "min": 57,
                    "max": 57
                },
                {
                    "prop": "mana",
                    "min": 77,
                    "max": 77
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "cast3",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "skill",
                    "p": 61,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 63,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 65,
                    "min": 1,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "sor",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "pierce-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "pierce-ltng",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "extra-cold",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 79,
            "n": "Tal Rasha's Guardianship",
            "c": "uth",
            "tc": "dpur",
            "lvl": "26",
            "m": [
                {
                    "prop": "ease",
                    "min": -60,
                    "max": -60
                },
                {
                    "prop": "red-mag",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mag%",
                    "min": 88,
                    "max": 88
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-ltng",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac",
                    "min": 400,
                    "max": 400
                }
            ],
            "ms": [
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 80,
            "n": "Tal Rasha's Horadric Crest",
            "c": "xsk",
            "tc": "dpur",
            "lvl": "26",
            "m": [
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hp",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "ac",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "lifesteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": []
        },
        {
            "id": 81,
            "n": "Griswold's Valor",
            "c": "urn",
            "tc": "dgld",
            "lvl": "44",
            "m": [
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 75
                },
                {
                    "prop": "abs-cold/lvl",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ease",
                    "min": -40,
                    "max": -40
                },
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "skilltab",
                    "p": 10,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 82,
            "n": "Griswold's Heart",
            "c": "xar",
            "tc": "dgld",
            "lvl": "44",
            "m": [
                {
                    "prop": "ac",
                    "min": 500,
                    "max": 500
                },
                {
                    "prop": "skilltab",
                    "p": 11,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "sock",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ease",
                    "min": -40,
                    "max": -40
                }
            ],
            "ms": []
        },
        {
            "id": 83,
            "n": "Griswold's Redemption",
            "c": "7ws",
            "tc": "dgld",
            "lvl": "44",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 240
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-undead",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                },
                {
                    "prop": "sock",
                    "min": 3,
                    "max": 4
                }
            ],
            "ms": [
                {
                    "prop": "skilltab",
                    "p": 9,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg-norm",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "dmg-norm",
                    "min": 10,
                    "max": 20
                }
            ]
        },
        {
            "id": 84,
            "n": "Griswold's Honor",
            "c": "paf",
            "tc": "dgld",
            "lvl": "44",
            "m": [
                {
                    "prop": "ac",
                    "min": 108,
                    "max": 108
                },
                {
                    "prop": "sock",
                    "p": 3
                },
                {
                    "prop": "block2",
                    "min": 65,
                    "max": 65
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 45,
                    "max": 45
                }
            ],
            "ms": []
        },
        {
            "id": 85,
            "n": "Trang-Oul's Guise",
            "c": "uh9",
            "tc": "dgld",
            "lvl": "32",
            "m": [
                {
                    "prop": "ac",
                    "min": 80,
                    "max": 100
                },
                {
                    "prop": "balance2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "thorns",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 86,
            "n": "Trang-Oul's Scales",
            "c": "xul",
            "tc": "dyel",
            "lvl": "32",
            "m": [
                {
                    "prop": "ease",
                    "min": -40,
                    "max": -40
                },
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-pois",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "skilltab",
                    "p": 8,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "move3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 150
                }
            ],
            "ms": [
                {
                    "prop": "res-ltng",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "red-dmg%",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 87,
            "n": "Trang-Oul's Wing",
            "c": "ne9",
            "tc": "dyel",
            "lvl": "32",
            "m": [
                {
                    "prop": "ac",
                    "min": 125,
                    "max": 125
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-fire",
                    "min": 38,
                    "max": 45
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-pois",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "skilltab",
                    "p": 7,
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "pierce-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "regen",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 88,
            "n": "Trang-Oul's Claws",
            "c": "xmg",
            "tc": "dyel",
            "lvl": "32",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "cast3",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-cold",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "skilltab",
                    "p": 6,
                    "min": 2,
                    "max": 2
                }
            ],
            "ms": [
                {
                    "prop": "extra-pois",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 89,
            "n": "Trang-Oul's Girth",
            "c": "utc",
            "tc": "dyel",
            "lvl": "32",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 100
                },
                {
                    "prop": "stam",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "hp",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ease",
                    "min": -40,
                    "max": -40
                },
                {
                    "prop": "mana",
                    "min": 25,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 90,
            "n": "M'avina's True Sight",
            "c": "ci3",
            "tc": "whit",
            "lvl": "21",
            "m": [
                {
                    "prop": "ac",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "mana",
                    "min": 25,
                    "max": 25
                }
            ],
            "ms": [
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 91,
            "n": "M'avina's Embrace",
            "c": "uld",
            "tc": "whit",
            "lvl": "21",
            "m": [
                {
                    "prop": "gethit-skill",
                    "p": 55,
                    "min": 10,
                    "max": 3
                },
                {
                    "prop": "ease",
                    "min": -30,
                    "max": -30
                },
                {
                    "prop": "red-mag",
                    "min": 5,
                    "max": 12
                },
                {
                    "prop": "skilltab",
                    "p": 1,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac/lvl",
                    "p": 32
                },
                {
                    "prop": "ac",
                    "min": 350,
                    "max": 350
                }
            ],
            "ms": [
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 92,
            "n": "M'avina's Icy Clutch",
            "c": "xtg",
            "tc": "whit",
            "lvl": "21",
            "m": [
                {
                    "prop": "ac",
                    "min": 45,
                    "max": 50
                },
                {
                    "prop": "dmg-cold",
                    "p": 150,
                    "min": 6,
                    "max": 18
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "gold%",
                    "min": 56,
                    "max": 56
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": [
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 131,
                    "max": 252
                },
                {
                    "prop": "extra-cold",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 93,
            "n": "M'avina's Tenet",
            "c": "zvb",
            "tc": "whit",
            "lvl": "21",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "light",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": [
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 94,
            "n": "M'avina's Caster",
            "c": "amc",
            "tc": "whit",
            "lvl": "21",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 188,
                    "max": 188
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "magicarrow",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                }
            ],
            "ms": [
                {
                    "prop": "dmg-mag",
                    "min": 114,
                    "max": 377
                },
                {
                    "prop": "hit-skill",
                    "p": 48,
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "skilltab",
                    "p": 0,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 95,
            "n": "Telling of Beads",
            "c": "amu",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "res-pois",
                    "min": 35,
                    "max": 50
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-cold",
                    "min": 18,
                    "max": 18
                },
                {
                    "prop": "thorns",
                    "min": 8,
                    "max": 10
                }
            ],
            "ms": []
        },
        {
            "id": 96,
            "n": "Laying of Hands",
            "c": "ulg",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-demon",
                    "min": 350,
                    "max": 350
                },
                {
                    "prop": "hit-skill",
                    "p": 101,
                    "min": 10,
                    "max": 3
                }
            ],
            "ms": []
        },
        {
            "id": 97,
            "n": "Rite of Passage",
            "c": "xlb",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "move3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "stam",
                    "min": 15,
                    "max": 25
                }
            ],
            "ms": []
        },
        {
            "id": 98,
            "n": "Dark Adherent",
            "c": "uui",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 305,
                    "max": 415
                },
                {
                    "prop": "res-fire",
                    "min": 24,
                    "max": 24
                },
                {
                    "prop": "gethit-skill",
                    "p": 48,
                    "min": 25,
                    "max": 3
                },
                {
                    "prop": "dmg-pois",
                    "p": 50,
                    "min": 125,
                    "max": 175
                }
            ],
            "ms": []
        },
        {
            "id": 99,
            "n": "Credendum",
            "c": "umc",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": []
        },
        {
            "id": 100,
            "n": "Dangoon's Teaching",
            "c": "7ma",
            "lvl": "55",
            "m": [
                {
                    "prop": "dmg/lvl",
                    "p": 12
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "hit-skill",
                    "p": 44,
                    "min": 10,
                    "max": 3
                },
                {
                    "prop": "dmg-fire",
                    "min": 20,
                    "max": 30
                }
            ],
            "ms": []
        },
        {
            "id": 101,
            "n": "Taebaek's Glory",
            "c": "uts",
            "lvl": "55",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mana",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-ltng",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "thorns",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "block",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "block3",
                    "min": 30,
                    "max": 30
                }
            ],
            "ms": []
        },
        {
            "id": 102,
            "n": "Haemosu's Adamant",
            "c": "xrs",
            "lvl": "55",
            "m": [
                {
                    "prop": "ac",
                    "min": 500,
                    "max": 500
                },
                {
                    "prop": "ac-miss",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "hp",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "ac-hth",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                }
            ],
            "ms": []
        },
        {
            "id": 103,
            "n": "Ondal's Almighty",
            "c": "uhm",
            "lvl": "55",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ease",
                    "min": -40,
                    "max": -40
                },
                {
                    "prop": "hit-skill",
                    "p": 72,
                    "min": 10,
                    "max": 3
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "balance3",
                    "min": 24,
                    "max": 24
                }
            ],
            "ms": []
        },
        {
            "id": 104,
            "n": "Guillaume's Face",
            "c": "xhm",
            "tc": "lgry",
            "lvl": "41",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "balance3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "crush",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "deadly",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                }
            ],
            "ms": []
        },
        {
            "id": 105,
            "n": "Wilhelm's Pride",
            "c": "ztb",
            "tc": "lgry",
            "lvl": "41",
            "m": [
                {
                    "prop": "ac%",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-cold",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 106,
            "n": "Magnus' Skin",
            "c": "xvg",
            "tc": "lgry",
            "lvl": "41",
            "m": [
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "att",
                    "min": 100,
                    "max": 100
                }
            ],
            "ms": []
        },
        {
            "id": 107,
            "n": "Whitstan's Guard",
            "c": "xml",
            "tc": "lgry",
            "lvl": "41",
            "m": [
                {
                    "prop": "ac%",
                    "min": 175,
                    "max": 175
                },
                {
                    "prop": "block3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "block",
                    "min": 55,
                    "max": 55
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 108,
            "n": "Hwanin's Splendor",
            "c": "xrn",
            "lvl": "28",
            "m": [
                {
                    "prop": "regen",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-cold",
                    "min": 37,
                    "max": 37
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                }
            ],
            "ms": []
        },
        {
            "id": 109,
            "n": "Hwanin's Refuge",
            "c": "xcl",
            "lvl": "28",
            "m": [
                {
                    "prop": "ac",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "res-pois",
                    "min": 27,
                    "max": 27
                },
                {
                    "prop": "hp",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "gethit-skill",
                    "p": 42,
                    "min": 10,
                    "max": 3
                }
            ],
            "ms": []
        },
        {
            "id": 110,
            "n": "Hwanin's Blessing",
            "c": "mbl",
            "lvl": "28",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 3,
                    "max": 33
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac/lvl",
                    "p": 12
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 12,
                    "max": 12
                }
            ],
            "ms": []
        },
        {
            "id": 111,
            "n": "Hwanin's Justice",
            "c": "9vo",
            "lvl": "28",
            "m": [
                {
                    "prop": "att",
                    "min": 330,
                    "max": 330
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "hit-skill",
                    "p": 45,
                    "min": 10,
                    "max": 3
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg-ltng",
                    "min": 5,
                    "max": 25
                }
            ],
            "ms": []
        },
        {
            "id": 112,
            "n": "Sazabi's Cobalt Redeemer",
            "c": "7ls",
            "tc": "dblu",
            "lvl": "34",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-demon",
                    "min": 318,
                    "max": 318
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 113,
            "n": "Sazabi's Ghost Liberator",
            "c": "upl",
            "tc": "dblu",
            "lvl": "34",
            "m": [
                {
                    "prop": "ac",
                    "min": 400,
                    "max": 400
                },
                {
                    "prop": "balance3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "att-demon",
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 75
                }
            ],
            "ms": []
        },
        {
            "id": 114,
            "n": "Sazabi's Mental Sheath",
            "c": "xhl",
            "tc": "dblu",
            "lvl": "34",
            "m": [
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "res-ltng",
                    "min": 15,
                    "max": 20
                }
            ],
            "ms": []
        },
        {
            "id": 115,
            "n": "Bul-Kathos' Sacred Charge",
            "c": "7gd",
            "tc": "dgrn",
            "lvl": "50",
            "m": [
                {
                    "prop": "crush",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                }
            ],
            "ms": []
        },
        {
            "id": 116,
            "n": "Bul-Kathos' Tribal Guardian",
            "c": "7wd",
            "tc": "dgrn",
            "lvl": "50",
            "m": [
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-pois",
                    "p": 50,
                    "min": 255,
                    "max": 255
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                }
            ],
            "ms": []
        },
        {
            "id": 117,
            "n": "Cow King's Horns",
            "c": "xap",
            "lvl": "20",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "thorns",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": []
        },
        {
            "id": 118,
            "n": "Cow King's Hide",
            "c": "stu",
            "lvl": "20",
            "m": [
                {
                    "prop": "res-all",
                    "min": 18,
                    "max": 18
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "hp",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "gethit-skill",
                    "p": 53,
                    "min": 18,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 119,
            "n": "Cow King's Hooves",
            "c": "vbt",
            "lvl": "20",
            "m": [
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "move3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-fire",
                    "min": 25,
                    "max": 35
                }
            ],
            "ms": []
        },
        {
            "id": 120,
            "n": "Naj's Puzzler",
            "c": "6cs",
            "lvl": "43",
            "m": [
                {
                    "prop": "enr",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "charged",
                    "p": 54,
                    "min": 69,
                    "max": 11
                },
                {
                    "prop": "cast3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-ltng",
                    "min": 6,
                    "max": 45
                },
                {
                    "prop": "mana",
                    "min": 70,
                    "max": 70
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ],
            "ms": []
        },
        {
            "id": 121,
            "n": "Naj's Light Plate",
            "c": "ult",
            "lvl": "43",
            "m": [
                {
                    "prop": "ease",
                    "min": -60,
                    "max": -60
                },
                {
                    "prop": "hp",
                    "min": 65,
                    "max": 65
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac",
                    "min": 300,
                    "max": 300
                }
            ],
            "ms": []
        },
        {
            "id": 122,
            "n": "Naj's Circlet",
            "c": "ci0",
            "lvl": "43",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "dmg-fire",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "light",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 53,
                    "min": 12,
                    "max": 5
                }
            ],
            "ms": []
        },
        {
            "id": 123,
            "n": "Sander's Paragon",
            "c": "cap",
            "tc": "lpur",
            "lvl": "20",
            "m": [
                {
                    "prop": "mag%",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "thorns",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ac/lvl",
                    "p": 8
                }
            ],
            "ms": []
        },
        {
            "id": 124,
            "n": "Sander's Riprap",
            "c": "vbt",
            "tc": "lpur",
            "lvl": "20",
            "m": [
                {
                    "prop": "move3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "att",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                }
            ],
            "ms": []
        },
        {
            "id": 125,
            "n": "Sander's Taboo",
            "c": "vgl",
            "tc": "lpur",
            "lvl": "20",
            "m": [
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-pois",
                    "p": 75,
                    "min": 30,
                    "max": 36
                }
            ],
            "ms": []
        },
        {
            "id": 126,
            "n": "Sander's Superstition",
            "c": "bwn",
            "tc": "lpur",
            "lvl": "20",
            "m": [
                {
                    "prop": "dmg%",
                    "p": 2,
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "mana",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "manasteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "cast3",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 25,
                    "max": 75
                }
            ],
            "ms": []
        }
    ],
    "unq_items": [
        {
            "id": 0,
            "n": "The Gnasher",
            "i": "invhaxu",
            "c": "hax",
            "lvl": "7",
            "m": [
                {
                    "prop": "str",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "crush",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 70
                }
            ]
        },
        {
            "id": 1,
            "n": "Deathspade",
            "i": "invaxeu",
            "c": "axe",
            "lvl": "12",
            "m": [
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-min",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "att%",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana-kill",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 70
                }
            ]
        },
        {
            "id": 2,
            "n": "Bladebone",
            "c": "2ax",
            "tc": "lgry",
            "lvl": "20",
            "m": [
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "att-undead",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "fire-min",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "fire-max",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "dmg%",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 3,
            "n": "Skull Splitter",
            "i": "invmpiu",
            "c": "mpi",
            "lvl": "28",
            "m": [
                {
                    "prop": "stupidity",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "regen-mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 100
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 100
                },
                {
                    "prop": "openwounds",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 4,
            "n": "Rakescar",
            "c": "wax",
            "tc": "dgry",
            "lvl": "36",
            "m": [
                {
                    "prop": "pois-min",
                    "min": 128,
                    "max": 128
                },
                {
                    "prop": "pois-max",
                    "min": 128,
                    "max": 128
                },
                {
                    "prop": "pois-len",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 75,
                    "max": 150
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 5,
            "n": "Axe of Fechmar",
            "c": "lax",
            "tc": "lpur",
            "lvl": "11",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 90
                },
                {
                    "prop": "freeze",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-cold",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 6,
            "n": "Goreshovel",
            "c": "bax",
            "tc": "dpur",
            "lvl": "19",
            "m": [
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "openwounds",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "dmg%",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "dmg-max",
                    "min": 9,
                    "max": 9
                }
            ]
        },
        {
            "id": 7,
            "n": "The Chieftain",
            "i": "invbtxu",
            "c": "btx",
            "lvl": "26",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 40
                }
            ]
        },
        {
            "id": 8,
            "n": "Brainhew",
            "i": "invgaxu",
            "c": "gax",
            "lvl": "34",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 14,
                    "max": 14
                },
                {
                    "prop": "mana",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 13
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 80
                },
                {
                    "prop": "dmg-fire",
                    "min": 15,
                    "max": 35
                }
            ]
        },
        {
            "id": 9,
            "n": "Humongous",
            "c": "gix",
            "tc": "blac",
            "lvl": "39",
            "m": [
                {
                    "prop": "str",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "dmg-min",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "dmg-max",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "ease",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 120
                }
            ]
        },
        {
            "id": 10,
            "n": "Torch of Iro",
            "i": "invwndu",
            "c": "wnd",
            "lvl": "7",
            "m": [
                {
                    "prop": "nec",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "dmg-fire",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "regen-mana",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 11,
            "n": "Maelstrom",
            "c": "ywn",
            "tc": "dblu",
            "lvl": "19",
            "m": [
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 9,
                    "max": 9
                },
                {
                    "prop": "res-ltng",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "mana",
                    "min": 13,
                    "max": 13
                },
                {
                    "prop": "cast2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "skill",
                    "p": 74,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 77,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 66,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 76,
                    "min": 1,
                    "max": 3
                }
            ]
        },
        {
            "id": 12,
            "n": "Gravenspine",
            "i": "invbwnu",
            "c": "bwn",
            "lvl": "27",
            "m": [
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "cold-min",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "cold-max",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "cold-len",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana",
                    "min": 25,
                    "max": 50
                }
            ]
        },
        {
            "id": 13,
            "n": "Ume's Lament",
            "c": "gwn",
            "tc": "lblu",
            "lvl": "38",
            "m": [
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "howl",
                    "min": 64,
                    "max": 64
                },
                {
                    "prop": "skill",
                    "p": 77,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 87,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 14,
            "n": "Felloak",
            "i": "invclbu",
            "c": "clb",
            "lvl": "4",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "fire-min",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "fire-max",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                }
            ]
        },
        {
            "id": 15,
            "n": "Knell Striker",
            "c": "scp",
            "tc": "dred",
            "lvl": "7",
            "m": [
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-pois",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "att",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                }
            ]
        },
        {
            "id": 16,
            "n": "Rusthandle",
            "c": "gsc",
            "tc": "lgld",
            "lvl": "23",
            "m": [
                {
                    "prop": "pal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 3,
                    "max": 7
                },
                {
                    "prop": "red-mag",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "skill",
                    "p": 111,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 103,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 17,
            "n": "Stormeye",
            "c": "wsp",
            "tc": "cred",
            "lvl": "31",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 120
                },
                {
                    "prop": "skill",
                    "p": 110,
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 118,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 121,
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 18,
            "n": "Stoutnail",
            "i": "invspcu",
            "c": "spc",
            "lvl": "7",
            "m": [
                {
                    "prop": "thorns",
                    "min": 3,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "vit",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 19,
            "n": "Crushflange",
            "c": "mac",
            "tc": "blac",
            "lvl": "12",
            "m": [
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                }
            ]
        },
        {
            "id": 20,
            "n": "Bloodrise",
            "i": "invmstu",
            "c": "mst",
            "lvl": "20",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "swing1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "skill",
                    "p": 96,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 21,
            "n": "The General's Tan Do Li Ga",
            "c": "fla",
            "tc": "dblu",
            "lvl": "28",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-max",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "slow",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 22,
            "n": "Ironstone",
            "c": "whm",
            "tc": "cblu",
            "lvl": "36",
            "m": [
                {
                    "prop": "att",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "*enr",
                    "min": -5,
                    "max": -5
                }
            ]
        },
        {
            "id": 23,
            "n": "Bonesnap",
            "i": "invmauu",
            "c": "mau",
            "lvl": "32",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "crush",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-cold",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 24,
            "n": "Steeldriver",
            "i": "invgma",
            "c": "gma",
            "tc": "cgrn",
            "lvl": "39",
            "m": [
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                },
                {
                    "prop": "swing3",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "regen-stam",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 250
                }
            ]
        },
        {
            "id": 25,
            "n": "Rixot's Keen",
            "c": "ssd",
            "tc": "blac",
            "lvl": "3",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 26,
            "n": "Blood Crescent",
            "i": "invscmu",
            "c": "scm",
            "lvl": "10",
            "m": [
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 80
                },
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "swing2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "lifesteal",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 27,
            "n": "Skewer of Krintiz",
            "i": "inv9sbu",
            "c": "sbr",
            "lvl": "14",
            "m": [
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "manasteal",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-norm",
                    "min": 3,
                    "max": 7
                }
            ]
        },
        {
            "id": 28,
            "n": "Gleamscythe",
            "i": "invflcu",
            "c": "flc",
            "lvl": "18",
            "m": [
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 100
                },
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 3,
                    "max": 5
                }
            ]
        },
        {
            "id": 29,
            "n": "Azurewrath",
            "i": "invcrsu",
            "c": "crs",
            "lvl": "18",
            "m": [
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dur",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-mag",
                    "min": 5,
                    "max": 10
                }
            ]
        },
        {
            "id": 30,
            "n": "Griswold's Edge",
            "i": "invbsdu",
            "c": "bsd",
            "lvl": "23",
            "m": [
                {
                    "prop": "fire-min",
                    "min": 10,
                    "max": 12
                },
                {
                    "prop": "fire-max",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "att",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "swing1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 120
                },
                {
                    "prop": "str",
                    "min": 12,
                    "max": 12
                }
            ]
        },
        {
            "id": 31,
            "n": "Hellplague",
            "i": "invlsdu",
            "c": "lsd",
            "lvl": "30",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "pois-min",
                    "min": 48,
                    "max": 48
                },
                {
                    "prop": "pois-max",
                    "min": 96,
                    "max": 96
                },
                {
                    "prop": "pois-len",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                },
                {
                    "prop": "dmg-fire",
                    "min": 25,
                    "max": 75
                },
                {
                    "prop": "fireskill",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 32,
            "n": "Culwen's Point",
            "c": "wsd",
            "tc": "whit",
            "lvl": "39",
            "m": [
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-pois-len",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                }
            ]
        },
        {
            "id": 33,
            "n": "Shadowfang",
            "i": "inv2hsu",
            "c": "2hs",
            "lvl": "16",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 9,
                    "max": 9
                },
                {
                    "prop": "res-cold",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "dmg-cold",
                    "p": 150,
                    "min": 10,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "lifesteal",
                    "min": 9,
                    "max": 9
                }
            ]
        },
        {
            "id": 34,
            "n": "Soulflay",
            "c": "clm",
            "tc": "dgrn",
            "lvl": "26",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 100
                },
                {
                    "prop": "res-all",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 35,
            "n": "Kinemil's Awl",
            "i": "invgisu",
            "c": "gis",
            "lvl": "31",
            "m": [
                {
                    "prop": "att",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "fire-min",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "fire-max",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 100
                },
                {
                    "prop": "skill",
                    "p": 102,
                    "min": 6,
                    "max": 6
                }
            ]
        },
        {
            "id": 36,
            "n": "Blacktongue",
            "i": "invbswu",
            "c": "bsw",
            "lvl": "35",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 150,
                    "min": 192,
                    "max": 192
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "*hp",
                    "min": -10,
                    "max": -10
                }
            ]
        },
        {
            "id": 37,
            "n": "Ripsaw",
            "c": "flb",
            "tc": "cblu",
            "lvl": "35",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "dmg-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 100
                }
            ]
        },
        {
            "id": 38,
            "n": "The Patriarch",
            "i": "invgsdu",
            "c": "gsd",
            "lvl": "39",
            "m": [
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "gold%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 120
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 39,
            "n": "Gull",
            "c": "dgr",
            "tc": "lgry",
            "lvl": "6",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mag%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "mana",
                    "min": -5,
                    "max": -5
                }
            ]
        },
        {
            "id": 40,
            "n": "The Diggler",
            "c": "dir",
            "tc": "dgry",
            "lvl": "15",
            "m": [
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-cold",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-fire",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 41,
            "n": "The Jade Tan Do",
            "i": "invkrsu",
            "c": "kri",
            "lvl": "26",
            "m": [
                {
                    "prop": "att",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-pois",
                    "p": 100,
                    "min": 460,
                    "max": 460
                },
                {
                    "prop": "res-pois",
                    "min": 95,
                    "max": 95
                },
                {
                    "prop": "res-pois-max",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 42,
            "n": "Spectral Shard",
            "c": "bld",
            "tc": "dblu",
            "lvl": "34",
            "m": [
                {
                    "prop": "cast3",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mana",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 55,
                    "max": 55
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 43,
            "n": "The Dragon Chang",
            "c": "spr",
            "tc": "dpur",
            "lvl": "11",
            "m": [
                {
                    "prop": "att",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg-min",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-fire",
                    "min": 3,
                    "max": 6
                }
            ]
        },
        {
            "id": 44,
            "n": "Razortine",
            "i": "invtriu",
            "c": "tri",
            "lvl": "16",
            "m": [
                {
                    "prop": "slow",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 45,
            "n": "Bloodthief",
            "c": "brn",
            "tc": "whit",
            "lvl": "23",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 12
                },
                {
                    "prop": "hp",
                    "min": 26,
                    "max": 26
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 70
                }
            ]
        },
        {
            "id": 46,
            "n": "Lance of Yaggai",
            "c": "spt",
            "tc": "lred",
            "lvl": "30",
            "m": [
                {
                    "prop": "thorns",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 47,
            "n": "The Tannr Gorerod",
            "c": "pik",
            "tc": "lgry",
            "lvl": "36",
            "m": [
                {
                    "prop": "fire-min",
                    "min": 23,
                    "max": 23
                },
                {
                    "prop": "fire-max",
                    "min": 54,
                    "max": 54
                },
                {
                    "prop": "res-fire-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "hp",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 80,
                    "max": 100
                }
            ]
        },
        {
            "id": 48,
            "n": "Dimoak's Hew",
            "c": "bar",
            "tc": "blac",
            "lvl": "11",
            "m": [
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": -8,
                    "max": -8
                }
            ]
        },
        {
            "id": 49,
            "n": "Steelgoad",
            "c": "vou",
            "tc": "cgrn",
            "lvl": "19",
            "m": [
                {
                    "prop": "howl",
                    "min": 96,
                    "max": 96
                },
                {
                    "prop": "deadly",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 80
                },
                {
                    "prop": "dur",
                    "min": 20,
                    "max": 40
                }
            ]
        },
        {
            "id": 50,
            "n": "Soul Harvest",
            "i": "invscyu",
            "c": "scy",
            "lvl": "26",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 90
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "enr",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 51,
            "n": "The Battlebranch",
            "c": "pax",
            "tc": "lblu",
            "lvl": "34",
            "m": [
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 70
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 100
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 7
                }
            ]
        },
        {
            "id": 52,
            "n": "Woestave",
            "c": "hal",
            "tc": "dblu",
            "lvl": "38",
            "m": [
                {
                    "prop": "slow",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "stupidity",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg-ac",
                    "min": -50,
                    "max": -50
                },
                {
                    "prop": "freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": -3,
                    "max": -3
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 20,
                    "max": 40
                }
            ]
        },
        {
            "id": 53,
            "n": "The Grim Reaper",
            "c": "wsc",
            "tc": "lpur",
            "lvl": "39",
            "m": [
                {
                    "prop": "deadly",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-min",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "*hp",
                    "min": -20,
                    "max": -20
                }
            ]
        },
        {
            "id": 54,
            "n": "Bane Ash",
            "c": "sst",
            "tc": "lgrn",
            "lvl": "7",
            "m": [
                {
                    "prop": "fire-min",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "fire-max",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "skill",
                    "p": 36,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 37,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 55,
            "n": "Serpent Lord",
            "c": "lst",
            "tc": "cgrn",
            "lvl": "12",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 75,
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light",
                    "min": -1,
                    "max": -1
                },
                {
                    "prop": "mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "manasteal",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 56,
            "n": "Spire of Lazarus",
            "i": "invcstu",
            "c": "cst",
            "lvl": "24",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "red-dmg",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "skill",
                    "p": 53,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 49,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 42,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "regen-mana",
                    "min": 43,
                    "max": 43
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 28
                },
                {
                    "prop": "sor",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 57,
            "n": "The Salamander",
            "c": "bst",
            "tc": "dred",
            "lvl": "28",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 15,
                    "max": 32
                },
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "skill",
                    "p": 51,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 47,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 37,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "fireskill",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 58,
            "n": "The Iron Jang Bong",
            "c": "wst",
            "tc": "dyel",
            "lvl": "38",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "cast3",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "skill",
                    "p": 48,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 46,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 44,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "sor",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 59,
            "n": "Pluckeye",
            "c": "sbw",
            "tc": "cblu",
            "lvl": "10",
            "m": [
                {
                    "prop": "att",
                    "min": 28,
                    "max": 28
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "hp",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "manasteal",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "mana-kill",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 60,
            "n": "Witherstring",
            "c": "hbw",
            "tc": "lred",
            "lvl": "18",
            "m": [
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-max",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "magicarrow",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg%",
                    "min": 40,
                    "max": 50
                }
            ]
        },
        {
            "id": 61,
            "n": "Raven Claw",
            "c": "lbw",
            "tc": "dred",
            "lvl": "20",
            "m": [
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dex",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "explosivearrow",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "str",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 70
                }
            ]
        },
        {
            "id": 62,
            "n": "Rogue's Bow",
            "i": "invcbwu",
            "c": "cbw",
            "lvl": "27",
            "m": [
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "deadly",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg%",
                    "min": 40,
                    "max": 60
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 63,
            "n": "Stormstrike",
            "i": "invsbbu",
            "c": "sbb",
            "lvl": "34",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "att",
                    "min": 28,
                    "max": 28
                },
                {
                    "prop": "pierce",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-ltng",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 90
                }
            ]
        },
        {
            "id": 64,
            "n": "Wizendraw",
            "c": "lbb",
            "tc": "dgrn",
            "lvl": "35",
            "m": [
                {
                    "prop": "magicarrow",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-cold",
                    "min": 26,
                    "max": 26
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 100
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "pierce-cold",
                    "min": 20,
                    "max": 35
                }
            ]
        },
        {
            "id": 65,
            "n": "Hellclap",
            "i": "invswbu",
            "c": "swb",
            "lvl": "36",
            "m": [
                {
                    "prop": "swing1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "fire-min",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "fire-max",
                    "min": 30,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 75
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dex",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 90
                },
                {
                    "prop": "fireskill",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 66,
            "n": "Blastbark",
            "c": "lwb",
            "tc": "lyel",
            "lvl": "38",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 130
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "manasteal",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 16,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 67,
            "n": "Leadcrow",
            "i": "invlxbu",
            "c": "lxb",
            "lvl": "12",
            "m": [
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "hp",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 70
                },
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "deadly",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "att",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 68,
            "n": "Ichorsting",
            "i": "invmxbu",
            "c": "mxb",
            "lvl": "24",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 75,
                    "min": 102,
                    "max": 102
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "pierce",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 69,
            "n": "Hellcast",
            "i": "invhxbu",
            "c": "hxb",
            "lvl": "36",
            "m": [
                {
                    "prop": "explosivearrow",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-fire-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "att",
                    "min": 70,
                    "max": 70
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 70,
                    "max": 80
                },
                {
                    "prop": "dmg-fire",
                    "min": 15,
                    "max": 35
                }
            ]
        },
        {
            "id": 70,
            "n": "Doomslinger",
            "i": "invrxbu",
            "c": "rxb",
            "lvl": "38",
            "m": [
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "pierce",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 100
                }
            ]
        },
        {
            "id": 71,
            "n": "Biggin's Bonnet",
            "i": "invcapu",
            "c": "cap",
            "lvl": "4",
            "m": [
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "att",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac",
                    "min": 14,
                    "max": 14
                }
            ]
        },
        {
            "id": 72,
            "n": "Tarnhelm",
            "c": "skp",
            "tc": "oran",
            "lvl": "20",
            "m": [
                {
                    "prop": "gold%",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 73,
            "n": "Coif of Glory",
            "i": "invhlmu",
            "c": "hlm",
            "lvl": "19",
            "m": [
                {
                    "prop": "light-thorns",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-ltng",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 74,
            "n": "Duskdeep",
            "i": "invfhlu",
            "c": "fhl",
            "lvl": "23",
            "m": [
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "red-dmg",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "dmg-max",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 75,
            "n": "Wormskull",
            "i": "invbhmu",
            "c": "bhm",
            "lvl": "28",
            "m": [
                {
                    "prop": "nec",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-pois",
                    "p": 200,
                    "min": 102,
                    "max": 102
                }
            ]
        },
        {
            "id": 76,
            "n": "Howltusk",
            "c": "ghm",
            "tc": "dgry",
            "lvl": "34",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "thorns",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac%",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "howl",
                    "min": 33,
                    "max": 33
                }
            ]
        },
        {
            "id": 77,
            "n": "Undead Crown",
            "c": "crn",
            "tc": "blac",
            "lvl": "39",
            "m": [
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 60
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att-undead",
                    "min": 50,
                    "max": 100
                },
                {
                    "prop": "skill",
                    "p": 69,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 78,
            "n": "The Face of Horror",
            "c": "msk",
            "tc": "lblu",
            "lvl": "27",
            "m": [
                {
                    "prop": "howl",
                    "min": 64,
                    "max": 64
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 79,
            "n": "Greyform",
            "c": "qui",
            "tc": "lgry",
            "lvl": "10",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-cold",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 80,
            "n": "Blinkbat's Form",
            "c": "lea",
            "tc": "dred",
            "lvl": "16",
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "move2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "fire-min",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "fire-max",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "balance2",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 81,
            "n": "The Centurion",
            "c": "hla",
            "tc": "cred",
            "lvl": "19",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "stam",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "stamdrain",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 82,
            "n": "Twitchthroe",
            "c": "stu",
            "tc": "lgrn",
            "lvl": "22",
            "m": [
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "block",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 83,
            "n": "Darkglow",
            "c": "rng",
            "tc": "dgrn",
            "lvl": "19",
            "m": [
                {
                    "prop": "att",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac-hth",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 70,
                    "max": 100
                }
            ]
        },
        {
            "id": 84,
            "n": "Hawkmail",
            "c": "scl",
            "tc": "cgrn",
            "lvl": "20",
            "m": [
                {
                    "prop": "ac%",
                    "min": 80,
                    "max": 100
                },
                {
                    "prop": "res-cold-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-cold",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "move2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 85,
            "n": "Sparking Mail",
            "c": "chn",
            "tc": "lyel",
            "lvl": "23",
            "m": [
                {
                    "prop": "ac%",
                    "min": 75,
                    "max": 85
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 20
                },
                {
                    "prop": "light-thorns",
                    "min": 10,
                    "max": 14
                },
                {
                    "prop": "res-ltng",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 86,
            "n": "Venom Ward",
            "c": "brs",
            "tc": "dyel",
            "lvl": "27",
            "m": [
                {
                    "prop": "res-pois-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-pois-len",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-pois",
                    "min": 90,
                    "max": 90
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 100
                }
            ]
        },
        {
            "id": 87,
            "n": "Iceblink",
            "c": "spl",
            "tc": "lgld",
            "lvl": "30",
            "m": [
                {
                    "prop": "freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-cold",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "red-mag",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac%",
                    "min": 70,
                    "max": 80
                }
            ]
        },
        {
            "id": 88,
            "n": "Boneflesh",
            "c": "plt",
            "tc": "dgld",
            "lvl": "35",
            "m": [
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 120
                },
                {
                    "prop": "att",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 89,
            "n": "Rockfleece",
            "c": "fld",
            "tc": "dgry",
            "lvl": "38",
            "m": [
                {
                    "prop": "ease",
                    "min": -10,
                    "max": -10
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 130
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "red-dmg",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 90,
            "n": "Rattlecage",
            "c": "gth",
            "tc": "dpur",
            "lvl": "39",
            "m": [
                {
                    "prop": "howl",
                    "min": 52,
                    "max": 52
                },
                {
                    "prop": "att",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 200,
                    "max": 200
                }
            ]
        },
        {
            "id": 91,
            "n": "Goldskin",
            "i": "invfulu",
            "c": "ful",
            "lvl": "38",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "res-all",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "thorns",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "gold%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 92,
            "n": "Silks of the Victor",
            "i": "invaaru",
            "c": "aar",
            "lvl": "38",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 120
                }
            ]
        },
        {
            "id": 93,
            "n": "Heavenly Garb",
            "c": "ltp",
            "tc": "cblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "regen-mana",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg-undead",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att-undead",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 94,
            "n": "Pelta Lunata",
            "i": "invbucu",
            "c": "buc",
            "lvl": "3",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "block2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dur",
                    "min": 8,
                    "max": 12
                }
            ]
        },
        {
            "id": 95,
            "n": "Umbral Disk",
            "i": "invsmlu",
            "c": "sml",
            "lvl": "12",
            "m": [
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "ac%",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dur",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 96,
            "n": "Stormguild",
            "i": "invlrgu",
            "c": "lrg",
            "lvl": "18",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-ltng",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 60
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "light-thorns",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dur",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 97,
            "n": "Wall of the Eyeless",
            "i": "invbshu",
            "c": "bsh",
            "lvl": "27",
            "m": [
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "manasteal",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-pois",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 98,
            "n": "Swordback Hold",
            "i": "invspku",
            "c": "spk",
            "lvl": "20",
            "m": [
                {
                    "prop": "thorns",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "bloody",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 60
                },
                {
                    "prop": "thorns",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 99,
            "n": "Steelclash",
            "i": "invkitu",
            "c": "kit",
            "lvl": "23",
            "m": [
                {
                    "prop": "block",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "pal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 100
                },
                {
                    "prop": "block2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dur",
                    "min": 15,
                    "max": 20
                }
            ]
        },
        {
            "id": 100,
            "n": "Bverrit Keep",
            "i": "invtowu",
            "c": "tow",
            "lvl": "26",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-fire",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "red-mag",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 80,
                    "max": 120
                },
                {
                    "prop": "block",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dur",
                    "min": 80,
                    "max": 100
                }
            ]
        },
        {
            "id": 101,
            "n": "The Ward",
            "i": "invgtsu",
            "c": "gts",
            "lvl": "35",
            "m": [
                {
                    "prop": "ac",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "red-mag",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "block",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 102,
            "n": "The Hand of Broc",
            "c": "lgl",
            "tc": "cblu",
            "lvl": "7",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-pois",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 10,
                    "max": 20
                }
            ]
        },
        {
            "id": 103,
            "n": "Bloodfist",
            "c": "vgl",
            "tc": "oran",
            "lvl": "12",
            "m": [
                {
                    "prop": "dmg-min",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "hp",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 104,
            "n": "Chance Guards",
            "c": "mgl",
            "tc": "lred",
            "lvl": "20",
            "m": [
                {
                    "prop": "gold%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 40
                },
                {
                    "prop": "att",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 105,
            "n": "Magefist",
            "c": "tgl",
            "tc": "lgry",
            "lvl": "31",
            "m": [
                {
                    "prop": "cast3",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "regen-mana",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "fireskill",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-fire",
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 106,
            "n": "Frostburn",
            "c": "hgl",
            "tc": "dred",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "mana%",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 1,
                    "max": 6
                },
                {
                    "prop": "ac%",
                    "min": 10,
                    "max": 20
                }
            ]
        },
        {
            "id": 107,
            "n": "Hotspur",
            "c": "lbt",
            "tc": "cred",
            "lvl": "7",
            "m": [
                {
                    "prop": "res-fire-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "hp",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg-fire",
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "ac",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "res-fire",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "ac%",
                    "min": 10,
                    "max": 20
                }
            ]
        },
        {
            "id": 108,
            "n": "Gorefoot",
            "c": "vbt",
            "tc": "dblu",
            "lvl": "12",
            "m": [
                {
                    "prop": "bloody",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "manasteal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "thorns",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "skill",
                    "p": 132,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 109,
            "n": "Treads of Cthon",
            "c": "mbt",
            "tc": "lgrn",
            "lvl": "20",
            "m": [
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac-miss",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "stamdrain",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "hp",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 40
                }
            ]
        },
        {
            "id": 110,
            "n": "Goblin Toe",
            "c": "tbt",
            "tc": "dgry",
            "lvl": "30",
            "m": [
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "red-dmg",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "red-mag",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "light",
                    "min": -1,
                    "max": -1
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 60
                }
            ]
        },
        {
            "id": 111,
            "n": "Tearhaunch",
            "c": "hbt",
            "tc": "dgrn",
            "lvl": "39",
            "m": [
                {
                    "prop": "ac",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dex",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 80
                },
                {
                    "prop": "skill",
                    "p": 115,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 112,
            "n": "Lenymo",
            "c": "lbl",
            "tc": "cgrn",
            "lvl": "10",
            "m": [
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen-mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "light",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 113,
            "n": "Snakecord",
            "c": "vbl",
            "tc": "blac",
            "lvl": "16",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 75,
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-pois-len",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 114,
            "n": "Nightsmoke",
            "c": "mbl",
            "tc": "lyel",
            "lvl": "27",
            "m": [
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-dmg",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 115,
            "n": "Goldwrap",
            "c": "tbl",
            "tc": "lblu",
            "lvl": "36",
            "m": [
                {
                    "prop": "mag%",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 40,
                    "max": 60
                },
                {
                    "prop": "gold%",
                    "min": 50,
                    "max": 80
                }
            ]
        },
        {
            "id": 116,
            "n": "Bladebuckle",
            "c": "hbl",
            "tc": "dyel",
            "lvl": "39",
            "m": [
                {
                    "prop": "thorns",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "red-dmg",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 80,
                    "max": 100
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 117,
            "n": "Nokozan Relic",
            "c": "amu",
            "lvl": "14",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "res-fire-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 118,
            "n": "The Eye of Etlich",
            "c": "amu",
            "lvl": "20",
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 10,
                    "max": 40
                },
                {
                    "prop": "light",
                    "min": 1,
                    "max": 5
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 7
                },
                {
                    "prop": "cold-min",
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "cold-max",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "cold-len",
                    "min": 50,
                    "max": 250
                }
            ]
        },
        {
            "id": 119,
            "n": "The Mahim-Oak Curio",
            "c": "amu",
            "lvl": "34",
            "m": [
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "att%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 120,
            "n": "Nagelring",
            "c": "rin",
            "lvl": "10",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "thorns",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "att",
                    "min": 50,
                    "max": 75
                },
                {
                    "prop": "mag%",
                    "min": 15,
                    "max": 30
                }
            ]
        },
        {
            "id": 121,
            "n": "Manald Heal",
            "c": "rin",
            "lvl": "20",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 7
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 8
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "regen-mana",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 122,
            "n": "The Stone of Jordan",
            "c": "rin",
            "lvl": "39",
            "m": [
                {
                    "prop": "mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 12,
                    "max": 12
                }
            ]
        },
        {
            "id": 123,
            "n": "Amulet of the Viper",
            "c": "vip",
            "lvl": "0",
            "m": [
                {
                    "prop": "mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "hp",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 124,
            "n": "Staff of Kings",
            "c": "msf",
            "lvl": "0",
            "m": [
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing3",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 125,
            "n": "Horadric Staff",
            "c": "hst",
            "lvl": "0",
            "m": [
                {
                    "prop": "mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-pois",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "hp",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing3",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 126,
            "n": "Hell Forge Hammer",
            "c": "hfh",
            "lvl": "0",
            "m": [
                {
                    "prop": "fire-min",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "fire-max",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac",
                    "min": 35,
                    "max": 35
                }
            ]
        },
        {
            "id": 127,
            "n": "Khalim's Flail",
            "c": "qf1",
            "lvl": "0",
            "m": [
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "swing3",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 128,
            "n": "Khalim's Will",
            "c": "qf2",
            "lvl": "0",
            "m": [
                {
                    "prop": "ltng-min",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ltng-max",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "swing3",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 6
                }
            ]
        },
        {
            "id": 129,
            "n": "Coldkill",
            "i": "invhaxu",
            "c": "9ha",
            "tc": "cblu",
            "lvl": "44",
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 50,
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-cold",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-cold-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 45,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "gethit-skill",
                    "p": 44,
                    "min": 10,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 190
                }
            ]
        },
        {
            "id": 130,
            "n": "Butcher's Pupil",
            "i": "invaxeu",
            "c": "9ax",
            "tc": "cblu",
            "lvl": "47",
            "m": [
                {
                    "prop": "deadly",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-norm",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 131,
            "n": "Islestrike",
            "c": "92a",
            "lvl": "51",
            "m": [
                {
                    "prop": "dru",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac-miss",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 170,
                    "max": 190
                },
                {
                    "prop": "skill",
                    "p": 233,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 248,
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 132,
            "n": "Pompeii's Wrath",
            "i": "invmpiu",
            "c": "9mp",
            "tc": "cred",
            "lvl": "53",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 244,
                    "min": 4,
                    "max": 8
                },
                {
                    "prop": "slow",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-fire",
                    "min": 35,
                    "max": 150
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 170
                }
            ]
        },
        {
            "id": 133,
            "n": "Guardian Naga",
            "c": "9wa",
            "lvl": "56",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 92,
                    "min": 5,
                    "max": 8
                },
                {
                    "prop": "thorns",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "dmg-pois",
                    "p": 250,
                    "min": 256,
                    "max": 256
                },
                {
                    "prop": "dmg-max",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 134,
            "n": "Warlord's Trust",
            "c": "9la",
            "tc": "whit",
            "lvl": "43",
            "m": [
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "regen",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit/lvl",
                    "p": 4
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "rep-dur",
                    "p": 25
                },
                {
                    "prop": "dmg%",
                    "min": 175,
                    "max": 175
                }
            ]
        },
        {
            "id": 135,
            "n": "Spellsteel",
            "c": "9ba",
            "tc": "whit",
            "lvl": "47",
            "m": [
                {
                    "prop": "ease",
                    "min": -60,
                    "max": -60
                },
                {
                    "prop": "mana",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "red-mag",
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "cast1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 165,
                    "max": 165
                },
                {
                    "prop": "regen-mana",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "charged",
                    "p": 54,
                    "min": 20,
                    "max": 1
                },
                {
                    "prop": "charged",
                    "p": 87,
                    "min": 30,
                    "max": 3
                },
                {
                    "prop": "charged",
                    "p": 101,
                    "min": 100,
                    "max": 10
                },
                {
                    "prop": "charged",
                    "p": 225,
                    "min": 60,
                    "max": 12
                }
            ]
        },
        {
            "id": 136,
            "n": "Stormrider",
            "i": "inv9btu",
            "c": "9bt",
            "tc": "lred",
            "lvl": "49",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 53,
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "hit-skill",
                    "p": 38,
                    "min": 10,
                    "max": 0
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 200
                },
                {
                    "prop": "dmg-norm",
                    "min": 35,
                    "max": 75
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dur",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light-thorns",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 38,
                    "min": 15,
                    "max": 5
                }
            ]
        },
        {
            "id": 137,
            "n": "Boneslayer Blade",
            "i": "invgaxu",
            "c": "9ga",
            "lvl": "50",
            "m": [
                {
                    "prop": "att-und/lvl",
                    "p": 10
                },
                {
                    "prop": "dmg-und/lvl",
                    "p": 20
                },
                {
                    "prop": "str",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att%",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "charged",
                    "p": 101,
                    "min": 200,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 101,
                    "min": 50,
                    "max": 0
                }
            ]
        },
        {
            "id": 138,
            "n": "The Minotaur",
            "i": "inv9giu",
            "c": "9gi",
            "lvl": "53",
            "m": [
                {
                    "prop": "stupidity",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "slow",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "crush",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 200
                }
            ]
        },
        {
            "id": 139,
            "n": "Suicide Branch",
            "c": "9wn",
            "lvl": "41",
            "m": [
                {
                    "prop": "thorns",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "cast2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "hp",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 140,
            "n": "Carin Shard",
            "c": "9yw",
            "tc": "cblu",
            "lvl": "43",
            "m": [
                {
                    "prop": "hp/lvl",
                    "p": 10
                },
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana/lvl",
                    "p": 10
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "regen",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "nec",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skilltab",
                    "p": 8,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 141,
            "n": "Arm of King Leoric",
            "i": "invbwnu",
            "c": "9bw",
            "lvl": "44",
            "m": [
                {
                    "prop": "skilltab",
                    "p": 8,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "gethit-skill",
                    "p": 93,
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "mana/lvl",
                    "p": 10
                },
                {
                    "prop": "gethit-skill",
                    "p": 88,
                    "min": 10,
                    "max": 2
                },
                {
                    "prop": "cast1",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "skilltab",
                    "p": 7,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 77,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 80,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 69,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 70,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 142,
            "n": "Blackhand Key",
            "i": "inv9gwu",
            "c": "9gw",
            "tc": "blac",
            "lvl": "49",
            "m": [
                {
                    "prop": "skilltab",
                    "p": 6,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "cast3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-fire",
                    "min": 37,
                    "max": 37
                },
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "charged",
                    "p": 150,
                    "min": 30,
                    "max": 13
                }
            ]
        },
        {
            "id": 143,
            "n": "Dark Clan Crusher",
            "i": "invclbu",
            "c": "9cl",
            "tc": "dgld",
            "lvl": "42",
            "m": [
                {
                    "prop": "dru",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "att-demon",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg%",
                    "min": 195,
                    "max": 195
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 25
                },
                {
                    "prop": "demon-heal",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 144,
            "n": "Zakarum's Hand",
            "c": "9sc",
            "tc": "lpur",
            "lvl": "45",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "regen-mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "regen-stam",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "hit-skill",
                    "p": 59,
                    "min": 6,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "skill",
                    "p": 114,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 118,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 145,
            "n": "The Fetid Sprinkler",
            "c": "9qs",
            "lvl": "46",
            "m": [
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hit-skill",
                    "p": 87,
                    "min": 5,
                    "max": 1
                },
                {
                    "prop": "hit-skill",
                    "p": 81,
                    "min": 10,
                    "max": 1
                },
                {
                    "prop": "dmg-pois",
                    "p": 100,
                    "min": 409,
                    "max": 409
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 190
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "dmg-norm",
                    "min": 15,
                    "max": 25
                }
            ]
        },
        {
            "id": 146,
            "n": "Hand of Blessed Light",
            "c": "9ws",
            "lvl": "50",
            "m": [
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg%",
                    "min": 130,
                    "max": 160
                },
                {
                    "prop": "att%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "regen-mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 45
                },
                {
                    "prop": "skill",
                    "p": 101,
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 121,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hit-skill",
                    "p": 121,
                    "min": 5,
                    "max": 4
                }
            ]
        },
        {
            "id": 147,
            "n": "Fleshrender",
            "i": "invspcu",
            "c": "9sp",
            "lvl": "46",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "crush",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "deadly",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-norm",
                    "min": 35,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 130,
                    "max": 200
                },
                {
                    "prop": "dru",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skilltab",
                    "p": 16,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dur",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 148,
            "n": "Sureshrill Frost",
            "c": "9ma",
            "lvl": "47",
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 125,
                    "min": 63,
                    "max": 112
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "dmg-norm",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "freeze",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "charged",
                    "p": 64,
                    "min": 50,
                    "max": 9
                }
            ]
        },
        {
            "id": 149,
            "n": "Moonfall",
            "i": "invmstu",
            "c": "9mt",
            "lvl": "50",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 56,
                    "min": 5,
                    "max": 6
                },
                {
                    "prop": "dmg-fire",
                    "min": 55,
                    "max": 115
                },
                {
                    "prop": "red-mag",
                    "min": 9,
                    "max": 12
                },
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "charged",
                    "p": 56,
                    "min": 60,
                    "max": 11
                },
                {
                    "prop": "dmg-norm",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 150,
            "n": "Baezil's Vortex",
            "c": "9fl",
            "tc": "dblu",
            "lvl": "53",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 48,
                    "min": 5,
                    "max": 8
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 150
                },
                {
                    "prop": "mana",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-ltng",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 48,
                    "min": 80,
                    "max": 15
                }
            ]
        },
        {
            "id": 151,
            "n": "Earthshaker",
            "c": "9wh",
            "lvl": "51",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 234,
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 180
                },
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skilltab",
                    "p": 17,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dur",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 152,
            "n": "Bloodtree Stump",
            "c": "9m9",
            "lvl": "56",
            "m": [
                {
                    "prop": "crush",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "skilltab",
                    "p": 13,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 129,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dur",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 153,
            "n": "The Gavel of Pain",
            "i": "inv9gmu",
            "c": "9gm",
            "lvl": "53",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 5,
                    "max": 1
                },
                {
                    "prop": "gethit-skill",
                    "p": 76,
                    "min": 5,
                    "max": 1
                },
                {
                    "prop": "thorns",
                    "min": 26,
                    "max": 26
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 12,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 130,
                    "max": 160
                },
                {
                    "prop": "charged",
                    "p": 66,
                    "min": 3,
                    "max": 8
                }
            ]
        },
        {
            "id": 154,
            "n": "Bloodletter",
            "c": "9ss",
            "tc": "cred",
            "lvl": "38",
            "m": [
                {
                    "prop": "dmg-norm",
                    "min": 12,
                    "max": 45
                },
                {
                    "prop": "att",
                    "min": 90,
                    "max": 90
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "stamdrain",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 140
                },
                {
                    "prop": "skill",
                    "p": 127,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 151,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "dur",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 155,
            "n": "Coldsteel Eye",
            "i": "invscmu",
            "c": "9sm",
            "lvl": "39",
            "m": [
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "slow",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dur",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 6
                }
            ]
        },
        {
            "id": 156,
            "n": "Hexfire",
            "i": "invsbru",
            "c": "9sb",
            "lvl": "41",
            "m": [
                {
                    "prop": "charged",
                    "p": 62,
                    "min": 36,
                    "max": 6
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-fire",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-fire-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-norm",
                    "min": 35,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 160
                },
                {
                    "prop": "fireskill",
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 157,
            "n": "Blade of Ali Baba",
            "c": "9fc",
            "tc": "cred",
            "lvl": "43",
            "m": [
                {
                    "prop": "sock",
                    "p": 3
                },
                {
                    "prop": "gold%/lvl",
                    "p": 20
                },
                {
                    "prop": "mag%/lvl",
                    "p": 8
                },
                {
                    "prop": "mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg%",
                    "min": 60,
                    "max": 120
                },
                {
                    "prop": "dex",
                    "min": 5,
                    "max": 15
                }
            ]
        },
        {
            "id": 158,
            "n": "Ginther's Rift",
            "i": "inv9cru",
            "c": "9cr",
            "lvl": "45",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 7,
                    "max": 12
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "rep-dur",
                    "p": 20
                },
                {
                    "prop": "dur",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg-mag",
                    "min": 50,
                    "max": 120
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 150
                }
            ]
        },
        {
            "id": 159,
            "n": "Headstriker",
            "c": "9bs",
            "tc": "bwht",
            "lvl": "47",
            "m": [
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "deadly/lvl",
                    "p": 12
                },
                {
                    "prop": "dmg/lvl",
                    "p": 8
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 150
                }
            ]
        },
        {
            "id": 160,
            "n": "Plague Bearer",
            "i": "inv9lsu",
            "c": "9ls",
            "lvl": "49",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 92,
                    "min": 5,
                    "max": 4
                },
                {
                    "prop": "dmg-pois",
                    "p": 200,
                    "min": 384,
                    "max": 384
                },
                {
                    "prop": "dmg-norm",
                    "min": 10,
                    "max": 45
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "res-pois",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "skill",
                    "p": 238,
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 161,
            "n": "The Atlantean",
            "c": "9wd",
            "tc": "lblu",
            "lvl": "50",
            "m": [
                {
                    "prop": "dur",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "str",
                    "min": 16,
                    "max": 16
                },
                {
                    "prop": "dex",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "vit",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 162,
            "n": "Crainte Vomir",
            "i": "inv2hsu",
            "c": "92h",
            "lvl": "50",
            "m": [
                {
                    "prop": "slow",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg-ac",
                    "min": -70,
                    "max": -70
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "swing3",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 163,
            "n": "Bing Sz Wang",
            "c": "9cm",
            "lvl": "51",
            "m": [
                {
                    "prop": "ease",
                    "min": -30,
                    "max": -30
                },
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 50,
                    "max": 140
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "freeze",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hit-skill",
                    "p": 64,
                    "min": 5,
                    "max": 3
                },
                {
                    "prop": "dmg%",
                    "min": 130,
                    "max": 160
                }
            ]
        },
        {
            "id": 164,
            "n": "The Vile Husk",
            "i": "invgisu",
            "c": "9gs",
            "tc": "dgry",
            "lvl": "52",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 6,
                    "max": 1
                },
                {
                    "prop": "dmg-und/lvl",
                    "p": 60
                },
                {
                    "prop": "res-pois",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-pois",
                    "p": 150,
                    "min": 426,
                    "max": 426
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "att-und/lvl",
                    "p": 20
                }
            ]
        },
        {
            "id": 165,
            "n": "Cloudcrack",
            "i": "invbswu",
            "c": "9b9",
            "lvl": "53",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 121,
                    "min": 6,
                    "max": 7
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 240
                },
                {
                    "prop": "ac",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-ltng-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "light-thorns",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "skilltab",
                    "p": 10,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 11,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 166,
            "n": "Todesfaelle Flamme",
            "i": "inv9fbu",
            "c": "9fb",
            "lvl": "54",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 50,
                    "max": 200
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "abs-fire",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "att-skill",
                    "p": 47,
                    "min": 10,
                    "max": 6
                },
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 160
                },
                {
                    "prop": "charged",
                    "p": 52,
                    "min": 45,
                    "max": 10
                },
                {
                    "prop": "charged",
                    "p": 51,
                    "min": 20,
                    "max": 10
                }
            ]
        },
        {
            "id": 167,
            "n": "Swordguard",
            "i": "invgsdu",
            "c": "9gd",
            "tc": "bwht",
            "lvl": "55",
            "m": [
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                },
                {
                    "prop": "ac/lvl",
                    "p": 40
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 170,
                    "max": 180
                },
                {
                    "prop": "ac-hth",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 168,
            "n": "Spineripper",
            "c": "9dg",
            "lvl": "40",
            "m": [
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "swing3",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 240
                },
                {
                    "prop": "dmg-norm",
                    "min": 15,
                    "max": 27
                },
                {
                    "prop": "nec",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 169,
            "n": "Heart Carver",
            "c": "9di",
            "lvl": "44",
            "m": [
                {
                    "prop": "deadly",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 15,
                    "max": 35
                },
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "skill",
                    "p": 131,
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 142,
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 150,
                    "min": 4,
                    "max": 4
                }
            ]
        },
        {
            "id": 170,
            "n": "Blackbog's Sharp",
            "i": "invkrsu",
            "c": "9kr",
            "lvl": "46",
            "m": [
                {
                    "prop": "slow",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-norm",
                    "min": 15,
                    "max": 45
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-pois",
                    "p": 250,
                    "min": 500,
                    "max": 500
                },
                {
                    "prop": "skill",
                    "p": 73,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 83,
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 92,
                    "min": 4,
                    "max": 4
                }
            ]
        },
        {
            "id": 171,
            "n": "Stormspike",
            "i": "inv9blu",
            "c": "9bl",
            "tc": "cblu",
            "lvl": "49",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 120
                },
                {
                    "prop": "light-thorns",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 38,
                    "min": 25,
                    "max": 3
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "res-ltng/lvl",
                    "p": 8
                }
            ]
        },
        {
            "id": 172,
            "n": "The Impaler",
            "c": "9sr",
            "tc": "lred",
            "lvl": "39",
            "m": [
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "openwounds",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 170
                },
                {
                    "prop": "skill",
                    "p": 19,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 14,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 173,
            "n": "Kelpie Snare",
            "i": "invtriu",
            "c": "9tr",
            "lvl": "41",
            "m": [
                {
                    "prop": "slow",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "res-fire",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "hp/lvl",
                    "p": 10
                },
                {
                    "prop": "dmg-norm",
                    "min": 30,
                    "max": 50
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 180
                }
            ]
        },
        {
            "id": 174,
            "n": "Soulfeast Tine",
            "i": "inv9bru",
            "c": "9br",
            "tc": "lyel",
            "lvl": "43",
            "m": [
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "manasteal",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "stamdrain",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 190
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 250
                },
                {
                    "prop": "dur",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 175,
            "n": "Hone Sundan",
            "c": "9st",
            "lvl": "45",
            "m": [
                {
                    "prop": "sock",
                    "p": 3
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "crush",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "rep-dur",
                    "p": 10
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 200
                }
            ]
        },
        {
            "id": 176,
            "n": "Spire of Honor",
            "c": "9p9",
            "tc": "lgry",
            "lvl": "47",
            "m": [
                {
                    "prop": "att%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "regen",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "dmg-dem/lvl",
                    "p": 12
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "skilltab",
                    "p": 9,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac%",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 177,
            "n": "The Meat Scraper",
            "c": "9b7",
            "tc": "dred",
            "lvl": "49",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "lifesteal",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mag%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "skilltab",
                    "p": 13,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 178,
            "n": "Blackleach Blade",
            "c": "9vo",
            "tc": "blac",
            "lvl": "50",
            "m": [
                {
                    "prop": "ease",
                    "min": -25,
                    "max": -25
                },
                {
                    "prop": "hit-skill",
                    "p": 72,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "dmg/lvl",
                    "p": 10
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 140
                }
            ]
        },
        {
            "id": 179,
            "n": "Athena's Wrath",
            "i": "inv9s8u",
            "c": "9s8",
            "lvl": "50",
            "m": [
                {
                    "prop": "dru",
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hp/lvl",
                    "p": 8
                },
                {
                    "prop": "dmg/lvl",
                    "p": 8
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 180
                }
            ]
        },
        {
            "id": 180,
            "n": "Pierre Tombale Couant",
            "c": "9pa",
            "tc": "lgld",
            "lvl": "51",
            "m": [
                {
                    "prop": "deadly",
                    "min": 55,
                    "max": 55
                },
                {
                    "prop": "bar",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "dmg-norm",
                    "min": 12,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 220
                },
                {
                    "prop": "att",
                    "min": 100,
                    "max": 200
                }
            ]
        },
        {
            "id": 181,
            "n": "Husoldal Evo",
            "c": "9h9",
            "lvl": "52",
            "m": [
                {
                    "prop": "regen",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 32
                },
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 182,
            "n": "Grim's Burning Dead",
            "c": "9wc",
            "tc": "cred",
            "lvl": "52",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 131,
                    "max": 232
                },
                {
                    "prop": "res-fire",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "dmg%",
                    "min": 140,
                    "max": 180
                },
                {
                    "prop": "thorns",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                },
                {
                    "prop": "nec",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 250
                }
            ]
        },
        {
            "id": 183,
            "n": "Razorswitch",
            "c": "8ss",
            "lvl": "36",
            "m": [
                {
                    "prop": "cast3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "thorns",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana",
                    "min": 175,
                    "max": 175
                },
                {
                    "prop": "hp",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "red-mag",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 184,
            "n": "Ribcracker",
            "c": "8ls",
            "tc": "lblu",
            "lvl": "39",
            "m": [
                {
                    "prop": "dmg-norm",
                    "min": 30,
                    "max": 65
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "crush",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "balance2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dur",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 185,
            "n": "Chromatic Ire",
            "i": "invcstu",
            "c": "8cs",
            "lvl": "43",
            "m": [
                {
                    "prop": "sor",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "cast1",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "light-thorns",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hp%",
                    "min": 20,
                    "max": 25
                },
                {
                    "prop": "skill",
                    "p": 61,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 63,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 65,
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 186,
            "n": "Warpspear",
            "c": "8bs",
            "tc": "cblu",
            "lvl": "47",
            "m": [
                {
                    "prop": "sor",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "skill",
                    "p": 54,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 43,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 58,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 250
                }
            ]
        },
        {
            "id": 187,
            "n": "Skull Collector",
            "i": "inv8wsu",
            "c": "8ws",
            "tc": "blac",
            "lvl": "49",
            "m": [
                {
                    "prop": "mana%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mag%/lvl",
                    "p": 8
                }
            ]
        },
        {
            "id": 188,
            "n": "Skystrike",
            "c": "8sb",
            "lvl": "36",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 250
                },
                {
                    "prop": "att",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "hit-skill",
                    "p": 56,
                    "min": 2,
                    "max": 6
                },
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 189,
            "n": "Riphook",
            "c": "8hb",
            "tc": "cred",
            "lvl": "39",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "slow",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "mana",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 10
                }
            ]
        },
        {
            "id": 190,
            "n": "Kuko Shakaku",
            "i": "inv8lbu",
            "c": "8lb",
            "tc": "lpur",
            "lvl": "41",
            "m": [
                {
                    "prop": "skill",
                    "p": 27,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "explosivearrow",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "pierce",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-fire",
                    "min": 40,
                    "max": 180
                },
                {
                    "prop": "skilltab",
                    "p": 0,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 191,
            "n": "Endlesshail",
            "i": "invcbwu",
            "c": "8cb",
            "lvl": "44",
            "m": [
                {
                    "prop": "res-cold",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "mana",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "ac-miss",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "skill",
                    "p": 26,
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 15,
                    "max": 30
                }
            ]
        },
        {
            "id": 192,
            "n": "Witchwild String",
            "i": "inv8s8u",
            "c": "8s8",
            "tc": "lblu",
            "lvl": "47",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 2,
                    "max": 5
                },
                {
                    "prop": "res-all",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "deadly/lvl",
                    "p": 8
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 170
                },
                {
                    "prop": "magicarrow",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "sock",
                    "p": 2
                }
            ]
        },
        {
            "id": 193,
            "n": "Cliffkiller",
            "c": "8l8",
            "lvl": "49",
            "m": [
                {
                    "prop": "ama",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 230
                },
                {
                    "prop": "ac-miss",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dmg-min",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "dmg-max",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 194,
            "n": "Magewrath",
            "i": "invswbu",
            "c": "8sw",
            "lvl": "51",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "red-mag",
                    "min": 9,
                    "max": 13
                },
                {
                    "prop": "skill",
                    "p": 22,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "stupidity",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "dmg%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 195,
            "n": "Goldstrike Arch",
            "c": "8lw",
            "tc": "lgry",
            "lvl": "54",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "att%",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 200
                },
                {
                    "prop": "dmg-demon",
                    "min": 100,
                    "max": 200
                },
                {
                    "prop": "hit-skill",
                    "p": 121,
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "regen",
                    "min": 12,
                    "max": 12
                }
            ]
        },
        {
            "id": 196,
            "n": "Langer Briser",
            "i": "inv8lxu",
            "c": "8lx",
            "lvl": "40",
            "m": [
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 170,
                    "max": 200
                },
                {
                    "prop": "mag%",
                    "min": 30,
                    "max": 60
                },
                {
                    "prop": "hp",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-max",
                    "min": 10,
                    "max": 30
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 212
                }
            ]
        },
        {
            "id": 197,
            "n": "Pus Spitter",
            "i": "inv8mxu",
            "c": "8mx",
            "tc": "cgrn",
            "lvl": "44",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 200,
                    "min": 192,
                    "max": 192
                },
                {
                    "prop": "hit-skill",
                    "p": 91,
                    "min": 4,
                    "max": 1
                },
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ease",
                    "min": -60,
                    "max": -60
                },
                {
                    "prop": "gethit-skill",
                    "p": 92,
                    "min": 9,
                    "max": 6
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 220
                },
                {
                    "prop": "att/lvl",
                    "p": 10
                }
            ]
        },
        {
            "id": 198,
            "n": "Buriza-Do Kyanon",
            "i": "invhxbu",
            "c": "8hx",
            "lvl": "59",
            "m": [
                {
                    "prop": "pierce",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dex",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "ac",
                    "min": 75,
                    "max": 150
                },
                {
                    "prop": "dmg/lvl",
                    "p": 20
                },
                {
                    "prop": "swing2",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "freeze",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "dmg-cold",
                    "p": 200,
                    "min": 32,
                    "max": 196
                }
            ]
        },
        {
            "id": 199,
            "n": "Demon Machine",
            "i": "invrxbu",
            "c": "8rx",
            "tc": "blac",
            "lvl": "57",
            "m": [
                {
                    "prop": "ac",
                    "min": 321,
                    "max": 321
                },
                {
                    "prop": "mana",
                    "min": 36,
                    "max": 36
                },
                {
                    "prop": "pierce",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "explosivearrow",
                    "min": 6,
                    "max": 6
                },
                {
                    "prop": "dmg-max",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "dmg%",
                    "min": 123,
                    "max": 123
                },
                {
                    "prop": "att",
                    "min": 632,
                    "max": 632
                }
            ]
        },
        {
            "id": 200,
            "n": "Armor",
            "m": []
        },
        {
            "id": 201,
            "n": "Peasant Crown",
            "c": "xap",
            "lvl": "36",
            "m": [
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "move2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen",
                    "min": 6,
                    "max": 12
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 202,
            "n": "Rockstopper",
            "i": "invxkpu",
            "c": "xkp",
            "lvl": "39",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 220
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 50
                },
                {
                    "prop": "res-cold",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 203,
            "n": "Stealskull",
            "i": "invhlmu",
            "c": "xlm",
            "lvl": "43",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "balance2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 200,
                    "max": 240
                },
                {
                    "prop": "mag%",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 204,
            "n": "Darksight Helm",
            "i": "invfhlu",
            "c": "xhl",
            "tc": "blac",
            "lvl": "46",
            "m": [
                {
                    "prop": "light",
                    "min": -4,
                    "max": -4
                },
                {
                    "prop": "ac/lvl",
                    "p": 16
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "gethit-skill",
                    "p": 71,
                    "min": 6,
                    "max": 3
                },
                {
                    "prop": "charged",
                    "p": 264,
                    "min": 30,
                    "max": 5
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 40
                }
            ]
        },
        {
            "id": 205,
            "n": "Valkyrie Wing",
            "c": "xhm",
            "lvl": "52",
            "m": [
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "mana-kill",
                    "min": 2,
                    "max": 4
                }
            ]
        },
        {
            "id": 206,
            "n": "Crown of Thieves",
            "i": "invxrnu",
            "c": "xrn",
            "tc": "dgld",
            "lvl": "57",
            "m": [
                {
                    "prop": "dex",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "lifesteal",
                    "min": 9,
                    "max": 12
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "mana",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "res-fire",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "gold%",
                    "min": 80,
                    "max": 100
                }
            ]
        },
        {
            "id": 207,
            "n": "Blackhorn's Face",
            "c": "xsk",
            "tc": "blac",
            "lvl": "49",
            "m": [
                {
                    "prop": "light-thorns",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "slow",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "abs-ltng",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-ltng",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 220
                }
            ]
        },
        {
            "id": 208,
            "n": "Vampire Gaze",
            "i": "invbhmu",
            "c": "xh9",
            "tc": "cgrn",
            "lvl": "49",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 8
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 8
                },
                {
                    "prop": "stamdrain",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "red-dmg%",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 6,
                    "max": 22
                }
            ]
        },
        {
            "id": 209,
            "n": "The Spirit Shroud",
            "c": "xui",
            "lvl": "36",
            "m": [
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "red-mag",
                    "min": 7,
                    "max": 11
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 150
                }
            ]
        },
        {
            "id": 210,
            "n": "Skin of the Vipermagi",
            "c": "xea",
            "tc": "dblu",
            "lvl": "37",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 120
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 35
                },
                {
                    "prop": "cast3",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "red-mag",
                    "min": 9,
                    "max": 13
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 211,
            "n": "Skin of the Flayed One",
            "c": "xla",
            "tc": "lred",
            "lvl": "39",
            "m": [
                {
                    "prop": "rep-dur",
                    "p": 10
                },
                {
                    "prop": "regen",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "dur",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 190
                },
                {
                    "prop": "thorns",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 212,
            "n": "Iron Pelt",
            "i": "invxtuu",
            "c": "xtu",
            "tc": "dgry",
            "lvl": "41",
            "m": [
                {
                    "prop": "dur",
                    "min": 125,
                    "max": 125
                },
                {
                    "prop": "hp",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 16
                },
                {
                    "prop": "red-dmg",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "ac/lvl",
                    "p": 24
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 100
                }
            ]
        },
        {
            "id": 213,
            "n": "Spirit Forge",
            "c": "xng",
            "lvl": "43",
            "m": [
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "hp/lvl",
                    "p": 10
                },
                {
                    "prop": "dmg-fire",
                    "min": 20,
                    "max": 65
                },
                {
                    "prop": "res-fire",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 160
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "sock",
                    "p": 2
                }
            ]
        },
        {
            "id": 214,
            "n": "Crow Caw",
            "c": "xcl",
            "lvl": "45",
            "m": [
                {
                    "prop": "openwounds",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "balance2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "*charged",
                    "p": 221,
                    "min": 3,
                    "max": 5
                }
            ]
        },
        {
            "id": 215,
            "n": "Shaftstop",
            "c": "xhn",
            "lvl": "46",
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "red-dmg%",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hp",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 220
                }
            ]
        },
        {
            "id": 216,
            "n": "Duriel's Shell",
            "c": "xrs",
            "tc": "oran",
            "lvl": "49",
            "m": [
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac/lvl",
                    "p": 10
                },
                {
                    "prop": "hp/lvl",
                    "p": 8
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-ltng",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-pois",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-cold",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dur",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 217,
            "n": "Skullder's Ire",
            "c": "xpl",
            "lvl": "50",
            "m": [
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "mag%/lvl",
                    "p": 10
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "dur",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "rep-dur",
                    "p": 20
                }
            ]
        },
        {
            "id": 218,
            "n": "Guardian Angel",
            "c": "xlt",
            "tc": "lgry",
            "lvl": "53",
            "m": [
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "pal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 200
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "att-dem/lvl",
                    "p": 5
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 219,
            "n": "Toothrow",
            "c": "xld",
            "tc": "whit",
            "lvl": "56",
            "m": [
                {
                    "prop": "thorns",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "ac",
                    "min": 40,
                    "max": 60
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "openwounds",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 220
                },
                {
                    "prop": "dur",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 220,
            "n": "Atma's Wail",
            "c": "xth",
            "lvl": "59",
            "m": [
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana%",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac/lvl",
                    "p": 16
                },
                {
                    "prop": "dur",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 160
                },
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 221,
            "n": "Black Hades",
            "c": "xul",
            "lvl": "61",
            "m": [
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "att-demon",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "sock",
                    "p": 3
                },
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 200
                },
                {
                    "prop": "dmg-demon",
                    "min": 30,
                    "max": 60
                }
            ]
        },
        {
            "id": 222,
            "n": "Corpsemourn",
            "i": "invxaru",
            "c": "xar",
            "tc": "blac",
            "lvl": "63",
            "m": [
                {
                    "prop": "str",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-cold",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "gethit-skill",
                    "p": 76,
                    "min": 6,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "dmg-fire",
                    "min": 12,
                    "max": 36
                },
                {
                    "prop": "charged",
                    "p": 74,
                    "min": 40,
                    "max": 5
                }
            ]
        },
        {
            "id": 223,
            "n": "Que-Hegan's Wisdom",
            "c": "xtp",
            "lvl": "59",
            "m": [
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "red-mag",
                    "min": 6,
                    "max": 10
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 160
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 224,
            "n": "Visceratuant",
            "i": "invbucu",
            "c": "xuc",
            "lvl": "36",
            "m": [
                {
                    "prop": "sor",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "light-thorns",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 225,
            "n": "Moser's Blessed Circle",
            "i": "invxmlu",
            "c": "xml",
            "lvl": "39",
            "m": [
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "block",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "sock",
                    "p": 2
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 220
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 226,
            "n": "Stormchaser",
            "i": "invxrgu",
            "c": "xrg",
            "tc": "cblu",
            "lvl": "43",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 60
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "res-ltng",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 150
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 220
                },
                {
                    "prop": "block2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "gethit-skill",
                    "p": 59,
                    "min": 4,
                    "max": 6
                },
                {
                    "prop": "gethit-skill",
                    "p": 245,
                    "min": 4,
                    "max": 5
                }
            ]
        },
        {
            "id": 227,
            "n": "Tiamat's Rebuke",
            "i": "invkitu",
            "c": "xit",
            "tc": "lgry",
            "lvl": "46",
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 150,
                    "min": 27,
                    "max": 53
                },
                {
                    "prop": "dmg-fire",
                    "min": 35,
                    "max": 95
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 120
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 200
                },
                {
                    "prop": "gethit-skill",
                    "p": 44,
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "gethit-skill",
                    "p": 48,
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "gethit-skill",
                    "p": 62,
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "dur",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 228,
            "n": "Gerke's Sanctuary",
            "i": "invtowu",
            "c": "xow",
            "tc": "lgrn",
            "lvl": "52",
            "m": [
                {
                    "prop": "red-dmg",
                    "min": 11,
                    "max": 16
                },
                {
                    "prop": "red-mag",
                    "min": 14,
                    "max": 18
                },
                {
                    "prop": "regen",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 240
                },
                {
                    "prop": "dur",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 229,
            "n": "Radament's Sphere",
            "i": "invgtsu",
            "c": "xts",
            "lvl": "58",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 100,
                    "min": 204,
                    "max": 204
                },
                {
                    "prop": "gethit-skill",
                    "p": 92,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-pois",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "block2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 83,
                    "min": 40,
                    "max": 6
                },
                {
                    "prop": "dur",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 230,
            "n": "Lidless Wall",
            "i": "invxshu",
            "c": "xsh",
            "tc": "dgld",
            "lvl": "49",
            "m": [
                {
                    "prop": "light",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 80,
                    "max": 130
                },
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana%",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 231,
            "n": "Lance Guard",
            "i": "invxpku",
            "c": "xpk",
            "lvl": "43",
            "m": [
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "thorns",
                    "min": 47,
                    "max": 47
                },
                {
                    "prop": "ac%",
                    "min": 70,
                    "max": 120
                },
                {
                    "prop": "deadly",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 232,
            "n": "Venom Grip",
            "c": "xlg",
            "lvl": "37",
            "m": [
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-pois-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg-pois",
                    "p": 100,
                    "min": 153,
                    "max": 153
                },
                {
                    "prop": "crush",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "ac%",
                    "min": 130,
                    "max": 160
                }
            ]
        },
        {
            "id": 233,
            "n": "Gravepalm",
            "c": "xvg",
            "lvl": "39",
            "m": [
                {
                    "prop": "enr",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-undead",
                    "min": 100,
                    "max": 200
                },
                {
                    "prop": "att-undead",
                    "min": 100,
                    "max": 200
                },
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 180
                }
            ]
        },
        {
            "id": 234,
            "n": "Ghoulhide",
            "c": "xmg",
            "lvl": "44",
            "m": [
                {
                    "prop": "att-und/lvl",
                    "p": 16
                },
                {
                    "prop": "dmg-und/lvl",
                    "p": 16
                },
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 5
                },
                {
                    "prop": "hp",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 190
                }
            ]
        },
        {
            "id": 235,
            "n": "Lava Gout",
            "c": "xtg",
            "lvl": "50",
            "m": [
                {
                    "prop": "res-fire",
                    "min": 24,
                    "max": 24
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "hit-skill",
                    "p": 52,
                    "min": 2,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "dmg-fire",
                    "min": 13,
                    "max": 46
                },
                {
                    "prop": "dur",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 236,
            "n": "Hellmouth",
            "c": "xhg",
            "lvl": "55",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 15,
                    "max": 72
                },
                {
                    "prop": "abs-fire",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "dur",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "hit-skill",
                    "p": 56,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "hit-skill",
                    "p": 225,
                    "min": 4,
                    "max": 12
                }
            ]
        },
        {
            "id": 237,
            "n": "Infernostride",
            "c": "xlb",
            "lvl": "37",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 12,
                    "max": 33
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-fire-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "gold%",
                    "min": 40,
                    "max": 70
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "gethit-skill",
                    "p": 46,
                    "min": 5,
                    "max": 8
                }
            ]
        },
        {
            "id": 238,
            "n": "Waterwalk",
            "c": "xvb",
            "lvl": "40",
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 210
                },
                {
                    "prop": "hp",
                    "min": 45,
                    "max": 65
                },
                {
                    "prop": "stam",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "res-fire-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "regen-stam",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 239,
            "n": "Silkweave",
            "c": "xmb",
            "lvl": "44",
            "m": [
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 190
                },
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac-miss",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "mana%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 240,
            "n": "War Traveler",
            "c": "xtb",
            "lvl": "50",
            "m": [
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mag%",
                    "min": 30,
                    "max": 50
                },
                {
                    "prop": "dur",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "move2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 190
                },
                {
                    "prop": "dmg-norm",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "thorns",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "stamdrain",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 241,
            "n": "Gore Rider",
            "c": "xhb",
            "lvl": "55",
            "m": [
                {
                    "prop": "ease",
                    "min": -25,
                    "max": -25
                },
                {
                    "prop": "deadly",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "crush",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "openwounds",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "dur",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "stam",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 242,
            "n": "String of Ears",
            "c": "zlb",
            "lvl": "37",
            "m": [
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 8
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dur",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 243,
            "n": "Razortail",
            "c": "zvb",
            "lvl": "39",
            "m": [
                {
                    "prop": "thorns/lvl",
                    "p": 8
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "pierce",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "ac",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "dmg-max",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 244,
            "n": "Gloom's Trap",
            "c": "zmb",
            "lvl": "45",
            "m": [
                {
                    "prop": "light",
                    "min": -3,
                    "max": -3
                },
                {
                    "prop": "mana%",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "regen-mana",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 245,
            "n": "Snowclash",
            "c": "ztb",
            "lvl": "49",
            "m": [
                {
                    "prop": "gethit-skill",
                    "p": 59,
                    "min": 5,
                    "max": 0
                },
                {
                    "prop": "abs-cold",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-cold-max",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg-cold",
                    "p": 75,
                    "min": 13,
                    "max": 21
                },
                {
                    "prop": "ac%",
                    "min": 130,
                    "max": 170
                },
                {
                    "prop": "skill",
                    "p": 59,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 55,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 60,
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 246,
            "n": "Thundergod's Vigor",
            "c": "zhb",
            "lvl": "55",
            "m": [
                {
                    "prop": "gethit-skill",
                    "p": 121,
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 50
                },
                {
                    "prop": "res-ltng-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "abs-ltng",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "skill",
                    "p": 34,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 35,
                    "min": 3,
                    "max": 3
                }
            ]
        },
        {
            "id": 247,
            "m": []
        },
        {
            "id": 248,
            "n": "Harlequin Crest",
            "c": "uap",
            "tc": "cgrn",
            "lvl": "69",
            "m": [
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "hp/lvl",
                    "p": 12
                },
                {
                    "prop": "mana/lvl",
                    "p": 12
                },
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dex",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "vit",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "enr",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 249,
            "n": "Veil of Steel",
            "c": "uhm",
            "tc": "lgry",
            "lvl": "77",
            "m": [
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ac%",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "light",
                    "min": -4,
                    "max": -4
                },
                {
                    "prop": "dur",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": 140,
                    "max": 140
                }
            ]
        },
        {
            "id": 250,
            "n": "The Gladiator's Bane",
            "c": "utu",
            "tc": "lgry",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "red-mag",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "red-dmg",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "thorns",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-pois-len",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dur",
                    "min": 103,
                    "max": 103
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 251,
            "n": "Arkaine's Valor",
            "c": "upl",
            "tc": "lred",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "red-dmg",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "vit/lvl",
                    "p": 4
                }
            ]
        },
        {
            "id": 252,
            "n": "Blackoak Shield",
            "i": "invsmlu",
            "c": "uml",
            "lvl": "67",
            "m": [
                {
                    "prop": "dex/lvl",
                    "p": 4
                },
                {
                    "prop": "ac%",
                    "min": 160,
                    "max": 200
                },
                {
                    "prop": "abs-cold/lvl",
                    "p": 5
                },
                {
                    "prop": "gethit-skill",
                    "p": 72,
                    "min": 4,
                    "max": 5
                },
                {
                    "prop": "dur",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "hp/lvl",
                    "p": 10
                },
                {
                    "prop": "block2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 253,
            "n": "Stormshield",
            "i": "invkitu",
            "c": "uit",
            "lvl": "77",
            "m": [
                {
                    "prop": "ac/lvl",
                    "p": 30
                },
                {
                    "prop": "red-dmg%",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "str",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "block2",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "res-ltng",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "block",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-cold",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "light-thorns",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 254,
            "n": "Hellslayer",
            "i": "invbtxu",
            "c": "7bt",
            "tc": "dred",
            "lvl": "71",
            "m": [
                {
                    "prop": "str/lvl",
                    "p": 4
                },
                {
                    "prop": "vit/lvl",
                    "p": 4
                },
                {
                    "prop": "dmg%/lvl",
                    "p": 24
                },
                {
                    "prop": "dmg-fire",
                    "min": 150,
                    "max": 250
                },
                {
                    "prop": "hp",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "att-skill",
                    "p": 47,
                    "min": 10,
                    "max": 0
                }
            ]
        },
        {
            "id": 255,
            "n": "Messerschmidt's Reaver",
            "i": "invgaxu",
            "c": "7ga",
            "tc": "blac",
            "lvl": "75",
            "m": [
                {
                    "prop": "dmg%/lvl",
                    "p": 20
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "enr",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "dmg-fire",
                    "min": 20,
                    "max": 240
                },
                {
                    "prop": "dur",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "att%",
                    "min": 100,
                    "max": 100
                }
            ]
        },
        {
            "id": 256,
            "n": "Baranar's Star",
            "i": "invmstu",
            "c": "7mt",
            "tc": "lred",
            "lvl": "70",
            "m": [
                {
                    "prop": "att%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "dur",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 200
                },
                {
                    "prop": "dmg-fire",
                    "min": 1,
                    "max": 200
                },
                {
                    "prop": "dmg-cold",
                    "min": 1,
                    "max": 200
                }
            ]
        },
        {
            "id": 257,
            "n": "Schaefer's Hammer",
            "c": "7wh",
            "tc": "lblu",
            "lvl": "83",
            "m": [
                {
                    "prop": "hit-skill",
                    "p": 42,
                    "min": 20,
                    "max": 10
                },
                {
                    "prop": "hp",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att/lvl",
                    "p": 16
                },
                {
                    "prop": "res-ltng",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg/lvl",
                    "p": 16
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 100,
                    "max": 130
                },
                {
                    "prop": "light",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-ltng",
                    "min": 50,
                    "max": 200
                }
            ]
        },
        {
            "id": 258,
            "n": "The Cranium Basher",
            "c": "7gm",
            "tc": "blac",
            "lvl": "85",
            "m": [
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "crush",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "dmg-norm",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 240
                },
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 4,
                    "max": 1
                }
            ]
        },
        {
            "id": 259,
            "n": "Lightsabre",
            "i": "invcrsu",
            "c": "7cr",
            "lvl": "66",
            "m": [
                {
                    "prop": "light",
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "att-skill",
                    "p": 53,
                    "min": 5,
                    "max": 0
                },
                {
                    "prop": "ignore-ac",
                    "p": 1,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "abs-ltng%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg-mag",
                    "min": 60,
                    "max": 120
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 200
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "dmg-norm",
                    "min": 10,
                    "max": 30
                }
            ]
        },
        {
            "id": 260,
            "n": "Doombringer",
            "i": "invbswu",
            "c": "7b7",
            "tc": "dred",
            "lvl": "75",
            "m": [
                {
                    "prop": "hp%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 250
                },
                {
                    "prop": "att%",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-norm",
                    "min": 30,
                    "max": 100
                },
                {
                    "prop": "hit-skill",
                    "p": 72,
                    "min": 8,
                    "max": 3
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 7
                }
            ]
        },
        {
            "id": 261,
            "n": "The Grandfather",
            "i": "invgsdu",
            "c": "7gd",
            "tc": "lyel",
            "lvl": "85",
            "m": [
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "hp",
                    "min": 80,
                    "max": 80
                },
                {
                    "prop": "dmg/lvl",
                    "p": 20
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 250
                }
            ]
        },
        {
            "id": 262,
            "n": "Wizardspike",
            "c": "7dg",
            "tc": "lgry",
            "lvl": "69",
            "m": [
                {
                    "prop": "mana/lvl",
                    "p": 16
                },
                {
                    "prop": "regen-mana",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana%",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "res-all",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "cast3",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 263,
            "n": "Constricting Ring",
            "c": "rin",
            "tc": "cblu",
            "lvl": "95",
            "m": [
                {
                    "prop": "res-all",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "regen",
                    "min": -30,
                    "max": -30
                },
                {
                    "prop": "mag%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "res-all-max",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 264,
            "n": "Stormspire",
            "c": "7wc",
            "tc": "dblu",
            "lvl": "78",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "gethit-skill",
                    "p": 53,
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 250
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "gethit-skill",
                    "p": 38,
                    "min": 2,
                    "max": 0
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 237
                },
                {
                    "prop": "light-thorns",
                    "min": 27,
                    "max": 27
                }
            ]
        },
        {
            "id": 265,
            "n": "Eaglehorn",
            "c": "6l7",
            "tc": "dgld",
            "lvl": "77",
            "m": [
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "att/lvl",
                    "p": 12
                },
                {
                    "prop": "dmg%/lvl",
                    "p": 16
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 200
                },
                {
                    "prop": "ama",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dex",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 266,
            "n": "Windforce",
            "c": "6lw",
            "tc": "dyel",
            "lvl": "80",
            "m": [
                {
                    "prop": "dex",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dmg/lvl",
                    "p": 25
                },
                {
                    "prop": "regen-stam",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "manasteal",
                    "min": 6,
                    "max": 8
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 267,
            "n": "Rings",
            "m": []
        },
        {
            "id": 268,
            "n": "Bul-Kathos' Wedding Band",
            "c": "rin",
            "tc": "dpur",
            "lvl": "66",
            "m": [
                {
                    "prop": "hp/lvl",
                    "p": 4
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "stam",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 269,
            "n": "The Cat's Eye",
            "c": "amu",
            "tc": "oran",
            "lvl": "58",
            "m": [
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "dex",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 270,
            "n": "The Rising Sun",
            "c": "amu",
            "tc": "lgld",
            "lvl": "73",
            "m": [
                {
                    "prop": "abs-fire/lvl",
                    "p": 6
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "gethit-skill",
                    "p": 56,
                    "min": 2,
                    "max": 0
                },
                {
                    "prop": "dmg-fire",
                    "min": 24,
                    "max": 48
                },
                {
                    "prop": "fireskill",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 271,
            "n": "Crescent Moon",
            "c": "amu",
            "tc": "lblu",
            "lvl": "58",
            "m": [
                {
                    "prop": "manasteal",
                    "min": 11,
                    "max": 15
                },
                {
                    "prop": "red-mag",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": -2,
                    "max": -2
                },
                {
                    "prop": "mana",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 6
                }
            ]
        },
        {
            "id": 272,
            "n": "Mara's Kaleidoscope",
            "c": "amu",
            "tc": "oran",
            "lvl": "80",
            "m": [
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "dex",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "vit",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "enr",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 273,
            "n": "Atma's Scarab",
            "c": "amu",
            "tc": "cgrn",
            "lvl": "60",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 100,
                    "min": 102,
                    "max": 102
                },
                {
                    "prop": "res-pois",
                    "min": 75,
                    "max": 75
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "thorns",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 5,
                    "max": 2
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 274,
            "n": "Dwarf Star",
            "c": "rin",
            "tc": "dgry",
            "lvl": "53",
            "m": [
                {
                    "prop": "gold%",
                    "min": 100,
                    "max": 100
                },
                {
                    "prop": "stam",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "regen-stam",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "hp",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "red-mag",
                    "min": 12,
                    "max": 15
                },
                {
                    "prop": "abs-fire%",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 275,
            "n": "Raven Frost",
            "c": "rin",
            "tc": "cblu",
            "lvl": "53",
            "m": [
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 15,
                    "max": 45
                },
                {
                    "prop": "abs-cold%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "att",
                    "min": 150,
                    "max": 250
                }
            ]
        },
        {
            "id": 276,
            "n": "Highlord's Wrath",
            "c": "amu",
            "tc": "bwht",
            "lvl": "73",
            "m": [
                {
                    "prop": "res-ltng",
                    "min": 35,
                    "max": 35
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 30
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "deadly/lvl",
                    "p": 3
                },
                {
                    "prop": "light-thorns",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 277,
            "n": "Saracen's Chance",
            "c": "amu",
            "tc": "dpur",
            "lvl": "55",
            "m": [
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "gethit-skill",
                    "p": 76,
                    "min": 10,
                    "max": 2
                },
                {
                    "prop": "str",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "dex",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "enr",
                    "min": 12,
                    "max": 12
                },
                {
                    "prop": "vit",
                    "min": 12,
                    "max": 12
                }
            ]
        },
        {
            "id": 278,
            "n": "Class-specific",
            "m": []
        },
        {
            "id": 279,
            "n": "Arreat's Face",
            "c": "baa",
            "lvl": "50",
            "m": [
                {
                    "prop": "bar",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 12,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 280,
            "n": "Homunculus",
            "c": "nea",
            "lvl": "50",
            "m": [
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 6,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "block",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "regen-mana",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-all",
                    "min": 40,
                    "max": 40
                }
            ]
        },
        {
            "id": 281,
            "n": "Titan's Revenge",
            "c": "ama",
            "lvl": "50",
            "m": [
                {
                    "prop": "ama",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 2,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "rep-quant",
                    "p": 30
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "dmg-norm",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "stack",
                    "min": 60,
                    "max": 60
                }
            ]
        },
        {
            "id": 282,
            "n": "Lycander's Aim",
            "c": "am7",
            "lvl": "50",
            "m": [
                {
                    "prop": "ama",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 0,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "manasteal",
                    "min": 5,
                    "max": 8
                },
                {
                    "prop": "dmg-norm",
                    "min": 25,
                    "max": 50
                }
            ]
        },
        {
            "id": 283,
            "n": "Lycander's Flank",
            "c": "am9",
            "lvl": "50",
            "m": [
                {
                    "prop": "ama",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 2,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "dmg-norm",
                    "min": 25,
                    "max": 50
                }
            ]
        },
        {
            "id": 284,
            "n": "The Oculus",
            "c": "oba",
            "lvl": "50",
            "m": [
                {
                    "prop": "sor",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "gethit-skill",
                    "p": 54,
                    "min": 25,
                    "max": 1
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "cast2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "ac%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 285,
            "n": "Herald of Zakarum",
            "c": "pa9",
            "lvl": "50",
            "m": [
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 9,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "block",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 286,
            "n": "Bartuc's Cut-Throat",
            "c": "9tw",
            "lvl": "50",
            "m": [
                {
                    "prop": "ass",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 20,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "dmg-norm",
                    "min": 25,
                    "max": 50
                }
            ]
        },
        {
            "id": 287,
            "n": "Jalal's Mane",
            "c": "dra",
            "lvl": "50",
            "m": [
                {
                    "prop": "dru",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 16,
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "att%",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "mana-kill",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 288,
            "n": "The Scalper",
            "c": "9ta",
            "lvl": "65",
            "m": [
                {
                    "prop": "rep-quant",
                    "p": 30
                },
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "att%",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "lifesteal",
                    "min": 4,
                    "max": 6
                },
                {
                    "prop": "mana-kill",
                    "min": 4,
                    "max": 4
                }
            ]
        },
        {
            "id": 289,
            "n": "Bloodmoon",
            "i": "invsbru",
            "c": "7sb",
            "tc": "cred",
            "lvl": "69",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 210,
                    "max": 260
                },
                {
                    "prop": "lifesteal",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "charged",
                    "p": 85,
                    "min": 9,
                    "max": 15
                },
                {
                    "prop": "heal-kill",
                    "min": 7,
                    "max": 13
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 290,
            "n": "Djinn Slayer",
            "i": "invscmu",
            "c": "7sm",
            "tc": "dpur",
            "lvl": "73",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "dmg-fire",
                    "min": 250,
                    "max": 500
                },
                {
                    "prop": "dmg-demon",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "att-demon",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "abs-ltng",
                    "min": 3,
                    "max": 7
                },
                {
                    "prop": "manasteal",
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 291,
            "n": "Deathbit",
            "c": "9tk",
            "lvl": "52",
            "m": [
                {
                    "prop": "deadly",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "dmg%",
                    "min": 130,
                    "max": 180
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 450
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 9
                },
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 6
                },
                {
                    "prop": "rep-quant",
                    "p": 25
                }
            ]
        },
        {
            "id": 292,
            "n": "Warshrike",
            "i": "invtk3",
            "c": "7bk",
            "tc": "bwht",
            "lvl": "83",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "pierce",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "rep-quant",
                    "p": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 48,
                    "min": 25,
                    "max": 9
                }
            ]
        },
        {
            "id": 293,
            "n": "Gut Siphon",
            "i": "invrxbu",
            "c": "6rx",
            "tc": "lgrn",
            "lvl": "79",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 220
                },
                {
                    "prop": "pierce",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "lifesteal",
                    "min": 12,
                    "max": 18
                },
                {
                    "prop": "slow",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                }
            ]
        },
        {
            "id": 294,
            "n": "Razor's Edge",
            "i": "invhaxu",
            "c": "7ha",
            "lvl": "75",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 175,
                    "max": 225
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "reduce-ac",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                }
            ]
        },
        {
            "id": 295,
            "n": "Gore Ripper",
            "tc": "dred",
            "m": []
        },
        {
            "id": 296,
            "n": "Demon Limb",
            "i": "invspcu",
            "c": "7sp",
            "tc": "dgrn",
            "lvl": "71",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "dmg-fire",
                    "min": 222,
                    "max": 333
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 13
                },
                {
                    "prop": "charged",
                    "p": 52,
                    "min": 20,
                    "max": 23
                },
                {
                    "prop": "rep-dur",
                    "p": 5
                },
                {
                    "prop": "dmg-demon",
                    "min": 123,
                    "max": 123
                },
                {
                    "prop": "res-fire",
                    "min": 15,
                    "max": 20
                }
            ]
        },
        {
            "id": 297,
            "n": "Steel Shade",
            "i": "invhlmu",
            "c": "ulm",
            "tc": "blac",
            "lvl": "70",
            "m": [
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 130
                },
                {
                    "prop": "abs-fire",
                    "min": 5,
                    "max": 11
                },
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 8
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 18
                }
            ]
        },
        {
            "id": 298,
            "n": "Tomb Reaver",
            "c": "7pa",
            "tc": "lyel",
            "lvl": "86",
            "m": [
                {
                    "prop": "swing2",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "light",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 280
                },
                {
                    "prop": "dmg-undead",
                    "min": 150,
                    "max": 230
                },
                {
                    "prop": "mag%",
                    "min": 50,
                    "max": 80
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 50
                },
                {
                    "prop": "att-undead",
                    "min": 250,
                    "max": 350
                },
                {
                    "prop": "reanimate",
                    "p": 1,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "heal-kill",
                    "min": 10,
                    "max": 14
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 3
                }
            ]
        },
        {
            "id": 299,
            "n": "Death's Web",
            "c": "7gw",
            "tc": "bwht",
            "lvl": "74",
            "m": [
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "pierce-pois",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "heal-kill",
                    "min": 7,
                    "max": 12
                },
                {
                    "prop": "mana-kill",
                    "min": 7,
                    "max": 12
                },
                {
                    "prop": "skilltab",
                    "p": 7,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 300,
            "n": "Nature's Peace",
            "c": "rin",
            "tc": "dgrn",
            "lvl": "77",
            "m": [
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "rip",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "red-dmg",
                    "min": 7,
                    "max": 11
                },
                {
                    "prop": "res-pois",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "charged",
                    "p": 226,
                    "min": 27,
                    "max": 5
                }
            ]
        },
        {
            "id": 301,
            "n": "Azurewrath",
            "i": "invcrs",
            "c": "7cr",
            "lvl": "87",
            "m": [
                {
                    "prop": "dmg-mag",
                    "min": 250,
                    "max": 500
                },
                {
                    "prop": "dmg%",
                    "min": 230,
                    "max": 270
                },
                {
                    "prop": "aura",
                    "p": 119,
                    "min": 10,
                    "max": 13
                },
                {
                    "prop": "dmg-cold",
                    "p": 250,
                    "min": 250,
                    "max": 500
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "all-stats",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 302,
            "n": "Seraph's Hymn",
            "i": "invamu2",
            "c": "amu",
            "tc": "bwht",
            "lvl": "73",
            "m": [
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 11,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "dmg-demon",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "dmg-undead",
                    "min": 25,
                    "max": 50
                },
                {
                    "prop": "att-demon",
                    "min": 150,
                    "max": 250
                },
                {
                    "prop": "att-undead",
                    "min": 150,
                    "max": 250
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 303,
            "n": "Zakarum's Salvation",
            "m": []
        },
        {
            "id": 304,
            "n": "Fleshripper",
            "i": "invkrsu",
            "c": "7kr",
            "tc": "dred",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "reduce-ac",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "openwounds",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "deadly",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "slow",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 305,
            "n": "Odium",
            "m": []
        },
        {
            "id": 306,
            "n": "Horizon's Tornado",
            "c": "7fl",
            "tc": "dpur",
            "lvl": "72",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 230,
                    "max": 280
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "slow",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "hit-skill",
                    "p": 245,
                    "min": 20,
                    "max": 15
                },
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                }
            ]
        },
        {
            "id": 307,
            "n": "Stone Crusher",
            "c": "7wh",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 280,
                    "max": 320
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "crush",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "reduce-ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "dmg-ac",
                    "min": -100,
                    "max": -100
                },
                {
                    "prop": "dmg",
                    "min": 10,
                    "max": 30
                }
            ]
        },
        {
            "id": 308,
            "n": "Jade Talon",
            "c": "7wb",
            "tc": "cgrn",
            "lvl": "74",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "res-all",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "skilltab",
                    "p": 19,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skilltab",
                    "p": 20,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 309,
            "n": "Shadow Dancer",
            "c": "uhb",
            "tc": "blac",
            "lvl": "79",
            "m": [
                {
                    "prop": "ac%",
                    "min": 70,
                    "max": 100
                },
                {
                    "prop": "move2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dex",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "skilltab",
                    "p": 19,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "ease",
                    "min": -20,
                    "max": -20
                }
            ]
        },
        {
            "id": 310,
            "n": "Cerebus' Bite",
            "c": "drb",
            "tc": "bwht",
            "lvl": "71",
            "m": [
                {
                    "prop": "ac%",
                    "min": 130,
                    "max": 140
                },
                {
                    "prop": "skilltab",
                    "p": 16,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 10
                },
                {
                    "prop": "att%",
                    "min": 60,
                    "max": 120
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "skill",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 311,
            "n": "Tyrael's Might",
            "i": "invaaru",
            "c": "uar",
            "tc": "dblu",
            "lvl": "87",
            "m": [
                {
                    "prop": "ease",
                    "min": -100,
                    "max": -100
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "rip",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-demon",
                    "min": 50,
                    "max": 100
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "str",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 312,
            "n": "Soul Drainer",
            "c": "umg",
            "tc": "dred",
            "lvl": "82",
            "m": [
                {
                    "prop": "ac%",
                    "min": 90,
                    "max": 120
                },
                {
                    "prop": "manasteal",
                    "min": 4,
                    "max": 7
                },
                {
                    "prop": "lifesteal",
                    "min": 4,
                    "max": 7
                },
                {
                    "prop": "hit-skill",
                    "p": 72,
                    "min": 8,
                    "max": 3
                },
                {
                    "prop": "dmg-ac",
                    "min": -50,
                    "max": -50
                }
            ]
        },
        {
            "id": 313,
            "n": "Rune Master",
            "c": "72a",
            "tc": "lblu",
            "lvl": "80",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 220,
                    "max": 270
                },
                {
                    "prop": "sock",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "res-cold-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 314,
            "n": "Death Cleaver",
            "c": "7wa",
            "lvl": "78",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 230,
                    "max": 280
                },
                {
                    "prop": "deadly",
                    "min": 66,
                    "max": 66
                },
                {
                    "prop": "reduce-ac",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "heal-kill",
                    "min": 6,
                    "max": 9
                }
            ]
        },
        {
            "id": 315,
            "n": "Executioner's Justice",
            "c": "7gi",
            "tc": "blac",
            "lvl": "83",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 290
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "reduce-ac",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "kill-skill",
                    "p": 87,
                    "min": 50,
                    "max": 6
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 316,
            "n": "Stoneraven",
            "c": "amd",
            "lvl": "72",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 230,
                    "max": 280
                },
                {
                    "prop": "dmg-mag",
                    "min": 101,
                    "max": 187
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 50
                },
                {
                    "prop": "ac",
                    "min": 400,
                    "max": 600
                },
                {
                    "prop": "skilltab",
                    "p": 2,
                    "min": 1,
                    "max": 3
                }
            ]
        },
        {
            "id": 317,
            "n": "Leviathan",
            "c": "uld",
            "tc": "cgrn",
            "lvl": "73",
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 200
                },
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "red-dmg%",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "str",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 318,
            "n": "Larzuk's Champion",
            "i": "invhfh",
            "m": []
        },
        {
            "id": 319,
            "n": "Wisp Projector",
            "c": "rin",
            "tc": "bwht",
            "lvl": "84",
            "m": [
                {
                    "prop": "abs-ltng%",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "hit-skill",
                    "p": 49,
                    "min": 10,
                    "max": 16
                },
                {
                    "prop": "mag%",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 226,
                    "min": 15,
                    "max": 2
                },
                {
                    "prop": "charged",
                    "p": 236,
                    "min": 13,
                    "max": 5
                },
                {
                    "prop": "charged",
                    "p": 246,
                    "min": 11,
                    "max": 7
                }
            ]
        },
        {
            "id": 320,
            "n": "Gargoyle's Bite",
            "c": "7ts",
            "tc": "cgrn",
            "lvl": "78",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "rep-quant",
                    "p": 30
                },
                {
                    "prop": "dmg-pois",
                    "p": 250,
                    "min": 300,
                    "max": 300
                },
                {
                    "prop": "lifesteal",
                    "min": 9,
                    "max": 15
                },
                {
                    "prop": "charged",
                    "p": 25,
                    "min": 60,
                    "max": 11
                }
            ]
        },
        {
            "id": 321,
            "n": "Lacerator",
            "c": "7b8",
            "tc": "blac",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 210
                },
                {
                    "prop": "rep-quant",
                    "p": 25
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "openwounds",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "howl",
                    "min": 64,
                    "max": 64
                },
                {
                    "prop": "hit-skill",
                    "p": 66,
                    "min": 33,
                    "max": 3
                }
            ]
        },
        {
            "id": 322,
            "n": "Mang Song's Lesson",
            "i": "inv8wsu",
            "c": "6ws",
            "tc": "dgld",
            "lvl": "86",
            "m": [
                {
                    "prop": "allskills",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "pierce-fire",
                    "min": 7,
                    "max": 15
                },
                {
                    "prop": "pierce-ltng",
                    "min": 7,
                    "max": 15
                },
                {
                    "prop": "pierce-cold",
                    "min": 7,
                    "max": 15
                },
                {
                    "prop": "regen-mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "cast2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 323,
            "n": "Viperfork",
            "c": "7br",
            "tc": "dgrn",
            "lvl": "79",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "dmg-pois",
                    "p": 250,
                    "min": 333,
                    "max": 333
                },
                {
                    "prop": "swing2",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "att",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "hit-skill",
                    "p": 83,
                    "min": 15,
                    "max": 9
                },
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 50
                }
            ]
        },
        {
            "id": 324,
            "n": "Ethereal Edge",
            "c": "7ba",
            "tc": "whit",
            "lvl": "82",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "abs-fire",
                    "min": 10,
                    "max": 12
                },
                {
                    "prop": "dmg-demon",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "demon-heal",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "att",
                    "min": 270,
                    "max": 350
                },
                {
                    "prop": "ethereal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 325,
            "n": "Demonhorn's Edge",
            "c": "bad",
            "tc": "dgry",
            "lvl": "69",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 160
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "thorns",
                    "min": 55,
                    "max": 77
                },
                {
                    "prop": "skilltab",
                    "p": 12,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skilltab",
                    "p": 13,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skilltab",
                    "p": 14,
                    "min": 1,
                    "max": 3
                }
            ]
        },
        {
            "id": 326,
            "n": "The Reaper's Toll",
            "i": "invscy",
            "c": "7s8",
            "lvl": "83",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "hit-skill",
                    "p": 87,
                    "min": 33,
                    "max": 1
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "lifesteal",
                    "min": 11,
                    "max": 15
                },
                {
                    "prop": "ease",
                    "min": -25,
                    "max": -25
                },
                {
                    "prop": "deadly",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "dmg-cold",
                    "min": 4,
                    "max": 44
                }
            ]
        },
        {
            "id": 327,
            "n": "Spirit Keeper",
            "c": "drd",
            "lvl": "75",
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 190
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "abs-ltng",
                    "min": 9,
                    "max": 14
                },
                {
                    "prop": "res-fire",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "abs-cold%",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "res-pois-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dru",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 328,
            "n": "Hellrack",
            "i": "invhxbu",
            "c": "6hx",
            "lvl": "84",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "dmg-elem",
                    "p": 33,
                    "min": 63,
                    "max": 324
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "att%",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "charged",
                    "p": 27,
                    "min": 150,
                    "max": 18
                }
            ]
        },
        {
            "id": 329,
            "n": "Alma Negra",
            "c": "pac",
            "tc": "blac",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 180,
                    "max": 210
                },
                {
                    "prop": "block2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "pal",
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-mag",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "att%",
                    "min": 40,
                    "max": 75
                },
                {
                    "prop": "dmg%",
                    "min": 40,
                    "max": 75
                }
            ]
        },
        {
            "id": 330,
            "n": "Darkforce Spawn",
            "c": "nef",
            "tc": "cred",
            "lvl": "72",
            "m": [
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 180
                },
                {
                    "prop": "cast2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "mana%",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "skilltab",
                    "p": 6,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skilltab",
                    "p": 7,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "skilltab",
                    "p": 8,
                    "min": 1,
                    "max": 3
                }
            ]
        },
        {
            "id": 331,
            "n": "Widowmaker",
            "i": "invswbu",
            "c": "6sw",
            "tc": "dred",
            "lvl": "73",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "deadly",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "magicarrow",
                    "min": 11,
                    "max": 11
                },
                {
                    "prop": "oskill",
                    "p": 22,
                    "min": 3,
                    "max": 5
                }
            ]
        },
        {
            "id": 332,
            "n": "Blood Raven's Charge",
            "i": "invswbu",
            "c": "amb",
            "tc": "dgld",
            "lvl": "79",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "att%",
                    "min": 200,
                    "max": 300
                },
                {
                    "prop": "explosivearrow",
                    "min": 13,
                    "max": 13
                },
                {
                    "prop": "skilltab",
                    "p": 0,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "charged",
                    "p": 95,
                    "min": 30,
                    "max": 5
                }
            ]
        },
        {
            "id": 333,
            "n": "Ghostflame",
            "c": "7bl",
            "tc": "cblu",
            "lvl": "70",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 190,
                    "max": 240
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-mag",
                    "min": 108,
                    "max": 108
                },
                {
                    "prop": "manasteal",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "ethereal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "light",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 334,
            "n": "Shadow Killer",
            "i": "invaxfu",
            "c": "7cs",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 170,
                    "max": 220
                },
                {
                    "prop": "reduce-ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "freeze",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "mana-kill",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "hit-skill",
                    "p": 44,
                    "min": 33,
                    "max": 8
                },
                {
                    "prop": "ethereal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 335,
            "n": "Gimmershred",
            "c": "7ta",
            "lvl": "78",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 210
                },
                {
                    "prop": "dmg-fire",
                    "min": 218,
                    "max": 483
                },
                {
                    "prop": "dmg-cold",
                    "p": 100,
                    "min": 176,
                    "max": 397
                },
                {
                    "prop": "dmg-ltng",
                    "min": 29,
                    "max": 501
                },
                {
                    "prop": "stack",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 336,
            "n": "Griffon's Eye",
            "c": "ci3",
            "lvl": "84",
            "m": [
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 200
                },
                {
                    "prop": "cast2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "extra-ltng",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "pierce-ltng",
                    "min": 15,
                    "max": 20
                }
            ]
        },
        {
            "id": 337,
            "n": "Windhammer",
            "i": "invmau",
            "c": "7m7",
            "tc": "cblu",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "crush",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "swing2",
                    "min": 60,
                    "max": 60
                },
                {
                    "prop": "hit-skill",
                    "p": 240,
                    "min": 33,
                    "max": 22
                }
            ]
        },
        {
            "id": 338,
            "n": "Thunderstroke",
            "c": "amf",
            "tc": "dblu",
            "lvl": "77",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 511
                },
                {
                    "prop": "hit-skill",
                    "p": 49,
                    "min": 20,
                    "max": 14
                },
                {
                    "prop": "swing2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "pierce-ltng",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "skill",
                    "p": 20,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "skilltab",
                    "p": 2,
                    "min": 2,
                    "max": 4
                }
            ]
        },
        {
            "id": 339,
            "n": "Giant Maimer",
            "tc": "cred",
            "m": []
        },
        {
            "id": 340,
            "n": "Demon's Arch",
            "c": "7s7",
            "tc": "cred",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 160,
                    "max": 210
                },
                {
                    "prop": "dmg-fire",
                    "min": 232,
                    "max": 323
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 12
                },
                {
                    "prop": "rep-quant",
                    "p": 30
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "dmg-ltng",
                    "min": 23,
                    "max": 333
                }
            ]
        },
        {
            "id": 341,
            "n": "Boneflame",
            "c": "nee",
            "tc": "dred",
            "lvl": "80",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 77,
                    "min": 15,
                    "max": 3
                },
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 3
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 342,
            "n": "Steel Pillar",
            "c": "7p7",
            "lvl": "77",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 210,
                    "max": 260
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "reduce-ac",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 80
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "crush",
                    "min": 25,
                    "max": 25
                }
            ]
        },
        {
            "id": 343,
            "n": "Nightwing's Veil",
            "c": "uhm",
            "tc": "cblu",
            "lvl": "75",
            "m": [
                {
                    "prop": "ac%",
                    "min": 90,
                    "max": 120
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "dex",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "abs-cold",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "extra-cold",
                    "min": 8,
                    "max": 15
                },
                {
                    "prop": "ease",
                    "min": -50,
                    "max": -50
                }
            ]
        },
        {
            "id": 344,
            "n": "Crown of Ages",
            "c": "urn",
            "tc": "dgld",
            "lvl": "86",
            "m": [
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "res-all",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "ac",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "indestruct",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "ac%",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 345,
            "n": "Andariel's Visage",
            "c": "usk",
            "tc": "dred",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 100,
                    "max": 150
                },
                {
                    "prop": "res-pois",
                    "min": 70,
                    "max": 70
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "res-pois-max",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 30
                },
                {
                    "prop": "gethit-skill",
                    "p": 92,
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "charged",
                    "p": 278,
                    "min": 20,
                    "max": 3
                },
                {
                    "prop": "lifesteal",
                    "min": 8,
                    "max": 10
                },
                {
                    "prop": "res-fire",
                    "min": -30,
                    "max": -30
                }
            ]
        },
        {
            "id": 346,
            "n": "Darkfear",
            "i": "invhlmu",
            "c": "ulm",
            "m": []
        },
        {
            "id": 347,
            "n": "Dragonscale",
            "c": "pae",
            "tc": "dgrn",
            "lvl": "84",
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 200
                },
                {
                    "prop": "abs-fire%",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "res-fire-max",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "dmg-fire",
                    "min": 211,
                    "max": 371
                },
                {
                    "prop": "oskill",
                    "p": 62,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "extra-fire",
                    "min": 15,
                    "max": 15
                }
            ]
        },
        {
            "id": 348,
            "n": "Steel Carapace",
            "c": "uul",
            "tc": "dgry",
            "lvl": "74",
            "m": [
                {
                    "prop": "ac%",
                    "min": 190,
                    "max": 220
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "red-dmg",
                    "min": 9,
                    "max": 14
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 60
                },
                {
                    "prop": "regen-mana",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "rep-dur",
                    "p": 5
                },
                {
                    "prop": "gethit-skill",
                    "p": 76,
                    "min": 8,
                    "max": 6
                }
            ]
        },
        {
            "id": 349,
            "n": "Medusa's Gaze",
            "i": "invtowu",
            "c": "uow",
            "tc": "lred",
            "lvl": "84",
            "m": [
                {
                    "prop": "ac%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "slow",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "gethit-skill",
                    "p": 91,
                    "min": 10,
                    "max": 7
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 9
                },
                {
                    "prop": "death-skill",
                    "p": 48,
                    "min": 100,
                    "max": 44
                },
                {
                    "prop": "res-cold",
                    "min": 40,
                    "max": 80
                }
            ]
        },
        {
            "id": 350,
            "n": "Ravenlore",
            "c": "dre",
            "tc": "dgld",
            "lvl": "82",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "res-all",
                    "min": 15,
                    "max": 25
                },
                {
                    "prop": "skilltab",
                    "p": 17,
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "pierce-fire",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "skill",
                    "p": 221,
                    "min": 7,
                    "max": 7
                }
            ]
        },
        {
            "id": 351,
            "n": "Boneshade",
            "i": "invbwnu",
            "c": "7bw",
            "tc": "dgry",
            "lvl": "84",
            "m": [
                {
                    "prop": "nec",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "cast2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "skill",
                    "p": 67,
                    "min": 4,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 68,
                    "min": 4,
                    "max": 5
                },
                {
                    "prop": "skill",
                    "p": 84,
                    "min": 2,
                    "max": 3
                },
                {
                    "prop": "skill",
                    "p": 93,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 78,
                    "min": 2,
                    "max": 3
                }
            ]
        },
        {
            "id": 352,
            "n": "Nethercrow",
            "tc": "cblu",
            "m": []
        },
        {
            "id": 353,
            "n": "Flamebellow",
            "i": "invgisu",
            "c": "7gs",
            "tc": "cred",
            "lvl": "79",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 170,
                    "max": 240
                },
                {
                    "prop": "dmg-fire",
                    "min": 233,
                    "max": 482
                },
                {
                    "prop": "fireskill",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "abs-fire%",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 225,
                    "min": 12,
                    "max": 16
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "vit",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "oskill",
                    "p": 41,
                    "min": 12,
                    "max": 18
                }
            ]
        },
        {
            "id": 354,
            "n": "Death's Fathom",
            "c": "obf",
            "lvl": "81",
            "m": [
                {
                    "prop": "sor",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "extra-cold",
                    "min": 15,
                    "max": 30
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "res-fire",
                    "min": 25,
                    "max": 40
                },
                {
                    "prop": "res-ltng",
                    "min": 25,
                    "max": 40
                }
            ]
        },
        {
            "id": 355,
            "n": "Wolfhowl",
            "c": "bac",
            "tc": "cred",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "skilltab",
                    "p": 14,
                    "min": 2,
                    "max": 3
                },
                {
                    "prop": "str",
                    "min": 8,
                    "max": 15
                },
                {
                    "prop": "dex",
                    "min": 8,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 8,
                    "max": 15
                },
                {
                    "prop": "oskill",
                    "p": 223,
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "charged",
                    "p": 237,
                    "min": 18,
                    "max": 15
                },
                {
                    "prop": "oskill",
                    "p": 224,
                    "min": 3,
                    "max": 6
                },
                {
                    "prop": "oskill",
                    "p": 232,
                    "min": 3,
                    "max": 6
                }
            ]
        },
        {
            "id": 356,
            "n": "Spirit Ward",
            "i": "invgtsu",
            "c": "uts",
            "tc": "dblu",
            "lvl": "76",
            "m": [
                {
                    "prop": "ac%",
                    "min": 130,
                    "max": 180
                },
                {
                    "prop": "abs-cold",
                    "min": 6,
                    "max": 11
                },
                {
                    "prop": "res-all",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "block",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "block2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "gethit-skill",
                    "p": 267,
                    "min": 5,
                    "max": 8
                }
            ]
        },
        {
            "id": 357,
            "n": "Kira's Guardian",
            "c": "ci2",
            "tc": "blac",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac",
                    "min": 50,
                    "max": 120
                },
                {
                    "prop": "res-all",
                    "min": 50,
                    "max": 70
                },
                {
                    "prop": "nofreeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                }
            ]
        },
        {
            "id": 358,
            "n": "Ormus' Robes",
            "c": "uui",
            "tc": "blac",
            "lvl": "83",
            "m": [
                {
                    "prop": "ac",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "extra-fire",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "extra-cold",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "extra-ltng",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "regen-mana",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "skill-rand",
                    "p": 3,
                    "min": 36,
                    "max": 60
                }
            ]
        },
        {
            "id": 359,
            "n": "Gheed's Fortune",
            "c": "cm3",
            "lvl": "70",
            "m": [
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 40
                },
                {
                    "prop": "gold%",
                    "min": 80,
                    "max": 160
                },
                {
                    "prop": "cheap",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 360,
            "n": "Stormlash",
            "c": "7fl",
            "tc": "dgry",
            "lvl": "86",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 300
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "hit-skill",
                    "p": 42,
                    "min": 15,
                    "max": 10
                },
                {
                    "prop": "hit-skill",
                    "p": 245,
                    "min": 20,
                    "max": 18
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 473
                },
                {
                    "prop": "light-thorns",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "abs-ltng",
                    "min": 3,
                    "max": 9
                }
            ]
        },
        {
            "id": 361,
            "n": "Halaberd's Reign",
            "c": "bae",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 170
                },
                {
                    "prop": "skilltab",
                    "p": 13,
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "bar",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "regen",
                    "min": 15,
                    "max": 23
                },
                {
                    "prop": "skill",
                    "p": 149,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 155,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 362,
            "n": "Warriv's Warder",
            "m": []
        },
        {
            "id": 363,
            "n": "Spike Thorn",
            "i": "invspku",
            "c": "upk",
            "tc": "dyel",
            "lvl": "78",
            "m": [
                {
                    "prop": "ac%",
                    "min": 120,
                    "max": 150
                },
                {
                    "prop": "thorns/lvl",
                    "p": 11
                },
                {
                    "prop": "dur",
                    "min": 250,
                    "max": 250
                },
                {
                    "prop": "balance2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "red-dmg%",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 364,
            "n": "Dracul's Grasp",
            "c": "uvg",
            "tc": "dred",
            "lvl": "84",
            "m": [
                {
                    "prop": "ac%",
                    "min": 90,
                    "max": 120
                },
                {
                    "prop": "lifesteal",
                    "min": 7,
                    "max": 10
                },
                {
                    "prop": "openwounds",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "hit-skill",
                    "p": 82,
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "heal-kill",
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 365,
            "n": "Frostwind",
            "i": "invlsdu",
            "c": "7ls",
            "tc": "cblu",
            "lvl": "78",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "freeze",
                    "min": 4,
                    "max": 4
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "dmg-cold",
                    "p": 150,
                    "min": 237,
                    "max": 486
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "abs-cold%",
                    "min": 7,
                    "max": 15
                },
                {
                    "prop": "oskill",
                    "p": 230,
                    "min": 7,
                    "max": 14
                }
            ]
        },
        {
            "id": 366,
            "n": "Templar's Might",
            "i": "invaaru",
            "c": "uar",
            "tc": "cgrn",
            "lvl": "82",
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 220
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "ac-miss",
                    "min": 250,
                    "max": 300
                },
                {
                    "prop": "stam",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "skilltab",
                    "p": 10,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 367,
            "n": "Eschuta's Temper",
            "c": "obc",
            "lvl": "80",
            "m": [
                {
                    "prop": "sor",
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "cast2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "extra-fire",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "extra-ltng",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "enr",
                    "min": 20,
                    "max": 30
                }
            ]
        },
        {
            "id": 368,
            "n": "Firelizard's Talons",
            "c": "7lw",
            "lvl": "75",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 200,
                    "max": 270
                },
                {
                    "prop": "swing2",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "skilltab",
                    "p": 20,
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "dmg-fire",
                    "min": 236,
                    "max": 480
                },
                {
                    "prop": "res-fire",
                    "min": 40,
                    "max": 70
                },
                {
                    "prop": "skill",
                    "p": 262,
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "skill",
                    "p": 272,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 369,
            "n": "Sandstorm Trek",
            "c": "uvb",
            "lvl": "72",
            "m": [
                {
                    "prop": "ac%",
                    "min": 140,
                    "max": 170
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "balance2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "stam/lvl",
                    "p": 8
                },
                {
                    "prop": "stamdrain",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "res-pois",
                    "min": 40,
                    "max": 70
                },
                {
                    "prop": "rep-dur",
                    "p": 5
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "vit",
                    "min": 10,
                    "max": 15
                }
            ]
        },
        {
            "id": 370,
            "n": "Marrowwalk",
            "c": "umb",
            "lvl": "74",
            "m": [
                {
                    "prop": "ac%",
                    "min": 170,
                    "max": 200
                },
                {
                    "prop": "move2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 88,
                    "min": 13,
                    "max": 33
                },
                {
                    "prop": "charged",
                    "p": 82,
                    "min": 10,
                    "max": 12
                },
                {
                    "prop": "regen-stam",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "regen-mana",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "half-freeze",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "str",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "dex",
                    "min": 17,
                    "max": 17
                },
                {
                    "prop": "skill",
                    "p": 69,
                    "min": 1,
                    "max": 2
                }
            ]
        },
        {
            "id": 371,
            "n": "Heaven's Light",
            "c": "7sc",
            "tc": "cblu",
            "lvl": "69",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 250,
                    "max": 300
                },
                {
                    "prop": "swing2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "reduce-ac",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "demon-heal",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 3
                }
            ]
        },
        {
            "id": 372,
            "n": "Merman's Sprocket",
            "m": []
        },
        {
            "id": 373,
            "n": "Arachnid Mesh",
            "c": "ulc",
            "tc": "blac",
            "lvl": "87",
            "m": [
                {
                    "prop": "ac%",
                    "min": 90,
                    "max": 120
                },
                {
                    "prop": "cast2",
                    "min": 20,
                    "max": 20
                },
                {
                    "prop": "charged",
                    "p": 278,
                    "min": 11,
                    "max": 3
                },
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "slow",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "mana%",
                    "min": 5,
                    "max": 5
                }
            ]
        },
        {
            "id": 374,
            "n": "Nosferatu's Coil",
            "c": "uvc",
            "lvl": "68",
            "m": [
                {
                    "prop": "str",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "mana-kill",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "slow",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "lifesteal",
                    "min": 5,
                    "max": 7
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "light",
                    "min": -3,
                    "max": -3
                }
            ]
        },
        {
            "id": 375,
            "n": "Metalgrid",
            "c": "amu",
            "lvl": "85",
            "m": [
                {
                    "prop": "ac",
                    "min": 300,
                    "max": 350
                },
                {
                    "prop": "res-all",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "att",
                    "min": 400,
                    "max": 450
                },
                {
                    "prop": "charged",
                    "p": 90,
                    "min": 11,
                    "max": 22
                },
                {
                    "prop": "charged",
                    "p": 76,
                    "min": 20,
                    "max": 12
                }
            ]
        },
        {
            "id": 376,
            "n": "Verdungo's Hearty Cord",
            "c": "umc",
            "tc": "blac",
            "lvl": "71",
            "m": [
                {
                    "prop": "ac%",
                    "min": 90,
                    "max": 140
                },
                {
                    "prop": "vit",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "stam",
                    "min": 100,
                    "max": 120
                },
                {
                    "prop": "balance2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "red-dmg%",
                    "min": 10,
                    "max": 15
                },
                {
                    "prop": "regen",
                    "min": 10,
                    "max": 13
                }
            ]
        },
        {
            "id": 377,
            "n": "Siggard's Stealth",
            "m": []
        },
        {
            "id": 378,
            "n": "Carrion Wind",
            "c": "rin",
            "lvl": "68",
            "m": [
                {
                    "prop": "ac-miss",
                    "min": 100,
                    "max": 160
                },
                {
                    "prop": "lifesteal",
                    "min": 6,
                    "max": 9
                },
                {
                    "prop": "res-pois",
                    "min": 55,
                    "max": 55
                },
                {
                    "prop": "gethit-skill",
                    "p": 92,
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "charged",
                    "p": 222,
                    "min": 15,
                    "max": 21
                },
                {
                    "prop": "hit-skill",
                    "p": 240,
                    "min": 8,
                    "max": 13
                },
                {
                    "prop": "dmg-to-mana",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 379,
            "n": "Giant Skull",
            "i": "invbhm",
            "c": "uh9",
            "tc": "lgry",
            "lvl": "73",
            "m": [
                {
                    "prop": "ac",
                    "min": 250,
                    "max": 320
                },
                {
                    "prop": "str",
                    "min": 25,
                    "max": 35
                },
                {
                    "prop": "crush",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 2
                },
                {
                    "prop": "knock",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 380,
            "n": "Astreon's Iron Ward",
            "c": "7ws",
            "tc": "blac",
            "lvl": "68",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 290
                },
                {
                    "prop": "slow",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "att%",
                    "min": 150,
                    "max": 200
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "dmg-mag",
                    "min": 80,
                    "max": 240
                },
                {
                    "prop": "red-dmg",
                    "min": 4,
                    "max": 7
                },
                {
                    "prop": "dmg",
                    "min": 40,
                    "max": 85
                },
                {
                    "prop": "skilltab",
                    "p": 9,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                }
            ]
        },
        {
            "id": 381,
            "n": "Annihilus",
            "i": "invmss",
            "c": "cm1",
            "lvl": "110",
            "m": [
                {
                    "prop": "allskills",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "all-stats",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "addxp",
                    "min": 5,
                    "max": 10
                }
            ]
        },
        {
            "id": 382,
            "n": "Arioc's Needle",
            "c": "7sr",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 180,
                    "max": 230
                },
                {
                    "prop": "dmg-pois",
                    "p": 250,
                    "min": 403,
                    "max": 403
                },
                {
                    "prop": "deadly",
                    "min": 50,
                    "max": 50
                },
                {
                    "prop": "ignore-ac",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                }
            ]
        },
        {
            "id": 383,
            "n": "Cranebeak",
            "i": "invmpiu",
            "c": "7mp",
            "lvl": "71",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 240,
                    "max": 300
                },
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 305
                },
                {
                    "prop": "swing2",
                    "min": 40,
                    "max": 40
                },
                {
                    "prop": "reduce-ac",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "mag%",
                    "min": 20,
                    "max": 50
                },
                {
                    "prop": "charged",
                    "p": 221,
                    "min": 15,
                    "max": 8
                }
            ]
        },
        {
            "id": 384,
            "n": "Nord's Tenderizer",
            "i": "invclbu",
            "c": "7cl",
            "lvl": "76",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 270,
                    "max": 330
                },
                {
                    "prop": "freeze",
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "swing2",
                    "min": 25,
                    "max": 25
                },
                {
                    "prop": "charged",
                    "p": 59,
                    "min": 12,
                    "max": 16
                },
                {
                    "prop": "att%",
                    "min": 150,
                    "max": 180
                },
                {
                    "prop": "abs-cold%",
                    "min": 5,
                    "max": 15
                },
                {
                    "prop": "dmg-cold",
                    "p": 125,
                    "min": 205,
                    "max": 455
                }
            ]
        },
        {
            "id": 385,
            "n": "Earth Shifter",
            "c": "7gm",
            "lvl": "77",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 250,
                    "max": 300
                },
                {
                    "prop": "hit-skill",
                    "p": 234,
                    "min": 25,
                    "max": 14
                },
                {
                    "prop": "crush",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "swing2",
                    "min": 10,
                    "max": 10
                },
                {
                    "prop": "charged",
                    "p": 244,
                    "min": 30,
                    "max": 14
                },
                {
                    "prop": "skilltab",
                    "p": 17,
                    "min": 7,
                    "max": 7
                },
                {
                    "prop": "cast2",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 386,
            "n": "Wraith Flight",
            "c": "7gl",
            "tc": "dblu",
            "lvl": "84",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 150,
                    "max": 190
                },
                {
                    "prop": "rep-quant",
                    "p": 40
                },
                {
                    "prop": "lifesteal",
                    "min": 9,
                    "max": 13
                },
                {
                    "prop": "mana-kill",
                    "min": 15,
                    "max": 15
                },
                {
                    "prop": "ethereal",
                    "min": 1,
                    "max": 1
                }
            ]
        },
        {
            "id": 387,
            "n": "Bonehew",
            "c": "7o7",
            "tc": "bwht",
            "lvl": "72",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 270,
                    "max": 320
                },
                {
                    "prop": "swing2",
                    "min": 30,
                    "max": 30
                },
                {
                    "prop": "charged",
                    "p": 74,
                    "min": 30,
                    "max": 14
                },
                {
                    "prop": "hit-skill",
                    "p": 84,
                    "min": 50,
                    "max": 16
                },
                {
                    "prop": "noheal",
                    "min": 1,
                    "max": 1
                },
                {
                    "prop": "sock",
                    "min": 2,
                    "max": 2
                }
            ]
        },
        {
            "id": 388,
            "n": "Ondal's Wisdom",
            "i": "invcstu",
            "c": "6cs",
            "lvl": "74",
            "m": [
                {
                    "prop": "cast2",
                    "min": 45,
                    "max": 45
                },
                {
                    "prop": "enr",
                    "min": 40,
                    "max": 50
                },
                {
                    "prop": "allskills",
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "ac",
                    "min": 450,
                    "max": 550
                },
                {
                    "prop": "addxp",
                    "min": 5,
                    "max": 5
                },
                {
                    "prop": "red-mag",
                    "min": 5,
                    "max": 8
                }
            ]
        },
        {
            "id": 389,
            "n": "The Redeemer",
            "c": "7sc",
            "lvl": "80",
            "m": [
                {
                    "prop": "dmg%",
                    "min": 250,
                    "max": 300
                },
                {
                    "prop": "dmg-demon",
                    "min": 200,
                    "max": 250
                },
                {
                    "prop": "pal",
                    "min": 2,
                    "max": 2
                },
                {
                    "prop": "ease",
                    "min": -60,
                    "max": -60
                },
                {
                    "prop": "skill",
                    "p": 124,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "skill",
                    "p": 101,
                    "min": 2,
                    "max": 4
                },
                {
                    "prop": "light",
                    "min": 3,
                    "max": 3
                },
                {
                    "prop": "reduce-ac",
                    "min": 33,
                    "max": 33
                },
                {
                    "prop": "dmg",
                    "min": 60,
                    "max": 120
                }
            ]
        },
        {
            "id": 390,
            "n": "Head Hunter's Glory",
            "i": "invbshu",
            "c": "ush",
            "lvl": "83",
            "m": [
                {
                    "prop": "ac",
                    "min": 320,
                    "max": 420
                },
                {
                    "prop": "ac-miss",
                    "min": 300,
                    "max": 350
                },
                {
                    "prop": "res-pois",
                    "min": 30,
                    "max": 40
                },
                {
                    "prop": "sock",
                    "min": 1,
                    "max": 3
                },
                {
                    "prop": "res-fire",
                    "min": 20,
                    "max": 30
                },
                {
                    "prop": "heal-kill",
                    "min": 5,
                    "max": 7
                }
            ]
        },
        {
            "id": 391,
            "n": "Steelrend",
            "c": "uhg",
            "lvl": "78",
            "m": [
                {
                    "prop": "ac",
                    "min": 170,
                    "max": 210
                },
                {
                    "prop": "str",
                    "min": 15,
                    "max": 20
                },
                {
                    "prop": "dmg%",
                    "min": 30,
                    "max": 60
                },
                {
                    "prop": "crush",
                    "min": 10,
                    "max": 10
                }
            ]
        },
        {
            "id": 392,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 74
                },
                {
                    "prop": "pierce-ltng",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-ltng",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "death-skill",
                    "p": 53,
                    "min": 100,
                    "max": 47
                }
            ]
        },
        {
            "id": 393,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 3,
                    "min": 24,
                    "max": 38
                },
                {
                    "prop": "pierce-cold",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-cold",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "death-skill",
                    "p": 59,
                    "min": 100,
                    "max": 37
                }
            ]
        },
        {
            "id": 394,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 17,
                    "max": 45
                },
                {
                    "prop": "pierce-fire",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-fire",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "death-skill",
                    "p": 56,
                    "min": 100,
                    "max": 31
                }
            ]
        },
        {
            "id": 395,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 50,
                    "min": 187,
                    "max": 187
                },
                {
                    "prop": "pierce-pois",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-pois",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "death-skill",
                    "p": 92,
                    "min": 100,
                    "max": 51
                }
            ]
        },
        {
            "id": 396,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-ltng",
                    "min": 1,
                    "max": 74
                },
                {
                    "prop": "pierce-ltng",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-ltng",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "levelup-skill",
                    "p": 48,
                    "min": 100,
                    "max": 41
                }
            ]
        },
        {
            "id": 397,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-cold",
                    "p": 3,
                    "min": 24,
                    "max": 38
                },
                {
                    "prop": "pierce-cold",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-cold",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "levelup-skill",
                    "p": 44,
                    "min": 100,
                    "max": 43
                }
            ]
        },
        {
            "id": 398,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-fire",
                    "min": 17,
                    "max": 45
                },
                {
                    "prop": "pierce-fire",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-fire",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "levelup-skill",
                    "p": 46,
                    "min": 100,
                    "max": 29
                }
            ]
        },
        {
            "id": 399,
            "n": "Rainbow Facet",
            "c": "jew",
            "lvl": "85",
            "m": [
                {
                    "prop": "dmg-pois",
                    "p": 50,
                    "min": 187,
                    "max": 187
                },
                {
                    "prop": "pierce-pois",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "extra-pois",
                    "min": 3,
                    "max": 5
                },
                {
                    "prop": "levelup-skill",
                    "p": 278,
                    "min": 100,
                    "max": 23
                }
            ]
        },
        {
            "id": 400,
            "n": "Hellfire Torch",
            "i": "invtrch",
            "c": "cm2",
            "lvl": "110",
            "m": [
                {
                    "prop": "randclassskill",
                    "min": 0,
                    "max": 6
                },
                {
                    "prop": "all-stats",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "res-all",
                    "min": 10,
                    "max": 20
                },
                {
                    "prop": "light",
                    "min": 8,
                    "max": 8
                },
                {
                    "prop": "hit-skill",
                    "p": 197,
                    "min": 5,
                    "max": 10
                },
                {
                    "prop": "charged",
                    "p": 62,
                    "min": 10,
                    "max": 30
                }
            ]
        }
    ],
    "stackables": {
        "tkf": {
            "n": "Throwing Knife"
        },
        "tax": {
            "n": "Throwing Axe"
        },
        "bkf": {
            "n": "Balanced Knife"
        },
        "bal": {
            "n": "Balanced Axe"
        },
        "jav": {
            "n": "Javelin"
        },
        "pil": {
            "n": "Pilum"
        },
        "ssp": {
            "n": "Short Spear"
        },
        "glv": {
            "n": "Glaive"
        },
        "tsp": {
            "n": "Throwing Spear"
        },
        "gps": {
            "n": "Rancid Gas Potion"
        },
        "ops": {
            "n": "Oil Potion"
        },
        "gpm": {
            "n": "Choking Gas Potion"
        },
        "opm": {
            "n": "Exploding Potion"
        },
        "gpl": {
            "n": "Strangling Gas Potion"
        },
        "opl": {
            "n": "Fulminating Potion"
        },
        "9tk": {
            "n": "Battle Dart"
        },
        "9ta": {
            "n": "Francisca"
        },
        "9bk": {
            "n": "War Dart"
        },
        "9b8": {
            "n": "Hurlbat"
        },
        "9ja": {
            "n": "War Javelin"
        },
        "9pi": {
            "n": "Great Pilum"
        },
        "9s9": {
            "n": "Simbilan"
        },
        "9gl": {
            "n": "Spiculum"
        },
        "9ts": {
            "n": "Harpoon"
        },
        "7tk": {
            "n": "Flying Knife"
        },
        "7ta": {
            "n": "Flying Axe"
        },
        "7bk": {
            "n": "Winged Knife"
        },
        "7b8": {
            "n": "Winged Axe"
        },
        "7ja": {
            "n": "Hyperion Javelin"
        },
        "7pi": {
            "n": "Stygian Pilum"
        },
        "7s7": {
            "n": "Balrog Spear"
        },
        "7gl": {
            "n": "Ghost Glaive"
        },
        "7ts": {
            "n": "Winged Harpoon"
        },
        "am5": {
            "n": "Maiden Javelin"
        },
        "ama": {
            "n": "Ceremonial Javelin"
        },
        "amf": {
            "n": "Matriarchal Javelin"
        },
        "tbk": {
            "n": "Tome of Town Portal"
        },
        "ibk": {
            "n": "Tome of Identify"
        },
        "gld": {
            "n": "Gold"
        },
        "aqv": {
            "n": "Arrows"
        },
        "cqv": {
            "n": "Bolts"
        },
        "key": {
            "n": "Key"
        },
        "rps": {},
        "rpl": {},
        "bps": {},
        "bpl": {}
    },
    "armor_items": {
        "cap": {
            "nc": "cap",
            "exc": "xap",
            "elc": "uap",
            "iq": 0,
            "n": "Cap",
            "minac": 3,
            "maxac": 5,
            "durability": 12,
            "rs": 0,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcap",
            "ui": "invcapu",
            "si": "invcapu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "skp": {
            "nc": "skp",
            "exc": "xkp",
            "elc": "ukp",
            "iq": 0,
            "n": "Skull Cap",
            "minac": 8,
            "maxac": 11,
            "durability": 18,
            "rs": 15,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invskp",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "5",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "hlm": {
            "nc": "hlm",
            "exc": "xlm",
            "elc": "ulm",
            "iq": 0,
            "n": "Helm",
            "minac": 15,
            "maxac": 18,
            "durability": 24,
            "rs": 26,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhlm",
            "ui": "invhlmu",
            "si": "invhlmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "11",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "fhl": {
            "nc": "fhl",
            "exc": "xhl",
            "elc": "uhl",
            "iq": 0,
            "n": "Full Helm",
            "minac": 23,
            "maxac": 26,
            "durability": 30,
            "rs": 41,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfhl",
            "ui": "invfhlu",
            "si": "invfhlu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "15",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "ghm": {
            "nc": "ghm",
            "exc": "xhm",
            "elc": "uhm",
            "iq": 0,
            "n": "Great Helm",
            "minac": 30,
            "maxac": 35,
            "durability": 40,
            "rs": 63,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invghm",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "23",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "crn": {
            "nc": "crn",
            "exc": "xrn",
            "elc": "urn",
            "iq": 0,
            "n": "Crown",
            "minac": 25,
            "maxac": 45,
            "durability": 50,
            "rs": 55,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcrn",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "29",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "msk": {
            "nc": "msk",
            "exc": "xsk",
            "elc": "usk",
            "iq": 0,
            "n": "Mask",
            "minac": 9,
            "maxac": 27,
            "durability": 20,
            "rs": 23,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invmsk",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "helm",
            "lvl": "19",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "qui": {
            "nc": "qui",
            "exc": "xui",
            "elc": "uui",
            "iq": 0,
            "n": "Quilted Armor",
            "minac": 8,
            "maxac": 11,
            "durability": 20,
            "rs": 12,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invqlt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "lea": {
            "nc": "lea",
            "exc": "xea",
            "elc": "uea",
            "iq": 0,
            "n": "Leather Armor",
            "minac": 14,
            "maxac": 17,
            "durability": 24,
            "rs": 15,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invlea",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "3",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "hla": {
            "nc": "hla",
            "exc": "xla",
            "elc": "ula",
            "iq": 0,
            "n": "Hard Leather Armor",
            "minac": 21,
            "maxac": 24,
            "durability": 28,
            "rs": 20,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhla",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "5",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "stu": {
            "nc": "stu",
            "exc": "xtu",
            "elc": "utu",
            "iq": 0,
            "n": "Studded Leather",
            "minac": 32,
            "maxac": 35,
            "durability": 32,
            "rs": 27,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invstu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "8",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "rng": {
            "nc": "rng",
            "exc": "xng",
            "elc": "ung",
            "iq": 0,
            "n": "Ring Mail",
            "minac": 45,
            "maxac": 48,
            "durability": 26,
            "rs": 36,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invrng",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "11",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "scl": {
            "nc": "scl",
            "exc": "xcl",
            "elc": "ucl",
            "iq": 0,
            "n": "Scale Mail",
            "minac": 57,
            "maxac": 60,
            "durability": 36,
            "rs": 44,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invscl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "13",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "chn": {
            "nc": "chn",
            "exc": "xhn",
            "elc": "uhn",
            "iq": 0,
            "n": "Chain Mail",
            "minac": 72,
            "maxac": 75,
            "durability": 45,
            "rs": 48,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invchn",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "15",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "brs": {
            "nc": "brs",
            "exc": "xrs",
            "elc": "urs",
            "iq": 0,
            "n": "Breast Plate",
            "minac": 65,
            "maxac": 68,
            "durability": 50,
            "rs": 30,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbrs",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "18",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "spl": {
            "nc": "spl",
            "exc": "xpl",
            "elc": "upl",
            "iq": 0,
            "n": "Splint Mail",
            "minac": 90,
            "maxac": 95,
            "durability": 30,
            "rs": 51,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invspl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "20",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "plt": {
            "nc": "plt",
            "exc": "xlt",
            "elc": "ult",
            "iq": 0,
            "n": "Plate Mail",
            "minac": 108,
            "maxac": 116,
            "durability": 60,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invplt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "24",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "fld": {
            "nc": "fld",
            "exc": "xld",
            "elc": "uld",
            "iq": 0,
            "n": "Field Plate",
            "minac": 101,
            "maxac": 105,
            "durability": 48,
            "rs": 55,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfld",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "28",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "gth": {
            "nc": "gth",
            "exc": "xth",
            "elc": "uth",
            "iq": 0,
            "n": "Gothic Plate",
            "minac": 128,
            "maxac": 135,
            "durability": 55,
            "rs": 70,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invgth",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "32",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ful": {
            "nc": "ful",
            "exc": "xul",
            "elc": "uul",
            "iq": 0,
            "n": "Full Plate Mail",
            "minac": 150,
            "maxac": 161,
            "durability": 70,
            "rs": 80,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invful",
            "ui": "invfulu",
            "si": "invfulu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "37",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "aar": {
            "nc": "aar",
            "exc": "xar",
            "elc": "uar",
            "iq": 0,
            "n": "Ancient Armor",
            "minac": 218,
            "maxac": 233,
            "durability": 60,
            "rs": 100,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invaar",
            "ui": "invaaru",
            "si": "invaaru",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "40",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ltp": {
            "nc": "ltp",
            "exc": "xtp",
            "elc": "utp",
            "iq": 0,
            "n": "Light Plate",
            "minac": 90,
            "maxac": 107,
            "durability": 60,
            "rs": 41,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invltp",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "35",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "buc": {
            "nc": "buc",
            "exc": "xuc",
            "elc": "uuc",
            "iq": 0,
            "n": "Buckler",
            "minac": 4,
            "maxac": 6,
            "durability": 12,
            "mind": 1,
            "maxd": 3,
            "rs": 12,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbuc",
            "ui": "invbucu",
            "si": "invbucu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "shie",
            "lvl": "1",
            "gemsockets": 1,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "sml": {
            "nc": "sml",
            "exc": "xml",
            "elc": "uml",
            "iq": 0,
            "n": "Small Shield",
            "minac": 8,
            "maxac": 10,
            "durability": 16,
            "mind": 2,
            "maxd": 3,
            "rs": 22,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invsml",
            "ui": "invsmlu",
            "si": "invsmlu",
            "iw": 2,
            "ih": 2,
            "it": 5,
            "type": "shie",
            "lvl": "5",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "lrg": {
            "nc": "lrg",
            "exc": "xrg",
            "elc": "urg",
            "iq": 0,
            "n": "Large Shield",
            "minac": 12,
            "maxac": 14,
            "durability": 24,
            "mind": 2,
            "maxd": 4,
            "rs": 34,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invlrg",
            "ui": "invlrgu",
            "si": "invlrgu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "11",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "kit": {
            "nc": "kit",
            "exc": "xit",
            "elc": "uit",
            "iq": 0,
            "n": "Kite Shield",
            "minac": 16,
            "maxac": 18,
            "durability": 30,
            "mind": 2,
            "maxd": 5,
            "rs": 47,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invkit",
            "ui": "invkitu",
            "si": "invkitu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "15",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "tow": {
            "nc": "tow",
            "exc": "xow",
            "elc": "uow",
            "iq": 0,
            "n": "Tower Shield",
            "minac": 22,
            "maxac": 25,
            "durability": 60,
            "mind": 1,
            "maxd": 5,
            "rs": 75,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invtow",
            "ui": "invtowu",
            "si": "invtowu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "22",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "gts": {
            "nc": "gts",
            "exc": "xts",
            "elc": "uts",
            "iq": 0,
            "n": "Gothic Shield",
            "minac": 30,
            "maxac": 35,
            "durability": 40,
            "mind": 2,
            "maxd": 6,
            "rs": 60,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invgts",
            "ui": "invgtsu",
            "si": "invgtsu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "shie",
            "lvl": "30",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "lgl": {
            "nc": "lgl",
            "exc": "xlg",
            "elc": "ulg",
            "iq": 0,
            "n": "Leather Gloves",
            "minac": 2,
            "maxac": 3,
            "durability": 12,
            "rs": 0,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "3",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "vgl": {
            "nc": "vgl",
            "exc": "xvg",
            "elc": "uvg",
            "iq": 0,
            "n": "Heavy Gloves",
            "minac": 5,
            "maxac": 6,
            "durability": 14,
            "rs": 0,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "7",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "mgl": {
            "nc": "mgl",
            "exc": "xmg",
            "elc": "umg",
            "iq": 0,
            "n": "Chain Gloves",
            "minac": 8,
            "maxac": 9,
            "durability": 16,
            "rs": 25,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "12",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "tgl": {
            "nc": "tgl",
            "exc": "xtg",
            "elc": "utg",
            "iq": 0,
            "n": "Light Gauntlets",
            "minac": 9,
            "maxac": 11,
            "durability": 18,
            "rs": 45,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "20",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "hgl": {
            "nc": "hgl",
            "exc": "xhg",
            "elc": "uhg",
            "iq": 0,
            "n": "Gauntlets",
            "minac": 12,
            "maxac": 15,
            "durability": 24,
            "rs": 60,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "27",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "lbt": {
            "nc": "lbt",
            "exc": "xlb",
            "elc": "ulb",
            "iq": 0,
            "n": "Boots",
            "minac": 2,
            "maxac": 3,
            "durability": 12,
            "mind": 3,
            "maxd": 8,
            "rs": 0,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "3",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "vbt": {
            "nc": "vbt",
            "exc": "xvb",
            "elc": "uvb",
            "iq": 0,
            "n": "Heavy Boots",
            "minac": 5,
            "maxac": 6,
            "durability": 14,
            "mind": 4,
            "maxd": 10,
            "rs": 18,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "7",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "mbt": {
            "nc": "mbt",
            "exc": "xmb",
            "elc": "umb",
            "iq": 0,
            "n": "Chain Boots",
            "minac": 8,
            "maxac": 9,
            "durability": 16,
            "mind": 6,
            "maxd": 12,
            "rs": 30,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "12",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "tbt": {
            "nc": "tbt",
            "exc": "xtb",
            "elc": "utb",
            "iq": 0,
            "n": "Light Plated Boots",
            "minac": 9,
            "maxac": 11,
            "durability": 18,
            "mind": 8,
            "maxd": 16,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "20",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "hbt": {
            "nc": "hbt",
            "exc": "xhb",
            "elc": "uhb",
            "iq": 0,
            "n": "Greaves",
            "minac": 12,
            "maxac": 15,
            "durability": 24,
            "mind": 10,
            "maxd": 20,
            "rs": 70,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "27",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "lbl": {
            "nc": "lbl",
            "exc": "zlb",
            "elc": "ulc",
            "iq": 0,
            "n": "Sash",
            "minac": 2,
            "maxac": 2,
            "durability": 12,
            "rs": 0,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "3",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "vbl": {
            "nc": "vbl",
            "exc": "zvb",
            "elc": "uvc",
            "iq": 0,
            "n": "Light Belt",
            "minac": 3,
            "maxac": 3,
            "durability": 14,
            "rs": 0,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "7",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "mbl": {
            "nc": "mbl",
            "exc": "zmb",
            "elc": "umc",
            "iq": 0,
            "n": "Belt",
            "minac": 5,
            "maxac": 5,
            "durability": 16,
            "rs": 25,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "12",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "tbl": {
            "nc": "tbl",
            "exc": "ztb",
            "elc": "utc",
            "iq": 0,
            "n": "Heavy Belt",
            "minac": 6,
            "maxac": 6,
            "durability": 18,
            "rs": 45,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "20",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "hbl": {
            "nc": "hbl",
            "exc": "zhb",
            "elc": "uhc",
            "iq": 0,
            "n": "Plated Belt",
            "minac": 8,
            "maxac": 11,
            "durability": 24,
            "rs": 60,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "27",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "bhm": {
            "nc": "bhm",
            "exc": "xh9",
            "elc": "uh9",
            "iq": 0,
            "n": "Bone Helm",
            "minac": 33,
            "maxac": 36,
            "durability": 40,
            "rs": 25,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbhm",
            "ui": "invbhmu",
            "si": "invbhmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "22",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "bsh": {
            "nc": "bsh",
            "exc": "xsh",
            "elc": "ush",
            "iq": 0,
            "n": "Bone Shield",
            "minac": 10,
            "maxac": 30,
            "durability": 40,
            "mind": 3,
            "maxd": 6,
            "rs": 25,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbsh",
            "ui": "invbshu",
            "si": "invbshu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "19",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "spk": {
            "nc": "spk",
            "exc": "xpk",
            "elc": "upk",
            "iq": 0,
            "n": "Spiked Shield",
            "minac": 15,
            "maxac": 25,
            "durability": 40,
            "mind": 5,
            "maxd": 9,
            "rs": 30,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invspk",
            "ui": "invspku",
            "si": "invspku",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "11",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xap": {
            "nc": "cap",
            "exc": "xap",
            "elc": "uap",
            "iq": 1,
            "n": "War Hat",
            "minac": 45,
            "maxac": 53,
            "durability": 12,
            "rs": 20,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcap",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "34",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xkp": {
            "nc": "skp",
            "exc": "xkp",
            "elc": "ukp",
            "iq": 1,
            "n": "Sallet",
            "minac": 52,
            "maxac": 62,
            "durability": 18,
            "rs": 43,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invskp",
            "ui": "invxkpu",
            "si": "invxkpu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "37",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xlm": {
            "nc": "hlm",
            "exc": "xlm",
            "elc": "ulm",
            "iq": 1,
            "n": "Casque",
            "minac": 63,
            "maxac": 72,
            "durability": 24,
            "rs": 59,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhlm",
            "ui": "invhlmu",
            "si": "invhlmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "42",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xhl": {
            "nc": "fhl",
            "exc": "xhl",
            "elc": "uhl",
            "iq": 1,
            "n": "Basinet",
            "minac": 75,
            "maxac": 84,
            "durability": 30,
            "rs": 82,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfhl",
            "ui": "invfhlu",
            "si": "invfhlu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "45",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xhm": {
            "nc": "ghm",
            "exc": "xhm",
            "elc": "uhm",
            "iq": 1,
            "n": "Winged Helm",
            "minac": 85,
            "maxac": 98,
            "durability": 40,
            "rs": 115,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invghm",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "51",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xrn": {
            "nc": "crn",
            "exc": "xrn",
            "elc": "urn",
            "iq": 1,
            "n": "Grand Crown",
            "minac": 78,
            "maxac": 113,
            "durability": 50,
            "rs": 103,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcrn",
            "ui": "invxrnu",
            "si": "invxrnu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "55",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xsk": {
            "nc": "msk",
            "exc": "xsk",
            "elc": "usk",
            "iq": 1,
            "n": "Death Mask",
            "minac": 54,
            "maxac": 86,
            "durability": 20,
            "rs": 55,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invmsk",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "helm",
            "lvl": "48",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xui": {
            "nc": "qui",
            "exc": "xui",
            "elc": "uui",
            "iq": 1,
            "n": "Ghost Armor",
            "minac": 102,
            "maxac": 117,
            "durability": 20,
            "rs": 38,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invqlt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "34",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xea": {
            "nc": "lea",
            "exc": "xea",
            "elc": "uea",
            "iq": 1,
            "n": "Serpentskin Armor",
            "minac": 111,
            "maxac": 126,
            "durability": 24,
            "rs": 43,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invlea",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "36",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xla": {
            "nc": "hla",
            "exc": "xla",
            "elc": "ula",
            "iq": 1,
            "n": "Demonhide Armor",
            "minac": 122,
            "maxac": 136,
            "durability": 28,
            "rs": 50,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhla",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "37",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xtu": {
            "nc": "stu",
            "exc": "xtu",
            "elc": "utu",
            "iq": 1,
            "n": "Trellised Armor",
            "minac": 138,
            "maxac": 153,
            "durability": 32,
            "rs": 61,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invstu",
            "ui": "invxtuu",
            "si": "invxtuu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "40",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xng": {
            "nc": "rng",
            "exc": "xng",
            "elc": "ung",
            "iq": 1,
            "n": "Linked Mail",
            "minac": 158,
            "maxac": 172,
            "durability": 26,
            "rs": 74,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invrng",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "42",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xcl": {
            "nc": "scl",
            "exc": "xcl",
            "elc": "ucl",
            "iq": 1,
            "n": "Tigulated Mail",
            "minac": 176,
            "maxac": 190,
            "durability": 36,
            "rs": 86,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invscl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "43",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xhn": {
            "nc": "chn",
            "exc": "xhn",
            "elc": "uhn",
            "iq": 1,
            "n": "Mesh Armor",
            "minac": 198,
            "maxac": 213,
            "durability": 45,
            "rs": 92,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invchn",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "45",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xrs": {
            "nc": "brs",
            "exc": "xrs",
            "elc": "urs",
            "iq": 1,
            "n": "Cuirass",
            "minac": 188,
            "maxac": 202,
            "durability": 50,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbrs",
            "si": "invxrss",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "47",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xpl": {
            "nc": "spl",
            "exc": "xpl",
            "elc": "upl",
            "iq": 1,
            "n": "Russet Armor",
            "minac": 225,
            "maxac": 243,
            "durability": 30,
            "rs": 97,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invspl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "49",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xlt": {
            "nc": "plt",
            "exc": "xlt",
            "elc": "ult",
            "iq": 1,
            "n": "Templar Coat",
            "minac": 252,
            "maxac": 274,
            "durability": 60,
            "rs": 118,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invplt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "52",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xld": {
            "nc": "fld",
            "exc": "xld",
            "elc": "uld",
            "iq": 1,
            "n": "Sharktooth Armor",
            "minac": 242,
            "maxac": 258,
            "durability": 48,
            "rs": 103,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfld",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "55",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xth": {
            "nc": "gth",
            "exc": "xth",
            "elc": "uth",
            "iq": 1,
            "n": "Embossed Plate",
            "minac": 282,
            "maxac": 303,
            "durability": 55,
            "rs": 125,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invgth",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "58",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xul": {
            "nc": "ful",
            "exc": "xul",
            "elc": "uul",
            "iq": 1,
            "n": "Chaos Armor",
            "minac": 315,
            "maxac": 342,
            "durability": 70,
            "rs": 140,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invful",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "61",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xar": {
            "nc": "aar",
            "exc": "xar",
            "elc": "uar",
            "iq": 1,
            "n": "Ornate Plate",
            "minac": 417,
            "maxac": 450,
            "durability": 60,
            "rs": 170,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invaar",
            "ui": "invxaru",
            "si": "invxaru",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "64",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xtp": {
            "nc": "ltp",
            "exc": "xtp",
            "elc": "utp",
            "iq": 1,
            "n": "Mage Plate",
            "minac": 225,
            "maxac": 261,
            "durability": 60,
            "rs": 55,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invltp",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "60",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "xuc": {
            "nc": "buc",
            "exc": "xuc",
            "elc": "uuc",
            "iq": 1,
            "n": "Defender",
            "minac": 41,
            "maxac": 49,
            "durability": 68,
            "mind": 8,
            "maxd": 12,
            "rs": 38,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbuc",
            "ui": "invbucu",
            "si": "invbucu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "shie",
            "lvl": "34",
            "gemsockets": 1,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xml": {
            "nc": "sml",
            "exc": "xml",
            "elc": "uml",
            "iq": 1,
            "n": "Round Shield",
            "minac": 47,
            "maxac": 55,
            "durability": 64,
            "mind": 7,
            "maxd": 14,
            "rs": 53,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invsml",
            "ui": "invxmlu",
            "si": "invxmlu",
            "iw": 2,
            "ih": 2,
            "it": 5,
            "type": "shie",
            "lvl": "37",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xrg": {
            "nc": "lrg",
            "exc": "xrg",
            "elc": "urg",
            "iq": 1,
            "n": "Scutum",
            "minac": 53,
            "maxac": 61,
            "durability": 62,
            "mind": 11,
            "maxd": 15,
            "rs": 71,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invlrg",
            "ui": "invxrgu",
            "si": "invxrgu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "42",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xit": {
            "nc": "kit",
            "exc": "xit",
            "elc": "uit",
            "iq": 1,
            "n": "Dragon Shield",
            "minac": 59,
            "maxac": 67,
            "durability": 76,
            "mind": 15,
            "maxd": 24,
            "rs": 91,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invkit",
            "ui": "invkitu",
            "si": "invkitu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "45",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xow": {
            "nc": "tow",
            "exc": "xow",
            "elc": "uow",
            "iq": 1,
            "n": "Pavise",
            "minac": 68,
            "maxac": 78,
            "durability": 72,
            "mind": 10,
            "maxd": 17,
            "rs": 133,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invtow",
            "ui": "invtowu",
            "si": "invtowu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "50",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xts": {
            "nc": "gts",
            "exc": "xts",
            "elc": "uts",
            "iq": 1,
            "n": "Ancient Shield",
            "minac": 80,
            "maxac": 93,
            "durability": 80,
            "mind": 12,
            "maxd": 16,
            "rs": 110,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invgts",
            "ui": "invgtsu",
            "si": "invgtsu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "shie",
            "lvl": "56",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xlg": {
            "nc": "lgl",
            "exc": "xlg",
            "elc": "ulg",
            "iq": 1,
            "n": "Demonhide Gloves",
            "minac": 28,
            "maxac": 35,
            "durability": 12,
            "rs": 20,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "33",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "xvg": {
            "nc": "vgl",
            "exc": "xvg",
            "elc": "uvg",
            "iq": 1,
            "n": "Sharkskin Gloves",
            "minac": 33,
            "maxac": 39,
            "durability": 14,
            "rs": 20,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "39",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "xmg": {
            "nc": "mgl",
            "exc": "xmg",
            "elc": "umg",
            "iq": 1,
            "n": "Heavy Bracers",
            "minac": 37,
            "maxac": 44,
            "durability": 16,
            "rs": 58,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "43",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "xtg": {
            "nc": "tgl",
            "exc": "xtg",
            "elc": "utg",
            "iq": 1,
            "n": "Battle Gauntlets",
            "minac": 39,
            "maxac": 47,
            "durability": 18,
            "rs": 88,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "49",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "xhg": {
            "nc": "hgl",
            "exc": "xhg",
            "elc": "uhg",
            "iq": 1,
            "n": "War Gauntlets",
            "minac": 43,
            "maxac": 53,
            "durability": 24,
            "rs": 110,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "54",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "xlb": {
            "nc": "lbt",
            "exc": "xlb",
            "elc": "ulb",
            "iq": 1,
            "n": "Demonhide Boots",
            "minac": 28,
            "maxac": 35,
            "durability": 12,
            "mind": 26,
            "maxd": 46,
            "rs": 20,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "36",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "xvb": {
            "nc": "vbt",
            "exc": "xvb",
            "elc": "uvb",
            "iq": 1,
            "n": "Sharkskin Boots",
            "minac": 33,
            "maxac": 39,
            "durability": 14,
            "mind": 28,
            "maxd": 50,
            "rs": 47,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "39",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "xmb": {
            "nc": "mbt",
            "exc": "xmb",
            "elc": "umb",
            "iq": 1,
            "n": "Mesh Boots",
            "minac": 37,
            "maxac": 44,
            "durability": 16,
            "mind": 23,
            "maxd": 52,
            "rs": 65,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "43",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "xtb": {
            "nc": "tbt",
            "exc": "xtb",
            "elc": "utb",
            "iq": 1,
            "n": "Battle Boots",
            "minac": 39,
            "maxac": 47,
            "durability": 18,
            "mind": 37,
            "maxd": 64,
            "rs": 95,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "49",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "xhb": {
            "nc": "hbt",
            "exc": "xhb",
            "elc": "uhb",
            "iq": 1,
            "n": "War Boots",
            "minac": 43,
            "maxac": 53,
            "durability": 24,
            "mind": 39,
            "maxd": 80,
            "rs": 125,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "54",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "zlb": {
            "nc": "lbl",
            "exc": "zlb",
            "elc": "ulc",
            "iq": 1,
            "n": "Demonhide Sash",
            "minac": 29,
            "maxac": 34,
            "durability": 12,
            "rs": 20,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "36",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "zvb": {
            "nc": "vbl",
            "exc": "zvb",
            "elc": "uvc",
            "iq": 1,
            "n": "Sharkskin Belt",
            "minac": 31,
            "maxac": 36,
            "durability": 14,
            "rs": 20,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "39",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "zmb": {
            "nc": "mbl",
            "exc": "zmb",
            "elc": "umc",
            "iq": 1,
            "n": "Mesh Belt",
            "minac": 35,
            "maxac": 40,
            "durability": 16,
            "rs": 58,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "43",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "ztb": {
            "nc": "tbl",
            "exc": "ztb",
            "elc": "utc",
            "iq": 1,
            "n": "Battle Belt",
            "minac": 37,
            "maxac": 42,
            "durability": 18,
            "rs": 88,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "49",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "zhb": {
            "nc": "hbl",
            "exc": "zhb",
            "elc": "uhc",
            "iq": 1,
            "n": "War Belt",
            "minac": 41,
            "maxac": 52,
            "durability": 24,
            "rs": 110,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "54",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "xh9": {
            "nc": "bhm",
            "exc": "xh9",
            "elc": "uh9",
            "iq": 1,
            "n": "Grim Helm",
            "minac": 60,
            "maxac": 125,
            "durability": 40,
            "rs": 58,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbhm",
            "ui": "invbhmu",
            "si": "invbhmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "50",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "xsh": {
            "nc": "bsh",
            "exc": "xsh",
            "elc": "ush",
            "iq": 1,
            "n": "Grim Shield",
            "minac": 50,
            "maxac": 150,
            "durability": 70,
            "mind": 14,
            "maxd": 20,
            "rs": 58,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbsh",
            "ui": "invxshu",
            "si": "invxshu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "48",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "xpk": {
            "nc": "spk",
            "exc": "xpk",
            "elc": "upk",
            "iq": 1,
            "n": "Barbed Shield",
            "minac": 58,
            "maxac": 78,
            "durability": 55,
            "mind": 18,
            "maxd": 35,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invspk",
            "ui": "invxpku",
            "si": "invxpku",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "42",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "dr1": {
            "nc": "dr1",
            "exc": "dr6",
            "elc": "drb",
            "iq": 0,
            "n": "Wolf Head",
            "minac": 8,
            "maxac": 11,
            "durability": 20,
            "rs": 16,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr1",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "4",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr2": {
            "nc": "dr2",
            "exc": "dr7",
            "elc": "drc",
            "iq": 0,
            "n": "Hawk Helm",
            "minac": 4,
            "maxac": 15,
            "durability": 20,
            "rs": 20,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr2",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "8",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr3": {
            "nc": "dr3",
            "exc": "dr8",
            "elc": "drd",
            "iq": 0,
            "n": "Antlers",
            "minac": 18,
            "maxac": 24,
            "durability": 20,
            "rs": 24,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr3",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "16",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr4": {
            "nc": "dr4",
            "exc": "dr9",
            "elc": "dre",
            "iq": 0,
            "n": "Falcon Mask",
            "minac": 12,
            "maxac": 28,
            "durability": 20,
            "rs": 28,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr4",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "20",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr5": {
            "nc": "dr5",
            "exc": "dra",
            "elc": "drf",
            "iq": 0,
            "n": "Spirit Mask",
            "minac": 22,
            "maxac": 35,
            "durability": 20,
            "rs": 30,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr5",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "24",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "ba1": {
            "nc": "ba1",
            "exc": "ba6",
            "elc": "bab",
            "iq": 0,
            "n": "Jawbone Cap",
            "minac": 10,
            "maxac": 15,
            "durability": 25,
            "rs": 25,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba1",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "phlm",
            "lvl": "4",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba2": {
            "nc": "ba2",
            "exc": "ba7",
            "elc": "bac",
            "iq": 0,
            "n": "Fanged Helm",
            "minac": 15,
            "maxac": 20,
            "durability": 35,
            "rs": 35,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba2",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "phlm",
            "lvl": "8",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba3": {
            "nc": "ba3",
            "exc": "ba8",
            "elc": "bad",
            "iq": 0,
            "n": "Horned Helm",
            "minac": 25,
            "maxac": 30,
            "durability": 45,
            "rs": 45,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba3",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "phlm",
            "lvl": "16",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba4": {
            "nc": "ba4",
            "exc": "ba9",
            "elc": "bae",
            "iq": 0,
            "n": "Assault Helmet",
            "minac": 30,
            "maxac": 35,
            "durability": 50,
            "rs": 55,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba4",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "phlm",
            "lvl": "20",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba5": {
            "nc": "ba5",
            "exc": "baa",
            "elc": "baf",
            "iq": 0,
            "n": "Avenger Guard",
            "minac": 35,
            "maxac": 50,
            "durability": 55,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba5",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "phlm",
            "lvl": "24",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "pa1": {
            "nc": "pa1",
            "exc": "pa6",
            "elc": "pab",
            "iq": 0,
            "n": "Targe",
            "minac": 8,
            "maxac": 12,
            "durability": 20,
            "mind": 2,
            "maxd": 6,
            "rs": 16,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "4",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa2": {
            "nc": "pa2",
            "exc": "pa7",
            "elc": "pac",
            "iq": 0,
            "n": "Rondache",
            "minac": 10,
            "maxac": 18,
            "durability": 30,
            "mind": 2,
            "maxd": 8,
            "rs": 26,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "8",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa3": {
            "nc": "pa3",
            "exc": "pa8",
            "elc": "pad",
            "iq": 0,
            "n": "Heraldic Shield",
            "minac": 16,
            "maxac": 26,
            "durability": 40,
            "mind": 3,
            "maxd": 9,
            "rs": 40,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa3",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "16",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa4": {
            "nc": "pa4",
            "exc": "pa9",
            "elc": "pae",
            "iq": 0,
            "n": "Aerin Shield",
            "minac": 26,
            "maxac": 36,
            "durability": 50,
            "mind": 4,
            "maxd": 10,
            "rs": 50,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa4",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "20",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa5": {
            "nc": "pa5",
            "exc": "paa",
            "elc": "paf",
            "iq": 0,
            "n": "Crown Shield",
            "minac": 30,
            "maxac": 40,
            "durability": 60,
            "mind": 4,
            "maxd": 12,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "24",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "ne1": {
            "nc": "ne1",
            "exc": "ne6",
            "elc": "neb",
            "iq": 0,
            "n": "Preserved Head",
            "minac": 2,
            "maxac": 5,
            "durability": 20,
            "rs": 12,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "4",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne2": {
            "nc": "ne2",
            "exc": "ne7",
            "elc": "neg",
            "iq": 0,
            "n": "Zombie Head",
            "minac": 4,
            "maxac": 8,
            "durability": 20,
            "rs": 14,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "8",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne3": {
            "nc": "ne3",
            "exc": "ne8",
            "elc": "ned",
            "iq": 0,
            "n": "Unraveller Head",
            "minac": 6,
            "maxac": 10,
            "durability": 20,
            "rs": 18,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne3",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "16",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne4": {
            "nc": "ne4",
            "exc": "ne9",
            "elc": "nee",
            "iq": 0,
            "n": "Gargoyle Head",
            "minac": 10,
            "maxac": 16,
            "durability": 20,
            "rs": 20,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne4",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "20",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne5": {
            "nc": "ne5",
            "exc": "nea",
            "elc": "nef",
            "iq": 0,
            "n": "Demon Head",
            "minac": 15,
            "maxac": 20,
            "durability": 20,
            "rs": 25,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "24",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ci0": {
            "nc": "ci0",
            "exc": "ci2",
            "elc": "ci3",
            "iq": 0,
            "n": "Circlet",
            "minac": 20,
            "maxac": 30,
            "durability": 35,
            "rs": 0,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invci0",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "circ",
            "lvl": "24",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "c": [
                "Circlet",
                "Helm",
                "Any Armor"
            ]
        },
        "ci1": {
            "nc": "ci1",
            "exc": "ci2",
            "elc": "ci3",
            "iq": 0,
            "n": "Coronet",
            "minac": 30,
            "maxac": 40,
            "durability": 30,
            "rs": 0,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invci1",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "circ",
            "lvl": "52",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "c": [
                "Circlet",
                "Helm",
                "Any Armor"
            ]
        },
        "ci2": {
            "nc": "ci1",
            "exc": "ci2",
            "elc": "ci3",
            "iq": 1,
            "n": "Tiara",
            "minac": 40,
            "maxac": 50,
            "durability": 25,
            "rs": 0,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invci2",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "circ",
            "lvl": "70",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "c": [
                "Circlet",
                "Helm",
                "Any Armor"
            ]
        },
        "ci3": {
            "nc": "ci1",
            "exc": "ci2",
            "elc": "ci3",
            "iq": 2,
            "n": "Diadem",
            "minac": 50,
            "maxac": 60,
            "durability": 20,
            "rs": 0,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invci3",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "circ",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "c": [
                "Circlet",
                "Helm",
                "Any Armor"
            ]
        },
        "uap": {
            "nc": "cap",
            "exc": "xap",
            "elc": "uap",
            "iq": 2,
            "n": "Shako",
            "minac": 98,
            "maxac": 141,
            "durability": 12,
            "rs": 50,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcap",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "58",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "ukp": {
            "nc": "skp",
            "exc": "xkp",
            "elc": "ukp",
            "iq": 2,
            "n": "Hydraskull",
            "minac": 101,
            "maxac": 145,
            "durability": 18,
            "rs": 84,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invskp",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "63",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "ulm": {
            "nc": "hlm",
            "exc": "xlm",
            "elc": "ulm",
            "iq": 2,
            "n": "Armet",
            "minac": 105,
            "maxac": 149,
            "durability": 24,
            "rs": 109,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhlm",
            "ui": "invhlmu",
            "si": "invhlmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "68",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "uhl": {
            "nc": "fhl",
            "exc": "xhl",
            "elc": "uhl",
            "iq": 2,
            "n": "Giant Conch",
            "minac": 110,
            "maxac": 154,
            "durability": 30,
            "rs": 142,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfhl",
            "ui": "invfhlu",
            "si": "invfhlu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "54",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "uhm": {
            "nc": "ghm",
            "exc": "xhm",
            "elc": "uhm",
            "iq": 2,
            "n": "Spired Helm",
            "minac": 114,
            "maxac": 159,
            "durability": 40,
            "rs": 192,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invghm",
            "si": "invuhms",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "79",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "urn": {
            "nc": "crn",
            "exc": "xrn",
            "elc": "urn",
            "iq": 2,
            "n": "Corona",
            "minac": 111,
            "maxac": 165,
            "durability": 50,
            "rs": 174,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invcrn",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "usk": {
            "nc": "msk",
            "exc": "xsk",
            "elc": "usk",
            "iq": 2,
            "n": "Demonhead",
            "minac": 101,
            "maxac": 154,
            "durability": 20,
            "rs": 102,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invmsk",
            "iw": 2,
            "ih": 2,
            "it": 2,
            "type": "helm",
            "lvl": "74",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "uui": {
            "nc": "qui",
            "exc": "xui",
            "elc": "uui",
            "iq": 2,
            "n": "Dusk Shroud",
            "minac": 361,
            "maxac": 467,
            "durability": 20,
            "rs": 77,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invqlt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "65",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uea": {
            "nc": "lea",
            "exc": "xea",
            "elc": "uea",
            "iq": 2,
            "n": "Wyrmhide",
            "minac": 364,
            "maxac": 470,
            "durability": 24,
            "rs": 84,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invlea",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "67",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ula": {
            "nc": "hla",
            "exc": "xla",
            "elc": "ula",
            "iq": 2,
            "n": "Scarab Husk",
            "minac": 369,
            "maxac": 474,
            "durability": 28,
            "rs": 95,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invhla",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "68",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "utu": {
            "nc": "stu",
            "exc": "xtu",
            "elc": "utu",
            "iq": 2,
            "n": "Wire Fleece",
            "minac": 375,
            "maxac": 481,
            "durability": 32,
            "rs": 111,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invstu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "70",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ung": {
            "nc": "rng",
            "exc": "xng",
            "elc": "ung",
            "iq": 2,
            "n": "Diamond Mail",
            "minac": 383,
            "maxac": 489,
            "durability": 26,
            "rs": 131,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invrng",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "72",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ucl": {
            "nc": "scl",
            "exc": "xcl",
            "elc": "ucl",
            "iq": 2,
            "n": "Loricated Mail",
            "minac": 390,
            "maxac": 496,
            "durability": 36,
            "rs": 149,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invscl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "73",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uhn": {
            "nc": "chn",
            "exc": "xhn",
            "elc": "uhn",
            "iq": 2,
            "n": "Boneweave",
            "minac": 399,
            "maxac": 505,
            "durability": 45,
            "rs": 158,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invchn",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "62",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "urs": {
            "nc": "brs",
            "exc": "xrs",
            "elc": "urs",
            "iq": 2,
            "n": "Great Hauberk",
            "minac": 395,
            "maxac": 501,
            "durability": 50,
            "rs": 118,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbrs",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "75",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "upl": {
            "nc": "spl",
            "exc": "xpl",
            "elc": "upl",
            "iq": 2,
            "n": "Balrog Skin",
            "minac": 410,
            "maxac": 517,
            "durability": 30,
            "rs": 165,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invspl",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "76",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "ult": {
            "nc": "plt",
            "exc": "xlt",
            "elc": "ult",
            "iq": 2,
            "n": "Hellforge Plate",
            "minac": 421,
            "maxac": 530,
            "durability": 60,
            "rs": 196,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invplt",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "78",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uld": {
            "nc": "fld",
            "exc": "xld",
            "elc": "uld",
            "iq": 2,
            "n": "Kraken Shell",
            "minac": 417,
            "maxac": 523,
            "durability": 48,
            "rs": 174,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invfld",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "81",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uth": {
            "nc": "gth",
            "exc": "xth",
            "elc": "uth",
            "iq": 2,
            "n": "Lacquered Plate",
            "minac": 433,
            "maxac": 541,
            "durability": 55,
            "rs": 208,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invgth",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "82",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uul": {
            "nc": "ful",
            "exc": "xul",
            "elc": "uul",
            "iq": 2,
            "n": "Shadow Plate",
            "minac": 446,
            "maxac": 557,
            "durability": 70,
            "rs": 230,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invful",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "83",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uar": {
            "nc": "aar",
            "exc": "xar",
            "elc": "uar",
            "iq": 2,
            "n": "Sacred Armor",
            "minac": 487,
            "maxac": 600,
            "durability": 60,
            "rs": 232,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invaar",
            "ui": "invaaru",
            "si": "invaaru",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "85",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "utp": {
            "nc": "ltp",
            "exc": "xtp",
            "elc": "utp",
            "iq": 2,
            "n": "Archon Plate",
            "minac": 410,
            "maxac": 524,
            "durability": 60,
            "rs": 103,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invltp",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "tors",
            "lvl": "84",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Armor",
                "Any Armor"
            ]
        },
        "uuc": {
            "nc": "buc",
            "exc": "xuc",
            "elc": "uuc",
            "iq": 2,
            "n": "Heater",
            "minac": 95,
            "maxac": 110,
            "durability": 88,
            "mind": 16,
            "maxd": 30,
            "rs": 77,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbuc",
            "ui": "invbucu",
            "si": "invbucu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "shie",
            "lvl": "58",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "uml": {
            "nc": "sml",
            "exc": "xml",
            "elc": "uml",
            "iq": 2,
            "n": "Luna",
            "minac": 108,
            "maxac": 123,
            "durability": 84,
            "mind": 17,
            "maxd": 29,
            "rs": 100,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invsml",
            "ui": "invsmlu",
            "si": "invsmlu",
            "iw": 2,
            "ih": 2,
            "it": 5,
            "type": "shie",
            "lvl": "61",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "urg": {
            "nc": "lrg",
            "exc": "xrg",
            "elc": "urg",
            "iq": 2,
            "n": "Hyperion",
            "minac": 119,
            "maxac": 135,
            "durability": 82,
            "mind": 14,
            "maxd": 32,
            "rs": 127,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invlrg",
            "ui": "invlrgu",
            "si": "invlrgu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "64",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "uit": {
            "nc": "kit",
            "exc": "xit",
            "elc": "uit",
            "iq": 2,
            "n": "Monarch",
            "minac": 133,
            "maxac": 148,
            "durability": 86,
            "mind": 12,
            "maxd": 34,
            "rs": 156,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invkit",
            "ui": "invkitu",
            "si": "invkitu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "72",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "uow": {
            "nc": "tow",
            "exc": "xow",
            "elc": "uow",
            "iq": 2,
            "n": "Aegis",
            "minac": 145,
            "maxac": 161,
            "durability": 92,
            "mind": 18,
            "maxd": 28,
            "rs": 219,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invtow",
            "ui": "invtowu",
            "si": "invtowu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "shie",
            "lvl": "79",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "uts": {
            "nc": "gts",
            "exc": "xts",
            "elc": "uts",
            "iq": 2,
            "n": "Ward",
            "minac": 153,
            "maxac": 170,
            "durability": 100,
            "mind": 11,
            "maxd": 35,
            "rs": 185,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invgts",
            "ui": "invgtsu",
            "si": "invutss",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "shie",
            "lvl": "84",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "ulg": {
            "nc": "lgl",
            "exc": "xlg",
            "elc": "ulg",
            "iq": 2,
            "n": "Bramble Mitts",
            "minac": 54,
            "maxac": 62,
            "durability": 12,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "57",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "uvg": {
            "nc": "vgl",
            "exc": "xvg",
            "elc": "uvg",
            "iq": 2,
            "n": "Vampirebone Gloves",
            "minac": 56,
            "maxac": 65,
            "durability": 14,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "63",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "umg": {
            "nc": "mgl",
            "exc": "xmg",
            "elc": "umg",
            "iq": 2,
            "n": "Vambraces",
            "minac": 59,
            "maxac": 67,
            "durability": 16,
            "rs": 106,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "69",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "utg": {
            "nc": "tgl",
            "exc": "xtg",
            "elc": "utg",
            "iq": 2,
            "n": "Crusader Gauntlets",
            "minac": 59,
            "maxac": 68,
            "durability": 18,
            "rs": 151,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "76",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "uhg": {
            "nc": "hgl",
            "exc": "xhg",
            "elc": "uhg",
            "iq": 2,
            "n": "Ogre Gauntlets",
            "minac": 62,
            "maxac": 71,
            "durability": 24,
            "rs": 185,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhgl",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "glov",
            "lvl": "85",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Gloves",
                "Any Armor"
            ]
        },
        "ulb": {
            "nc": "lbt",
            "exc": "xlb",
            "elc": "ulb",
            "iq": 2,
            "n": "Wyrmhide Boots",
            "minac": 54,
            "maxac": 62,
            "durability": 12,
            "mind": 65,
            "maxd": 100,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "60",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "uvb": {
            "nc": "vbt",
            "exc": "xvb",
            "elc": "uvb",
            "iq": 2,
            "n": "Scarabshell Boots",
            "minac": 56,
            "maxac": 65,
            "durability": 14,
            "mind": 60,
            "maxd": 110,
            "rs": 91,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "66",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "umb": {
            "nc": "mbt",
            "exc": "xmb",
            "elc": "umb",
            "iq": 2,
            "n": "Boneweave Boots",
            "minac": 59,
            "maxac": 67,
            "durability": 16,
            "mind": 69,
            "maxd": 118,
            "rs": 118,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "72",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "utb": {
            "nc": "tbt",
            "exc": "xtb",
            "elc": "utb",
            "iq": 2,
            "n": "Mirrored Boots",
            "minac": 59,
            "maxac": 68,
            "durability": 18,
            "mind": 50,
            "maxd": 145,
            "rs": 163,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "81",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "uhb": {
            "nc": "hbt",
            "exc": "xhb",
            "elc": "uhb",
            "iq": 2,
            "n": "Myrmidon Greaves",
            "minac": 62,
            "maxac": 71,
            "durability": 24,
            "mind": 83,
            "maxd": 149,
            "rs": 208,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbt",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "boot",
            "lvl": "85",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Boots",
                "Any Armor"
            ]
        },
        "ulc": {
            "nc": "lbl",
            "exc": "zlb",
            "elc": "ulc",
            "iq": 2,
            "n": "Spiderweb Sash",
            "minac": 55,
            "maxac": 62,
            "durability": 12,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invlbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "61",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "uvc": {
            "nc": "vbl",
            "exc": "zvb",
            "elc": "uvc",
            "iq": 2,
            "n": "Vampirefang Belt",
            "minac": 56,
            "maxac": 63,
            "durability": 14,
            "rs": 50,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invvbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "68",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "umc": {
            "nc": "mbl",
            "exc": "zmb",
            "elc": "umc",
            "iq": 2,
            "n": "Mithril Coil",
            "minac": 58,
            "maxac": 65,
            "durability": 16,
            "rs": 106,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invmbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "75",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "utc": {
            "nc": "tbl",
            "exc": "ztb",
            "elc": "utc",
            "iq": 2,
            "n": "Troll Belt",
            "minac": 59,
            "maxac": 66,
            "durability": 18,
            "rs": 151,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invtbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "82",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "uhc": {
            "nc": "hbl",
            "exc": "zhb",
            "elc": "uhc",
            "iq": 2,
            "n": "Colossus Girdle",
            "minac": 61,
            "maxac": 71,
            "durability": 24,
            "rs": 185,
            "rd": 0,
            "hi": 0,
            "gt": 0,
            "i": "invhbl",
            "iw": 2,
            "ih": 1,
            "it": 8,
            "type": "belt",
            "lvl": "85",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Belt",
                "Any Armor"
            ]
        },
        "uh9": {
            "nc": "bhm",
            "exc": "xh9",
            "elc": "uh9",
            "iq": 2,
            "n": "Bone Visage",
            "minac": 100,
            "maxac": 157,
            "durability": 40,
            "rs": 106,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invbhm",
            "ui": "invbhmu",
            "si": "invbhmu",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "helm",
            "lvl": "84",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Armor",
            "c": [
                "Helm",
                "Any Armor"
            ]
        },
        "ush": {
            "nc": "bsh",
            "exc": "xsh",
            "elc": "ush",
            "iq": 2,
            "n": "Troll Nest",
            "minac": 158,
            "maxac": 173,
            "durability": 74,
            "mind": 24,
            "maxd": 38,
            "rs": 106,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invbsh",
            "ui": "invbshu",
            "si": "invbshu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "76",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "upk": {
            "nc": "spk",
            "exc": "xpk",
            "elc": "upk",
            "iq": 2,
            "n": "Blade Barrier",
            "minac": 147,
            "maxac": 163,
            "durability": 83,
            "mind": 26,
            "maxd": 40,
            "rs": 118,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invspk",
            "ui": "invspku",
            "si": "invspku",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "shie",
            "lvl": "68",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "c": [
                "Shield",
                "Any Shield",
                "Any Armor",
                "Second Hand"
            ]
        },
        "dr6": {
            "nc": "dr1",
            "exc": "dr6",
            "elc": "drb",
            "iq": 1,
            "n": "Alpha Helm",
            "minac": 52,
            "maxac": 62,
            "durability": 20,
            "rs": 44,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr1",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "35",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr7": {
            "nc": "dr2",
            "exc": "dr7",
            "elc": "drc",
            "iq": 1,
            "n": "Griffon Headdress",
            "minac": 46,
            "maxac": 68,
            "durability": 20,
            "rs": 50,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr2",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "40",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr8": {
            "nc": "dr3",
            "exc": "dr8",
            "elc": "drd",
            "iq": 1,
            "n": "Hunter's Guise",
            "minac": 67,
            "maxac": 81,
            "durability": 20,
            "rs": 56,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr3",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "46",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dr9": {
            "nc": "dr4",
            "exc": "dr9",
            "elc": "dre",
            "iq": 1,
            "n": "Sacred Feathers",
            "minac": 58,
            "maxac": 87,
            "durability": 20,
            "rs": 62,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr4",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "50",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dra": {
            "nc": "dr5",
            "exc": "dra",
            "elc": "drf",
            "iq": 1,
            "n": "Totemic Mask",
            "minac": 73,
            "maxac": 98,
            "durability": 20,
            "rs": 65,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr5",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "55",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "ba6": {
            "nc": "ba1",
            "exc": "ba6",
            "elc": "bab",
            "iq": 1,
            "n": "Jawbone Visor",
            "minac": 55,
            "maxac": 68,
            "durability": 25,
            "rs": 58,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "33",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba7": {
            "nc": "ba2",
            "exc": "ba7",
            "elc": "bac",
            "iq": 1,
            "n": "Lion Helm",
            "minac": 63,
            "maxac": 75,
            "durability": 35,
            "rs": 73,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "38",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba8": {
            "nc": "ba3",
            "exc": "ba8",
            "elc": "bad",
            "iq": 1,
            "n": "Rage Mask",
            "minac": 78,
            "maxac": 90,
            "durability": 45,
            "rs": 88,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba3",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "44",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "ba9": {
            "nc": "ba4",
            "exc": "ba9",
            "elc": "bae",
            "iq": 1,
            "n": "Savage Helmet",
            "minac": 85,
            "maxac": 98,
            "durability": 50,
            "rs": 103,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba4",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "49",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "baa": {
            "nc": "ba5",
            "exc": "baa",
            "elc": "baf",
            "iq": 1,
            "n": "Slayer Guard",
            "minac": 93,
            "maxac": 120,
            "durability": 55,
            "rs": 118,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "54",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "pa6": {
            "nc": "pa1",
            "exc": "pa6",
            "elc": "pab",
            "iq": 1,
            "n": "Akaran Targe",
            "minac": 101,
            "maxac": 125,
            "durability": 20,
            "mind": 12,
            "maxd": 16,
            "rs": 44,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "35",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa7": {
            "nc": "pa2",
            "exc": "pa7",
            "elc": "pac",
            "iq": 1,
            "n": "Akaran Rondache",
            "minac": 113,
            "maxac": 137,
            "durability": 30,
            "mind": 15,
            "maxd": 20,
            "rs": 59,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "40",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa8": {
            "nc": "pa3",
            "exc": "pa8",
            "elc": "pad",
            "iq": 1,
            "n": "Protector Shield",
            "minac": 129,
            "maxac": 153,
            "durability": 40,
            "mind": 18,
            "maxd": 24,
            "rs": 69,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa3",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "46",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pa9": {
            "nc": "pa4",
            "exc": "pa9",
            "elc": "pae",
            "iq": 1,
            "n": "Gilded Shield",
            "minac": 144,
            "maxac": 168,
            "durability": 50,
            "mind": 20,
            "maxd": 28,
            "rs": 89,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa4",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "51",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "paa": {
            "nc": "pa5",
            "exc": "paa",
            "elc": "paf",
            "iq": 1,
            "n": "Royal Shield",
            "minac": 156,
            "maxac": 181,
            "durability": 60,
            "mind": 24,
            "maxd": 32,
            "rs": 114,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "55",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "ne6": {
            "nc": "ne1",
            "exc": "ne6",
            "elc": "neb",
            "iq": 1,
            "n": "Mummified Trophy",
            "minac": 38,
            "maxac": 48,
            "durability": 20,
            "rs": 38,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "33",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne7": {
            "nc": "ne2",
            "exc": "ne7",
            "elc": "neg",
            "iq": 1,
            "n": "Fetish Trophy",
            "minac": 41,
            "maxac": 52,
            "durability": 20,
            "rs": 41,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "39",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne8": {
            "nc": "ne3",
            "exc": "ne8",
            "elc": "ned",
            "iq": 1,
            "n": "Sexton Trophy",
            "minac": 44,
            "maxac": 55,
            "durability": 20,
            "rs": 47,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne3",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "45",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ne9": {
            "nc": "ne4",
            "exc": "ne9",
            "elc": "nee",
            "iq": 1,
            "n": "Cantor Trophy",
            "minac": 50,
            "maxac": 64,
            "durability": 20,
            "rs": 50,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne4",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "49",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "nea": {
            "nc": "ne5",
            "exc": "nea",
            "elc": "nef",
            "iq": 1,
            "n": "Hierophant Trophy",
            "minac": 58,
            "maxac": 70,
            "durability": 20,
            "rs": 58,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "54",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "drb": {
            "nc": "dr1",
            "exc": "dr6",
            "elc": "drb",
            "iq": 2,
            "n": "Blood Spirit",
            "minac": 101,
            "maxac": 145,
            "durability": 20,
            "rs": 86,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr1",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "62",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "drc": {
            "nc": "dr2",
            "exc": "dr7",
            "elc": "drc",
            "iq": 2,
            "n": "Sun Spirit",
            "minac": 98,
            "maxac": 147,
            "durability": 20,
            "rs": 95,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr2",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "69",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "drd": {
            "nc": "dr3",
            "exc": "dr8",
            "elc": "drd",
            "iq": 2,
            "n": "Earth Spirit",
            "minac": 107,
            "maxac": 152,
            "durability": 20,
            "rs": 104,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr3",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "76",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "dre": {
            "nc": "dr4",
            "exc": "dr9",
            "elc": "dre",
            "iq": 2,
            "n": "Sky Spirit",
            "minac": 103,
            "maxac": 155,
            "durability": 20,
            "rs": 113,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr4",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "83",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "drf": {
            "nc": "dr5",
            "exc": "dra",
            "elc": "drf",
            "iq": 2,
            "n": "Dream Spirit",
            "minac": 109,
            "maxac": 159,
            "durability": 20,
            "rs": 118,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invdr5",
            "iw": 2,
            "ih": 2,
            "it": 8,
            "type": "pelt",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Druid Item",
            "c": [
                "Pelt",
                "Helm",
                "Any Armor",
                "Druid Item",
                "Class Specific"
            ]
        },
        "bab": {
            "nc": "ba1",
            "exc": "ba6",
            "elc": "bab",
            "iq": 2,
            "n": "Carnage Helm",
            "minac": 102,
            "maxac": 147,
            "durability": 25,
            "rs": 106,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "60",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "bac": {
            "nc": "ba2",
            "exc": "ba7",
            "elc": "bac",
            "iq": 2,
            "n": "Fury Visor",
            "minac": 105,
            "maxac": 150,
            "durability": 35,
            "rs": 129,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "66",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "bad": {
            "nc": "ba3",
            "exc": "ba8",
            "elc": "bad",
            "iq": 2,
            "n": "Destroyer Helm",
            "minac": 111,
            "maxac": 156,
            "durability": 45,
            "rs": 151,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba3",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "73",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "bae": {
            "nc": "ba4",
            "exc": "ba9",
            "elc": "bae",
            "iq": 2,
            "n": "Conqueror Crown",
            "minac": 114,
            "maxac": 159,
            "durability": 50,
            "rs": 174,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba4",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "80",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "baf": {
            "nc": "ba5",
            "exc": "baa",
            "elc": "baf",
            "iq": 2,
            "n": "Guardian Crown",
            "minac": 117,
            "maxac": 168,
            "durability": 55,
            "rs": 196,
            "rd": 0,
            "hi": 1,
            "gt": 1,
            "i": "invba5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "phlm",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Helm",
            "eq2n": "Barbarian Item",
            "c": [
                "Primal Helm",
                "Helm",
                "Any Armor",
                "Barbarian Item",
                "Class Specific"
            ]
        },
        "pab": {
            "nc": "pa1",
            "exc": "pa6",
            "elc": "pab",
            "iq": 2,
            "n": "Sacred Targe",
            "minac": 126,
            "maxac": 158,
            "durability": 45,
            "mind": 22,
            "maxd": 70,
            "rs": 86,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "63",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pac": {
            "nc": "pa2",
            "exc": "pa7",
            "elc": "pac",
            "iq": 2,
            "n": "Sacred Rondache",
            "minac": 138,
            "maxac": 164,
            "durability": 68,
            "mind": 35,
            "maxd": 58,
            "rs": 109,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "70",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pad": {
            "nc": "pa3",
            "exc": "pa8",
            "elc": "pad",
            "iq": 2,
            "n": "Kurast Shield",
            "minac": 154,
            "maxac": 172,
            "durability": 55,
            "mind": 10,
            "maxd": 82,
            "rs": 124,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa3",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "74",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "pae": {
            "nc": "pa4",
            "exc": "pa9",
            "elc": "pae",
            "iq": 2,
            "n": "Zakarum Shield",
            "minac": 169,
            "maxac": 193,
            "durability": 65,
            "mind": 46,
            "maxd": 46,
            "rs": 142,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa4",
            "iw": 2,
            "ih": 4,
            "it": 0,
            "type": "ashd",
            "lvl": "82",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "paf": {
            "nc": "pa5",
            "exc": "paa",
            "elc": "paf",
            "iq": 2,
            "n": "Vortex Shield",
            "minac": 182,
            "maxac": 225,
            "durability": 90,
            "mind": 5,
            "maxd": 87,
            "rs": 148,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invpa5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ashd",
            "lvl": "85",
            "gemsockets": 4,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Paladin Item",
            "c": [
                "Auric Shields",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Paladin Item",
                "Class Specific"
            ]
        },
        "neb": {
            "nc": "ne1",
            "exc": "ne6",
            "elc": "neb",
            "iq": 2,
            "n": "Minion Skull",
            "minac": 95,
            "maxac": 139,
            "durability": 20,
            "rs": 77,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne1",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "59",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "neg": {
            "nc": "ne2",
            "exc": "ne7",
            "elc": "neg",
            "iq": 2,
            "n": "Hellspawn Skull",
            "minac": 96,
            "maxac": 141,
            "durability": 20,
            "rs": 82,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne2",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "67",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "ned": {
            "nc": "ne3",
            "exc": "ne8",
            "elc": "ned",
            "iq": 2,
            "n": "Overseer Skull",
            "minac": 98,
            "maxac": 142,
            "durability": 20,
            "rs": 91,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne3",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "66",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "nee": {
            "nc": "ne4",
            "exc": "ne9",
            "elc": "nee",
            "iq": 2,
            "n": "Succubus Skull",
            "minac": 100,
            "maxac": 146,
            "durability": 20,
            "rs": 95,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne4",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "81",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        },
        "nef": {
            "nc": "ne5",
            "exc": "nea",
            "elc": "nef",
            "iq": 2,
            "n": "Bloodlord Skull",
            "minac": 103,
            "maxac": 148,
            "durability": 20,
            "rs": 106,
            "rd": 0,
            "hi": 1,
            "gt": 2,
            "i": "invne5",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "head",
            "lvl": "85",
            "gemsockets": 2,
            "spawnable": 1,
            "nodurability": 0,
            "ig": [],
            "eq1n": "Any Shield",
            "eq2n": "Necromancer Item",
            "c": [
                "Voodoo Heads",
                "Any Shield",
                "Any Armor",
                "Second Hand",
                "Necromancer Item",
                "Class Specific"
            ]
        }
    },
    "weapon_items": {
        "hax": {
            "nc": "hax",
            "exc": "9ha",
            "elc": "7ha",
            "iq": 0,
            "n": "Hand Axe",
            "durability": 28,
            "mind": 3,
            "maxd": 6,
            "hi": 1,
            "gt": 0,
            "i": "invhax",
            "ui": "invhaxu",
            "si": "invhaxu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "3",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "axe": {
            "nc": "axe",
            "exc": "9ax",
            "elc": "7ax",
            "iq": 0,
            "n": "Axe",
            "durability": 24,
            "mind": 4,
            "maxd": 11,
            "rs": 32,
            "hi": 1,
            "gt": 0,
            "i": "invaxe",
            "ui": "invaxeu",
            "si": "invaxeu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "7",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "2ax": {
            "nc": "2ax",
            "exc": "92a",
            "elc": "72a",
            "iq": 0,
            "n": "Double Axe",
            "durability": 24,
            "mind": 5,
            "maxd": 13,
            "rs": 43,
            "hi": 1,
            "gt": 0,
            "i": "inv2ax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "13",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "mpi": {
            "nc": "mpi",
            "exc": "9mp",
            "elc": "7mp",
            "iq": 0,
            "n": "Military Pick",
            "durability": 26,
            "mind": 7,
            "maxd": 11,
            "rs": 49,
            "rd": 33,
            "hi": 1,
            "gt": 0,
            "i": "invmpi",
            "ui": "invmpiu",
            "si": "invmpiu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "19",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wax": {
            "nc": "wax",
            "exc": "9wa",
            "elc": "7wa",
            "iq": 0,
            "n": "War Axe",
            "durability": 26,
            "mind": 10,
            "maxd": 18,
            "rs": 67,
            "hi": 1,
            "gt": 0,
            "i": "invwax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "25",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "lax": {
            "nc": "lax",
            "exc": "9la",
            "elc": "7la",
            "iq": 0,
            "n": "Large Axe",
            "durability": 30,
            "min2d": 6,
            "max2d": 13,
            "rs": 35,
            "hi": 1,
            "gt": 0,
            "i": "invlax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "6",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bax": {
            "nc": "bax",
            "exc": "9ba",
            "elc": "7ba",
            "iq": 0,
            "n": "Broad Axe",
            "durability": 35,
            "min2d": 10,
            "max2d": 18,
            "rs": 48,
            "hi": 1,
            "gt": 0,
            "i": "invbrx",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "12",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "btx": {
            "nc": "btx",
            "exc": "9bt",
            "elc": "7bt",
            "iq": 0,
            "n": "Battle Axe",
            "durability": 40,
            "min2d": 12,
            "max2d": 32,
            "rs": 54,
            "hi": 1,
            "gt": 0,
            "i": "invbtx",
            "ui": "invbtxu",
            "si": "invbtxu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "17",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gax": {
            "nc": "gax",
            "exc": "9ga",
            "elc": "7ga",
            "iq": 0,
            "n": "Great Axe",
            "durability": 50,
            "min2d": 9,
            "max2d": 30,
            "rs": 63,
            "rd": 39,
            "hi": 1,
            "gt": 0,
            "i": "invgax",
            "ui": "invgaxu",
            "si": "invgaxu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "axe",
            "lvl": "23",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gix": {
            "nc": "gix",
            "exc": "9gi",
            "elc": "7gi",
            "iq": 0,
            "n": "Giant Axe",
            "durability": 50,
            "min2d": 22,
            "max2d": 45,
            "rs": 70,
            "hi": 1,
            "gt": 0,
            "i": "invgix",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "27",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wnd": {
            "nc": "wnd",
            "exc": "9wn",
            "elc": "7wn",
            "iq": 0,
            "n": "Wand",
            "durability": 15,
            "mind": 2,
            "maxd": 4,
            "hi": 1,
            "gt": 0,
            "i": "invwnd",
            "ui": "invwndu",
            "si": "invwndu",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "2",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "ywn": {
            "nc": "ywn",
            "exc": "9yw",
            "elc": "7yw",
            "iq": 0,
            "n": "Yew Wand",
            "durability": 15,
            "mind": 2,
            "maxd": 8,
            "hi": 1,
            "gt": 0,
            "i": "invywn",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "12",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bwn": {
            "nc": "bwn",
            "exc": "9bw",
            "elc": "7bw",
            "iq": 0,
            "n": "Bone Wand",
            "durability": 15,
            "mind": 3,
            "maxd": 7,
            "hi": 1,
            "gt": 0,
            "i": "invbwn",
            "ui": "invbwnu",
            "si": "invbwnu",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "18",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gwn": {
            "nc": "gwn",
            "exc": "9gw",
            "elc": "7gw",
            "iq": 0,
            "n": "Grim Wand",
            "durability": 15,
            "mind": 5,
            "maxd": 11,
            "hi": 1,
            "gt": 0,
            "i": "invgwn",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "26",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "clb": {
            "nc": "clb",
            "exc": "9cl",
            "elc": "7cl",
            "iq": 0,
            "n": "Club",
            "durability": 24,
            "mind": 1,
            "maxd": 6,
            "hi": 1,
            "gt": 0,
            "i": "invclb",
            "ui": "invclbu",
            "si": "invclbu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "scp": {
            "nc": "scp",
            "exc": "9sc",
            "elc": "7sc",
            "iq": 0,
            "n": "Scepter",
            "durability": 50,
            "mind": 6,
            "maxd": 11,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invscp",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "3",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gsc": {
            "nc": "gsc",
            "exc": "9qs",
            "elc": "7qs",
            "iq": 0,
            "n": "Grand Scepter",
            "durability": 60,
            "mind": 8,
            "maxd": 18,
            "rs": 37,
            "hi": 1,
            "gt": 0,
            "i": "invgsc",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "15",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wsp": {
            "nc": "wsp",
            "exc": "9ws",
            "elc": "7ws",
            "iq": 0,
            "n": "War Scepter",
            "durability": 70,
            "mind": 10,
            "maxd": 17,
            "rs": 55,
            "hi": 1,
            "gt": 0,
            "i": "invwsp",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "21",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "spc": {
            "nc": "spc",
            "exc": "9sp",
            "elc": "7sp",
            "iq": 0,
            "n": "Spiked Club",
            "durability": 36,
            "mind": 5,
            "maxd": 8,
            "hi": 1,
            "gt": 0,
            "i": "invspc",
            "ui": "invspcu",
            "si": "invspcu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "4",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "mac": {
            "nc": "mac",
            "exc": "9ma",
            "elc": "7ma",
            "iq": 0,
            "n": "Mace",
            "durability": 60,
            "mind": 3,
            "maxd": 10,
            "rs": 27,
            "hi": 1,
            "gt": 0,
            "i": "invmac",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "8",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "mst": {
            "nc": "mst",
            "exc": "9mt",
            "elc": "7mt",
            "iq": 0,
            "n": "Morning Star",
            "durability": 72,
            "mind": 7,
            "maxd": 16,
            "rs": 36,
            "hi": 1,
            "gt": 0,
            "i": "invmst",
            "ui": "invmstu",
            "si": "invmstu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "13",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "fla": {
            "nc": "fla",
            "exc": "9fl",
            "elc": "7fl",
            "iq": 0,
            "n": "Flail",
            "durability": 30,
            "mind": 1,
            "maxd": 24,
            "rs": 41,
            "rd": 35,
            "hi": 1,
            "gt": 0,
            "i": "invfla",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "19",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "whm": {
            "nc": "whm",
            "exc": "9wh",
            "elc": "7wh",
            "iq": 0,
            "n": "War Hammer",
            "durability": 55,
            "mind": 19,
            "maxd": 29,
            "rs": 53,
            "hi": 1,
            "gt": 0,
            "i": "invwhm",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "25",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "mau": {
            "nc": "mau",
            "exc": "9m9",
            "elc": "7m7",
            "iq": 0,
            "n": "Maul",
            "durability": 60,
            "min2d": 30,
            "max2d": 43,
            "rs": 69,
            "hi": 1,
            "gt": 0,
            "i": "invmau",
            "ui": "invmauu",
            "si": "invmauu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "hamm",
            "lvl": "21",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gma": {
            "nc": "gma",
            "exc": "9gm",
            "elc": "7gm",
            "iq": 0,
            "n": "Great Maul",
            "durability": 60,
            "min2d": 38,
            "max2d": 58,
            "rs": 99,
            "hi": 1,
            "gt": 0,
            "i": "invgma",
            "ui": "invgma",
            "si": "invgma",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "32",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "ssd": {
            "nc": "ssd",
            "exc": "9ss",
            "elc": "7ss",
            "iq": 0,
            "n": "Short Sword",
            "durability": 24,
            "mind": 2,
            "maxd": 7,
            "hi": 1,
            "gt": 0,
            "i": "invssd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "scm": {
            "nc": "scm",
            "exc": "9sm",
            "elc": "7sm",
            "iq": 0,
            "n": "Scimitar",
            "durability": 22,
            "mind": 2,
            "maxd": 6,
            "rd": 21,
            "hi": 1,
            "gt": 0,
            "i": "invscm",
            "ui": "invscmu",
            "si": "invscmu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "5",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "sbr": {
            "nc": "sbr",
            "exc": "9sb",
            "elc": "7sb",
            "iq": 0,
            "n": "Sabre",
            "durability": 32,
            "mind": 3,
            "maxd": 8,
            "rs": 25,
            "rd": 25,
            "hi": 1,
            "gt": 0,
            "i": "invsbr",
            "ui": "inv9sbu",
            "si": "inv9sbu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "8",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "flc": {
            "nc": "flc",
            "exc": "9fc",
            "elc": "7fc",
            "iq": 0,
            "n": "Falchion",
            "durability": 32,
            "mind": 9,
            "maxd": 17,
            "rs": 33,
            "hi": 1,
            "gt": 0,
            "i": "invflc",
            "ui": "invflcu",
            "si": "invflcu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "11",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "crs": {
            "nc": "crs",
            "exc": "9cr",
            "elc": "7cr",
            "iq": 0,
            "n": "Crystal Sword",
            "durability": 20,
            "mind": 5,
            "maxd": 15,
            "rs": 43,
            "hi": 1,
            "gt": 0,
            "i": "invcrs",
            "ui": "invcrsu",
            "si": "invcrsu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "swor",
            "lvl": "11",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bsd": {
            "nc": "bsd",
            "exc": "9bs",
            "elc": "7bs",
            "iq": 0,
            "n": "Broad Sword",
            "durability": 32,
            "mind": 7,
            "maxd": 14,
            "rs": 48,
            "hi": 1,
            "gt": 0,
            "i": "invbsd",
            "ui": "invbsdu",
            "si": "invbsdu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "15",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "lsd": {
            "nc": "lsd",
            "exc": "9ls",
            "elc": "7ls",
            "iq": 0,
            "n": "Long Sword",
            "durability": 44,
            "mind": 3,
            "maxd": 19,
            "rs": 55,
            "rd": 39,
            "hi": 1,
            "gt": 0,
            "i": "invlsd",
            "ui": "invlsdu",
            "si": "invlsdu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "20",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wsd": {
            "nc": "wsd",
            "exc": "9wd",
            "elc": "7wd",
            "iq": 0,
            "n": "War Sword",
            "durability": 44,
            "mind": 8,
            "maxd": 20,
            "rs": 71,
            "rd": 45,
            "hi": 1,
            "gt": 0,
            "i": "invwsd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "27",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "2hs": {
            "nc": "2hs",
            "exc": "92h",
            "elc": "72h",
            "iq": 0,
            "n": "Two-Handed Sword",
            "durability": 44,
            "mind": 2,
            "maxd": 9,
            "min2d": 8,
            "max2d": 17,
            "rs": 35,
            "rd": 27,
            "hi": 1,
            "gt": 0,
            "i": "inv2hs",
            "ui": "inv2hsu",
            "si": "inv2hsu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "10",
            "gemsockets": 3,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "clm": {
            "nc": "clm",
            "exc": "9cm",
            "elc": "7cm",
            "iq": 0,
            "n": "Claymore",
            "durability": 50,
            "mind": 5,
            "maxd": 12,
            "min2d": 13,
            "max2d": 30,
            "rs": 47,
            "hi": 1,
            "gt": 0,
            "i": "invclm",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "17",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gis": {
            "nc": "gis",
            "exc": "9gs",
            "elc": "7gs",
            "iq": 0,
            "n": "Giant Sword",
            "durability": 50,
            "mind": 3,
            "maxd": 16,
            "min2d": 9,
            "max2d": 28,
            "rs": 56,
            "rd": 34,
            "hi": 1,
            "gt": 0,
            "i": "invgis",
            "ui": "invgisu",
            "si": "invgisu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "21",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bsw": {
            "nc": "bsw",
            "exc": "9b9",
            "elc": "7b7",
            "iq": 0,
            "n": "Bastard Sword",
            "durability": 40,
            "mind": 7,
            "maxd": 19,
            "min2d": 20,
            "max2d": 28,
            "rs": 62,
            "hi": 1,
            "gt": 0,
            "i": "invbsw",
            "ui": "invbswu",
            "si": "invbswu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "24",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "flb": {
            "nc": "flb",
            "exc": "9fb",
            "elc": "7fb",
            "iq": 0,
            "n": "Flamberge",
            "durability": 50,
            "mind": 9,
            "maxd": 15,
            "min2d": 13,
            "max2d": 26,
            "rs": 70,
            "rd": 49,
            "hi": 1,
            "gt": 0,
            "i": "invflb",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "27",
            "gemsockets": 5,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "gsd": {
            "nc": "gsd",
            "exc": "9gd",
            "elc": "7gd",
            "iq": 0,
            "n": "Great Sword",
            "durability": 50,
            "mind": 12,
            "maxd": 20,
            "min2d": 25,
            "max2d": 42,
            "rs": 100,
            "rd": 60,
            "hi": 1,
            "gt": 0,
            "i": "invgsd",
            "ui": "invgsdu",
            "si": "invgsdu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "33",
            "gemsockets": 6,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "dgr": {
            "nc": "dgr",
            "exc": "9dg",
            "elc": "7dg",
            "iq": 0,
            "n": "Dagger",
            "durability": 16,
            "mind": 1,
            "maxd": 4,
            "hi": 1,
            "gt": 0,
            "i": "invdgr",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "3",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "dir": {
            "nc": "dir",
            "exc": "9di",
            "elc": "7di",
            "iq": 0,
            "n": "Dirk",
            "durability": 20,
            "mind": 3,
            "maxd": 9,
            "rd": 25,
            "hi": 1,
            "gt": 0,
            "i": "invdir",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "9",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "kri": {
            "nc": "kri",
            "exc": "9kr",
            "elc": "7kr",
            "iq": 0,
            "n": "Kris",
            "durability": 24,
            "mind": 2,
            "maxd": 11,
            "rd": 45,
            "hi": 1,
            "gt": 0,
            "i": "invkrs",
            "ui": "invkrsu",
            "si": "invkrsu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "17",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bld": {
            "nc": "bld",
            "exc": "9bl",
            "elc": "7bl",
            "iq": 0,
            "n": "Blade",
            "durability": 24,
            "mind": 4,
            "maxd": 15,
            "rs": 35,
            "rd": 51,
            "hi": 1,
            "gt": 0,
            "i": "invbld",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "23",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "tkf": {
            "nc": "tkf",
            "exc": "9tk",
            "elc": "7tk",
            "iq": 0,
            "n": "Throwing Knife",
            "s": 1,
            "durability": 4,
            "mind": 2,
            "maxd": 3,
            "minmd": 4,
            "maxmd": 9,
            "rd": 21,
            "gt": 0,
            "i": "invtkn",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "2",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "tax": {
            "nc": "tax",
            "exc": "9ta",
            "elc": "7ta",
            "iq": 0,
            "n": "Throwing Axe",
            "s": 1,
            "durability": 6,
            "mind": 4,
            "maxd": 7,
            "minmd": 8,
            "maxmd": 12,
            "rd": 40,
            "gt": 0,
            "i": "invtax",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "taxe",
            "lvl": "7",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bkf": {
            "nc": "bkf",
            "exc": "9bk",
            "elc": "7bk",
            "iq": 0,
            "n": "Balanced Knife",
            "s": 1,
            "durability": 8,
            "mind": 1,
            "maxd": 8,
            "minmd": 6,
            "maxmd": 11,
            "rd": 51,
            "gt": 0,
            "i": "invbkf",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "13",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bal": {
            "nc": "bal",
            "exc": "9b8",
            "elc": "7b8",
            "iq": 0,
            "n": "Balanced Axe",
            "s": 1,
            "durability": 10,
            "mind": 5,
            "maxd": 10,
            "minmd": 12,
            "maxmd": 15,
            "rd": 57,
            "gt": 0,
            "i": "invbal",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "taxe",
            "lvl": "16",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "jav": {
            "nc": "jav",
            "exc": "9ja",
            "elc": "7ja",
            "iq": 0,
            "n": "Javelin",
            "s": 1,
            "durability": 2,
            "mind": 1,
            "maxd": 5,
            "minmd": 6,
            "maxmd": 14,
            "gt": 0,
            "i": "invjav",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "1",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "pil": {
            "nc": "pil",
            "exc": "9pi",
            "elc": "7pi",
            "iq": 0,
            "n": "Pilum",
            "s": 1,
            "durability": 3,
            "mind": 4,
            "maxd": 9,
            "minmd": 7,
            "maxmd": 20,
            "rd": 45,
            "gt": 0,
            "i": "invpil",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "10",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "ssp": {
            "nc": "ssp",
            "exc": "9s9",
            "elc": "7s7",
            "iq": 0,
            "n": "Short Spear",
            "s": 1,
            "durability": 4,
            "mind": 2,
            "maxd": 13,
            "minmd": 10,
            "maxmd": 22,
            "rs": 40,
            "rd": 40,
            "gt": 0,
            "i": "invssp",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "15",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "glv": {
            "nc": "glv",
            "exc": "9gl",
            "elc": "7gl",
            "iq": 0,
            "n": "Glaive",
            "s": 1,
            "durability": 5,
            "mind": 5,
            "maxd": 17,
            "minmd": 16,
            "maxmd": 22,
            "rs": 52,
            "rd": 35,
            "gt": 0,
            "i": "invglv",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "23",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "tsp": {
            "nc": "tsp",
            "exc": "9ts",
            "elc": "7ts",
            "iq": 0,
            "n": "Throwing Spear",
            "s": 1,
            "durability": 6,
            "mind": 5,
            "maxd": 15,
            "minmd": 12,
            "maxmd": 30,
            "rd": 65,
            "gt": 0,
            "i": "invtsp",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "29",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "spr": {
            "nc": "spr",
            "exc": "9sr",
            "elc": "7sr",
            "iq": 0,
            "n": "Spear",
            "durability": 30,
            "min2d": 3,
            "max2d": 15,
            "rd": 20,
            "hi": 1,
            "gt": 0,
            "i": "invspr",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "5",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "tri": {
            "nc": "tri",
            "exc": "9tr",
            "elc": "7tr",
            "iq": 0,
            "n": "Trident",
            "durability": 35,
            "min2d": 9,
            "max2d": 15,
            "rs": 38,
            "rd": 24,
            "hi": 1,
            "gt": 0,
            "i": "invtri",
            "ui": "invtriu",
            "si": "invtriu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "9",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "brn": {
            "nc": "brn",
            "exc": "9br",
            "elc": "7br",
            "iq": 0,
            "n": "Brandistock",
            "durability": 28,
            "min2d": 7,
            "max2d": 17,
            "rs": 40,
            "rd": 50,
            "hi": 1,
            "gt": 0,
            "i": "invbrn",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "16",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "spt": {
            "nc": "spt",
            "exc": "9st",
            "elc": "7st",
            "iq": 0,
            "n": "Spetum",
            "durability": 28,
            "min2d": 15,
            "max2d": 23,
            "rs": 54,
            "rd": 35,
            "hi": 1,
            "gt": 0,
            "i": "invspt",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "20",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "pik": {
            "nc": "pik",
            "exc": "9p9",
            "elc": "7p7",
            "iq": 0,
            "n": "Pike",
            "durability": 25,
            "min2d": 14,
            "max2d": 63,
            "rs": 60,
            "rd": 45,
            "hi": 1,
            "gt": 0,
            "i": "invpik",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "24",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bar": {
            "nc": "bar",
            "exc": "9b7",
            "elc": "7o7",
            "iq": 0,
            "n": "Bardiche",
            "durability": 50,
            "min2d": 1,
            "max2d": 27,
            "rs": 40,
            "hi": 1,
            "gt": 0,
            "i": "invbar",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "5",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "vou": {
            "nc": "vou",
            "exc": "9vo",
            "elc": "7vo",
            "iq": 0,
            "n": "Voulge",
            "durability": 50,
            "min2d": 6,
            "max2d": 21,
            "rs": 50,
            "hi": 1,
            "gt": 0,
            "i": "invvou",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "11",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "scy": {
            "nc": "scy",
            "exc": "9s8",
            "elc": "7s8",
            "iq": 0,
            "n": "Scythe",
            "durability": 65,
            "min2d": 8,
            "max2d": 20,
            "rs": 41,
            "rd": 41,
            "hi": 1,
            "gt": 0,
            "i": "invscy",
            "ui": "invscyu",
            "si": "invscyu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "15",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "pax": {
            "nc": "pax",
            "exc": "9pa",
            "elc": "7pa",
            "iq": 0,
            "n": "Poleaxe",
            "durability": 65,
            "min2d": 18,
            "max2d": 39,
            "rs": 62,
            "hi": 1,
            "gt": 0,
            "i": "invpax",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "21",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "hal": {
            "nc": "hal",
            "exc": "9h9",
            "elc": "7h7",
            "iq": 0,
            "n": "Halberd",
            "durability": 55,
            "min2d": 12,
            "max2d": 45,
            "rs": 75,
            "rd": 47,
            "hi": 1,
            "gt": 0,
            "i": "invhal",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "29",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wsc": {
            "nc": "wsc",
            "exc": "9wc",
            "elc": "7wc",
            "iq": 0,
            "n": "War Scythe",
            "durability": 55,
            "min2d": 15,
            "max2d": 36,
            "rs": 80,
            "rd": 80,
            "hi": 1,
            "gt": 0,
            "i": "invwsc",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "34",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "sst": {
            "nc": "sst",
            "exc": "8ss",
            "elc": "6ss",
            "iq": 0,
            "n": "Short Staff",
            "durability": 20,
            "min2d": 1,
            "max2d": 5,
            "hi": 1,
            "gt": 0,
            "i": "invsst",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "staf",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "lst": {
            "nc": "lst",
            "exc": "8ls",
            "elc": "6ls",
            "iq": 0,
            "n": "Long Staff",
            "durability": 30,
            "min2d": 2,
            "max2d": 8,
            "hi": 1,
            "gt": 0,
            "i": "invlst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "8",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "cst": {
            "nc": "cst",
            "exc": "8cs",
            "elc": "6cs",
            "iq": 0,
            "n": "Gnarled Staff",
            "durability": 35,
            "min2d": 4,
            "max2d": 12,
            "hi": 1,
            "gt": 0,
            "i": "invcst",
            "ui": "invcstu",
            "si": "invcstu",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "12",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "bst": {
            "nc": "bst",
            "exc": "8bs",
            "elc": "6bs",
            "iq": 0,
            "n": "Battle Staff",
            "durability": 40,
            "min2d": 6,
            "max2d": 13,
            "hi": 1,
            "gt": 0,
            "i": "invbst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "17",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "wst": {
            "nc": "wst",
            "exc": "8ws",
            "elc": "6ws",
            "iq": 0,
            "n": "War Staff",
            "durability": 50,
            "min2d": 12,
            "max2d": 28,
            "hi": 1,
            "gt": 0,
            "i": "invwst",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "24",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "sbw": {
            "nc": "sbw",
            "exc": "8sb",
            "elc": "6sb",
            "iq": 0,
            "n": "Short Bow",
            "durability": 20,
            "min2d": 1,
            "max2d": 4,
            "rd": 15,
            "hi": 1,
            "gt": 0,
            "i": "invsbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "1",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "hbw": {
            "nc": "hbw",
            "exc": "8hb",
            "elc": "6hb",
            "iq": 0,
            "n": "Hunter's Bow",
            "durability": 32,
            "min2d": 2,
            "max2d": 6,
            "rd": 28,
            "hi": 1,
            "gt": 0,
            "i": "invhbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "5",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "lbw": {
            "nc": "lbw",
            "exc": "8lb",
            "elc": "6lb",
            "iq": 0,
            "n": "Long Bow",
            "durability": 28,
            "min2d": 3,
            "max2d": 10,
            "rs": 22,
            "rd": 19,
            "hi": 1,
            "gt": 0,
            "i": "invlbw",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "8",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "cbw": {
            "nc": "cbw",
            "exc": "8cb",
            "elc": "6cb",
            "iq": 0,
            "n": "Composite Bow",
            "durability": 36,
            "min2d": 4,
            "max2d": 8,
            "rs": 25,
            "rd": 35,
            "hi": 1,
            "gt": 0,
            "i": "invcbw",
            "ui": "invcbwu",
            "si": "invcbwu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "12",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "sbb": {
            "nc": "sbb",
            "exc": "8s8",
            "elc": "6s7",
            "iq": 0,
            "n": "Short Battle Bow",
            "durability": 40,
            "min2d": 5,
            "max2d": 11,
            "rs": 30,
            "rd": 40,
            "hi": 1,
            "gt": 0,
            "i": "invsbb",
            "ui": "invsbbu",
            "si": "invsbbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "18",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "lbb": {
            "nc": "lbb",
            "exc": "8l8",
            "elc": "6l7",
            "iq": 0,
            "n": "Long Battle Bow",
            "durability": 44,
            "min2d": 3,
            "max2d": 18,
            "rs": 40,
            "rd": 50,
            "hi": 1,
            "gt": 0,
            "i": "invlbb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "23",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "swb": {
            "nc": "swb",
            "exc": "8sw",
            "elc": "6sw",
            "iq": 0,
            "n": "Short War Bow",
            "durability": 48,
            "min2d": 6,
            "max2d": 14,
            "rs": 35,
            "rd": 55,
            "hi": 1,
            "gt": 0,
            "i": "invswb",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "27",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "lwb": {
            "nc": "lwb",
            "exc": "8lw",
            "elc": "6lw",
            "iq": 0,
            "n": "Long War Bow",
            "durability": 55,
            "min2d": 3,
            "max2d": 23,
            "rs": 50,
            "rd": 65,
            "hi": 1,
            "gt": 0,
            "i": "invlwb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "31",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "lxb": {
            "nc": "lxb",
            "exc": "8lx",
            "elc": "6lx",
            "iq": 0,
            "n": "Light Crossbow",
            "durability": 30,
            "min2d": 6,
            "max2d": 9,
            "rs": 21,
            "rd": 27,
            "hi": 1,
            "gt": 0,
            "i": "invlxb",
            "ui": "invlxbu",
            "si": "invlxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "6",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "mxb": {
            "nc": "mxb",
            "exc": "8mx",
            "elc": "6mx",
            "iq": 0,
            "n": "Crossbow",
            "durability": 40,
            "min2d": 9,
            "max2d": 16,
            "rs": 40,
            "rd": 33,
            "hi": 1,
            "gt": 0,
            "i": "invmxb",
            "ui": "invmxbu",
            "si": "invmxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "15",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "hxb": {
            "nc": "hxb",
            "exc": "8hx",
            "elc": "6hx",
            "iq": 0,
            "n": "Heavy Crossbow",
            "durability": 50,
            "min2d": 14,
            "max2d": 26,
            "rs": 60,
            "rd": 40,
            "hi": 1,
            "gt": 0,
            "i": "invhxb",
            "ui": "invhxbu",
            "si": "invhxbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "xbow",
            "lvl": "24",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "rxb": {
            "nc": "rxb",
            "exc": "8rx",
            "elc": "6rx",
            "iq": 0,
            "n": "Repeating Crossbow",
            "durability": 40,
            "min2d": 6,
            "max2d": 12,
            "rs": 40,
            "rd": 50,
            "hi": 1,
            "gt": 0,
            "i": "invrxb",
            "ui": "invrxbu",
            "si": "invrxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "33",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "gps": {
            "nc": "gps",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Rancid Gas Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invgpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "32",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "ops": {
            "nc": "ops",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Oil Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invopl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "28",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "gpm": {
            "nc": "gpm",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Choking Gas Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invgpm",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "20",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "opm": {
            "nc": "opm",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Exploding Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invopm",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "16",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "gpl": {
            "nc": "gpl",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Strangling Gas Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invgps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "8",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "opl": {
            "nc": "opl",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Fulminating Potion",
            "s": 1,
            "durability": 2,
            "maxd": 1,
            "gt": 0,
            "i": "invops",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "tpot",
            "lvl": "4",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Thrown Weapon",
            "c": [
                "Missile Potion",
                "Thrown Weapon",
                "Weapon"
            ]
        },
        "d33": {
            "nc": "d33",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Decoy Gidbinn",
            "durability": 10,
            "mind": 1,
            "maxd": 2,
            "rs": 15,
            "rd": 20,
            "gt": 0,
            "i": "invd33",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "0",
            "gemsockets": 0,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "g33": {
            "nc": "g33",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "The Gidbinn",
            "durability": 30,
            "mind": 3,
            "maxd": 7,
            "rs": 15,
            "rd": 25,
            "gt": 0,
            "i": "invg33",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "0",
            "gemsockets": 0,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "leg": {
            "nc": "leg",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Wirt's Leg",
            "durability": 66,
            "mind": 2,
            "maxd": 8,
            "hi": 1,
            "gt": 0,
            "i": "invleg",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "club",
            "lvl": "0",
            "gemsockets": 3,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "hdm": {
            "nc": "hdm",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Horadric Malus",
            "durability": 55,
            "mind": 6,
            "maxd": 15,
            "rs": 15,
            "rd": 15,
            "gt": 0,
            "i": "invhmr",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "hamm",
            "lvl": "0",
            "gemsockets": 0,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "hfh": {
            "nc": "hfh",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Hell Forge Hammer",
            "durability": 55,
            "mind": 6,
            "maxd": 15,
            "hi": 1,
            "gt": 0,
            "i": "invhfh",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "0",
            "gemsockets": 5,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "hst": {
            "nc": "hst",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Horadric Staff",
            "durability": 50,
            "min2d": 12,
            "max2d": 20,
            "rs": 30,
            "gt": 0,
            "i": "invhst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "0",
            "gemsockets": 0,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "msf": {
            "nc": "msf",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Shaft of the Horadric Staff",
            "durability": 45,
            "min2d": 10,
            "max2d": 15,
            "rs": 25,
            "gt": 0,
            "i": "invmsf",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "staf",
            "lvl": "0",
            "gemsockets": 0,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ha": {
            "nc": "hax",
            "exc": "9ha",
            "elc": "7ha",
            "iq": 1,
            "n": "Hatchet",
            "durability": 28,
            "mind": 10,
            "maxd": 21,
            "rs": 25,
            "rd": 25,
            "hi": 1,
            "gt": 0,
            "i": "invhax",
            "ui": "invhaxu",
            "si": "invhaxu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "31",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ax": {
            "nc": "axe",
            "exc": "9ax",
            "elc": "7ax",
            "iq": 1,
            "n": "Cleaver",
            "durability": 24,
            "mind": 10,
            "maxd": 33,
            "rs": 68,
            "hi": 1,
            "gt": 0,
            "i": "invaxe",
            "ui": "invaxeu",
            "si": "invaxeu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "34",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "92a": {
            "nc": "2ax",
            "exc": "92a",
            "elc": "72a",
            "iq": 1,
            "n": "Twin Axe",
            "durability": 24,
            "mind": 13,
            "maxd": 38,
            "rs": 85,
            "hi": 1,
            "gt": 0,
            "i": "inv2ax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "39",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9mp": {
            "nc": "mpi",
            "exc": "9mp",
            "elc": "7mp",
            "iq": 1,
            "n": "Crowbill",
            "durability": 26,
            "mind": 14,
            "maxd": 34,
            "rs": 94,
            "rd": 70,
            "hi": 1,
            "gt": 0,
            "i": "invmpi",
            "ui": "invmpiu",
            "si": "invmpiu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "43",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9wa": {
            "nc": "wax",
            "exc": "9wa",
            "elc": "7wa",
            "iq": 1,
            "n": "Naga",
            "durability": 26,
            "mind": 16,
            "maxd": 45,
            "rs": 121,
            "hi": 1,
            "gt": 0,
            "i": "invwax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "48",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9la": {
            "nc": "lax",
            "exc": "9la",
            "elc": "7la",
            "iq": 1,
            "n": "Military Axe",
            "durability": 30,
            "min2d": 14,
            "max2d": 34,
            "rs": 73,
            "hi": 1,
            "gt": 0,
            "i": "invlax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "34",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ba": {
            "nc": "bax",
            "exc": "9ba",
            "elc": "7ba",
            "iq": 1,
            "n": "Bearded Axe",
            "durability": 35,
            "min2d": 21,
            "max2d": 49,
            "rs": 92,
            "hi": 1,
            "gt": 0,
            "i": "invbrx",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "38",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9bt": {
            "nc": "btx",
            "exc": "9bt",
            "elc": "7bt",
            "iq": 1,
            "n": "Tabar",
            "durability": 40,
            "min2d": 24,
            "max2d": 77,
            "rs": 101,
            "hi": 1,
            "gt": 0,
            "i": "invbtx",
            "ui": "inv9btu",
            "si": "inv9btu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "42",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ga": {
            "nc": "gax",
            "exc": "9ga",
            "elc": "7ga",
            "iq": 1,
            "n": "Gothic Axe",
            "durability": 50,
            "min2d": 18,
            "max2d": 70,
            "rs": 115,
            "rd": 79,
            "hi": 1,
            "gt": 0,
            "i": "invgax",
            "ui": "invgaxu",
            "si": "invgaxu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "axe",
            "lvl": "46",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gi": {
            "nc": "gix",
            "exc": "9gi",
            "elc": "7gi",
            "iq": 1,
            "n": "Ancient Axe",
            "durability": 50,
            "min2d": 43,
            "max2d": 85,
            "rs": 125,
            "hi": 1,
            "gt": 0,
            "i": "invgix",
            "ui": "inv9giu",
            "si": "inv9giu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "51",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9wn": {
            "nc": "wnd",
            "exc": "9wn",
            "elc": "7wn",
            "iq": 1,
            "n": "Burnt Wand",
            "durability": 15,
            "mind": 8,
            "maxd": 18,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invwnd",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "31",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9yw": {
            "nc": "ywn",
            "exc": "9yw",
            "elc": "7yw",
            "iq": 1,
            "n": "Petrified Wand",
            "durability": 15,
            "mind": 8,
            "maxd": 24,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invywn",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "38",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9bw": {
            "nc": "bwn",
            "exc": "9bw",
            "elc": "7bw",
            "iq": 1,
            "n": "Tomb Wand",
            "durability": 15,
            "mind": 10,
            "maxd": 22,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invbwn",
            "ui": "invbwnu",
            "si": "invbwnu",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "43",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gw": {
            "nc": "gwn",
            "exc": "9gw",
            "elc": "7gw",
            "iq": 1,
            "n": "Grave Wand",
            "durability": 15,
            "mind": 13,
            "maxd": 29,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invgwn",
            "ui": "inv9gwu",
            "si": "inv9gwu",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "49",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9cl": {
            "nc": "clb",
            "exc": "9cl",
            "elc": "7cl",
            "iq": 1,
            "n": "Cudgel",
            "durability": 24,
            "mind": 6,
            "maxd": 21,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invclb",
            "ui": "invclbu",
            "si": "invclbu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "30",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9sc": {
            "nc": "scp",
            "exc": "9sc",
            "elc": "7sc",
            "iq": 1,
            "n": "Rune Scepter",
            "durability": 50,
            "mind": 13,
            "maxd": 24,
            "rs": 58,
            "hi": 1,
            "gt": 0,
            "i": "invscp",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "31",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9qs": {
            "nc": "gsc",
            "exc": "9qs",
            "elc": "7qs",
            "iq": 1,
            "n": "Holy Water Sprinkler",
            "durability": 60,
            "mind": 14,
            "maxd": 36,
            "rs": 76,
            "hi": 1,
            "gt": 0,
            "i": "invgsc",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "40",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ws": {
            "nc": "wsp",
            "exc": "9ws",
            "elc": "7ws",
            "iq": 1,
            "n": "Divine Scepter",
            "durability": 70,
            "mind": 16,
            "maxd": 38,
            "rs": 103,
            "hi": 1,
            "gt": 0,
            "i": "invwsp",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "45",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9sp": {
            "nc": "spc",
            "exc": "9sp",
            "elc": "7sp",
            "iq": 1,
            "n": "Barbed Club",
            "durability": 36,
            "mind": 13,
            "maxd": 25,
            "rs": 30,
            "hi": 1,
            "gt": 0,
            "i": "invspc",
            "ui": "invspcu",
            "si": "invspcu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "32",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ma": {
            "nc": "mac",
            "exc": "9ma",
            "elc": "7ma",
            "iq": 1,
            "n": "Flanged Mace",
            "durability": 60,
            "mind": 15,
            "maxd": 23,
            "rs": 61,
            "hi": 1,
            "gt": 0,
            "i": "invmac",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "35",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9mt": {
            "nc": "mst",
            "exc": "9mt",
            "elc": "7mt",
            "iq": 1,
            "n": "Jagged Star",
            "durability": 72,
            "mind": 20,
            "maxd": 31,
            "rs": 74,
            "hi": 1,
            "gt": 0,
            "i": "invmst",
            "ui": "invmstu",
            "si": "invmstu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "39",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9fl": {
            "nc": "fla",
            "exc": "9fl",
            "elc": "7fl",
            "iq": 1,
            "n": "Knout",
            "durability": 30,
            "mind": 13,
            "maxd": 35,
            "rs": 82,
            "rd": 73,
            "hi": 1,
            "gt": 0,
            "i": "invfla",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "43",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9wh": {
            "nc": "whm",
            "exc": "9wh",
            "elc": "7wh",
            "iq": 1,
            "n": "Battle Hammer",
            "durability": 55,
            "mind": 35,
            "maxd": 58,
            "rs": 100,
            "hi": 1,
            "gt": 0,
            "i": "invwhm",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "48",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9m9": {
            "nc": "mau",
            "exc": "9m9",
            "elc": "7m7",
            "iq": 1,
            "n": "War Club",
            "durability": 60,
            "min2d": 53,
            "max2d": 78,
            "rs": 124,
            "hi": 1,
            "gt": 0,
            "i": "invmau",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "hamm",
            "lvl": "45",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gm": {
            "nc": "gma",
            "exc": "9gm",
            "elc": "7gm",
            "iq": 1,
            "n": "Martel de Fer",
            "durability": 60,
            "min2d": 61,
            "max2d": 99,
            "rs": 169,
            "hi": 1,
            "gt": 0,
            "i": "invgma",
            "ui": "inv9gmu",
            "si": "inv9gmu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "53",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ss": {
            "nc": "ssd",
            "exc": "9ss",
            "elc": "7ss",
            "iq": 1,
            "n": "Gladius",
            "durability": 24,
            "mind": 8,
            "maxd": 22,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invssd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "30",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9sm": {
            "nc": "scm",
            "exc": "9sm",
            "elc": "7sm",
            "iq": 1,
            "n": "Cutlass",
            "durability": 22,
            "mind": 8,
            "maxd": 21,
            "rs": 25,
            "rd": 52,
            "hi": 1,
            "gt": 0,
            "i": "invscm",
            "ui": "invscmu",
            "si": "invscmu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "43",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9sb": {
            "nc": "sbr",
            "exc": "9sb",
            "elc": "7sb",
            "iq": 1,
            "n": "Shamshir",
            "durability": 32,
            "mind": 10,
            "maxd": 24,
            "rs": 58,
            "rd": 58,
            "hi": 1,
            "gt": 0,
            "i": "invsbr",
            "ui": "invsbru",
            "si": "invsbru",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "35",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9fc": {
            "nc": "flc",
            "exc": "9fc",
            "elc": "7fc",
            "iq": 1,
            "n": "Tulwar",
            "durability": 32,
            "mind": 16,
            "maxd": 35,
            "rs": 70,
            "rd": 42,
            "hi": 1,
            "gt": 0,
            "i": "invflc",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "37",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9cr": {
            "nc": "crs",
            "exc": "9cr",
            "elc": "7cr",
            "iq": 1,
            "n": "Dimensional Blade",
            "durability": 20,
            "mind": 13,
            "maxd": 35,
            "rs": 85,
            "rd": 60,
            "hi": 1,
            "gt": 0,
            "i": "invcrs",
            "ui": "inv9cru",
            "si": "inv9cru",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "swor",
            "lvl": "37",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9bs": {
            "nc": "bsd",
            "exc": "9bs",
            "elc": "7bs",
            "iq": 1,
            "n": "Battle Sword",
            "durability": 32,
            "mind": 16,
            "maxd": 34,
            "rs": 92,
            "rd": 43,
            "hi": 1,
            "gt": 0,
            "i": "invbsd",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "40",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ls": {
            "nc": "lsd",
            "exc": "9ls",
            "elc": "7ls",
            "iq": 1,
            "n": "Rune Sword",
            "durability": 44,
            "mind": 10,
            "maxd": 42,
            "rs": 103,
            "rd": 79,
            "hi": 1,
            "gt": 0,
            "i": "invlsd",
            "ui": "inv9lsu",
            "si": "inv9lsu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "44",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9wd": {
            "nc": "wsd",
            "exc": "9wd",
            "elc": "7wd",
            "iq": 1,
            "n": "Ancient Sword",
            "durability": 44,
            "mind": 18,
            "maxd": 43,
            "rs": 127,
            "rd": 88,
            "hi": 1,
            "gt": 0,
            "i": "invwsd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "49",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "92h": {
            "nc": "2hs",
            "exc": "92h",
            "elc": "72h",
            "iq": 1,
            "n": "Espandon",
            "durability": 44,
            "mind": 8,
            "maxd": 26,
            "min2d": 18,
            "max2d": 40,
            "rs": 73,
            "rd": 61,
            "hi": 1,
            "gt": 0,
            "i": "inv2hs",
            "ui": "inv2hsu",
            "si": "inv2hsu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "37",
            "gemsockets": 3,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9cm": {
            "nc": "clm",
            "exc": "9cm",
            "elc": "7cm",
            "iq": 1,
            "n": "Dacian Falx",
            "durability": 50,
            "mind": 13,
            "maxd": 30,
            "min2d": 26,
            "max2d": 61,
            "rs": 91,
            "rd": 20,
            "hi": 1,
            "gt": 0,
            "i": "invclm",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "42",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gs": {
            "nc": "gis",
            "exc": "9gs",
            "elc": "7gs",
            "iq": 1,
            "n": "Tusk Sword",
            "durability": 50,
            "mind": 10,
            "maxd": 37,
            "min2d": 19,
            "max2d": 58,
            "rs": 104,
            "rd": 71,
            "hi": 1,
            "gt": 0,
            "i": "invgis",
            "ui": "invgisu",
            "si": "invgisu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "45",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9b9": {
            "nc": "bsw",
            "exc": "9b9",
            "elc": "7b7",
            "iq": 1,
            "n": "Gothic Sword",
            "durability": 40,
            "mind": 14,
            "maxd": 40,
            "min2d": 39,
            "max2d": 60,
            "rs": 113,
            "rd": 20,
            "hi": 1,
            "gt": 0,
            "i": "invbsw",
            "ui": "invbswu",
            "si": "invbswu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "48",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9fb": {
            "nc": "flb",
            "exc": "9fb",
            "elc": "7fb",
            "iq": 1,
            "n": "Zweihander",
            "durability": 50,
            "mind": 19,
            "maxd": 35,
            "min2d": 29,
            "max2d": 54,
            "rs": 125,
            "rd": 94,
            "hi": 1,
            "gt": 0,
            "i": "invflb",
            "ui": "inv9fbu",
            "si": "inv9fbu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "49",
            "gemsockets": 5,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gd": {
            "nc": "gsd",
            "exc": "9gd",
            "elc": "7gd",
            "iq": 1,
            "n": "Executioner Sword",
            "durability": 50,
            "mind": 24,
            "maxd": 40,
            "min2d": 47,
            "max2d": 80,
            "rs": 170,
            "rd": 110,
            "hi": 1,
            "gt": 0,
            "i": "invgsd",
            "ui": "invgsdu",
            "si": "invgsdu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "54",
            "gemsockets": 6,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9dg": {
            "nc": "dgr",
            "exc": "9dg",
            "elc": "7dg",
            "iq": 1,
            "n": "Poignard",
            "durability": 16,
            "mind": 6,
            "maxd": 18,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invdgr",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "31",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9di": {
            "nc": "dir",
            "exc": "9di",
            "elc": "7di",
            "iq": 1,
            "n": "Rondel",
            "durability": 20,
            "mind": 10,
            "maxd": 26,
            "rs": 25,
            "rd": 58,
            "hi": 1,
            "gt": 0,
            "i": "invdir",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "36",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9kr": {
            "nc": "kri",
            "exc": "9kr",
            "elc": "7kr",
            "iq": 1,
            "n": "Cinquedeas",
            "durability": 24,
            "mind": 15,
            "maxd": 31,
            "rs": 25,
            "rd": 88,
            "hi": 1,
            "gt": 0,
            "i": "invkrs",
            "ui": "invkrsu",
            "si": "invkrsu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "42",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9bl": {
            "nc": "bld",
            "exc": "9bl",
            "elc": "7bl",
            "iq": 1,
            "n": "Stiletto",
            "durability": 24,
            "mind": 19,
            "maxd": 36,
            "rs": 47,
            "rd": 97,
            "hi": 1,
            "gt": 0,
            "i": "invbld",
            "ui": "inv9blu",
            "si": "inv9blu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "46",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9tk": {
            "nc": "tkf",
            "exc": "9tk",
            "elc": "7tk",
            "iq": 1,
            "n": "Battle Dart",
            "s": 1,
            "durability": 6,
            "mind": 8,
            "maxd": 16,
            "minmd": 11,
            "maxmd": 24,
            "rs": 25,
            "rd": 52,
            "gt": 0,
            "i": "invtkn",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "31",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ta": {
            "nc": "tax",
            "exc": "9ta",
            "elc": "7ta",
            "iq": 1,
            "n": "Francisca",
            "s": 1,
            "durability": 15,
            "mind": 11,
            "maxd": 22,
            "minmd": 18,
            "maxmd": 33,
            "rs": 25,
            "rd": 80,
            "gt": 0,
            "i": "invtax",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "taxe",
            "lvl": "34",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9bk": {
            "nc": "bkf",
            "exc": "9bk",
            "elc": "7bk",
            "iq": 1,
            "n": "War Dart",
            "s": 1,
            "durability": 20,
            "mind": 6,
            "maxd": 24,
            "minmd": 14,
            "maxmd": 27,
            "rs": 25,
            "rd": 97,
            "gt": 0,
            "i": "invbkf",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "39",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9b8": {
            "nc": "bal",
            "exc": "9b8",
            "elc": "7b8",
            "iq": 1,
            "n": "Hurlbat",
            "s": 1,
            "durability": 16,
            "mind": 13,
            "maxd": 27,
            "minmd": 24,
            "maxmd": 34,
            "rs": 25,
            "rd": 106,
            "gt": 0,
            "i": "invbal",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "taxe",
            "lvl": "41",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ja": {
            "nc": "jav",
            "exc": "9ja",
            "elc": "7ja",
            "iq": 1,
            "n": "War Javelin",
            "s": 1,
            "durability": 10,
            "mind": 6,
            "maxd": 19,
            "minmd": 14,
            "maxmd": 32,
            "rs": 25,
            "rd": 25,
            "gt": 0,
            "i": "invjav",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "30",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9pi": {
            "nc": "pil",
            "exc": "9pi",
            "elc": "7pi",
            "iq": 1,
            "n": "Great Pilum",
            "s": 1,
            "durability": 12,
            "mind": 11,
            "maxd": 26,
            "minmd": 16,
            "maxmd": 42,
            "rs": 25,
            "rd": 88,
            "gt": 0,
            "i": "invpil",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "37",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9s9": {
            "nc": "ssp",
            "exc": "9s9",
            "elc": "7s7",
            "iq": 1,
            "n": "Simbilan",
            "s": 1,
            "durability": 14,
            "mind": 8,
            "maxd": 32,
            "minmd": 27,
            "maxmd": 50,
            "rs": 80,
            "rd": 80,
            "gt": 0,
            "i": "invssp",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "40",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9gl": {
            "nc": "glv",
            "exc": "9gl",
            "elc": "7gl",
            "iq": 1,
            "n": "Spiculum",
            "s": 1,
            "durability": 16,
            "mind": 13,
            "maxd": 38,
            "minmd": 32,
            "maxmd": 60,
            "rs": 98,
            "rd": 73,
            "gt": 0,
            "i": "invglv",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "46",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9ts": {
            "nc": "tsp",
            "exc": "9ts",
            "elc": "7ts",
            "iq": 1,
            "n": "Harpoon",
            "s": 1,
            "durability": 18,
            "mind": 13,
            "maxd": 35,
            "minmd": 18,
            "maxmd": 54,
            "rs": 25,
            "rd": 118,
            "gt": 0,
            "i": "invtsp",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "51",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9sr": {
            "nc": "spr",
            "exc": "9sr",
            "elc": "7sr",
            "iq": 1,
            "n": "War Spear",
            "durability": 30,
            "min2d": 10,
            "max2d": 37,
            "rs": 25,
            "rd": 25,
            "hi": 1,
            "gt": 0,
            "i": "invspr",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "33",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9tr": {
            "nc": "tri",
            "exc": "9tr",
            "elc": "7tr",
            "iq": 1,
            "n": "Fuscina",
            "durability": 35,
            "min2d": 19,
            "max2d": 37,
            "rs": 77,
            "rd": 25,
            "hi": 1,
            "gt": 0,
            "i": "invtri",
            "ui": "invtriu",
            "si": "invtriu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "36",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9br": {
            "nc": "brn",
            "exc": "9br",
            "elc": "7br",
            "iq": 1,
            "n": "War Fork",
            "durability": 28,
            "min2d": 16,
            "max2d": 40,
            "rs": 80,
            "rd": 95,
            "hi": 1,
            "gt": 0,
            "i": "invbrn",
            "ui": "inv9bru",
            "si": "inv9bru",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "41",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9st": {
            "nc": "spt",
            "exc": "9st",
            "elc": "7st",
            "iq": 1,
            "n": "Yari",
            "durability": 28,
            "min2d": 29,
            "max2d": 59,
            "rs": 101,
            "hi": 1,
            "gt": 0,
            "i": "invspt",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "44",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9p9": {
            "nc": "pik",
            "exc": "9p9",
            "elc": "7p7",
            "iq": 1,
            "n": "Lance",
            "durability": 25,
            "min2d": 27,
            "max2d": 114,
            "rs": 110,
            "rd": 88,
            "hi": 1,
            "gt": 0,
            "i": "invpik",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "47",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9b7": {
            "nc": "bar",
            "exc": "9b7",
            "elc": "7o7",
            "iq": 1,
            "n": "Lochaber Axe",
            "durability": 50,
            "min2d": 6,
            "max2d": 58,
            "rs": 80,
            "hi": 1,
            "gt": 0,
            "i": "invbar",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "33",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9vo": {
            "nc": "vou",
            "exc": "9vo",
            "elc": "7vo",
            "iq": 1,
            "n": "Bill",
            "durability": 50,
            "min2d": 14,
            "max2d": 53,
            "rs": 95,
            "hi": 1,
            "gt": 0,
            "i": "invvou",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "37",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9s8": {
            "nc": "scy",
            "exc": "9s8",
            "elc": "7s8",
            "iq": 1,
            "n": "Battle Scythe",
            "durability": 65,
            "min2d": 18,
            "max2d": 45,
            "rs": 82,
            "rd": 82,
            "hi": 1,
            "gt": 0,
            "i": "invscy",
            "ui": "inv9s8u",
            "si": "inv9s8u",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "40",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9pa": {
            "nc": "pax",
            "exc": "9pa",
            "elc": "7pa",
            "iq": 1,
            "n": "Partizan",
            "durability": 65,
            "min2d": 34,
            "max2d": 75,
            "rs": 113,
            "rd": 67,
            "hi": 1,
            "gt": 0,
            "i": "invpax",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "35",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9h9": {
            "nc": "hal",
            "exc": "9h9",
            "elc": "7h7",
            "iq": 1,
            "n": "Bec-de-Corbin",
            "durability": 55,
            "min2d": 13,
            "max2d": 85,
            "rs": 133,
            "rd": 91,
            "hi": 1,
            "gt": 0,
            "i": "invhal",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "51",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "9wc": {
            "nc": "wsc",
            "exc": "9wc",
            "elc": "7wc",
            "iq": 1,
            "n": "Grim Scythe",
            "durability": 55,
            "min2d": 30,
            "max2d": 70,
            "rs": 140,
            "rd": 140,
            "hi": 1,
            "gt": 0,
            "i": "invwsc",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "55",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8ss": {
            "nc": "sst",
            "exc": "8ss",
            "elc": "6ss",
            "iq": 1,
            "n": "Jo Staff",
            "durability": 20,
            "min2d": 6,
            "max2d": 21,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invsst",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "staf",
            "lvl": "30",
            "gemsockets": 2,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8ls": {
            "nc": "lst",
            "exc": "8ls",
            "elc": "6ls",
            "iq": 1,
            "n": "Quarterstaff",
            "durability": 30,
            "min2d": 8,
            "max2d": 26,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invlst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "35",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8cs": {
            "nc": "cst",
            "exc": "8cs",
            "elc": "6cs",
            "iq": 1,
            "n": "Cedar Staff",
            "durability": 35,
            "min2d": 11,
            "max2d": 32,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invcst",
            "ui": "invcstu",
            "si": "invcstu",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "38",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8bs": {
            "nc": "bst",
            "exc": "8bs",
            "elc": "6bs",
            "iq": 1,
            "n": "Gothic Staff",
            "durability": 40,
            "min2d": 14,
            "max2d": 34,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invbst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "42",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8ws": {
            "nc": "wst",
            "exc": "8ws",
            "elc": "6ws",
            "iq": 1,
            "n": "Rune Staff",
            "durability": 50,
            "min2d": 24,
            "max2d": 58,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invwst",
            "ui": "inv8wsu",
            "si": "inv8wsu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "47",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "8sb": {
            "nc": "sbw",
            "exc": "8sb",
            "elc": "6sb",
            "iq": 1,
            "n": "Edge Bow",
            "durability": 20,
            "min2d": 6,
            "max2d": 19,
            "rs": 25,
            "rd": 43,
            "hi": 1,
            "gt": 0,
            "i": "invsbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "30",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8hb": {
            "nc": "hbw",
            "exc": "8hb",
            "elc": "6hb",
            "iq": 1,
            "n": "Razor Bow",
            "durability": 32,
            "min2d": 8,
            "max2d": 22,
            "rs": 25,
            "rd": 62,
            "hi": 1,
            "gt": 0,
            "i": "invhbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "33",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8lb": {
            "nc": "lbw",
            "exc": "8lb",
            "elc": "6lb",
            "iq": 1,
            "n": "Cedar Bow",
            "durability": 28,
            "min2d": 10,
            "max2d": 29,
            "rs": 53,
            "rd": 49,
            "hi": 1,
            "gt": 0,
            "i": "invlbw",
            "ui": "inv8lbu",
            "si": "inv8lbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "35",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8cb": {
            "nc": "cbw",
            "exc": "8cb",
            "elc": "6cb",
            "iq": 1,
            "n": "Double Bow",
            "durability": 36,
            "min2d": 11,
            "max2d": 26,
            "rs": 58,
            "rd": 73,
            "hi": 1,
            "gt": 0,
            "i": "invcbw",
            "ui": "invcbwu",
            "si": "invcbwu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "39",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8s8": {
            "nc": "sbb",
            "exc": "8s8",
            "elc": "6s7",
            "iq": 1,
            "n": "Short Siege Bow",
            "durability": 40,
            "min2d": 13,
            "max2d": 30,
            "rs": 65,
            "rd": 80,
            "hi": 1,
            "gt": 0,
            "i": "invsbb",
            "ui": "inv8s8u",
            "si": "inv8s8u",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "43",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8l8": {
            "nc": "lbb",
            "exc": "8l8",
            "elc": "6l7",
            "iq": 1,
            "n": "Large Siege Bow",
            "durability": 44,
            "min2d": 10,
            "max2d": 42,
            "rs": 80,
            "rd": 95,
            "hi": 1,
            "gt": 0,
            "i": "invlbb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "46",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8sw": {
            "nc": "swb",
            "exc": "8sw",
            "elc": "6sw",
            "iq": 1,
            "n": "Rune Bow",
            "durability": 48,
            "min2d": 14,
            "max2d": 35,
            "rs": 73,
            "rd": 103,
            "hi": 1,
            "gt": 0,
            "i": "invswb",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "49",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8lw": {
            "nc": "lwb",
            "exc": "8lw",
            "elc": "6lw",
            "iq": 1,
            "n": "Gothic Bow",
            "durability": 55,
            "min2d": 10,
            "max2d": 50,
            "rs": 95,
            "rd": 118,
            "hi": 1,
            "gt": 0,
            "i": "invlwb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "52",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8lx": {
            "nc": "lxb",
            "exc": "8lx",
            "elc": "6lx",
            "iq": 1,
            "n": "Arbalest",
            "durability": 30,
            "min2d": 14,
            "max2d": 27,
            "rs": 52,
            "rd": 61,
            "hi": 1,
            "gt": 0,
            "i": "invlxb",
            "ui": "inv8lxu",
            "si": "inv8lxu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "34",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8mx": {
            "nc": "mxb",
            "exc": "8mx",
            "elc": "6mx",
            "iq": 1,
            "n": "Siege Crossbow",
            "durability": 40,
            "min2d": 20,
            "max2d": 42,
            "rs": 80,
            "rd": 70,
            "hi": 1,
            "gt": 0,
            "i": "invmxb",
            "ui": "inv8mxu",
            "si": "inv8mxu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "40",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8hx": {
            "nc": "hxb",
            "exc": "8hx",
            "elc": "6hx",
            "iq": 1,
            "n": "Ballista",
            "durability": 50,
            "min2d": 33,
            "max2d": 55,
            "rs": 110,
            "rd": 80,
            "hi": 1,
            "gt": 0,
            "i": "invhxb",
            "ui": "invhxbu",
            "si": "invhxbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "xbow",
            "lvl": "47",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "8rx": {
            "nc": "rxb",
            "exc": "8rx",
            "elc": "6rx",
            "iq": 1,
            "n": "Chu-Ko-Nu",
            "durability": 40,
            "min2d": 14,
            "max2d": 32,
            "rs": 80,
            "rd": 95,
            "hi": 1,
            "gt": 0,
            "i": "invrxb",
            "ui": "invrxbu",
            "si": "invrxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "54",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "qf1": {
            "nc": "fla",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Khalim's Flail",
            "durability": 30,
            "mind": 1,
            "maxd": 15,
            "rs": 41,
            "rd": 35,
            "hi": 1,
            "gt": 0,
            "i": "invqf1",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "0",
            "gemsockets": 3,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "qf2": {
            "nc": "fla",
            "exc": "",
            "elc": "",
            "iq": 0,
            "n": "Khalim's Will",
            "durability": 30,
            "mind": 1,
            "maxd": 15,
            "hi": 1,
            "gt": 0,
            "i": "invqf2",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "0",
            "gemsockets": 3,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "ktr": {
            "nc": "ktr",
            "exc": "9ar",
            "elc": "7ar",
            "iq": 0,
            "n": "Katar",
            "durability": 48,
            "mind": 4,
            "maxd": 7,
            "rs": 20,
            "rd": 20,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "1",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "wrb": {
            "nc": "wrb",
            "exc": "9wb",
            "elc": "7wb",
            "iq": 0,
            "n": "Wrist Blade",
            "durability": 52,
            "mind": 5,
            "maxd": 9,
            "rs": 33,
            "rd": 33,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "9",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "axf": {
            "nc": "axf",
            "exc": "9xf",
            "elc": "7xf",
            "iq": 0,
            "n": "Hatchet Hands",
            "durability": 56,
            "mind": 2,
            "maxd": 15,
            "rs": 37,
            "rd": 37,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "12",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "ces": {
            "nc": "ces",
            "exc": "9cs",
            "elc": "7cs",
            "iq": 0,
            "n": "Cestus",
            "durability": 72,
            "mind": 7,
            "maxd": 15,
            "rs": 42,
            "rd": 42,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "15",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "clw": {
            "nc": "clw",
            "exc": "9lw",
            "elc": "7lw",
            "iq": 0,
            "n": "Claws",
            "durability": 64,
            "mind": 8,
            "maxd": 15,
            "rs": 46,
            "rd": 46,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "18",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "btl": {
            "nc": "btl",
            "exc": "9tw",
            "elc": "7tw",
            "iq": 0,
            "n": "Blade Talons",
            "durability": 69,
            "mind": 10,
            "maxd": 14,
            "rs": 50,
            "rd": 50,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "21",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "skr": {
            "nc": "skr",
            "exc": "9qr",
            "elc": "7qr",
            "iq": 0,
            "n": "Scissors Katar",
            "durability": 68,
            "mind": 9,
            "maxd": 17,
            "rs": 55,
            "rd": 55,
            "hi": 1,
            "gt": 0,
            "i": "invskr",
            "ui": "invskru",
            "si": "invskru",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "24",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9ar": {
            "nc": "ktr",
            "exc": "9ar",
            "elc": "7ar",
            "iq": 1,
            "n": "Quhab",
            "durability": 48,
            "mind": 11,
            "maxd": 24,
            "rs": 57,
            "rd": 57,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "28",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9wb": {
            "nc": "wrb",
            "exc": "9wb",
            "elc": "7wb",
            "iq": 1,
            "n": "Wrist Spike",
            "durability": 56,
            "mind": 13,
            "maxd": 27,
            "rs": 66,
            "rd": 66,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "32",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9xf": {
            "nc": "axf",
            "exc": "9xf",
            "elc": "7xf",
            "iq": 1,
            "n": "Fascia",
            "durability": 64,
            "mind": 8,
            "maxd": 37,
            "rs": 69,
            "rd": 69,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h",
            "lvl": "36",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "eq2n": "Assassin Item",
            "c": [
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9cs": {
            "nc": "ces",
            "exc": "9cs",
            "elc": "7cs",
            "iq": 1,
            "n": "Hand Scythe",
            "durability": 72,
            "mind": 16,
            "maxd": 37,
            "rs": 73,
            "rd": 73,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "41",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9lw": {
            "nc": "clw",
            "exc": "9lw",
            "elc": "7lw",
            "iq": 1,
            "n": "Greater Claws",
            "durability": 52,
            "mind": 18,
            "maxd": 37,
            "rs": 76,
            "rd": 76,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "45",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9tw": {
            "nc": "btl",
            "exc": "9tw",
            "elc": "7tw",
            "iq": 1,
            "n": "Greater Talons",
            "durability": 69,
            "mind": 21,
            "maxd": 35,
            "rs": 79,
            "rd": 79,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "50",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "9qr": {
            "nc": "skr",
            "exc": "9qr",
            "elc": "7qr",
            "iq": 1,
            "n": "Scissors Quhab",
            "durability": 68,
            "mind": 19,
            "maxd": 40,
            "rs": 82,
            "rd": 82,
            "hi": 1,
            "gt": 0,
            "i": "invskr",
            "ui": "invskru",
            "si": "invskru",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "54",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7ar": {
            "nc": "ktr",
            "exc": "9ar",
            "elc": "7ar",
            "iq": 2,
            "n": "Suwayyah",
            "durability": 48,
            "mind": 39,
            "maxd": 52,
            "rs": 99,
            "rd": 99,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "59",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7wb": {
            "nc": "wrb",
            "exc": "9wb",
            "elc": "7wb",
            "iq": 2,
            "n": "Wrist Sword",
            "durability": 56,
            "mind": 34,
            "maxd": 45,
            "rs": 105,
            "rd": 105,
            "hi": 1,
            "gt": 0,
            "i": "invktr",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "62",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7xf": {
            "nc": "axf",
            "exc": "9xf",
            "elc": "7xf",
            "iq": 2,
            "n": "War Fist",
            "durability": 64,
            "mind": 44,
            "maxd": 53,
            "rs": 108,
            "rd": 108,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "68",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7cs": {
            "nc": "ces",
            "exc": "9cs",
            "elc": "7cs",
            "iq": 2,
            "n": "Battle Cestus",
            "durability": 72,
            "mind": 36,
            "maxd": 42,
            "rs": 110,
            "rd": 110,
            "hi": 1,
            "gt": 0,
            "i": "invaxf",
            "ui": "invaxfu",
            "si": "invaxfu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "73",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7lw": {
            "nc": "clw",
            "exc": "9lw",
            "elc": "7lw",
            "iq": 2,
            "n": "Feral Claws",
            "durability": 52,
            "mind": 22,
            "maxd": 53,
            "rs": 113,
            "rd": 113,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "78",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7tw": {
            "nc": "btl",
            "exc": "9tw",
            "elc": "7tw",
            "iq": 2,
            "n": "Runic Talons",
            "durability": 69,
            "mind": 24,
            "maxd": 44,
            "rs": 115,
            "rd": 115,
            "hi": 1,
            "gt": 0,
            "i": "invclw",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "81",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7qr": {
            "nc": "skr",
            "exc": "9qr",
            "elc": "7qr",
            "iq": 2,
            "n": "Scissors Suwayyah",
            "durability": 68,
            "mind": 40,
            "maxd": 51,
            "rs": 118,
            "rd": 118,
            "hi": 1,
            "gt": 0,
            "i": "invskr",
            "ui": "invskru",
            "si": "invskru",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "h2h2",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Hand to Hand",
            "c": [
                "Hand to Hand 2",
                "Hand to Hand",
                "Melee Weapon",
                "Weapon",
                "Assassin Item",
                "Class Specific"
            ]
        },
        "7ha": {
            "nc": "hax",
            "exc": "9ha",
            "elc": "7ha",
            "iq": 2,
            "n": "Tomahawk",
            "durability": 28,
            "mind": 33,
            "maxd": 58,
            "rs": 125,
            "rd": 67,
            "hi": 1,
            "gt": 0,
            "i": "invhax",
            "ui": "invhaxu",
            "si": "invhaxu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "54",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ax": {
            "nc": "axe",
            "exc": "9ax",
            "elc": "7ax",
            "iq": 2,
            "n": "Small Crescent",
            "durability": 24,
            "mind": 38,
            "maxd": 60,
            "rs": 115,
            "rd": 83,
            "hi": 1,
            "gt": 0,
            "i": "invaxe",
            "ui": "invaxeu",
            "si": "invaxeu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "61",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "72a": {
            "nc": "2ax",
            "exc": "92a",
            "elc": "72a",
            "iq": 2,
            "n": "Ettin Axe",
            "durability": 24,
            "mind": 33,
            "maxd": 66,
            "rs": 145,
            "rd": 45,
            "hi": 1,
            "gt": 0,
            "i": "inv2ax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "70",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7mp": {
            "nc": "mpi",
            "exc": "9mp",
            "elc": "7mp",
            "iq": 2,
            "n": "War Spike",
            "durability": 26,
            "mind": 30,
            "maxd": 48,
            "rs": 133,
            "rd": 54,
            "hi": 1,
            "gt": 0,
            "i": "invmpi",
            "ui": "invmpiu",
            "si": "invmpiu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "79",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7wa": {
            "nc": "wax",
            "exc": "9wa",
            "elc": "7wa",
            "iq": 2,
            "n": "Berserker Axe",
            "durability": 26,
            "mind": 24,
            "maxd": 71,
            "rs": 138,
            "rd": 59,
            "hi": 1,
            "gt": 0,
            "i": "invwax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7la": {
            "nc": "lax",
            "exc": "9la",
            "elc": "7la",
            "iq": 2,
            "n": "Feral Axe",
            "durability": 30,
            "min2d": 25,
            "max2d": 123,
            "rs": 196,
            "hi": 1,
            "gt": 0,
            "i": "invlax",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "57",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ba": {
            "nc": "bax",
            "exc": "9ba",
            "elc": "7ba",
            "iq": 2,
            "n": "Silver-edged Axe",
            "durability": 35,
            "min2d": 62,
            "max2d": 110,
            "rs": 166,
            "rd": 65,
            "hi": 1,
            "gt": 0,
            "i": "invbrx",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "65",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7bt": {
            "nc": "btx",
            "exc": "9bt",
            "elc": "7bt",
            "iq": 2,
            "n": "Decapitator",
            "durability": 40,
            "min2d": 49,
            "max2d": 137,
            "rs": 189,
            "rd": 33,
            "hi": 1,
            "gt": 0,
            "i": "invbtx",
            "ui": "invbtxu",
            "si": "invbtxu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "73",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ga": {
            "nc": "gax",
            "exc": "9ga",
            "elc": "7ga",
            "iq": 2,
            "n": "Champion Axe",
            "durability": 50,
            "min2d": 59,
            "max2d": 94,
            "rs": 167,
            "rd": 59,
            "hi": 1,
            "gt": 0,
            "i": "invgax",
            "ui": "invgaxu",
            "si": "invgaxu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "axe",
            "lvl": "82",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gi": {
            "nc": "gix",
            "exc": "9gi",
            "elc": "7gi",
            "iq": 2,
            "n": "Glorious Axe",
            "durability": 50,
            "min2d": 60,
            "max2d": 124,
            "rs": 164,
            "rd": 55,
            "hi": 1,
            "gt": 0,
            "i": "invgix",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "axe",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Melee Weapon",
            "c": [
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7wn": {
            "nc": "wnd",
            "exc": "9wn",
            "elc": "7wn",
            "iq": 2,
            "n": "Polished Wand",
            "durability": 22,
            "mind": 18,
            "maxd": 33,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invwnd",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "55",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7yw": {
            "nc": "ywn",
            "exc": "9yw",
            "elc": "7yw",
            "iq": 2,
            "n": "Ghost Wand",
            "durability": 14,
            "mind": 20,
            "maxd": 40,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invywn",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "wand",
            "lvl": "65",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7bw": {
            "nc": "bwn",
            "exc": "9bw",
            "elc": "7bw",
            "iq": 2,
            "n": "Lich Wand",
            "durability": 17,
            "mind": 10,
            "maxd": 31,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invbwn",
            "ui": "invbwnu",
            "si": "invbwnu",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "75",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gw": {
            "nc": "gwn",
            "exc": "9gw",
            "elc": "7gw",
            "iq": 2,
            "n": "Unearthed Wand",
            "durability": 18,
            "mind": 22,
            "maxd": 28,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invgwn",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "wand",
            "lvl": "86",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Wand",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7cl": {
            "nc": "clb",
            "exc": "9cl",
            "elc": "7cl",
            "iq": 2,
            "n": "Truncheon",
            "durability": 55,
            "mind": 35,
            "maxd": 43,
            "rs": 88,
            "rd": 43,
            "hi": 1,
            "gt": 0,
            "i": "invclb",
            "ui": "invclbu",
            "si": "invclbu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "52",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7sc": {
            "nc": "scp",
            "exc": "9sc",
            "elc": "7sc",
            "iq": 2,
            "n": "Mighty Scepter",
            "durability": 50,
            "mind": 40,
            "maxd": 52,
            "rs": 125,
            "rd": 65,
            "hi": 1,
            "gt": 0,
            "i": "invscp",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "62",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7qs": {
            "nc": "gsc",
            "exc": "9qs",
            "elc": "7qs",
            "iq": 2,
            "n": "Seraph Rod",
            "durability": 60,
            "mind": 45,
            "maxd": 54,
            "rs": 108,
            "rd": 69,
            "hi": 1,
            "gt": 0,
            "i": "invgsc",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "76",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ws": {
            "nc": "wsp",
            "exc": "9ws",
            "elc": "7ws",
            "iq": 2,
            "n": "Caduceus",
            "durability": 70,
            "mind": 37,
            "maxd": 43,
            "rs": 97,
            "rd": 70,
            "hi": 1,
            "gt": 0,
            "i": "invwsp",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "scep",
            "lvl": "85",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Scepter",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7sp": {
            "nc": "spc",
            "exc": "9sp",
            "elc": "7sp",
            "iq": 2,
            "n": "Tyrant Club",
            "durability": 65,
            "mind": 32,
            "maxd": 58,
            "rs": 133,
            "hi": 1,
            "gt": 0,
            "i": "invspc",
            "ui": "invspcu",
            "si": "invspcu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "club",
            "lvl": "57",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Club",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ma": {
            "nc": "mac",
            "exc": "9ma",
            "elc": "7ma",
            "iq": 2,
            "n": "Reinforced Mace",
            "durability": 60,
            "mind": 41,
            "maxd": 49,
            "rs": 145,
            "rd": 46,
            "hi": 1,
            "gt": 0,
            "i": "invmac",
            "si": "inv7mas",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "63",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7mt": {
            "nc": "mst",
            "exc": "9mt",
            "elc": "7mt",
            "iq": 2,
            "n": "Devil Star",
            "durability": 72,
            "mind": 43,
            "maxd": 53,
            "rs": 153,
            "rd": 44,
            "hi": 1,
            "gt": 0,
            "i": "invmst",
            "ui": "invmstu",
            "si": "invmstu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "70",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7fl": {
            "nc": "fla",
            "exc": "9fl",
            "elc": "7fl",
            "iq": 2,
            "n": "Scourge",
            "durability": 65,
            "mind": 3,
            "maxd": 80,
            "rs": 125,
            "rd": 77,
            "hi": 1,
            "gt": 0,
            "i": "invfla",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "mace",
            "lvl": "76",
            "gemsockets": 5,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Mace",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7wh": {
            "nc": "whm",
            "exc": "9wh",
            "elc": "7wh",
            "iq": 2,
            "n": "Legendary Mallet",
            "durability": 65,
            "mind": 50,
            "maxd": 61,
            "rs": 189,
            "hi": 1,
            "gt": 0,
            "i": "invwhm",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "82",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7m7": {
            "nc": "mau",
            "exc": "9m9",
            "elc": "7m7",
            "iq": 2,
            "n": "Ogre Maul",
            "durability": 60,
            "min2d": 77,
            "max2d": 106,
            "rs": 225,
            "hi": 1,
            "gt": 0,
            "i": "invmau",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "hamm",
            "lvl": "69",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gm": {
            "nc": "gma",
            "exc": "9gm",
            "elc": "7gm",
            "iq": 2,
            "n": "Thunder Maul",
            "durability": 60,
            "min2d": 33,
            "max2d": 180,
            "rs": 253,
            "hi": 1,
            "gt": 0,
            "i": "invgma",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "hamm",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Blunt",
            "c": [
                "Hammer",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ss": {
            "nc": "ssd",
            "exc": "9ss",
            "elc": "7ss",
            "iq": 2,
            "n": "Falcata",
            "durability": 24,
            "mind": 31,
            "maxd": 59,
            "rs": 150,
            "rd": 88,
            "hi": 1,
            "gt": 0,
            "i": "invssd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "56",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7sm": {
            "nc": "scm",
            "exc": "9sm",
            "elc": "7sm",
            "iq": 2,
            "n": "Ataghan",
            "durability": 22,
            "mind": 26,
            "maxd": 46,
            "rs": 138,
            "rd": 95,
            "hi": 1,
            "gt": 0,
            "i": "invscm",
            "ui": "invscmu",
            "si": "invscmu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "61",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7sb": {
            "nc": "sbr",
            "exc": "9sb",
            "elc": "7sb",
            "iq": 2,
            "n": "Elegant Blade",
            "durability": 32,
            "mind": 33,
            "maxd": 45,
            "rs": 109,
            "rd": 122,
            "hi": 1,
            "gt": 0,
            "i": "invsbr",
            "ui": "invsbru",
            "si": "invsbru",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "63",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7fc": {
            "nc": "flc",
            "exc": "9fc",
            "elc": "7fc",
            "iq": 2,
            "n": "Hydra Edge",
            "durability": 32,
            "mind": 28,
            "maxd": 68,
            "rs": 142,
            "rd": 105,
            "hi": 1,
            "gt": 0,
            "i": "invflc",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "69",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7cr": {
            "nc": "crs",
            "exc": "9cr",
            "elc": "7cr",
            "iq": 2,
            "n": "Phase Blade",
            "durability": 0,
            "mind": 31,
            "maxd": 35,
            "rs": 25,
            "rd": 136,
            "hi": 1,
            "gt": 0,
            "i": "invcrs",
            "ui": "invcrsu",
            "si": "invcrsu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "swor",
            "lvl": "73",
            "gemsockets": 6,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7bs": {
            "nc": "bsd",
            "exc": "9bs",
            "elc": "7bs",
            "iq": 2,
            "n": "Conquest Sword",
            "durability": 32,
            "mind": 37,
            "maxd": 53,
            "rs": 142,
            "rd": 112,
            "hi": 1,
            "gt": 0,
            "i": "invbsd",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "78",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ls": {
            "nc": "lsd",
            "exc": "9ls",
            "elc": "7ls",
            "iq": 2,
            "n": "Cryptic Sword",
            "durability": 44,
            "mind": 5,
            "maxd": 77,
            "rs": 99,
            "rd": 109,
            "hi": 1,
            "gt": 0,
            "i": "invlsd",
            "ui": "invlsdu",
            "si": "invlsdu",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "82",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7wd": {
            "nc": "wsd",
            "exc": "9wd",
            "elc": "7wd",
            "iq": 2,
            "n": "Mythical Sword",
            "durability": 44,
            "mind": 40,
            "maxd": 50,
            "rs": 147,
            "rd": 124,
            "hi": 1,
            "gt": 0,
            "i": "invwsd",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "swor",
            "lvl": "85",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "72h": {
            "nc": "2hs",
            "exc": "92h",
            "elc": "72h",
            "iq": 2,
            "n": "Legend Sword",
            "durability": 44,
            "mind": 22,
            "maxd": 56,
            "min2d": 50,
            "max2d": 94,
            "rs": 175,
            "rd": 100,
            "hi": 1,
            "gt": 0,
            "i": "inv2hs",
            "ui": "inv2hsu",
            "si": "inv2hsu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "59",
            "gemsockets": 3,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7cm": {
            "nc": "clm",
            "exc": "9cm",
            "elc": "7cm",
            "iq": 2,
            "n": "Highland Blade",
            "durability": 50,
            "mind": 22,
            "maxd": 62,
            "min2d": 67,
            "max2d": 96,
            "rs": 171,
            "rd": 104,
            "hi": 1,
            "gt": 0,
            "i": "invclm",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "66",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gs": {
            "nc": "gis",
            "exc": "9gs",
            "elc": "7gs",
            "iq": 2,
            "n": "Balrog Blade",
            "durability": 50,
            "mind": 15,
            "maxd": 75,
            "min2d": 55,
            "max2d": 118,
            "rs": 185,
            "rd": 87,
            "hi": 1,
            "gt": 0,
            "i": "invgis",
            "ui": "invgisu",
            "si": "invgisu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "71",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7b7": {
            "nc": "bsw",
            "exc": "9b9",
            "elc": "7b7",
            "iq": 2,
            "n": "Champion Sword",
            "durability": 40,
            "mind": 24,
            "maxd": 54,
            "min2d": 71,
            "max2d": 83,
            "rs": 163,
            "rd": 103,
            "hi": 1,
            "gt": 0,
            "i": "invbsw",
            "ui": "invbswu",
            "si": "invbswu",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "77",
            "gemsockets": 4,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7fb": {
            "nc": "flb",
            "exc": "9fb",
            "elc": "7fb",
            "iq": 2,
            "n": "Colossus Sword",
            "durability": 50,
            "mind": 26,
            "maxd": 70,
            "min2d": 61,
            "max2d": 121,
            "rs": 182,
            "rd": 95,
            "hi": 1,
            "gt": 0,
            "i": "invflb",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "80",
            "gemsockets": 5,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gd": {
            "nc": "gsd",
            "exc": "9gd",
            "elc": "7gd",
            "iq": 2,
            "n": "Colossus Blade",
            "durability": 50,
            "mind": 25,
            "maxd": 65,
            "min2d": 58,
            "max2d": 115,
            "rs": 189,
            "rd": 110,
            "hi": 1,
            "gt": 0,
            "i": "invgsd",
            "ui": "invgsdu",
            "si": "invgsdu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "swor",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed1or2": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Sword",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7dg": {
            "nc": "dgr",
            "exc": "9dg",
            "elc": "7dg",
            "iq": 2,
            "n": "Bone Knife",
            "durability": 26,
            "mind": 23,
            "maxd": 49,
            "rs": 38,
            "rd": 75,
            "hi": 1,
            "gt": 0,
            "i": "invdgr",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "58",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7di": {
            "nc": "dir",
            "exc": "9di",
            "elc": "7di",
            "iq": 2,
            "n": "Mithril Point",
            "durability": 55,
            "mind": 37,
            "maxd": 53,
            "rs": 55,
            "rd": 98,
            "hi": 1,
            "gt": 0,
            "i": "invdir",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "knif",
            "lvl": "70",
            "gemsockets": 1,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7kr": {
            "nc": "kri",
            "exc": "9kr",
            "elc": "7kr",
            "iq": 2,
            "n": "Fanged Knife",
            "durability": 36,
            "mind": 15,
            "maxd": 57,
            "rs": 42,
            "rd": 86,
            "hi": 1,
            "gt": 0,
            "i": "invkrs",
            "ui": "invkrsu",
            "si": "invkrsu",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "83",
            "gemsockets": 3,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7bl": {
            "nc": "bld",
            "exc": "9bl",
            "elc": "7bl",
            "iq": 2,
            "n": "Legend Spike",
            "durability": 47,
            "mind": 31,
            "maxd": 47,
            "rs": 65,
            "rd": 67,
            "hi": 1,
            "gt": 0,
            "i": "invbld",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "knif",
            "lvl": "85",
            "gemsockets": 2,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Swords and Knives",
            "c": [
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7tk": {
            "nc": "tkf",
            "exc": "9tk",
            "elc": "7tk",
            "iq": 2,
            "n": "Flying Knife",
            "s": 1,
            "durability": 6,
            "mind": 23,
            "maxd": 54,
            "minmd": 23,
            "maxmd": 54,
            "rs": 48,
            "rd": 141,
            "gt": 0,
            "i": "invtkn",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "64",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ta": {
            "nc": "tax",
            "exc": "9ta",
            "elc": "7ta",
            "iq": 2,
            "n": "Flying Axe",
            "s": 1,
            "durability": 15,
            "mind": 17,
            "maxd": 65,
            "minmd": 15,
            "maxmd": 66,
            "rs": 88,
            "rd": 108,
            "gt": 0,
            "i": "invtax",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "taxe",
            "lvl": "56",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7bk": {
            "nc": "bkf",
            "exc": "9bk",
            "elc": "7bk",
            "iq": 2,
            "n": "Winged Knife",
            "s": 1,
            "durability": 20,
            "mind": 27,
            "maxd": 35,
            "minmd": 23,
            "maxmd": 39,
            "rs": 45,
            "rd": 142,
            "gt": 0,
            "i": "invbkf",
            "ui": "invtk3",
            "iw": 1,
            "ih": 2,
            "it": 2,
            "type": "tkni",
            "lvl": "77",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Knife",
            "c": [
                "Throwing Knife",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Knife",
                "Swords and Knives",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7b8": {
            "nc": "bal",
            "exc": "9b8",
            "elc": "7b8",
            "iq": 2,
            "n": "Winged Axe",
            "s": 1,
            "durability": 16,
            "mind": 11,
            "maxd": 56,
            "minmd": 7,
            "maxmd": 60,
            "rs": 96,
            "rd": 122,
            "gt": 0,
            "i": "invbal",
            "iw": 2,
            "ih": 3,
            "it": 2,
            "type": "taxe",
            "lvl": "80",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Axe",
            "c": [
                "Throwing Axe",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Axe",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ja": {
            "nc": "jav",
            "exc": "9ja",
            "elc": "7ja",
            "iq": 2,
            "n": "Hyperion Javelin",
            "s": 1,
            "durability": 10,
            "mind": 21,
            "maxd": 57,
            "minmd": 28,
            "maxmd": 55,
            "rs": 98,
            "rd": 123,
            "gt": 0,
            "i": "invjav",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "54",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7pi": {
            "nc": "pil",
            "exc": "9pi",
            "elc": "7pi",
            "iq": 2,
            "n": "Stygian Pilum",
            "s": 1,
            "durability": 12,
            "mind": 14,
            "maxd": 64,
            "minmd": 21,
            "maxmd": 75,
            "rs": 118,
            "rd": 112,
            "gt": 0,
            "i": "invpil",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "62",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7s7": {
            "nc": "ssp",
            "exc": "9s9",
            "elc": "7s7",
            "iq": 2,
            "n": "Balrog Spear",
            "s": 1,
            "durability": 14,
            "mind": 33,
            "maxd": 63,
            "minmd": 40,
            "maxmd": 62,
            "rs": 127,
            "rd": 95,
            "gt": 0,
            "i": "invssp",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "jave",
            "lvl": "71",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7gl": {
            "nc": "glv",
            "exc": "9gl",
            "elc": "7gl",
            "iq": 2,
            "n": "Ghost Glaive",
            "s": 1,
            "durability": 16,
            "mind": 19,
            "maxd": 60,
            "minmd": 30,
            "maxmd": 85,
            "rs": 89,
            "rd": 137,
            "gt": 0,
            "i": "invglv",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "79",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7ts": {
            "nc": "tsp",
            "exc": "9ts",
            "elc": "7ts",
            "iq": 2,
            "n": "Winged Harpoon",
            "s": 1,
            "durability": 18,
            "mind": 27,
            "maxd": 35,
            "minmd": 11,
            "maxmd": 77,
            "rs": 76,
            "rd": 145,
            "gt": 0,
            "i": "invtsp",
            "iw": 1,
            "ih": 4,
            "it": 2,
            "type": "jave",
            "lvl": "85",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Combo Weapon",
            "eq2n": "Spear",
            "c": [
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7sr": {
            "nc": "spr",
            "exc": "9sr",
            "elc": "7sr",
            "iq": 2,
            "n": "Hyperion Spear",
            "durability": 30,
            "min2d": 35,
            "max2d": 119,
            "rs": 155,
            "rd": 120,
            "hi": 1,
            "gt": 0,
            "i": "invspr",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "58",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7tr": {
            "nc": "tri",
            "exc": "9tr",
            "elc": "7tr",
            "iq": 2,
            "n": "Stygian Pike",
            "durability": 35,
            "min2d": 29,
            "max2d": 144,
            "rs": 168,
            "rd": 97,
            "hi": 1,
            "gt": 0,
            "i": "invtri",
            "ui": "invtriu",
            "si": "invtriu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "66",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7br": {
            "nc": "brn",
            "exc": "9br",
            "elc": "7br",
            "iq": 2,
            "n": "Mancatcher",
            "durability": 28,
            "min2d": 42,
            "max2d": 92,
            "rs": 132,
            "rd": 134,
            "hi": 1,
            "gt": 0,
            "i": "invbrn",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "74",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7st": {
            "nc": "spt",
            "exc": "9st",
            "elc": "7st",
            "iq": 2,
            "n": "Ghost Spear",
            "durability": 28,
            "min2d": 18,
            "max2d": 155,
            "rs": 122,
            "rd": 163,
            "hi": 1,
            "gt": 0,
            "i": "invspt",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "83",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7p7": {
            "nc": "pik",
            "exc": "9p9",
            "elc": "7p7",
            "iq": 2,
            "n": "War Pike",
            "durability": 25,
            "min2d": 33,
            "max2d": 178,
            "rs": 165,
            "rd": 106,
            "hi": 1,
            "gt": 0,
            "i": "invpik",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "spea",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7o7": {
            "nc": "bar",
            "exc": "9b7",
            "elc": "7o7",
            "iq": 2,
            "n": "Ogre Axe",
            "durability": 50,
            "min2d": 28,
            "max2d": 145,
            "rs": 195,
            "rd": 75,
            "hi": 1,
            "gt": 0,
            "i": "invbar",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "60",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7vo": {
            "nc": "vou",
            "exc": "9vo",
            "elc": "7vo",
            "iq": 2,
            "n": "Colossus Voulge",
            "durability": 50,
            "min2d": 17,
            "max2d": 165,
            "rs": 210,
            "rd": 55,
            "hi": 1,
            "gt": 0,
            "i": "invvou",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "64",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7s8": {
            "nc": "scy",
            "exc": "9s8",
            "elc": "7s8",
            "iq": 2,
            "n": "Thresher",
            "durability": 65,
            "min2d": 12,
            "max2d": 141,
            "rs": 152,
            "rd": 118,
            "hi": 1,
            "gt": 0,
            "i": "invscy",
            "ui": "invscyu",
            "si": "invscyu",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "71",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7pa": {
            "nc": "pax",
            "exc": "9pa",
            "elc": "7pa",
            "iq": 2,
            "n": "Cryptic Axe",
            "durability": 65,
            "min2d": 33,
            "max2d": 150,
            "rs": 165,
            "rd": 103,
            "hi": 1,
            "gt": 0,
            "i": "invpax",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "79",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7h7": {
            "nc": "hal",
            "exc": "9h9",
            "elc": "7h7",
            "iq": 2,
            "n": "Great Poleaxe",
            "durability": 55,
            "min2d": 46,
            "max2d": 127,
            "rs": 179,
            "rd": 99,
            "hi": 1,
            "gt": 0,
            "i": "invhal",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "84",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "7wc": {
            "nc": "wsc",
            "exc": "9wc",
            "elc": "7wc",
            "iq": 2,
            "n": "Giant Thresher",
            "durability": 55,
            "min2d": 40,
            "max2d": 114,
            "rs": 188,
            "rd": 140,
            "hi": 1,
            "gt": 0,
            "i": "invwsc",
            "iw": 2,
            "ih": 4,
            "it": 2,
            "type": "pole",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spears and Polearms",
            "c": [
                "Polearm",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6ss": {
            "nc": "sst",
            "exc": "8ss",
            "elc": "6ss",
            "iq": 2,
            "n": "Walking Stick",
            "durability": 20,
            "min2d": 69,
            "max2d": 85,
            "rs": 25,
            "hi": 1,
            "gt": 0,
            "i": "invsst",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "staf",
            "lvl": "58",
            "gemsockets": 2,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6ls": {
            "nc": "lst",
            "exc": "8ls",
            "elc": "6ls",
            "iq": 2,
            "n": "Stalagmite",
            "durability": 30,
            "min2d": 75,
            "max2d": 107,
            "rs": 63,
            "rd": 35,
            "hi": 1,
            "gt": 0,
            "i": "invlst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "66",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6cs": {
            "nc": "cst",
            "exc": "8cs",
            "elc": "6cs",
            "iq": 2,
            "n": "Elder Staff",
            "durability": 35,
            "min2d": 80,
            "max2d": 93,
            "rs": 44,
            "rd": 37,
            "hi": 1,
            "gt": 0,
            "i": "invcst",
            "ui": "invcstu",
            "si": "invcstu",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "74",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6bs": {
            "nc": "bst",
            "exc": "8bs",
            "elc": "6bs",
            "iq": 2,
            "n": "Shillelagh",
            "durability": 40,
            "min2d": 65,
            "max2d": 108,
            "rs": 52,
            "rd": 27,
            "hi": 1,
            "gt": 0,
            "i": "invbst",
            "iw": 1,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "83",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6ws": {
            "nc": "wst",
            "exc": "8ws",
            "elc": "6ws",
            "iq": 2,
            "n": "Archon Staff",
            "durability": 26,
            "min2d": 83,
            "max2d": 99,
            "rs": 34,
            "hi": 1,
            "gt": 0,
            "i": "invwst",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "staf",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Staves And Rods",
            "c": [
                "Staff",
                "Staves And Rods",
                "Blunt",
                "Melee Weapon",
                "Weapon"
            ]
        },
        "6sb": {
            "nc": "sbw",
            "exc": "8sb",
            "elc": "6sb",
            "iq": 2,
            "n": "Spider Bow",
            "durability": 20,
            "min2d": 23,
            "max2d": 50,
            "rs": 64,
            "rd": 143,
            "hi": 1,
            "gt": 0,
            "i": "invsbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "55",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6hb": {
            "nc": "hbw",
            "exc": "8hb",
            "elc": "6hb",
            "iq": 2,
            "n": "Blade Bow",
            "durability": 32,
            "min2d": 21,
            "max2d": 41,
            "rs": 76,
            "rd": 119,
            "hi": 1,
            "gt": 0,
            "i": "invhbw",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "60",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6lb": {
            "nc": "lbw",
            "exc": "8lb",
            "elc": "6lb",
            "iq": 2,
            "n": "Shadow Bow",
            "durability": 28,
            "min2d": 15,
            "max2d": 59,
            "rs": 52,
            "rd": 188,
            "hi": 1,
            "gt": 0,
            "i": "invlbw",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "63",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6cb": {
            "nc": "cbw",
            "exc": "8cb",
            "elc": "6cb",
            "iq": 2,
            "n": "Great Bow",
            "durability": 36,
            "min2d": 12,
            "max2d": 52,
            "rs": 121,
            "rd": 107,
            "hi": 1,
            "gt": 0,
            "i": "invcbw",
            "ui": "invcbwu",
            "si": "invcbwu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "68",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6s7": {
            "nc": "sbb",
            "exc": "8s8",
            "elc": "6s7",
            "iq": 2,
            "n": "Diamond Bow",
            "durability": 40,
            "min2d": 33,
            "max2d": 40,
            "rs": 89,
            "rd": 132,
            "hi": 1,
            "gt": 0,
            "i": "invsbb",
            "ui": "invsbbu",
            "si": "invsbbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "72",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6l7": {
            "nc": "lbb",
            "exc": "8l8",
            "elc": "6l7",
            "iq": 2,
            "n": "Crusader Bow",
            "durability": 44,
            "min2d": 15,
            "max2d": 63,
            "rs": 97,
            "rd": 121,
            "hi": 1,
            "gt": 0,
            "i": "invlbb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "77",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6sw": {
            "nc": "swb",
            "exc": "8sw",
            "elc": "6sw",
            "iq": 2,
            "n": "Ward Bow",
            "durability": 48,
            "min2d": 20,
            "max2d": 53,
            "rs": 72,
            "rd": 146,
            "hi": 1,
            "gt": 0,
            "i": "invswb",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "bow",
            "lvl": "80",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6lw": {
            "nc": "lwb",
            "exc": "8lw",
            "elc": "6lw",
            "iq": 2,
            "n": "Hydra Bow",
            "durability": 55,
            "min2d": 10,
            "max2d": 68,
            "rs": 134,
            "rd": 167,
            "hi": 1,
            "gt": 0,
            "i": "invlwb",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "bow",
            "lvl": "85",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Bow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6lx": {
            "nc": "lxb",
            "exc": "8lx",
            "elc": "6lx",
            "iq": 2,
            "n": "Pellet Bow",
            "durability": 30,
            "min2d": 28,
            "max2d": 73,
            "rs": 83,
            "rd": 155,
            "hi": 1,
            "gt": 0,
            "i": "invlxb",
            "ui": "invlxbu",
            "si": "invlxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "57",
            "gemsockets": 3,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6mx": {
            "nc": "mxb",
            "exc": "8mx",
            "elc": "6mx",
            "iq": 2,
            "n": "Gorgon Crossbow",
            "durability": 40,
            "min2d": 25,
            "max2d": 87,
            "rs": 117,
            "rd": 105,
            "hi": 1,
            "gt": 0,
            "i": "invmxb",
            "ui": "invmxbu",
            "si": "invmxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "67",
            "gemsockets": 4,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6hx": {
            "nc": "hxb",
            "exc": "8hx",
            "elc": "6hx",
            "iq": 2,
            "n": "Colossus Crossbow",
            "durability": 50,
            "min2d": 32,
            "max2d": 91,
            "rs": 163,
            "rd": 77,
            "hi": 1,
            "gt": 0,
            "i": "invhxb",
            "ui": "invhxbu",
            "si": "invhxbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "xbow",
            "lvl": "75",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "6rx": {
            "nc": "rxb",
            "exc": "8rx",
            "elc": "6rx",
            "iq": 2,
            "n": "Demon Crossbow",
            "durability": 40,
            "min2d": 26,
            "max2d": 40,
            "rs": 141,
            "rd": 98,
            "hi": 1,
            "gt": 0,
            "i": "invrxb",
            "ui": "invrxbu",
            "si": "invrxbu",
            "iw": 2,
            "ih": 3,
            "it": 8,
            "type": "xbow",
            "lvl": "84",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile Weapon",
            "c": [
                "Crossbow",
                "Missile Weapon",
                "Weapon"
            ]
        },
        "ob1": {
            "nc": "ob1",
            "exc": "ob6",
            "elc": "obb",
            "iq": 0,
            "n": "Eagle Orb",
            "durability": 20,
            "mind": 2,
            "maxd": 5,
            "hi": 1,
            "gt": 0,
            "i": "invob1",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "1",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob2": {
            "nc": "ob2",
            "exc": "ob7",
            "elc": "obc",
            "iq": 0,
            "n": "Sacred Globe",
            "durability": 30,
            "mind": 3,
            "maxd": 8,
            "hi": 1,
            "gt": 0,
            "i": "invob2",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "8",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob3": {
            "nc": "ob3",
            "exc": "ob8",
            "elc": "obd",
            "iq": 0,
            "n": "Smoked Sphere",
            "durability": 35,
            "mind": 4,
            "maxd": 10,
            "hi": 1,
            "gt": 0,
            "i": "invob3",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "12",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob4": {
            "nc": "ob4",
            "exc": "ob9",
            "elc": "obe",
            "iq": 0,
            "n": "Clasped Orb",
            "durability": 40,
            "mind": 5,
            "maxd": 12,
            "hi": 1,
            "gt": 0,
            "i": "invob4",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "17",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob5": {
            "nc": "ob5",
            "exc": "oba",
            "elc": "obf",
            "iq": 0,
            "n": "Jared's Stone",
            "durability": 50,
            "mind": 8,
            "maxd": 18,
            "hi": 1,
            "gt": 0,
            "i": "invob5",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "orb",
            "lvl": "24",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "am1": {
            "nc": "am1",
            "exc": "am6",
            "elc": "amb",
            "iq": 0,
            "n": "Stag Bow",
            "durability": 48,
            "min2d": 7,
            "max2d": 12,
            "rs": 30,
            "rd": 45,
            "hi": 1,
            "gt": 0,
            "i": "invam1",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "18",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am2": {
            "nc": "am2",
            "exc": "am7",
            "elc": "amc",
            "iq": 0,
            "n": "Reflex Bow",
            "durability": 55,
            "min2d": 9,
            "max2d": 19,
            "rs": 35,
            "rd": 60,
            "hi": 1,
            "gt": 0,
            "i": "invam2",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "27",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am3": {
            "nc": "am3",
            "exc": "am8",
            "elc": "amd",
            "iq": 0,
            "n": "Maiden Spear",
            "durability": 28,
            "min2d": 18,
            "max2d": 24,
            "rs": 54,
            "rd": 40,
            "hi": 1,
            "gt": 0,
            "i": "invam3",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "18",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am4": {
            "nc": "am4",
            "exc": "am9",
            "elc": "ame",
            "iq": 0,
            "n": "Maiden Pike",
            "durability": 25,
            "min2d": 23,
            "max2d": 55,
            "rs": 63,
            "rd": 52,
            "hi": 1,
            "gt": 0,
            "i": "invam4",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "27",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am5": {
            "nc": "am5",
            "exc": "ama",
            "elc": "amf",
            "iq": 0,
            "n": "Maiden Javelin",
            "s": 1,
            "durability": 6,
            "mind": 8,
            "maxd": 14,
            "minmd": 6,
            "maxmd": 22,
            "rs": 33,
            "rd": 47,
            "gt": 0,
            "i": "invam5",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "ajav",
            "lvl": "23",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Javelin",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Javelin",
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "ob6": {
            "nc": "ob1",
            "exc": "ob6",
            "elc": "obb",
            "iq": 1,
            "n": "Glowing Orb",
            "durability": 20,
            "mind": 8,
            "maxd": 21,
            "hi": 1,
            "gt": 0,
            "i": "invob1",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "32",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob7": {
            "nc": "ob2",
            "exc": "ob7",
            "elc": "obc",
            "iq": 1,
            "n": "Crystalline Globe",
            "durability": 30,
            "mind": 10,
            "maxd": 26,
            "hi": 1,
            "gt": 0,
            "i": "invob2",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "37",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob8": {
            "nc": "ob3",
            "exc": "ob8",
            "elc": "obd",
            "iq": 1,
            "n": "Cloudy Sphere",
            "durability": 35,
            "mind": 11,
            "maxd": 29,
            "hi": 1,
            "gt": 0,
            "i": "invob3",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "41",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "ob9": {
            "nc": "ob4",
            "exc": "ob9",
            "elc": "obe",
            "iq": 1,
            "n": "Sparkling Ball",
            "durability": 40,
            "mind": 13,
            "maxd": 32,
            "hi": 1,
            "gt": 0,
            "i": "invob4",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "46",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "oba": {
            "nc": "ob5",
            "exc": "oba",
            "elc": "obf",
            "iq": 1,
            "n": "Swirling Crystal",
            "durability": 50,
            "mind": 18,
            "maxd": 42,
            "hi": 1,
            "gt": 0,
            "i": "invob5",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "orb",
            "lvl": "50",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "am6": {
            "nc": "am1",
            "exc": "am6",
            "elc": "amb",
            "iq": 1,
            "n": "Ashwood Bow",
            "durability": 48,
            "min2d": 16,
            "max2d": 29,
            "rs": 56,
            "rd": 77,
            "hi": 1,
            "gt": 0,
            "i": "invam1",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "39",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am7": {
            "nc": "am2",
            "exc": "am7",
            "elc": "amc",
            "iq": 1,
            "n": "Ceremonial Bow",
            "durability": 55,
            "min2d": 19,
            "max2d": 41,
            "rs": 73,
            "rd": 110,
            "hi": 1,
            "gt": 0,
            "i": "invam2",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "47",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am8": {
            "nc": "am3",
            "exc": "am8",
            "elc": "amd",
            "iq": 1,
            "n": "Ceremonial Spear",
            "durability": 28,
            "min2d": 34,
            "max2d": 51,
            "rs": 101,
            "rd": 80,
            "hi": 1,
            "gt": 0,
            "i": "invam3",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "43",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "am9": {
            "nc": "am4",
            "exc": "am9",
            "elc": "ame",
            "iq": 1,
            "n": "Ceremonial Pike",
            "durability": 25,
            "min2d": 42,
            "max2d": 101,
            "rs": 115,
            "rd": 98,
            "hi": 1,
            "gt": 0,
            "i": "invam4",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "51",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "ama": {
            "nc": "am5",
            "exc": "ama",
            "elc": "amf",
            "iq": 1,
            "n": "Ceremonial Javelin",
            "s": 1,
            "durability": 6,
            "mind": 18,
            "maxd": 35,
            "minmd": 18,
            "maxmd": 54,
            "rs": 25,
            "rd": 109,
            "gt": 0,
            "i": "invam5",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "ajav",
            "lvl": "35",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Javelin",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Javelin",
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "obb": {
            "nc": "ob1",
            "exc": "ob6",
            "elc": "obb",
            "iq": 2,
            "n": "Heavenly Stone",
            "durability": 20,
            "mind": 21,
            "maxd": 46,
            "hi": 1,
            "gt": 0,
            "i": "invob1",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "59",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "obc": {
            "nc": "ob2",
            "exc": "ob7",
            "elc": "obc",
            "iq": 2,
            "n": "Eldritch Orb",
            "durability": 30,
            "mind": 18,
            "maxd": 50,
            "hi": 1,
            "gt": 0,
            "i": "invob2",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "67",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "obd": {
            "nc": "ob3",
            "exc": "ob8",
            "elc": "obd",
            "iq": 2,
            "n": "Demon Heart",
            "durability": 35,
            "mind": 23,
            "maxd": 55,
            "hi": 1,
            "gt": 0,
            "i": "invob3",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "75",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "obe": {
            "nc": "ob4",
            "exc": "ob9",
            "elc": "obe",
            "iq": 2,
            "n": "Vortex Orb",
            "durability": 40,
            "mind": 12,
            "maxd": 66,
            "hi": 1,
            "gt": 0,
            "i": "invob4",
            "iw": 1,
            "ih": 2,
            "it": 8,
            "type": "orb",
            "lvl": "84",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "obf": {
            "nc": "ob5",
            "exc": "oba",
            "elc": "obf",
            "iq": 2,
            "n": "Dimensional Shard",
            "durability": 50,
            "mind": 30,
            "maxd": 53,
            "hi": 1,
            "gt": 0,
            "i": "invob5",
            "iw": 1,
            "ih": 3,
            "it": 8,
            "type": "orb",
            "lvl": "85",
            "gemsockets": 4,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Weapon",
            "eq2n": "Sorceress Item",
            "c": [
                "Orb",
                "Weapon",
                "Sorceress Item",
                "Class Specific"
            ]
        },
        "amb": {
            "nc": "am1",
            "exc": "am6",
            "elc": "amb",
            "iq": 2,
            "n": "Matriarchal Bow",
            "durability": 48,
            "min2d": 20,
            "max2d": 47,
            "rs": 87,
            "rd": 187,
            "hi": 1,
            "gt": 0,
            "i": "invam1",
            "ui": "invswbu",
            "si": "invswbu",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "53",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "amc": {
            "nc": "am2",
            "exc": "am7",
            "elc": "amc",
            "iq": 2,
            "n": "Grand Matron Bow",
            "durability": 55,
            "min2d": 14,
            "max2d": 72,
            "rs": 108,
            "rd": 152,
            "hi": 1,
            "gt": 0,
            "i": "invam2",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "abow",
            "lvl": "78",
            "gemsockets": 5,
            "spawnable": 1,
            "handed2": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Bow",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Bow",
                "Bow",
                "Missile Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "amd": {
            "nc": "am3",
            "exc": "am8",
            "elc": "amd",
            "iq": 2,
            "n": "Matriarchal Spear",
            "durability": 28,
            "min2d": 65,
            "max2d": 95,
            "rs": 114,
            "rd": 142,
            "hi": 1,
            "gt": 0,
            "i": "invam3",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "61",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "ame": {
            "nc": "am4",
            "exc": "am9",
            "elc": "ame",
            "iq": 2,
            "n": "Matriarchal Pike",
            "durability": 25,
            "min2d": 37,
            "max2d": 153,
            "rs": 132,
            "rd": 149,
            "hi": 1,
            "gt": 0,
            "i": "invam4",
            "iw": 2,
            "ih": 4,
            "it": 8,
            "type": "aspe",
            "lvl": "81",
            "gemsockets": 6,
            "spawnable": 1,
            "handed2": 1,
            "ig": [],
            "eq1n": "Spear",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Spear",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        },
        "amf": {
            "nc": "am5",
            "exc": "ama",
            "elc": "amf",
            "iq": 2,
            "n": "Matriarchal Javelin",
            "s": 1,
            "durability": 6,
            "mind": 30,
            "maxd": 54,
            "minmd": 35,
            "maxmd": 66,
            "rs": 107,
            "rd": 151,
            "gt": 0,
            "i": "invam5",
            "iw": 1,
            "ih": 3,
            "it": 2,
            "type": "ajav",
            "lvl": "65",
            "gemsockets": 0,
            "spawnable": 1,
            "ig": [],
            "eq1n": "Javelin",
            "eq2n": "Amazon Item",
            "c": [
                "Amazon Javelin",
                "Javelin",
                "Combo Weapon",
                "Melee Weapon",
                "Weapon",
                "Thrown Weapon",
                "Weapon",
                "Spear",
                "Spears and Polearms",
                "Melee Weapon",
                "Weapon",
                "Amazon Item",
                "Class Specific"
            ]
        }
    },
    "other_items": {
        "elx": {
            "iq": 0,
            "n": "Elixir",
            "hi": 0,
            "gt": 0,
            "i": "invpot",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "elix",
            "lvl": "21",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Elixir",
                "Miscellaneous"
            ]
        },
        "hpo": {
            "iq": 0,
            "hi": 0,
            "gt": 0,
            "i": "invrps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mpo": {
            "iq": 0,
            "hi": 0,
            "gt": 0,
            "i": "invbps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "hpf": {
            "iq": 0,
            "hi": 0,
            "gt": 0,
            "i": "invrpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mpf": {
            "iq": 0,
            "hi": 0,
            "gt": 0,
            "i": "invbpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "vps": {
            "iq": 0,
            "n": "Stamina Potion",
            "hi": 0,
            "gt": 0,
            "i": "invwps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "spot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Stamina Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "yps": {
            "iq": 0,
            "n": "Antidote Potion",
            "hi": 0,
            "gt": 0,
            "i": "invnps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "apot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Antidote Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "rvs": {
            "iq": 0,
            "n": "Rejuvenation Potion",
            "hi": 0,
            "gt": 0,
            "i": "invvps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Healing Potion",
            "eq2n": "Mana Potion",
            "c": [
                "Rejuv Potion",
                "Healing Potion",
                "Potion",
                "Miscellaneous",
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "rvl": {
            "iq": 0,
            "n": "Full Rejuvenation Potion",
            "hi": 0,
            "gt": 0,
            "i": "invvpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Healing Potion",
            "eq2n": "Mana Potion",
            "c": [
                "Rejuv Potion",
                "Healing Potion",
                "Potion",
                "Miscellaneous",
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "wms": {
            "iq": 0,
            "n": "Thawing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invyps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "wpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Thawing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "tbk": {
            "iq": 0,
            "n": "Tome of Town Portal",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invbbk",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "book",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Book",
                "Miscellaneous"
            ]
        },
        "ibk": {
            "iq": 0,
            "n": "Tome of Identify",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invrbk",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "book",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Book",
                "Miscellaneous"
            ]
        },
        "amu": {
            "iq": 0,
            "n": "Amulet",
            "hi": 1,
            "gt": 1,
            "i": "invamu",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "amul",
            "lvl": "1",
            "gemsockets": 1,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invamu1",
                "invamu2",
                "invamu3"
            ],
            "eq1n": "Miscellaneous",
            "c": [
                "Amulet",
                "Miscellaneous"
            ]
        },
        "vip": {
            "iq": 0,
            "n": "Top of the Horadric Staff",
            "hi": 0,
            "gt": 0,
            "i": "invvip",
            "ui": "invvip",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "amul",
            "lvl": "15",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [
                "invamu1",
                "invamu2",
                "invamu3"
            ],
            "eq1n": "Miscellaneous",
            "c": [
                "Amulet",
                "Miscellaneous"
            ]
        },
        "rin": {
            "iq": 0,
            "n": "Ring",
            "hi": 1,
            "gt": 1,
            "i": "invrin",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ring",
            "lvl": "1",
            "gemsockets": 1,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invrin1",
                "invrin2",
                "invrin3",
                "invrin4",
                "invrin5"
            ],
            "eq1n": "Miscellaneous",
            "c": [
                "Ring",
                "Miscellaneous"
            ]
        },
        "gld": {
            "iq": 0,
            "n": "Gold",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invgld",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gold",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Gold",
                "Miscellaneous"
            ]
        },
        "bks": {
            "iq": 0,
            "n": "Scroll of Inifuss",
            "hi": 0,
            "gt": 0,
            "i": "invscb",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "bkd": {
            "iq": 0,
            "n": "Key to the Cairn Stones",
            "hi": 0,
            "gt": 0,
            "i": "invscb",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "aqv": {
            "iq": 0,
            "n": "Arrows",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invqvr",
            "iw": 1,
            "ih": 3,
            "it": 0,
            "type": "bowq",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile",
            "eq2n": "Second Hand",
            "c": [
                "Bow Quiver",
                "Missile",
                "Miscellaneous",
                "Second Hand"
            ]
        },
        "tch": {
            "iq": 0,
            "n": "Torch",
            "hi": 0,
            "gt": 0,
            "i": "invtrch",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "torc",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Torch",
                "Miscellaneous"
            ]
        },
        "cqv": {
            "iq": 0,
            "n": "Bolts",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invcqv",
            "iw": 1,
            "ih": 3,
            "it": 0,
            "type": "xboq",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Missile",
            "eq2n": "Second Hand",
            "c": [
                "Crossbow Quiver",
                "Missile",
                "Miscellaneous",
                "Second Hand"
            ]
        },
        "tsc": {
            "iq": 0,
            "n": "Scroll of Town Portal",
            "hi": 0,
            "gt": 0,
            "i": "invbsc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "scro",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Scroll",
                "Miscellaneous"
            ]
        },
        "isc": {
            "iq": 0,
            "n": "Scroll of Identify",
            "hi": 0,
            "gt": 0,
            "i": "invrsc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "scro",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Scroll",
                "Miscellaneous"
            ]
        },
        "hrt": {
            "iq": 0,
            "n": "Heart",
            "hi": 0,
            "gt": 0,
            "i": "invhrt",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "brz": {
            "iq": 0,
            "n": "Brain",
            "hi": 0,
            "gt": 0,
            "i": "invbrnz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "jaw": {
            "iq": 0,
            "n": "Jawbone",
            "hi": 0,
            "gt": 0,
            "i": "invjaw",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "eyz": {
            "iq": 0,
            "n": "Eye",
            "hi": 0,
            "gt": 0,
            "i": "inveye",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "hrn": {
            "iq": 0,
            "n": "Horn",
            "hi": 0,
            "gt": 0,
            "i": "invhorn",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "tal": {
            "iq": 0,
            "n": "Tail",
            "hi": 0,
            "gt": 0,
            "i": "invtail",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "flg": {
            "iq": 0,
            "n": "Flag",
            "hi": 0,
            "gt": 0,
            "i": "invflag",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "fng": {
            "iq": 0,
            "n": "Fang",
            "hi": 0,
            "gt": 0,
            "i": "invfang",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "qll": {
            "iq": 0,
            "n": "Quill",
            "hi": 0,
            "gt": 0,
            "i": "invquil",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "sol": {
            "iq": 0,
            "n": "Soul",
            "hi": 0,
            "gt": 0,
            "i": "invsple",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "scz": {
            "iq": 0,
            "n": "Scalp",
            "hi": 0,
            "gt": 0,
            "i": "invscp",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "spe": {
            "iq": 0,
            "n": "Spleen",
            "hi": 0,
            "gt": 0,
            "i": "invsple",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "body",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Body Part",
                "Miscellaneous"
            ]
        },
        "key": {
            "iq": 0,
            "n": "Key",
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invkey",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "key",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Key",
                "Miscellaneous"
            ]
        },
        "luv": {
            "iq": 0,
            "n": "The Black Tower Key",
            "hi": 0,
            "gt": 0,
            "i": "invmph",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "key",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Key",
                "Miscellaneous"
            ]
        },
        "xyz": {
            "iq": 0,
            "n": "Right Click to permanently add 20 to Life}Potion of Life",
            "hi": 0,
            "gt": 0,
            "i": "invxyz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "j34": {
            "iq": 0,
            "n": "A Jade Figurine",
            "hi": 0,
            "gt": 0,
            "i": "invjbi",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "g34": {
            "iq": 0,
            "n": "The Golden Bird",
            "hi": 0,
            "gt": 0,
            "i": "invgbi",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "bbb": {
            "iq": 0,
            "n": "Lam Esen's Tome",
            "hi": 0,
            "gt": 0,
            "i": "invbbb",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "box": {
            "iq": 0,
            "n": "Horadric Cube",
            "hi": 0,
            "gt": 0,
            "i": "invbox",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "tr1": {
            "iq": 0,
            "n": "Horadric Scroll",
            "hi": 0,
            "gt": 0,
            "i": "invhscr",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "mss": {
            "iq": 0,
            "n": "Mephisto's Soulstone",
            "hi": 0,
            "gt": 0,
            "i": "invmss",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "ass": {
            "iq": 0,
            "n": "Right Click to learn skill of your choice}Book of Skill",
            "hi": 0,
            "gt": 0,
            "i": "invsbk",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "qey": {
            "iq": 0,
            "n": "Khalim's Eye",
            "hi": 0,
            "gt": 0,
            "i": "inveye",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "qhr": {
            "iq": 0,
            "n": "Khalim's Heart",
            "hi": 0,
            "gt": 0,
            "i": "invhrt",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "qbr": {
            "iq": 0,
            "n": "Khalim's Brain",
            "hi": 0,
            "gt": 0,
            "i": "invbrnz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "ear": {
            "iq": 0,
            "n": "Ear",
            "hi": 0,
            "gt": 0,
            "i": "invear",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "play",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Player Body Part",
                "Miscellaneous"
            ]
        },
        "gcv": {
            "iq": 0,
            "n": "Chipped Amethyst",
            "hi": 0,
            "gt": 0,
            "i": "invgsva",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gema",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Amethyst",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ],
                [
                    {
                        "prop": "str",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    }
                ],
                [
                    {
                        "prop": "ac",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ]
            ]
        },
        "gfv": {
            "iq": 0,
            "n": "Flawed Amethyst",
            "hi": 0,
            "gt": 0,
            "i": "invgsvb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gema",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Amethyst",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 60,
                        "max": 60
                    }
                ],
                [
                    {
                        "prop": "str",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    }
                ],
                [
                    {
                        "prop": "ac",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "gsv": {
            "iq": 0,
            "n": "Amethyst",
            "hi": 0,
            "gt": 0,
            "i": "invgsvc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gema",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Amethyst",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 80,
                        "max": 80
                    }
                ],
                [
                    {
                        "prop": "str",
                        "p": 0,
                        "min": 6,
                        "max": 6
                    }
                ],
                [
                    {
                        "prop": "ac",
                        "p": 0,
                        "min": 18,
                        "max": 18
                    }
                ]
            ]
        },
        "gzv": {
            "iq": 0,
            "n": "Flawless Amethyst",
            "hi": 0,
            "gt": 0,
            "i": "invgsvd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gema",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Amethyst",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 100,
                        "max": 100
                    }
                ],
                [
                    {
                        "prop": "str",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "ac",
                        "p": 0,
                        "min": 24,
                        "max": 24
                    }
                ]
            ]
        },
        "gpv": {
            "iq": 0,
            "n": "Perfect Amethyst",
            "hi": 0,
            "gt": 0,
            "i": "invgsve",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gema",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Amethyst",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 150,
                        "max": 150
                    }
                ],
                [
                    {
                        "prop": "str",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "ac",
                        "p": 0,
                        "min": 30,
                        "max": 30
                    }
                ]
            ]
        },
        "gcy": {
            "iq": 0,
            "n": "Chipped Topaz",
            "hi": 0,
            "gt": 0,
            "i": "invgsya",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemt",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Topaz",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ltng-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ltng-max",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "p": 0,
                        "min": 9,
                        "max": 9
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "gfy": {
            "iq": 0,
            "n": "Flawed Topaz",
            "hi": 0,
            "gt": 0,
            "i": "invgsyb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemt",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Topaz",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ltng-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ltng-max",
                        "p": 0,
                        "min": 14,
                        "max": 14
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "p": 0,
                        "min": 13,
                        "max": 13
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ]
            ]
        },
        "gsy": {
            "iq": 0,
            "n": "Topaz",
            "hi": 0,
            "gt": 0,
            "i": "invgsyc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemt",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Topaz",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ltng-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ltng-max",
                        "p": 0,
                        "min": 22,
                        "max": 22
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "p": 0,
                        "min": 22,
                        "max": 22
                    }
                ]
            ]
        },
        "gly": {
            "iq": 0,
            "n": "Flawless Topaz",
            "hi": 0,
            "gt": 0,
            "i": "invgsyd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemt",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Topaz",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ltng-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ltng-max",
                        "p": 0,
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "p": 0,
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "p": 0,
                        "min": 28,
                        "max": 28
                    }
                ]
            ]
        },
        "gpy": {
            "iq": 0,
            "n": "Perfect Topaz",
            "hi": 0,
            "gt": 0,
            "i": "invgsye",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemt",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Topaz",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ltng-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ltng-max",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "p": 0,
                        "min": 24,
                        "max": 24
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ]
            ]
        },
        "gcb": {
            "iq": 0,
            "n": "Chipped Sapphire",
            "hi": 0,
            "gt": 0,
            "i": "invgsba",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gems",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Sapphire",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "cold-min",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "cold-max",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "cold-len",
                        "p": 0,
                        "min": 25,
                        "max": 25
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "gfb": {
            "iq": 0,
            "n": "Flawed Sapphire",
            "hi": 0,
            "gt": 0,
            "i": "invgsbb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gems",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Sapphire",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "cold-min",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "cold-max",
                        "p": 0,
                        "min": 5,
                        "max": 5
                    },
                    {
                        "prop": "cold-len",
                        "p": 0,
                        "min": 35,
                        "max": 35
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "p": 0,
                        "min": 17,
                        "max": 17
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ]
            ]
        },
        "gsb": {
            "iq": 0,
            "n": "Sapphire",
            "hi": 0,
            "gt": 0,
            "i": "invgsbc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gems",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Sapphire",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "cold-min",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    },
                    {
                        "prop": "cold-max",
                        "p": 0,
                        "min": 7,
                        "max": 7
                    },
                    {
                        "prop": "cold-len",
                        "p": 0,
                        "min": 50,
                        "max": 50
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "p": 0,
                        "min": 24,
                        "max": 24
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "p": 0,
                        "min": 22,
                        "max": 22
                    }
                ]
            ]
        },
        "glb": {
            "iq": 0,
            "n": "Flawless Sapphire",
            "hi": 0,
            "gt": 0,
            "i": "invgsbd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gems",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Sapphire",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "cold-min",
                        "p": 0,
                        "min": 6,
                        "max": 6
                    },
                    {
                        "prop": "cold-max",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    },
                    {
                        "prop": "cold-len",
                        "p": 0,
                        "min": 60,
                        "max": 60
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "p": 0,
                        "min": 31,
                        "max": 31
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "p": 0,
                        "min": 28,
                        "max": 28
                    }
                ]
            ]
        },
        "gpb": {
            "iq": 0,
            "n": "Perfect Sapphire",
            "hi": 0,
            "gt": 0,
            "i": "invgsbe",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gems",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Sapphire",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "cold-min",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    },
                    {
                        "prop": "cold-max",
                        "p": 0,
                        "min": 14,
                        "max": 14
                    },
                    {
                        "prop": "cold-len",
                        "p": 0,
                        "min": 75,
                        "max": 75
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "p": 0,
                        "min": 38,
                        "max": 38
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ]
            ]
        },
        "gcg": {
            "iq": 0,
            "n": "Chipped Emerald",
            "hi": 0,
            "gt": 0,
            "i": "invgsga",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "geme",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Emerald",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "pois-min",
                        "p": 0,
                        "min": 34,
                        "max": 34
                    },
                    {
                        "prop": "pois-max",
                        "p": 0,
                        "min": 34,
                        "max": 34
                    },
                    {
                        "prop": "pois-len",
                        "p": 0,
                        "min": 75,
                        "max": 75
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "gfg": {
            "iq": 0,
            "n": "Flawed Emerald",
            "hi": 0,
            "gt": 0,
            "i": "invgsgb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "geme",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Emerald",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "pois-min",
                        "p": 0,
                        "min": 51,
                        "max": 51
                    },
                    {
                        "prop": "pois-max",
                        "p": 0,
                        "min": 51,
                        "max": 51
                    },
                    {
                        "prop": "pois-len",
                        "p": 0,
                        "min": 100,
                        "max": 100
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ]
            ]
        },
        "gsg": {
            "iq": 0,
            "n": "Emerald",
            "hi": 0,
            "gt": 0,
            "i": "invgsgc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "geme",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Emerald",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "pois-min",
                        "p": 0,
                        "min": 82,
                        "max": 82
                    },
                    {
                        "prop": "pois-max",
                        "p": 0,
                        "min": 82,
                        "max": 82
                    },
                    {
                        "prop": "pois-len",
                        "p": 0,
                        "min": 125,
                        "max": 125
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "p": 0,
                        "min": 6,
                        "max": 6
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "p": 0,
                        "min": 22,
                        "max": 22
                    }
                ]
            ]
        },
        "glg": {
            "iq": 0,
            "n": "Flawless Emerald",
            "hi": 0,
            "gt": 0,
            "i": "invgsgd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "geme",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Emerald",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "pois-min",
                        "p": 0,
                        "min": 101,
                        "max": 101
                    },
                    {
                        "prop": "pois-max",
                        "p": 0,
                        "min": 101,
                        "max": 101
                    },
                    {
                        "prop": "pois-len",
                        "p": 0,
                        "min": 152,
                        "max": 152
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "p": 0,
                        "min": 28,
                        "max": 28
                    }
                ]
            ]
        },
        "gpg": {
            "iq": 0,
            "n": "Perfect Emerald",
            "hi": 0,
            "gt": 0,
            "i": "invgsge",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "geme",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Emerald",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "pois-min",
                        "p": 0,
                        "min": 143,
                        "max": 143
                    },
                    {
                        "prop": "pois-max",
                        "p": 0,
                        "min": 143,
                        "max": 143
                    },
                    {
                        "prop": "pois-len",
                        "p": 0,
                        "min": 179,
                        "max": 179
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ]
            ]
        },
        "gcr": {
            "iq": 0,
            "n": "Chipped Ruby",
            "hi": 0,
            "gt": 0,
            "i": "invgsra",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemr",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Ruby",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "fire-min",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "fire-max",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "gfr": {
            "iq": 0,
            "n": "Flawed Ruby",
            "hi": 0,
            "gt": 0,
            "i": "invgsrb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemr",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Ruby",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "fire-min",
                        "p": 0,
                        "min": 5,
                        "max": 5
                    },
                    {
                        "prop": "fire-max",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "p": 0,
                        "min": 17,
                        "max": 17
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ]
            ]
        },
        "gsr": {
            "iq": 0,
            "n": "Ruby",
            "hi": 0,
            "gt": 0,
            "i": "invgsrc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemr",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Ruby",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "fire-min",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    },
                    {
                        "prop": "fire-max",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "p": 0,
                        "min": 24,
                        "max": 24
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "p": 0,
                        "min": 22,
                        "max": 22
                    }
                ]
            ]
        },
        "glr": {
            "iq": 0,
            "n": "Flawless Ruby",
            "hi": 0,
            "gt": 0,
            "i": "invgsrd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemr",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Ruby",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "fire-min",
                        "p": 0,
                        "min": 10,
                        "max": 10
                    },
                    {
                        "prop": "fire-max",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "p": 0,
                        "min": 31,
                        "max": 31
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "p": 0,
                        "min": 28,
                        "max": 28
                    }
                ]
            ]
        },
        "gpr": {
            "iq": 0,
            "n": "Perfect Ruby",
            "hi": 0,
            "gt": 0,
            "i": "invgsre",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemr",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Ruby",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "fire-min",
                        "p": 0,
                        "min": 15,
                        "max": 15
                    },
                    {
                        "prop": "fire-max",
                        "p": 0,
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "p": 0,
                        "min": 38,
                        "max": 38
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ]
            ]
        },
        "gcw": {
            "iq": 0,
            "n": "Chipped Diamond",
            "hi": 0,
            "gt": 0,
            "i": "invgswa",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemd",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Diamond",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-undead",
                        "p": 0,
                        "min": 28,
                        "max": 28
                    }
                ],
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "p": 0,
                        "min": 6,
                        "max": 6
                    }
                ]
            ]
        },
        "gfw": {
            "iq": 0,
            "n": "Flawed Diamond",
            "hi": 0,
            "gt": 0,
            "i": "invgswb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemd",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Diamond",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-undead",
                        "p": 0,
                        "min": 34,
                        "max": 34
                    }
                ],
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 40,
                        "max": 40
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ]
            ]
        },
        "gsw": {
            "iq": 0,
            "n": "Diamond",
            "hi": 0,
            "gt": 0,
            "i": "invgswc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemd",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Diamond",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-undead",
                        "p": 0,
                        "min": 44,
                        "max": 44
                    }
                ],
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 60,
                        "max": 60
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "p": 0,
                        "min": 11,
                        "max": 11
                    }
                ]
            ]
        },
        "glw": {
            "iq": 0,
            "n": "Flawless Diamond",
            "hi": 0,
            "gt": 0,
            "i": "invgswd",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemd",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Diamond",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-undead",
                        "p": 0,
                        "min": 54,
                        "max": 54
                    }
                ],
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 80,
                        "max": 80
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "p": 0,
                        "min": 14,
                        "max": 14
                    }
                ]
            ]
        },
        "gpw": {
            "iq": 0,
            "n": "Perfect Diamond",
            "hi": 0,
            "gt": 0,
            "i": "invgswe",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemd",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Diamond",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-undead",
                        "p": 0,
                        "min": 68,
                        "max": 68
                    }
                ],
                [
                    {
                        "prop": "att",
                        "p": 0,
                        "min": 100,
                        "max": 100
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "p": 0,
                        "min": 19,
                        "max": 19
                    }
                ]
            ]
        },
        "hp1": {
            "iq": 0,
            "n": "Minor Healing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invhp1",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "hp2": {
            "iq": 0,
            "n": "Light Healing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invhp2",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "hp3": {
            "iq": 0,
            "n": "Healing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invhp3",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "hp4": {
            "iq": 0,
            "n": "Greater Healing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invhp4",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "hp5": {
            "iq": 0,
            "n": "Super Healing Potion",
            "hi": 0,
            "gt": 0,
            "i": "invhp5",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mp1": {
            "iq": 0,
            "n": "Minor Mana Potion",
            "hi": 0,
            "gt": 0,
            "i": "invmp1",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mp2": {
            "iq": 0,
            "n": "Light Mana Potion",
            "hi": 0,
            "gt": 0,
            "i": "invmp2",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mp3": {
            "iq": 0,
            "n": "Mana Potion",
            "hi": 0,
            "gt": 0,
            "i": "invmp3",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mp4": {
            "iq": 0,
            "n": "Greater Mana Potion",
            "hi": 0,
            "gt": 0,
            "i": "invmp4",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "mp5": {
            "iq": 0,
            "n": "Super Mana Potion",
            "hi": 0,
            "gt": 0,
            "i": "invmp5",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "skc": {
            "iq": 0,
            "n": "Chipped Skull",
            "hi": 0,
            "gt": 0,
            "i": "invskc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemz",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Skull",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "p": 0,
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "lifesteal",
                        "p": 0,
                        "min": 2,
                        "max": 2
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "p": 0,
                        "min": 2,
                        "max": 2
                    },
                    {
                        "prop": "regen-mana",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    }
                ]
            ]
        },
        "skf": {
            "iq": 0,
            "n": "Flawed Skull",
            "hi": 0,
            "gt": 0,
            "i": "invskf",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemz",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Skull",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "p": 0,
                        "min": 2,
                        "max": 2
                    },
                    {
                        "prop": "lifesteal",
                        "p": 0,
                        "min": 2,
                        "max": 2
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "regen-mana",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "p": 0,
                        "min": 8,
                        "max": 8
                    }
                ]
            ]
        },
        "sku": {
            "iq": 0,
            "n": "Skull",
            "hi": 0,
            "gt": 0,
            "i": "invsku",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemz",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Skull",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "p": 0,
                        "min": 2,
                        "max": 2
                    },
                    {
                        "prop": "lifesteal",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "regen-mana",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ]
            ]
        },
        "skl": {
            "iq": 0,
            "n": "Flawless Skull",
            "hi": 0,
            "gt": 0,
            "i": "invskl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemz",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Skull",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "lifesteal",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    },
                    {
                        "prop": "regen-mana",
                        "p": 0,
                        "min": 12,
                        "max": 12
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "p": 0,
                        "min": 16,
                        "max": 16
                    }
                ]
            ]
        },
        "skz": {
            "iq": 0,
            "n": "Perfect Skull",
            "hi": 0,
            "gt": 0,
            "i": "invskz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "gemz",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Gem",
            "c": [
                "Skull",
                "Gem",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "p": 0,
                        "min": 3,
                        "max": 3
                    },
                    {
                        "prop": "lifesteal",
                        "p": 0,
                        "min": 4,
                        "max": 4
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "p": 0,
                        "min": 5,
                        "max": 5
                    },
                    {
                        "prop": "regen-mana",
                        "p": 0,
                        "min": 19,
                        "max": 19
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "p": 0,
                        "min": 20,
                        "max": 20
                    }
                ]
            ]
        },
        "hrb": {
            "iq": 0,
            "n": "Herb",
            "hi": 0,
            "gt": 0,
            "i": "invhrb",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "herb",
            "lvl": "3",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Herb",
                "Miscellaneous"
            ]
        },
        "cm1": {
            "iq": 0,
            "n": "Small Charm",
            "hi": 0,
            "gt": 0,
            "i": "invchm",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "scha",
            "lvl": "28",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invch1",
                "invch4",
                "invch7"
            ],
            "eq1n": "Charm",
            "c": [
                "Small Charm",
                "Charm",
                "Miscellaneous"
            ]
        },
        "cm2": {
            "iq": 0,
            "n": "Large Charm",
            "hi": 0,
            "gt": 0,
            "i": "invwnd",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "mcha",
            "lvl": "14",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invch2",
                "invch5",
                "invch8"
            ],
            "eq1n": "Charm",
            "c": [
                "Medium Charm",
                "Charm",
                "Miscellaneous"
            ]
        },
        "cm3": {
            "iq": 0,
            "n": "Grand Charm",
            "hi": 0,
            "gt": 0,
            "i": "invsst",
            "iw": 1,
            "ih": 3,
            "it": 0,
            "type": "lcha",
            "lvl": "1",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invch3",
                "invch6",
                "invch9"
            ],
            "eq1n": "Charm",
            "c": [
                "Large Charm",
                "Charm",
                "Miscellaneous"
            ]
        },
        "rps": {
            "iq": 0,
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invrps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "rpl": {
            "iq": 0,
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invrpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "hpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Healing Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "bps": {
            "iq": 0,
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invbps",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "bpl": {
            "iq": 0,
            "s": 1,
            "hi": 0,
            "gt": 0,
            "i": "invbpl",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "mpot",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Potion",
            "c": [
                "Mana Potion",
                "Potion",
                "Miscellaneous"
            ]
        },
        "r01": {
            "iq": 0,
            "n": "El Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrel",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "11",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "light",
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "att",
                        "min": 50,
                        "max": 50
                    }
                ],
                [
                    {
                        "prop": "light",
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ac",
                        "min": 15,
                        "max": 15
                    }
                ],
                [
                    {
                        "prop": "light",
                        "min": 1,
                        "max": 1
                    },
                    {
                        "prop": "ac",
                        "min": 15,
                        "max": 15
                    }
                ]
            ]
        },
        "r02": {
            "iq": 0,
            "n": "Eld Rune",
            "hi": 0,
            "gt": 0,
            "i": "invreld",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "11",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att-undead",
                        "min": 50,
                        "max": 50
                    },
                    {
                        "prop": "dmg-undead",
                        "min": 75,
                        "max": 75
                    }
                ],
                [
                    {
                        "prop": "stamdrain",
                        "min": 15,
                        "max": 15
                    }
                ],
                [
                    {
                        "prop": "block",
                        "min": 7,
                        "max": 7
                    }
                ]
            ]
        },
        "r03": {
            "iq": 0,
            "n": "Tir Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrtir",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "13",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "mana-kill",
                        "min": 2,
                        "max": 2
                    }
                ],
                [
                    {
                        "prop": "mana-kill",
                        "min": 2,
                        "max": 2
                    }
                ],
                [
                    {
                        "prop": "mana-kill",
                        "min": 2,
                        "max": 2
                    }
                ]
            ]
        },
        "r04": {
            "iq": 0,
            "n": "Nef Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrnef",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "13",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "knock",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "ac-miss",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "ac-miss",
                        "min": 30,
                        "max": 30
                    }
                ]
            ]
        },
        "r05": {
            "iq": 0,
            "n": "Eth Rune",
            "hi": 0,
            "gt": 0,
            "i": "invreth",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "15",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "reduce-ac",
                        "min": 25,
                        "max": 25
                    }
                ],
                [
                    {
                        "prop": "regen-mana",
                        "min": 15,
                        "max": 15
                    }
                ],
                [
                    {
                        "prop": "regen-mana",
                        "min": 15,
                        "max": 15
                    }
                ]
            ]
        },
        "r06": {
            "iq": 0,
            "n": "Ith Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrith",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "15",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-max",
                        "min": 9,
                        "max": 9
                    }
                ],
                [
                    {
                        "prop": "dmg-to-mana",
                        "min": 15,
                        "max": 15
                    }
                ],
                [
                    {
                        "prop": "dmg-to-mana",
                        "min": 15,
                        "max": 15
                    }
                ]
            ]
        },
        "r07": {
            "iq": 0,
            "n": "Tal Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrtal",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "17",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-pois",
                        "p": 125,
                        "min": 154,
                        "max": 154
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "res-pois",
                        "min": 35,
                        "max": 35
                    }
                ]
            ]
        },
        "r08": {
            "iq": 0,
            "n": "Ral Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrral",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "19",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-fire",
                        "min": 5,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "res-fire",
                        "min": 35,
                        "max": 35
                    }
                ]
            ]
        },
        "r09": {
            "iq": 0,
            "n": "Ort Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrort",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "21",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-ltng",
                        "min": 1,
                        "max": 50
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "res-ltng",
                        "min": 35,
                        "max": 35
                    }
                ]
            ]
        },
        "r10": {
            "iq": 0,
            "n": "Thul Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrthul",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "23",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-cold",
                        "p": 75,
                        "min": 3,
                        "max": 14
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "res-cold",
                        "min": 35,
                        "max": 35
                    }
                ]
            ]
        },
        "r11": {
            "iq": 0,
            "n": "Amn Rune",
            "hi": 0,
            "gt": 0,
            "i": "invramn",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "25",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "lifesteal",
                        "min": 7,
                        "max": 7
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "min": 14,
                        "max": 14
                    }
                ],
                [
                    {
                        "prop": "thorns",
                        "min": 14,
                        "max": 14
                    }
                ]
            ]
        },
        "r12": {
            "iq": 0,
            "n": "Sol Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrsol",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "27",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg-min",
                        "min": 9,
                        "max": 9
                    }
                ],
                [
                    {
                        "prop": "red-dmg",
                        "min": 7,
                        "max": 7
                    }
                ],
                [
                    {
                        "prop": "red-dmg",
                        "min": 7,
                        "max": 7
                    }
                ]
            ]
        },
        "r13": {
            "iq": 0,
            "n": "Shael Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrshae",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "29",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "swing2",
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "balance2",
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "block2",
                        "min": 20,
                        "max": 20
                    }
                ]
            ]
        },
        "r14": {
            "iq": 0,
            "n": "Dol Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrdol",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "31",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "howl",
                        "min": 32,
                        "max": 32
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "min": 7,
                        "max": 7
                    }
                ],
                [
                    {
                        "prop": "regen",
                        "min": 7,
                        "max": 7
                    }
                ]
            ]
        },
        "r15": {
            "iq": 0,
            "n": "Hel Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrhel",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "33",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ease",
                        "min": -20,
                        "max": -20
                    }
                ],
                [
                    {
                        "prop": "ease",
                        "min": -15,
                        "max": -15
                    }
                ],
                [
                    {
                        "prop": "ease",
                        "min": -15,
                        "max": -15
                    }
                ]
            ]
        },
        "r16": {
            "iq": 0,
            "n": "Io Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrio",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "35",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "vit",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "vit",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "vit",
                        "min": 10,
                        "max": 10
                    }
                ]
            ]
        },
        "r17": {
            "iq": 0,
            "n": "Lum Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrlum",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "37",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "enr",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "enr",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "enr",
                        "min": 10,
                        "max": 10
                    }
                ]
            ]
        },
        "r18": {
            "iq": 0,
            "n": "Ko Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrko",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "39",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dex",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "dex",
                        "min": 10,
                        "max": 10
                    }
                ]
            ]
        },
        "r19": {
            "iq": 0,
            "n": "Fal Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrfal",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "41",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "str",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "str",
                        "min": 10,
                        "max": 10
                    }
                ],
                [
                    {
                        "prop": "str",
                        "min": 10,
                        "max": 10
                    }
                ]
            ]
        },
        "r20": {
            "iq": 0,
            "n": "Lem Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrlem",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "43",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "gold%",
                        "min": 75,
                        "max": 75
                    }
                ],
                [
                    {
                        "prop": "gold%",
                        "min": 50,
                        "max": 50
                    }
                ],
                [
                    {
                        "prop": "gold%",
                        "min": 50,
                        "max": 50
                    }
                ]
            ]
        },
        "r21": {
            "iq": 0,
            "n": "Pul Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrpul",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "45",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att-demon",
                        "min": 100,
                        "max": 100
                    },
                    {
                        "prop": "dmg-demon",
                        "min": 75,
                        "max": 75
                    }
                ],
                [
                    {
                        "prop": "ac%",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "ac%",
                        "min": 30,
                        "max": 30
                    }
                ]
            ]
        },
        "r22": {
            "iq": 0,
            "n": "Um Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrum",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "47",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "openwounds",
                        "min": 25,
                        "max": 25
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "min": 15,
                        "max": 15
                    }
                ],
                [
                    {
                        "prop": "res-all",
                        "min": 22,
                        "max": 22
                    }
                ]
            ]
        },
        "r23": {
            "iq": 0,
            "n": "Mal Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrmal",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "49",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "noheal",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "red-mag",
                        "min": 7,
                        "max": 7
                    }
                ],
                [
                    {
                        "prop": "red-mag",
                        "min": 7,
                        "max": 7
                    }
                ]
            ]
        },
        "r24": {
            "iq": 0,
            "n": "Ist Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrist",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "51",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "mag%",
                        "min": 30,
                        "max": 30
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "min": 25,
                        "max": 25
                    }
                ],
                [
                    {
                        "prop": "mag%",
                        "min": 25,
                        "max": 25
                    }
                ]
            ]
        },
        "r25": {
            "iq": 0,
            "n": "Gul Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrgul",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "53",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "att%",
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "res-pois-max",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "res-pois-max",
                        "min": 5,
                        "max": 5
                    }
                ]
            ]
        },
        "r26": {
            "iq": 0,
            "n": "Vex Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrvex",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "55",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "manasteal",
                        "min": 7,
                        "max": 7
                    }
                ],
                [
                    {
                        "prop": "res-fire-max",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "res-fire-max",
                        "min": 5,
                        "max": 5
                    }
                ]
            ]
        },
        "r27": {
            "iq": 0,
            "n": "Ohm Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrohm",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "57",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "dmg%",
                        "min": 50,
                        "max": 50
                    }
                ],
                [
                    {
                        "prop": "res-cold-max",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "res-cold-max",
                        "min": 5,
                        "max": 5
                    }
                ]
            ]
        },
        "r28": {
            "iq": 0,
            "n": "Lo Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrlo",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "59",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "deadly",
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "res-ltng-max",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "res-ltng-max",
                        "min": 5,
                        "max": 5
                    }
                ]
            ]
        },
        "r29": {
            "iq": 0,
            "n": "Sur Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrsur",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "61",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "stupidity",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "mana%",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "mana",
                        "min": 50,
                        "max": 50
                    }
                ]
            ]
        },
        "r30": {
            "iq": 0,
            "n": "Ber Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrber",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "63",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "crush",
                        "min": 20,
                        "max": 20
                    }
                ],
                [
                    {
                        "prop": "red-dmg%",
                        "min": 8,
                        "max": 8
                    }
                ],
                [
                    {
                        "prop": "red-dmg%",
                        "min": 8,
                        "max": 8
                    }
                ]
            ]
        },
        "r31": {
            "iq": 0,
            "n": "Jah Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrjo",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "65",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "ignore-ac",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "hp%",
                        "min": 5,
                        "max": 5
                    }
                ],
                [
                    {
                        "prop": "hp",
                        "min": 50,
                        "max": 50
                    }
                ]
            ]
        },
        "r32": {
            "iq": 0,
            "n": "Cham Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrcham",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "67",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "freeze",
                        "min": 3,
                        "max": 3
                    }
                ],
                [
                    {
                        "prop": "nofreeze",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "nofreeze",
                        "min": 1,
                        "max": 1
                    }
                ]
            ]
        },
        "r33": {
            "iq": 0,
            "n": "Zod Rune",
            "hi": 0,
            "gt": 0,
            "i": "invrzod",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "rune",
            "lvl": "69",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Socket Filler",
            "c": [
                "Rune",
                "Socket Filler",
                "Miscellaneous"
            ],
            "m": [
                [
                    {
                        "prop": "indestruct",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "indestruct",
                        "min": 1,
                        "max": 1
                    }
                ],
                [
                    {
                        "prop": "indestruct",
                        "min": 1,
                        "max": 1
                    }
                ]
            ]
        },
        "jew": {
            "iq": 0,
            "n": "Jewel",
            "hi": 0,
            "gt": 0,
            "i": "invgswe",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "jewl",
            "lvl": "1",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [
                "invjw1",
                "invjw2",
                "invjw3",
                "invjw4",
                "invjw5",
                "invjw6"
            ],
            "eq1n": "Socket Filler",
            "c": [
                "Jewel",
                "Socket Filler",
                "Miscellaneous"
            ]
        },
        "ice": {
            "iq": 0,
            "n": "Keep it to thaw Anya}Malah's Potion",
            "hi": 0,
            "gt": 0,
            "i": "invxyz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "0sc": {
            "iq": 0,
            "n": "Scroll of Knowledge",
            "hi": 0,
            "gt": 0,
            "i": "invrsc",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "scro",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "eq1n": "Miscellaneous",
            "c": [
                "Scroll",
                "Miscellaneous"
            ]
        },
        "tr2": {
            "iq": 0,
            "n": "Right Click to Cast}Scroll of Resistance",
            "hi": 0,
            "gt": 0,
            "i": "invscb",
            "iw": 2,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "pk1": {
            "iq": 0,
            "n": "Key of Terror",
            "hi": 0,
            "gt": 0,
            "i": "invmph",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "pk2": {
            "iq": 0,
            "n": "Key of Hate",
            "hi": 0,
            "gt": 0,
            "i": "invmph",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "pk3": {
            "iq": 0,
            "n": "Key of Destruction",
            "hi": 0,
            "gt": 0,
            "i": "invmph",
            "iw": 1,
            "ih": 2,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "dhn": {
            "iq": 0,
            "n": "Diablo's Horn",
            "hi": 0,
            "gt": 0,
            "i": "invfang",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "bey": {
            "iq": 0,
            "n": "Baal's Eye",
            "hi": 0,
            "gt": 0,
            "i": "inveye",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "mbr": {
            "iq": 0,
            "n": "Mephisto's Brain",
            "hi": 0,
            "gt": 0,
            "i": "invbrnz",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "toa": {
            "iq": 0,
            "n": "Right-click to reset Stat/Skill Points}Token of Absolution",
            "hi": 0,
            "gt": 0,
            "i": "invtoa",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "tes": {
            "iq": 0,
            "n": "Twisted Essence of Suffering",
            "hi": 0,
            "gt": 0,
            "i": "invtes",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "ceh": {
            "iq": 0,
            "n": "Charged Essence of Hatred",
            "hi": 0,
            "gt": 0,
            "i": "invceh",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "bet": {
            "iq": 0,
            "n": "Burning Essence of Terror",
            "hi": 0,
            "gt": 0,
            "i": "invbet",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "fed": {
            "iq": 0,
            "n": "Festering Essence of Destruction",
            "hi": 0,
            "gt": 0,
            "i": "invfed",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "0",
            "gemsockets": 0,
            "spawnable": 0,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        },
        "std": {
            "iq": 0,
            "n": "Standard of Heroes",
            "hi": 0,
            "gt": 0,
            "i": "invflag",
            "iw": 1,
            "ih": 1,
            "it": 0,
            "type": "ques",
            "lvl": "90",
            "gemsockets": 0,
            "spawnable": 1,
            "nodurability": 1,
            "ig": [],
            "c": [
                "Quest"
            ]
        }
    },
    "version": "diablo2_constants_97"
};